import React, { useState, useEffect, useLayoutEffect, useCallback, useMemo, useRef } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '@/App';
import { API } from '@/App';
import { Database, Loader2, AlertTriangle, LogOut, ChevronLeft, ChevronRight, Search, Eye, EyeOff, Key, X, Download, ClipboardList, Upload, Plus, Inbox } from 'lucide-react';
// SheetJS TARAYICIDA. Paketi ~1 MB buyutuyor, bilincli: sunucu yuklenen dosyanin
// aslini SAKLAMIYOR (sema §9.7), o yuzden satirlari istemci uretmek zorunda.
// Ayni kutuphane sunucuda da var (yalnizca YAZMA icin) ve goc script'inde de —
// ucu de xlsx 0.18.5.
import * as XLSX from 'xlsx';
// Excel seri numarasi artefaktini OKUMA ANINDA geri alir (sema §9.6.1).
// mdb-tarama'DAN DEGIL: o SAGLAMA icin fs/crypto cagiriyor ve zincire
// dondurulmus mdb-birlestirme'yi sokuyor — ikisi de tarayici paketine giremez.
// Bu dosyanin kurali sifir bagimlilik; sagalama kapisi onu kaynak duzeyinde
// denetliyor (require/__filename/process/Intl/import gecmeyecek).
import { satirlariGunlestir } from '../../lib/mdb-gunlestirme';

// === MASTER DATABASE PAGE ===
// Gorsel dil admin panelinden BILEREK farkli: admin siyah + #FFDD59, burasi acik zemin.
// Ekip saatlerce veri tarayacak; yogun tabloyu koyu zeminde okumak yorucu.
// (Auth oncesi loading/403/hata ekranlari admin diliyle kaliyor — kasitli.)
//
// NOT (axios interceptor): AdminPage.js module seviyesinde global bir 401 interceptor kuruyor,
// ama sadece su URL'ler icin: /api/admin, /influencer-counts, /influencer-signups,
// /brand-contacts, /export-. '/api/master-database/*' bu listede OLMADIGI icin interceptor
// devreye girmez ve 401'i burada kendimiz ele aliriz.

const PAGE_LIMIT = 50;

// Sekmeler — soldan saga bu sirada. Sayilar KESISIR (bir kisi hem outreach hem seeding
// olabilir), yani sekme sayilarinin toplami tekil kisi sayisini asar. Bu beklenen davranis.
// SIRA IKI SORUYU AYIRIR (Bora, 2 Eyl · sema §12 madde 70).
// Ilk dordu "bu kayit NEREDEN geldi" sorusuna cevap veriyor ve hepsi sources
// alanina bakiyor: hepsi · outreach · inreach · ikisi birden.
// Son ikisi kaydin NE OLDUGUNU soyluyor ve ayri alanlara bakiyor
// (is_seeding_account, is_talent). Onceki sirada 'dual' en sonda duruyordu ve
// iki soru birbirine karisiyordu.
// YALNIZ GORUNUM SIRASI: anahtarlar ve varsayilan (Tumu = 'all') degismedi.
const TABS = [
  { key: 'all' },
  { key: 'outreach' },
  { key: 'inreach' },
  { key: 'dual' },
  { key: 'seeding' },
  { key: 'talent' },
];

// COKLU SECIM [Bora, 25 Ekim]: Tumu disindaki sekmeler secilip cikarilir; liste
// SECILI SEKMELERIN BIRLESIMI. Secim URL'de ve sunucuya TEK parametrede
// (sekmeler=outreach,seeding) AYNI ADLARLA gider; hangi kaydin hangi sekmeye
// girdigini SUNUCU bilir (lib/mdb-sekmeler.js). Panel kosul kurmaz.
//   Tumu = parametre yok · hicbiri = sekmeler= (bos).
// Sekme sayaclari her sekme icin sekmeler=<o ad> gonderir: her sekme kendi toplami.
const SECILEBILIR_SEKMELER = TABS.filter((x) => x.key !== 'all').map((x) => x.key);

// Secim -> gorunum degeri. null = Tumu. Hepsi secildiyse Tumu'ye doner (ayni
// liste, tek link). Sira sabit: ayni secim her zaman ayni linki verir.
const sekmeSecimi = (liste) => {
  const secili = SECILEBILIR_SEKMELER.filter((k) => liste.includes(k));
  return secili.length === SECILEBILIR_SEKMELER.length ? null : secili;
};

// Siralanabilir kolon -> API sort anahtari
const SORTABLE = {
  followers: 'followers',
  ig_story: 'ig_story',
  ig_reel: 'ig_reel',
  // ARTIK GERCEK SEGMENT SIRALAMASI. Onceden 'name'e esleniyordu: URL'de
  // ?sort=segment gorunuyor ama sunucuya sort=name gidiyordu ve tablo sessizce
  // ISIM sirasina geri sariyordu (sema §12 madde 61; ekranda ters alfabetik
  // isim, segment kolonu karisik). Sunucu bilinmeyen sort'a 400 doner, sessiz
  // geri sarma ISTEMCIDEYDI.
  segment: 'segment',
  // Fiyat tarihi. Tarihi BILINENLER her iki yonde de onde, bilinmeyenler sonda
  // (sunucudaki __nullLast). Siralama bir is listesi: neyin eksik oldugu gorunsun.
  quoted_at: 'quoted_at',
  // Veri tazeligi. Bilinmeyenler iki yonde de sonda (sunucudaki __nullLast).
  tazelik: 'tazelik',
};

const PLATFORM_ABBR = {
  instagram: 'IG',
  tiktok: 'TikTok',
  youtube: 'YT',
  podcast: 'Podcast',
  x: 'X',
  twitter: 'X',
  pinterest: 'Pinterest',
};

const platformLabel = (p) => {
  const key = String(p || '').trim().toLowerCase();
  if (PLATFORM_ABBR[key]) return PLATFORM_ABBR[key];
  return key ? key.charAt(0).toUpperCase() + key.slice(1) : '—';
};

// === MECRA KULLANICI ADI ETIKETI — DINAMIK URETIMIN TEK KAYNAGI ===
// Buradan turetilenler, hepsi bu kadar:
//   HANDLE_WORD.tr       -> uc mecra alan etiketi (editIgHandle /
//                           editTiktokHandle / editYtHandle), yeni kayit
//                           formundaki uc etiket, ve gecmis (audit) satirinin
//                           `platforms.<mecra>.handle` dinamik etiketi
//                           (t.handleWord)
//   HANDLE_WORD.trCumle  -> cakisma mesajlarindaki alan ifadesi
//                           (handleFieldLabel: "TikTok kullanıcı adı" ...)
// Onceden audit etiketi AYRI bir kaynaktan geliyordu — o satira gomulu 'handle'
// dizgesi — ve sozluktekiyle ayni ekran metnini uretiyordu; biri degistirilip
// oteki unutulabilirdi.
//
// TR'nin IKI bicimi var: 'Kullanıcı Adı' alan ETIKETI (baslik bicimi),
// 'kullanıcı adı' CUMLE ICI. Ikisi de ELLE yazili — programla kucultmuyorum:
// bu depoda locale'siz toLowerCase 'İ' uzerinde U+0307 birakip handle bozdu
// (12 Eyl), ve iki kelimelik bir sabit icin o makineyi kurmaya deger degil.
//
// KAPSAM SINIRI (olculdu): bu sabit kelimeyi TEKILLESTIRMIYOR. "kullanıcı adı"
// TR sozlugunde ayrica YEDI satirda duz metin olarak geciyor (arama ipuclari,
// "kullanıcı adı yok", Mecralar notu, yeni kayit
// Instagram etiketi...). Onlar cumle ici gecisler ve kimi cekim ekiyle
// ("adı yok") duruyor; sablona sokmak metni bozardi, bilerek DISARIDALAR.
const HANDLE_WORD = { tr: 'Kullanıcı Adı', trCumle: 'kullanıcı adı', en: 'handle' };

// === SEGMENT ETIKETI ===
// brand_segment artik TEK DEGER (string) ve dogrudan saklaniyor — turetilmiyor.
// Sozluk dokuz deger: A, AB, B, BC, C, MAB, MB, MBC, K. 'conservative' alani kalkti.
// Bos/yok ise null doner ve satirda "+ ata" rozeti gosterilir.
function segmentLabel(doc) {
  const raw = doc?.brand_segment;
  // Goc oncesi kalan dizi kayitlari icin geriye donuk tolerans: birlestirilerek gosterilir.
  // Goc tamamlandiginda bu dal olu kod olur, ama yarim goc halinde kolon bos kalmaz.
  if (Array.isArray(raw)) {
    const joined = raw.filter(Boolean).join('-');
    return joined || null;
  }
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  return trimmed || null;
}

// === COCUK YASLARI ===
// children[] iki farkli bicimde gelebilir: { age_months, measured_at } veya { birth_year, birth_month }.
// age_months bicimi olcum anindaki yasi tutar; measured_at varsa bugune tasinir, yoksa oldugu
// gibi kullanilir (bayat olabilir — veri kalitesi ayri bir is).
const monthsBetween = (from, to) =>
  (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());

// Yasin yani sira NEREDEN geldigini de dondurur — cunku hepsi ayni guvenilirlikte degil:
//   'birth'    : {birth_year, birth_month} -> bugunku yas KESIN            (canli: 548 kayit)
//   'measured' : {age_months, measured_at} -> olcum tarihinden hesaplanir  (canli: 773 kayit)
//   'undated'  : {age_months} tarih YOK    -> YANILTICI, girildigi andaki  (canli: 552 kayit)
//                deger; bir yil once "6 ay" girildiyse cocuk bugun 18 aylik ama 6 gorunur.
function childAgeInfo(child, now) {
  if (!child || typeof child !== 'object') return null;
  if (typeof child.age_months === 'number' && Number.isFinite(child.age_months)) {
    if (child.measured_at) {
      const m = new Date(child.measured_at);
      if (!Number.isNaN(m.getTime())) {
        return {
          months: Math.max(0, child.age_months + Math.max(0, monthsBetween(m, now))),
          kind: 'measured',
          measuredAt: m,
        };
      }
    }
    return { months: Math.max(0, child.age_months), kind: 'undated' };
  }
  if (typeof child.birth_year === 'number' && Number.isFinite(child.birth_year)) {
    const bm = typeof child.birth_month === 'number' ? child.birth_month : 1;
    const b = new Date(child.birth_year, Math.min(11, Math.max(0, bm - 1)), 1);
    const m = monthsBetween(b, now);
    return m >= 0 ? { months: m, kind: 'birth', birthDate: b } : null;
  }
  return null;
}

function childAgeMonths(child, now) {
  const info = childAgeInfo(child, now);
  return info ? info.months : null;
}

// 36 aydan kucuk -> "N ay", buyuk -> "N yas"
// === COCUK YASI: AY <-> YIL ===
// SAKLAMA DEGISMIYOR: children[].age_months, ay cinsinden TAM SAYI.
// 36 ay sinirinin kendiliginden islemesi (prosedur §11.3: bebek 36 ayda cocuk olur)
// age_months + measured_at ikilisine bagli; yasi iki ayri alanda tutmak bu gecisi
// elle yapmayi gerektirirdi. Degisen yalnizca GIRIS ve GOSTERIM.
const CHILD_YEAR_THRESHOLD = 36; // ay; bu esikten itibaren yil olarak konusuluyor
const CHILD_YEAR_MIN = 3;        // 36 ay
const CHILD_YEAR_MAX = 18;       // 216 ay

// Virgul de nokta da kabul: "3,5" ve "3.5" ayni. Bos ya da gecersiz -> null.
function parseDecimalInput(value) {
  const metin = String(value ?? '').trim().replace(',', '.');
  if (metin === '') return null;
  const n = Number(metin);
  return Number.isFinite(n) ? n : null;
}

// age_months -> kutuda gosterilecek metin (secili birime gore).
//
// YAS BIRIMINDE EN YAKIN YARIMA YUVARLANIR. Sema §3.6 yas biriminde yalnizca
// yarim kabul ediyor (3 · 3,5 · 4 · 4,5); ham bolme 86 ay icin 7,166666666666667
// uretiyordu. Kapatilan hata yolu somut: 7,1666666 goren biri kutunun bozuk
// oldugunu dusunup 7 yaziyor ve cocuk sessizce iki ay kuculuyor.
//
// BU YALNIZCA GORUNUM. Yuvarlanmis deger SAKLANMAZ: kutuya elle dokunulmadikca
// kaydedilen deger ham age_months'tur (bkz. draft.childMonths / childEdited).
// Sema §3.6: "Birim degistirilince deger CEVRILIR, yeniden yorumlanmaz" —
// ceviri kayipli olamaz, o yuzden yuvarlama gosterimde biter.
function childMonthsToInput(months, unit, ondalikAyirici) {
  if (typeof months !== 'number' || !Number.isFinite(months)) return '';
  if (unit !== 'yas') return String(months);
  const yil = Math.round((months / 12) * 2) / 2;
  return Number.isInteger(yil) ? String(yil) : String(yil).replace('.', ondalikAyirici);
}

// === BEBEK / COCUK — GRUPLAMA, SAYAC, DIZI KURMA [Y16, Bora 1 Kas] ===
// SAKLAMA DEGISMEDI: children[].age_months (+ measured_at / birth_year), sema §3.6
// (bebek/cocuk kolonu yok, 36 ay esigi TURETILIR). Bebek = bugunku yasi
// < CHILD_YEAR_THRESHOLD (36 ay); cocuk = >= 36 ay (216 ay ustu "18+" de cocuk).
// Yasi okunamayan giris cocuk grubunda BOS kutuyla durur: siniflanamaz ve
// kullanici yas girene kadar kaydetme durur (onceki "cocukYas" kurali).
//
// Her giris orijinal indeksini (ref) tasir. Govde { age_months, ref } ile gider;
// sunucu (vChildren) mevcut girisi ref'ten bulur — gruplar sirayi degistirse ya
// da ortadan silinse bile dogru cocugun birth_year / measured_at'i korunur.
//
// UC DURUM TEK SEVIYEDE: iki sayac da bos = bilinmiyor (children govdeye girmez).
// Bir sayac bosaltilinca IKISI de bilinmiyor olur, diziler DURUR (geri donussuz
// silme yok); bir sayac yazilinca oteki dizinin uzunluguyla geri gelir.
//
// SAF fonksiyonlar: girdi durum, cikti yeni durum. null -> kullanici onayi reddetti.
//   durum = { bebekSayi, cocukSayi, bebek: [giris], cocuk: [giris] }
//   giris = { ref: number|null, ay: number|null, deger: string, edited: bool }
function cocukGrupla(children, now) {
  const bebek = [];
  const cocuk = [];
  (Array.isArray(children) ? children : []).forEach((c, ref) => {
    const ay = childAgeMonths(c, now);
    const giris = { ref, ay: typeof ay === 'number' ? ay : null };
    (giris.ay !== null && giris.ay < CHILD_YEAR_THRESHOLD ? bebek : cocuk).push(giris);
  });
  return { bebek, cocuk };
}

// Kayit -> taslak. Bebek kutusu AY (tam sayi), cocuk kutusu YAS (yariya yuvarli
// gosterim; dokunulmadikca ham ay saklanir — childMonthsToInput'taki kural).
function cocukTaslagiOku(children, now, ondalikAyirici) {
  const alanVar = Array.isArray(children);
  const g = cocukGrupla(children, now);
  const kur = (dizi, yas) => dizi.map((x) => ({
    ref: x.ref, ay: x.ay, edited: false,
    deger: yas ? childMonthsToInput(x.ay, 'yas', ondalikAyirici) : (x.ay === null ? '' : String(x.ay)),
  }));
  return {
    bebekSayi: alanVar ? String(g.bebek.length) : '',
    cocukSayi: alanVar ? String(g.cocuk.length) : '',
    bebek: kur(g.bebek, false),
    cocuk: kur(g.cocuk, true),
  };
}

const cocukBilinmiyor = (k) => k.bebekSayi === '' && k.cocukSayi === '';
const cocukDolu = (x) => x.ref !== null || String(x.deger).trim() !== '';
const cocukDoluSayisi = (k) => [...k.bebek, ...k.cocuk].filter(cocukDolu).length;
const cocukBosalt = () => ({ bebekSayi: '0', cocukSayi: '0', bebek: [], cocuk: [] });

// Sayac. Grup kendi SONUNDAN kirpilir; ref oldugu icin ortadan silme de guvenli
// ama sayac tek basina yalniz sondan alir. Dolu kutu gidecekse onay sorulur.
// Toplam (bebek + cocuk) en fazla 12.
function cocukSayiUygula(k, grup, ham, onaySor) {
  const metin = String(ham ?? '').trim();
  if (metin === '') return { ...k, bebekSayi: '', cocukSayi: '' };
  const oteki = grup === 'bebek' ? 'cocuk' : 'bebek';
  const next = Math.max(0, Math.min(12 - k[oteki].length, Number(metin) || 0));
  const dizi = k[grup];
  if (next < dizi.length) {
    const kaybolacak = dizi.slice(next).filter(cocukDolu);
    if (kaybolacak.length && !onaySor(kaybolacak.length)) return null;
  }
  const yeni = dizi.slice(0, next);
  while (yeni.length < next) yeni.push({ ref: null, ay: null, deger: '', edited: false });
  return {
    ...k,
    [grup]: yeni,
    [`${grup}Sayi`]: String(next),
    [`${oteki}Sayi`]: String(k[oteki].length),
  };
}

// Kutuya ELLE yazmak: deger + "dokunuldu" bayragi. Bayrak kalkinca ham ay degil
// yazilan deger kaydedilir.
function cocukDegerYaz(k, grup, i, deger) {
  const dizi = k[grup].map((x, j) => (j === i ? { ...x, deger, edited: true } : x));
  return { ...k, [grup]: dizi };
}

// Taslak -> govde dizisi. Bilinmiyorsa null (children gonderilmez).
//   bebek: 0-35 AY, tam sayi · cocuk: 3-18 YAS, yarim kabul (3,5 -> 42 ay)
//   dokunulmamis mevcut giris HAM ay ile gider (216 ustu dahil)
// Sira: mevcutlar orijinal indeks sirasiyla, yeniler sonda.
function cocukDizisiKur(k) {
  if (cocukBilinmiyor(k)) return null;
  const girisler = [];
  let hata = false;
  for (const [grup, yas] of [['bebek', false], ['cocuk', true]]) {
    for (const x of k[grup]) {
      let ay = x.ay;
      if (x.edited || x.ref === null) {
        const n = parseDecimalInput(x.deger);
        if (yas) {
          ay = n !== null && n >= CHILD_YEAR_MIN && n <= CHILD_YEAR_MAX && Number.isInteger(n * 2)
            ? Math.round(n * 12) : null;
        } else {
          ay = n !== null && Number.isInteger(n) && n >= 0 && n < CHILD_YEAR_THRESHOLD ? n : null;
        }
      }
      if (ay === null) hata = true;
      girisler.push(x.ref === null ? { age_months: ay } : { age_months: ay, ref: x.ref });
    }
  }
  if (hata) return { dizi: null, hata: 'cocukYas' };
  const mevcut = girisler.filter((x) => 'ref' in x).sort((a, b) => a.ref - b.ref);
  const yeni = girisler.filter((x) => !('ref' in x));
  return { dizi: [...mevcut, ...yeni], hata: null };
}

function monthsToText(months, t) {
  if (months === null || months === undefined) return null;
  // 18 YASTAN BUYUK -> "18+". Deger DEGISTIRILMEZ, veri temizligi YAPILMAZ.
  // Canlida 12 giris 216 ayin ustunde, en buyugu 408 ay (34 yas). Bunlar
  // muhtemelen cocuk degil — influencer'in kendi yasi ya da goc artefakti.
  // 34'u oldugu gibi basmak veriyi YANLIS ANLATIYOR (o kayitta 34 yasinda bir
  // "cocuk" var gibi okunuyor); degeri silmek ya da kirpmak BILGIYI YOK EDIYOR.
  // "18+" ikisini de yapmiyor: gosterim kaydin cocuk yasi olarak okunamayacagini
  // soyluyor, ham deger veritabaninda yerinde duruyor.
  //
  // Birim eki YOK — "18+ yas" degil, sadece "18+".
  // Metin CHILD_YEAR_MAX'ten turetiliyor; ust sinir degisirse burasi kendiliginden
  // uyar ve ayri bir ceviri anahtarina gerek kalmaz (tr/en'de zaten ayni dizge).
  //
  // 216 ayin KENDISI bu dalin disinda: "18 yas" olarak basilmaya devam ediyor.
  // DUZENLEME MODU ETKILENMEZ: kutu bugunku degeri gostermeye devam eder
  // (408 ay -> "34" + yas birimi). Kutuda "18+" gostermek degeri duzenlenemez
  // hale getirirdi.
  if (months > CHILD_YEAR_MAX * 12) return `${CHILD_YEAR_MAX}+`;
  if (months < CHILD_YEAR_THRESHOLD) return `${months} ${t.monthUnit}`;
  // 6'ya tam bolunuyorsa yarim yas TAM ifade edilebilir: 42 -> "3,5 yas".
  // Bolunmuyorsa (or. 38 ay) yariya yuvarlamak OLMAYAN bir kesinlik iddia ederdi;
  // bugunku davranis korunur ve tam yila indirilir: 38 -> "3 yas".
  // (Canli olcum: 36 ay ustu 685 giristen 659'u 6'ya tam boluniyor, 26'si bolunmuyor.)
  if (months % 6 === 0) {
    const yil = months / 12;
    const metin = Number.isInteger(yil) ? String(yil) : String(yil).replace('.', t.decimalSep);
    return `${metin} ${t.yearUnit}`;
  }
  return `${Math.floor(months / 12)} ${t.yearUnit}`;
}

function childAgeText(child, now, t) {
  return monthsToText(childAgeMonths(child, now), t);
}

// === INSTAGRAM HANDLE ZORUNLULUGU — TEK YUKLEM ===
// Zorunluluk YALNIZCA yeni kayitta var. Duzenlemede handle BOSALTILABILIR ve
// sunucu $unset yapar — orada "zorunlu alan" diye bir kavram yok ve bu davranis
// DEGISMIYOR.
//
// UC PANEL KAPISI DA BURADAN TURUYOR, cunku uc farkli soru degil IKI soru var:
//   yildiz (*)        -> "bu alan zorunlu MU"       -> mdbHandleZorunlu
//   disabled + return -> "zorunlu ve EKSIK mi"      -> mdbHandleEksik
// Ikisi ayri kaldi cunku yildiz alan BOSKEN DE DOLUYKEN DE basilmali (etiket,
// uyari degil); disabled ve return ise yalnizca eksikken devreye girer.
// Ucu de tek kaynaktan turedigi icin "zorunlu" tanimi degisirse ucu birden uyar.
//
// SUNUCUDAKI DORDUNCU KAPI (mdbHandleDogrula) AYRIDIR ve yerinde duruyor:
// panel yanlis davransa bile POST handle'siz kayit acmaz.
const mdbHandleZorunlu = (yeniMi) => Boolean(yeniMi);
const mdbHandleEksik = (d, yeniMi) =>
  mdbHandleZorunlu(yeniMi) && !String(d?.instagram_handle ?? '').trim();

// === UC DURUMLU BOOLEAN — BES ALANIN TAMAMI BUNU KULLANIR ===
// is_expert · is_seeding_account · is_talent · pregnancy.is_pregnant ·
// whatsapp_community.member. Saklama UC DURUM tasiyor (true / false / alan hic
// yok) ama onay kutusu IKISINI ifade edebiliyordu; isaretsiz kutu "Hayir" diye
// okunuyordu. Uc durum bir gorunum tercihi degil, VERI GIRISININ KENDISI:
// kullanici "bilinmiyor"u secince alan GONDERILMEZ, false gonderilmez.
//
// ⚠ KIRILGAN DEGISMEZ (madde 33). Bu bes alan taslak/prev SIMETRISINE bagli:
// form kurulumu (startEdit) ve put3()'un prev argumani AYNI fonksiyondan gecmek
// ZORUNDA. Onceden ikisi de elle "doc.X === true" yaziyordu ve simetri elle
// korunuyordu; artik TEK fonksiyon (bool3Oku) ikisini de uretiyor, yani simetri
// yapisal. Bozulursa alan degismemis kayitlarda da govdeye girer ve sirasiyla
// 2.496 · 2.331 · 2.643 kayda SESSIZCE false yazilir — audit_log'a "degisti"
// bile yazmadan.
const BOOL3_BOS = '';
const bool3Oku = (v) => (v === true ? 'evet' : v === false ? 'hayir' : BOOL3_BOS);
const bool3Yaz = (d) => (d === 'evet' ? true : d === 'hayir' ? false : null);

// === ANNE MI? · EVLI MI? — FORM [KARAR Bora, 1 Kas] ===
// Uc degerli "Anne mi?" SAKLANMAZ: sunucu is_mother + is_married'den turetir
// (anne_durumu, lib/mdb-profil-kurali.js). Form SAKLANAN iki alani duzenler;
// asagidaki iki fonksiyon kayit <-> form cevirisinin TEK yeri.
//   Okuma: is_mother true -> evet · false + is_married true -> potansiyel ·
//          false -> hayir · yok -> bos
//   Yazma: evet -> is_mother true (is_married gonderilmez: anne evli sayilir)
//          potansiyel -> is_mother false + is_married true
//          hayir -> is_mother false + is_married taslaktan (Potansiyel -> Degil: Hayir; bos ise gonderilmez)
// [Y35, Bora 3 Kas 19:40] Kartta "Evli mi?" kutusu YOK; is_married yalniz kutulardan yazilir.
//          erkek -> is_mother false (cinsiyet degistiyse) · is_married gonderilmez
// Donus bool3 metni; BOOL3_BOS = alan gonderilmez (put3).
function anneMiOku(doc) {
  if (doc.is_mother === true) return 'evet';
  if (doc.is_mother === false) return doc.is_married === true ? 'potansiyel' : 'hayir';
  return BOOL3_BOS;
}
function anneEvliYaz(d) {
  if (d.gender === 'erkek') {
    return { is_mother: d.anne_mi === BOOL3_BOS ? BOOL3_BOS : 'hayir', is_married: BOOL3_BOS };
  }
  if (d.anne_mi === 'evet') return { is_mother: 'evet', is_married: BOOL3_BOS };
  if (d.anne_mi === 'potansiyel') return { is_mother: 'hayir', is_married: 'evet' };
  if (d.anne_mi === 'hayir') {
    return { is_mother: 'hayir', is_married: d.is_married === 'evet' ? BOOL3_BOS : d.is_married };
  }
  return { is_mother: BOOL3_BOS, is_married: d.is_married === 'evet' ? BOOL3_BOS : d.is_married };
}

// === ANNE ISARET KUTULARI — Anne · Hamile · Potansiyel · Degil [Bora, 1 Kas] ===
// Kart tasarimi: uc degerli "Anne mi?" secimi DORT kutuya dondu. Saklanan alanlar
// ayni (is_mother · is_married · pregnancy.is_pregnant); kutu -> alan cevirisi
// anneEvliYaz'da. Gecis kurallari BURADA, bilesende degil:
//   Anne / Potansiyel / Degil birbirini dislar; isaretli kutuya tiklamak kaldirir (—).
//   Hamile bagimsiz ama isaretlenince Anne da isaretlenir; Anne kaldirilinca
//     Hamile de kalkar (hamile kadin anne sayilir — 4. kural).
//   Potansiyel ya da Degil: Hamile kalkar; kayitli bebek/cocuk varsa ONAYLA
//     bosaltilir (children: [] ayni istekte gider). Potansiyel -> Degil: Evli Hayir.
//   Erkek: dort kutu kilitli, degisiklik yok.
// Donus { d, onay }: onay > 0 ise cagiran "N bilgi silinecek" diye sorar; ret ->
// hicbir sey degismez.
// Hamile kaldirma: kayitta alan YOKTUYSA (hamile_ilk bos) bos'a doner, gonderilmez;
// varsa Hayir (false) olur.
function hamileKapat(d) {
  if (d.pregnancy_is_pregnant !== 'evet') return d.pregnancy_is_pregnant;
  return d.hamile_ilk === BOOL3_BOS ? BOOL3_BOS : 'hayir';
}
function anneKutuSec(d, kutu) {
  if (d.gender === 'erkek') return { d, onay: 0 };
  if (kutu === 'anne') {
    return d.anne_mi === 'evet'
      ? { d: { ...d, anne_mi: BOOL3_BOS, pregnancy_is_pregnant: hamileKapat(d) }, onay: 0 }
      : { d: { ...d, anne_mi: 'evet' }, onay: 0 };
  }
  if (kutu === 'hamile') {
    return d.pregnancy_is_pregnant === 'evet'
      ? { d: { ...d, pregnancy_is_pregnant: hamileKapat(d) }, onay: 0 }
      : { d: { ...d, pregnancy_is_pregnant: 'evet', anne_mi: 'evet' }, onay: 0 };
  }
  const deger = kutu === 'potansiyel' ? 'potansiyel' : 'hayir';
  if (d.anne_mi === deger) return { d: { ...d, anne_mi: BOOL3_BOS }, onay: 0 };
  const n = cocukDoluSayisi(d.cocuk);
  return {
    d: {
      ...d,
      anne_mi: deger,
      pregnancy_is_pregnant: hamileKapat(d),
      ...(deger === 'hayir' && d.anne_mi === 'potansiyel' ? { is_married: 'hayir' } : {}),
      ...(n > 0 ? { cocuk: cocukBosalt() } : {}),
    },
    onay: n,
  };
}
// Cinsiyet Erkek: Anne mi? Hayir (is_mother false gider — "erkek anne olamaz"),
// Hamile kalkar. Kutular kilitli ve bos gorunur.
function cinsiyetSec(d, v) {
  return v === 'erkek'
    ? { ...d, gender: v, anne_mi: 'hayir', pregnancy_is_pregnant: hamileKapat(d) }
    : { ...d, gender: v };
}
// Potansiyel ya da Degil iken dort bebek/cocuk alani INAKTIF (tanim geregi
// cocugu yok). Erkekte ACIK (baba profilleri).
const cocukAlanlariKilitli = (d) =>
  d.gender !== 'erkek' && (d.anne_mi === 'potansiyel' || d.anne_mi === 'hayir');
// Kutularin isaretleri. Okuma: kayittan (Potansiyel / Degil sunucunun anne_durumu'su).
// is_mother bilinmiyorsa (alan yok) hicbiri isaretli degil. Erkekte null ("—").
function anneKutulariOku(doc) {
  if (doc.gender === 'erkek') return null;
  const bilinen = typeof doc.is_mother === 'boolean';
  return {
    anne: doc.is_mother === true,
    hamile: doc.pregnancy?.is_pregnant === true,
    potansiyel: bilinen && doc.anne_durumu === 'potansiyel',
    degil: bilinen && doc.anne_durumu === 'hayir',
  };
}
function anneKutulariTaslak(d) {
  if (d.gender === 'erkek') return null;
  return {
    anne: d.anne_mi === 'evet',
    hamile: d.pregnancy_is_pregnant === 'evet',
    potansiyel: d.anne_mi === 'potansiyel',
    degil: d.anne_mi === 'hayir',
  };
}

// [Y36, Bora 3 Kas 21:07] BEKLENEN DOGUM — ay + yil ("en kotu yaklasik"); sunucu
// ayin 1'ini UTC sakliyor. Hamilelik ayi = 9 − (bugunden beklenen doguma kalan ay),
// 1–9 arasina sikistirilir; kalan < 0 -> "gecti".
const dogumAyYil = (v) => {
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : { ay: d.getUTCMonth() + 1, yil: d.getUTCFullYear() };
};
const dogumMetni = (dy) => (dy ? `${String(dy.ay).padStart(2, '0')}.${dy.yil}` : '');
const dogumaKalanAy = (dy, simdi = new Date()) =>
  dy.yil * 12 + dy.ay - (simdi.getFullYear() * 12 + simdi.getMonth() + 1);
const hamilelikAyi = (dy, simdi = new Date()) => Math.min(9, Math.max(1, 9 - dogumaKalanAy(dy, simdi)));
// [Y36, Bora 3 Kas 22:34] AKTIFLIK — son 90 gun reel sayisi (reel_olcum.son3ay):
// 0 -> inaktif · 1–2 -> pasif · 3+ -> aktif. Sayi yoksa rozet yok.
// Sunucudaki MDB_INREACH_SEBEP ile AYNI metin (plan.dokunulmayan[].sebep).
const INREACH_SEBEP = 'Inreach — influencer kendisi verdi';
const AKTIFLIK_SINIF = {
  aktif: 'bg-[#E8F3E8] text-[#3D6B3D]', pasif: 'bg-[#FAEFD5] text-[#8A6A20]', inaktif: 'bg-[#F3F1EE] text-[#6D6960]',
};
const aktiflikDurumu = (n) => (typeof n !== 'number' || !Number.isFinite(n) ? null
  : n >= 3 ? 'aktif' : n >= 1 ? 'pasif' : 'inaktif');

// [Y27] MARKALAR — kart kutusu tek satir metin ("Prima, Dalin"). Taslak metni ve
// "dokunuldu mu" karsilastirmasi AYNI fonksiyondan (markaMetni); bolme panelde
// kaba (virgul / noktali virgul / satir sonu), asil temizlik SUNUCUDA
// (vMarkaListesi -> mdbTarama.splitBrands: Evet/Hayir atilir, yazim farki tekillesir).
const markaMetni = (doc) => (Array.isArray(doc?.worked_brands) ? doc.worked_brands : []).join(', ');
const markaMetniBol = (metin) => String(metin ?? '').split(/[,;\n]/).map((x) => x.trim()).filter(Boolean);
// [Y32] HEDIYELESME — Markalar'in ikizi (gifted_brands); ayni bolme, ayni sunucu kurali.
const hediyeMetni = (doc) => (Array.isArray(doc?.gifted_brands) ? doc.gifted_brands : []).join(', ');

// === GOVDE KURULUMU — TEK YER, IKI CAGIRAN ===
// Duzenleme (PATCH) ve yeni kayit (POST) AYNI fonksiyondan geciyor.
// Fark tek sey: REFERANS BELGE. Duzenlemede mevcut kayit, yeni kayitta BOS
// BELGE ({}). put "oncekinden farkli mi" diye soruyor; bos referansta bu
// kendiliginden "bos degil mi"ye donuyor — ekle() adinda ikinci bir kurala
// gerek kalmiyor ve o fonksiyon SILINDI.
//
// IKI ISTISNA put desenine UYMUYOR, bilerek ayri duruyorlar:
//  (a) children — UC DURUMLU (bos = bilinmiyor). put "farkli mi" sorar, burada
//      soru "kullanici cevapladi mi". childCount !== '' kapisi disarida kaliyor.
//  (b) platforms — fields'in ICINDE DEGIL, ayri bir govde anahtari; POST ucu
//      onu bugun hic okumuyor. Bu yuzden burada YOK, saveEdit'te kaliyor.
//
// Doner: { fields, acikCevaplar, hata } — hata varsa cagiran KENDI mesajini
// basar (bu fonksiyon ekrana dokunmaz).
// [Y16] UST DUZEYDE: saf (yalniz d ve ref); test kaynaktan cagiriyor.
const mdbGovdeKur = (d, ref) => {
  const rates = ref.rates || {};
  const fields = {};
  const put = (key, next, prev) => {
    if (JSON.stringify(next ?? null) !== JSON.stringify(prev ?? null)) fields[key] = next;
  };
  const money = (v) => (String(v).trim() === '' ? null : Number(v));
  put('instagram_handle', d.instagram_handle.trim(), ref.instagram_handle || '');
  put('full_name', d.full_name.trim(), ref.full_name || '');
  put('tiktok_handle', d.tiktok_handle.trim(), ref.tiktok_handle || '');
  put('youtube_handle', d.youtube_handle.trim(), ref.youtube_handle || '');
  // UC DURUMLU BOOLEAN. prev, startEdit ile AYNI fonksiyondan (bool3Oku) —
  // simetri artik elle degil YAPISAL. "Bilinmiyor" secili kalirsa alan govdeye
  // HIC girmez: bu bir deger degil, cevabin yoklugu. false gondermekle ayni
  // sey DEGIL (false "bakildi, degil" demek).
  // ACIK CEVAP LISTESI. Sunucudaki kapi "alan yokken gelen false bir cevap
  // degil, varsayilandir" diyor ve HAKLI — ama uc durumlu kontrolde "Hayir"
  // FORMUN VARSAYILANI DEGIL, KULLANICININ SECIMI. Ikisi ayni govdede ayni
  // goruntuyu veriyordu; niyet artik acikca bildiriliyor.
  // Yalnizca put3 dolduruyor: listeye giren her alan uc durumlu kontrolden
  // gecmis demektir.
  const acikCevaplar = [];
  const put3 = (key, next, prev) => {
    if (next === prev) return;          // dokunulmamis
    if (next === BOOL3_BOS) return;     // "bilinmiyor" -> alan gonderilmez
    fields[key] = bool3Yaz(next);
    acikCevaplar.push(key);
  };
  put3('is_expert', d.is_expert, bool3Oku(ref.is_expert));
  put3('is_seeding_account', d.is_seeding_account, bool3Oku(ref.is_seeding_account));
  put3('is_talent', d.is_talent, bool3Oku(ref.is_talent));
  put3('pregnancy.is_pregnant', d.pregnancy_is_pregnant, bool3Oku(ref.pregnancy?.is_pregnant));
  // [Y36] beklenen dogum YALNIZ hamile isaretliyken gonderilir ("YYYY-MM"); bos '' -> sunucu siler.
  if (d.pregnancy_is_pregnant === 'evet') {
    const eskiDy = dogumAyYil(ref.pregnancy?.due_date);
    const eski = eskiDy ? `${eskiDy.yil}-${String(eskiDy.ay).padStart(2, '0')}` : '';
    const yeni = d.dogum_ay && d.dogum_yil ? `${d.dogum_yil}-${String(d.dogum_ay).padStart(2, '0')}` : '';
    put('pregnancy.due_date', yeni, eski);
  }
  put3('whatsapp_community.member', d.whatsapp_member, bool3Oku(ref.whatsapp_community?.member));
  // PROFIL [26 Eki]. is_mother / has_agency put3 ile: acik cevap listesine
  // girerler, alan yokken secilen "Hayır" sunucuda varsayilan sanilip
  // atlanmaz. Ajans adi bosaltilinca '' gider; sunucu alani siler.
  put('gender', d.gender || null, ref.gender ?? null);
  // [1 Kas] Anne mi? / Evli mi? -> saklanan iki alan (anneEvliYaz, tek yer).
  const anneEvli = anneEvliYaz(d);
  put3('is_mother', anneEvli.is_mother, bool3Oku(ref.is_mother));
  put3('is_married', anneEvli.is_married, bool3Oku(ref.is_married));
  put3('has_agency', d.has_agency, bool3Oku(ref.has_agency));
  put('agency_name', d.agency_name.trim(), ref.agency_name || '');
  // [Y35] Influencer Hakkinda — bos kutu '' gider, sunucu alani siler.
  put('influencer_hakkinda', String(d.influencer_hakkinda ?? '').trim(), ref.influencer_hakkinda || '');
  put('city', d.city.trim(), ref.city || '');
  put('phone', d.phone.trim(), ref.phone || '');
  put('email', d.email.trim(), ref.email || '');
  put('billing_type', d.billing_type || null, ref.billing_type ?? null);
  put('barter_open', d.barter_open || null, ref.barter_open ?? null);
  // brand_segment: DUZENLEME kartinda ayri bir akista atanıyor (segmentEditing ->
  // patchRecord), o yuzden saveEdit'te hic yoktu. YENI KAYIT formunda ise bir
  // secici var. Ortak kurucuya alindi; duzenleme tarafinda taslak degeri belgeden
  // geldigi icin (startEdit) put onu ASLA gondermez — degismiyorsa govdeye girmez.
  // SEEDING ise segment GONDERILMEZ: kapali secicide kalmis bir deger 400
  // uretmesin. Var olan kayitta seeding'e cevirirken mevcut segmenti sunucu
  // siliyor (uyari formda); burada prev ile ayni deger verilip alan disarida.
  put('brand_segment',
    d.is_seeding_account === 'evet' ? (ref.brand_segment ?? null) : (d.brand_segment || null),
    ref.brand_segment ?? null);
  put('category', d.category, Array.isArray(ref.category) ? ref.category.filter(Boolean) : []);
  put('expertise', d.expertise, Array.isArray(ref.expertise) ? ref.expertise.filter(Boolean) : []);
  // [Y27] MARKALAR — KUTUYA DOKUNULMADIYSA (metin baslangictakiyle ayni) alan govdeye
  // GIRMEZ; sunucunun normallestirdigi liste geri yazilip "degisti" sanilmasin.
  {
    const ilk = markaMetni(ref);
    const simdi = d.markalar ?? ilk;
    if (simdi !== ilk) fields.worked_brands = markaMetniBol(simdi);
  }
  // [Y32] HEDIYELESME — ayni kural: dokunulmadiysa govdeye girmez; bos kutu [] (temizler).
  {
    const ilk = hediyeMetni(ref);
    const simdi = d.hediyeler ?? ilk;
    if (simdi !== ilk) fields.gifted_brands = markaMetniBol(simdi);
  }
  put('rates.ig_story', money(d.ig_story), rates.ig_story ?? null);
  put('rates.ig_reel', money(d.ig_reel), rates.ig_reel ?? null);
  put('rates.tiktok_video', money(d.tiktok_video), rates.tiktok_video ?? null);
  put('rates.youtube_video', money(d.youtube_video), rates.youtube_video ?? null);
  put('rates.youtube_shorts', money(d.youtube_shorts), rates.youtube_shorts ?? null);
  put('rates.combo_reel_story', money(d.combo_reel_story), rates.combo_reel_story ?? null);
  put('rates.ig_collab', money(d.ig_collab), rates.ig_collab ?? null);
  put('rates.ig_ad_15day', money(d.ig_ad_15day), rates.ig_ad_15day ?? null);

  // COCUKLAR [Y16] — bebek / cocuk gruplarindan cocukDizisiKur kurar: govdeye
  // { age_months, ref } (mevcut) ve { age_months } (yeni) gider; sira orijinal
  // indeks, yeniler sonda. Sunucu (vChildren) mevcut girisi ref'ten bulur.
  // KUTUYA DOKUNULMADIYSA HAM AY YAZILIR (yas grubunda gosterim yariya
  // yuvarlaniyor: 86 ay -> "7"; okumak cocugu sessizce iki ay kucultur, §3.6).
  // IKI SAYAC DA BOSSA children GOVDEYE HIC GIRMEZ: "bilinmiyor" alanin
  // YOKLUGU; bos dizi "bakildi, cocugu yok" demek olurdu.
  const cocukKurulum = cocukDizisiKur(d.cocuk);
  if (cocukKurulum) {
    if (cocukKurulum.hata) return { fields, acikCevaplar, hata: cocukKurulum.hata };
    const alanVardi = Array.isArray(ref.children);
    const simdi = new Date();
    const onceki = (alanVardi ? ref.children : []).map((c, i) => ({ age_months: childAgeMonths(c, simdi), ref: i }));
    // ALAN HIC YOKKEN girilen 0 GERCEK BIR DEGISIKLIKTIR: "sorulmadi" -> "yok".
    // Dokunulmamis kayitta dizi (yas + ref sirasi) oncekiyle birebir ayni -> gitmez.
    if (!alanVardi || JSON.stringify(cocukKurulum.dizi) !== JSON.stringify(onceki)) {
      fields.children = cocukKurulum.dizi;
    }
  }
  // [Y35] INSTAGRAM BIO — fields'ta DEGIL (belgede platforms[instagram].bio): ayri
  // govde anahtari instagram_bio; dokunulmadiysa undefined (govdeye girmez).
  const bioIlk = igBioOku(ref).trim();
  const bioSimdi = String(d.instagram_bio ?? bioIlk).trim();
  const instagramBio = bioSimdi !== bioIlk ? bioSimdi : undefined;
  return { fields, acikCevaplar, hata: null, instagramBio };
};

// === COCUK SAYISI ===
// Dizi uzunlugu ile tahmin farkliysa ekip icin is kuyrugu: mukerrer kayit olabilir.
// Cok cocuklu kayitlarin tekillestirilmesi BILINCLI olarak insana birakildi.
function childCountMismatch(doc) {
  const est = doc?.cocuk_sayisi_tahmini;
  if (typeof est !== 'number' || !Number.isFinite(est)) return null;
  const len = Array.isArray(doc?.children) ? doc.children.length : 0;
  return len !== est ? { len, est } : null;
}

// Takipci kolonu MECRA BAZINDA gosterilir. Onceden dizinin en yuksek degeri
// aliniyordu ve hangi mecraya ait oldugu soylenmiyordu: 575 kayitta birden fazla
// platform var ve orada yanlis mecranin sayisi gorunuyordu (or. edakok59 icin
// 5.400K yaziyordu, o TikTok degeri; Instagram'i 1.800K).
const FOLLOWER_ORDER = ['instagram', 'tiktok', 'youtube'];

// Bir mecranin kaydini bulur. Donen deger uc durumu AYIRT EDER:
//   null            -> o mecranin kaydi HIC YOK        -> "n/a"
//   {followers:null}-> kayit var, takipci degeri bos    -> "—"
//   {followers:N}   -> deger var
function platformEntry(doc, platform) {
  const list = Array.isArray(doc?.platforms) ? doc.platforms : [];
  const hit = list.find((p) => String(p?.platform || '').trim().toLowerCase() === platform);
  if (!hit) return null;
  const n = hit.followers;
  return {
    followers: typeof n === 'number' && Number.isFinite(n) ? n : null,
    handle: hit.handle,
    measuredAt: hit.measured_at ?? null,
    source: hit.source ?? null, // tarih bicimlemesi icin: elle mi girildi, goc mu
  };
}

// === TAKIPCI KUTUSU: BINLIK AYIRICI ===
// 100000000 gozle okunamiyor, yanlis basamak sayisi girmek kolay. Kutu artik
// type="text" + inputMode="numeric" (telefonda sayi tusu acilir, masaustunde
// bicimlenmis metin gosterilebilir — type="number" ayirici kabul etmez).
//
// Taslakta HAM RAKAMLAR tutulur, ekranda bicimlenmis hali gosterilir.
// Boylece sunucuya giden deger zaten ayiricisizdir; arka uctaki
// replace(/[\s.]/g,'') ikinci bir guvenlik agi olarak yerinde kalir.
const onlyDigits = (value) => String(value == null ? '' : value).replace(/\D/g, '');

// 1234567 -> "1,234,567"
//
// AYRAC VIRGUL [KARAR Bora, 5 Eyl] — eski adi formatThousandsTr'di ve nokta
// kullaniyordu. Ad artik yanlisti: bicim TR degil, panelin her yerinde gecerli
// olan tek bicim (bkz. SAYI_LOCALE). Iki ayrac bir arada okunurlugu ARTIRMIYOR,
// azaltiyordu: ozet "2.802", tablo "4,700,000", kutu "12.000" yaziyordu.
//
// YALNIZ AYRAC KARAKTERI DEGISTI. Rakam temizleme (onlyDigits), imlec koruma
// (restoreCaretByDigits) ve taslakta HAM RAKAM tutma davranisi aynen duruyor —
// olculdu: kutuya ne yazilirsa yazilsin govdeye yalnizca rakamlar gidiyor,
// ayrac karakteri sunucuya HIC ULASMIYOR.
const formatBinlik = (value) => {
  const d = onlyDigits(value);
  return d.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Imleci "ayni RAKAM sayisindan sonraya" geri koyar. Bu olmadan ortadaki bir
// rakami duzeltince imlec sona firlar — ayirici eklendikce metnin uzunlugu
// degistigi icin tarayici eski konumu koruyamaz.
const restoreCaretByDigits = (el, digitsBefore) => {
  let i = 0;
  let seen = 0;
  while (i < el.value.length && seen < digitsBefore) {
    if (/\d/.test(el.value[i])) seen += 1;
    i += 1;
  }
  el.setSelectionRange(i, i);
};

// Binlik ayirici uygulanan sayi kutusunun ORTAK davranisi — takipci ve ucret
// kutulari bunu paylasir, ayni mantik iki yere yazilmaz.
// onValue'ya HAM rakam dizesi gider ('12000'); ayirici yalnizca goruntudedir.
const thousandsInputProps = (value, onValue) => ({
  type: 'text',
  inputMode: 'numeric',
  autoComplete: 'off',
  value: formatBinlik(value),
  onChange: (e) => {
    const el = e.target;
    const caret = el.selectionStart ?? el.value.length;
    const digitsBefore = onlyDigits(el.value.slice(0, caret)).length;
    onValue(onlyDigits(el.value));
    requestAnimationFrame(() => {
      if (el.isConnected) restoreCaretByDigits(el, digitsBefore);
    });
  },
});

// Profil adresleri YALNIZCA handle'dan turetilir — instagram_url alani KULLANILMAZ,
// tek kaynak handle olsun diye. Bastaki @ temizlenir.
const cleanHandle = (h) => String(h || '').trim().replace(/^@+/, '');
const PROFILE_URL = {
  instagram: (h) => `https://www.instagram.com/${encodeURIComponent(cleanHandle(h))}/`,
  tiktok: (h) => `https://www.tiktok.com/@${encodeURIComponent(cleanHandle(h))}`,
  youtube: (h) => `https://www.youtube.com/@${encodeURIComponent(cleanHandle(h))}`,
};
function profileUrl(platform, handle) {
  const h = cleanHandle(handle);
  if (!h || !PROFILE_URL[platform]) return null;
  return PROFILE_URL[platform](h);
}

// Bir kaydin belirli mecradaki profil adresi. TEK YERDE tanimli — tablo satiri ve
// detay paneli ayni kurali kullanir.
//
// instagram_handle'a YALNIZCA Instagram icin dusulur. Onceden tablo satirinda
// `entry.handle || doc.instagram_handle` yaziyordu ve mecra ayrimi yoktu: kendi
// handle'i olmayan bir TikTok/YouTube kaydi icin Instagram adindan adres
// uretiliyordu, yani var olmayan bir kanala baglanti basiliyordu
// (canli veride 88 YouTube + 13 TikTok girisi — or. youtube.com/@annecocukharitasi).
// O mecranin kendi handle'i yoksa adres YOK: baglanti basilmaz, duz metin kalir.
// UST SEVIYE HANDLE ALANLARI — mecra basina, tek yerde, UC MECRA.
// ONCELIK [Bora, 26 Eki]: ONCE ust seviye alan (kimlik), yoksa mecranin
// platforms girisi. Eskiden tersiydi, cunku platforms[].handle panelden ayrica
// duzenleniyordu ve "son duzenlenen" oydu. Artik elle duzenlenmiyor: ust
// seviye alanin aynasi (sunucu mdbKimlikAynasi). Iki yer ayrismissa (gecmisten
// kalan 17 kayit) dogru olan kimliktir. Giris yalniz ust alan bossa kullanilir
// (gocten gelen, ust alani hic yazilmamis kayitlar).
const UST_SEVIYE_HANDLE = {
  instagram: (doc) => doc?.instagram_handle,
  tiktok: (doc) => doc?.tiktok_handle,
  youtube: (doc) => doc?.youtube_handle,
};

const platformProfileUrl = (doc, platform, entry) =>
  profileUrl(platform, (UST_SEVIYE_HANDLE[platform] ? UST_SEVIYE_HANDLE[platform](doc) : null) || entry?.handle);

// [Y18] Kart izgarasi: kimlik satiri ve dort kolon AYNI oranla hizali kalsin
// diye tek sabit. Profil en genis (kutular + cocuk yasi tek satir), ucret ve
// not dar. minmax(0, …) uzun metnin kolonu sisirmesini engeller; izgaradaki
// [overflow-wrap:anywhere] uzun e-postayi kendi kolonunda kirar (tasmaz).
// Dar / orta ekran (1 / 2 kolon) aynen.
// [Y35, Bora 3 Kas 19:49] BES kolon: en sagda metin kolonu (Instagram bio ustte,
// Influencer Hakkinda altta) — en genisi; diger dort biraz daraldi.
const KART_KOLONLARI = 'xl:grid-cols-[minmax(0,0.8fr)_minmax(0,1.15fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.3fr)]';
// [Y35] Metin hucresi: 6 satirdan uzun ya da 280 karakterden uzunsa "devamı".
const METIN_KISA_KARAKTER = 280;
const METIN_KISA_SATIR = 6;
const metinUzunMu = (v) => {
  const m = String(v || '');
  return m.length > METIN_KISA_KARAKTER || m.split('\n').length > METIN_KISA_SATIR;
};
// [Y35] Influencer Hakkinda: 1.000 YUMUSAK sinir (sayac amber), 4.000 sert (sunucu).
const HAKKINDA_YUMUSAK_SINIR = 1000;
const HAKKINDA_EN_COK = 4000;
const BIO_EN_COK = 1000;
// Ham instagram girisinin bio'su (platformEntry bio tasimiyor — takipci izdusumu).
const igGirisi = (doc) => (Array.isArray(doc?.platforms) ? doc.platforms : [])
  .find((p) => String(p?.platform || '').trim().toLowerCase() === 'instagram') || null;
const igBioOku = (doc) => {
  const ig = igGirisi(doc);
  return ig && typeof ig.bio === 'string' ? ig.bio : '';
};

// === OTURUM ANAHTARI ===
// master-database'in KENDI anahtari. Admin paneli 'admin_token' kullanmaya devam
// ediyor ve iki sayfa birbirinin anahtarini ne okur ne siler.
//
// Onceden ikisi de 'admin_token'a yaziyordu: ayni tarayicida ikisine birden girilince
// ikinci giris birincinin token'ini eziyor, birinden cikmak digerini de dusuruyordu.
// Canlida admin paneli boyle koptu — MDB girisi anahtari ezdi, sonra temizlenince
// admin sekmesi tokensiz kaldi ve her istek 401 aldi.
//
// BU BIR YETKI DEGISIKLIGI DEGIL: ayni admin_users kaydi, ayni sifre, ayni TOTP.
// Degisen tek sey token'in NEREDE saklandigi.
//
// Anahtar TEK YERDE tanimli — bugunku hatanin sinifi tam olarak adin birden fazla
// yerde elle yazilmis olmasiydi.
const MDB_TOKEN_KEY = 'mdb_token';
const mdbTokenOku = () => localStorage.getItem(MDB_TOKEN_KEY);
const mdbTokenYaz = (token) => localStorage.setItem(MDB_TOKEN_KEY, token);
// Yalnizca KENDI anahtarini siler. admin_token'a DOKUNMAZ — eski oturumlari
// temizlemek admin panelinin oturumunu bozardi.
const mdbTokenSil = () => localStorage.removeItem(MDB_TOKEN_KEY);

const TRY_CODES = ['TRY', 'TL', '₺', 'TRL'];

// === ORTAK TARIH BICIMLENDIRICI (ay + yil) ===
// Ekip fiyatin hangi AY alindigini bilmek istiyor, hangi gun degil.
//   normal      -> "07.2026"
//   1 Ocak ise  -> "2025" (yalnizca yil)
// 1 Ocak istisnasi: eski kayitlarda yalnizca YIL biliniyordu ve veritabanina
// 1 Ocak olarak yazilmis. "01.2025" gostermek elimizde olmayan bir ay bilgisini
// varmis gibi sunmak olurdu.
//
// SAAT DILIMI SABIT: Europe/Istanbul. Tarayicinin yereline birakilirsa gece
// yarisina yakin damgalar baska saat diliminde BIR ONCEKI AYA kayar — veride
// bol miktarda 20:59:04 UTC (= 23:59:04 Istanbul) damga var, tam risk bolgesi.
const DISPLAY_TZ = 'Europe/Istanbul';

// 1 OCAK ISTISNASI YALNIZCA GOC KAYNAKLI TARIHLER ICIN.
// Goc sirasinda yalnizca yili bilinen kayitlar 1 Ocak olarak yazildi; o tarihlerde
// "01.2024" yazmak olmayan bir kesinlik iddia eder, dogrusu "2024".
// Ama kural tarihin NEREDEN geldigine bakmiyordu: 1 Ocak'ta ELLE girilmis gercek
// bir tarih de yil olarak gorunuyordu. Yilbasi tatili olmasi bunu nadir kilar ama
// imkansiz kilmaz ve o kayitta ay bilgisi sessizce kayboluyordu.
//
// VARSAYILAN "istisna YOK". Istisna beyaz listeyle acilir (bkz. asagisi):
// kaynagi BILINMEYEN bir tarihte olmayan kesinlik iddia etmek de, olan kesinligi
// gizlemek de yanlis — ama ikincisi daha az zarar veriyor.
function formatMonthYear(value, gocKaynakli = false) {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: DISPLAY_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const year = get('year');
  const month = get('month');
  const day = get('day');
  if (!year || !month) return null;
  if (gocKaynakli && month === '01' && day === '01') return year; // yalnizca yil biliniyordu
  return `${month}.${year}`;
}

// Istisna BEYAZ LISTE ile acilir: yalnizca kaynagi BILINEN goc degerleri.
//
// "manuel/manual DEGILSE goctur" demek yanlis olurdu, cunku null "gocten geldi"
// demek degil, "kaynagi BILINMIYOR" demek — canli veride 1540 kayitta
// quoted_at_source null. Bilinmeyen bir kaynakta 1 Ocak'i yil olarak gostermek,
// var olmayan bir bilgiyi (yalnizca yil biliniyordu) uydurmak olur.
//
// Beyaz listedeki degerler goc script'inin yazdigi kaynak etiketleri; 'goc'
// backfill sonrasi kullanilacak olan.
const UCRET_GOC_KAYNAKLARI = ['satir', 'dosya_adi', 'sheet_adi', 'goc'];
const NOT_GOC_YAZARLARI = ['göç'];
const ucretGocKaynakli = (rates) => UCRET_GOC_KAYNAKLARI.includes(rates?.quoted_at_source);
// Notta provenance ayri bir alanda degil, YAZARIN kendisinde: goc notlarinin author'i
// 'göç', uctan eklenen notlarinki e-posta adresi. Beyaz liste deseni ayni kaliyor.
const notGocKaynakli = (note) => NOT_GOC_YAZARLARI.includes(note?.author);

// E-postadan kisa gosterim: "bora@personaajans.com" -> "bora"
const shortUser = (email) => {
  const local = String(email || '').split('@')[0].trim();
  return local || null;
};

// ============================================================================
// RENDER GUVENLIGI
// React bir NESNEYI dogrudan basamaz; denerse "Minified React error #31" firlatir
// ve TUM agaci cokertir (beyaz sayfa). Tek bir kaydin bozuk verisi butun sayfayi
// dusurmemeli. Bu yuzden belgeden gelen ham degerler JSX'e girmeden once
// safeText()'ten gecirilir.
//
// Canli ornek: campaign_items.deliverables semada NESNE
// ({story_count, reel_count, collab, ad_days}) ama dogrudan basiliyordu —
// kampanyasi olan ilk kayitta sayfa komple beyaz oluyordu.
// ============================================================================
function safeText(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return value.trim() || null;
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : null;
  if (typeof value === 'boolean') return String(value);
  // Date: burada bicimlendirilmez — cagiran taraf fmtDate kullanmali.
  if (value instanceof Date) return null;
  if (Array.isArray(value)) {
    const parts = value.map(safeText).filter(Boolean);
    return parts.length ? parts.join(', ') : null;
  }
  // Duz nesne: basilamaz. null donerek cagiran tarafin '—' gostermesini saglar.
  return null;
}

// campaign_items.deliverables hem METIN hem NESNE olabilir.
// Nesne ise okunabilir ozete cevrilir: {story_count:2, reel_count:1} -> "2 story, 1 reel"
function deliverablesText(value, t) {
  if (typeof value === 'string') return value.trim() || null;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return safeText(value);
  const parts = [];
  const n = (v) => (typeof v === 'number' && Number.isFinite(v) && v > 0 ? v : null);
  if (n(value.story_count)) parts.push(`${value.story_count} story`);
  if (n(value.reel_count)) parts.push(`${value.reel_count} reel`);
  if (value.collab) parts.push(t.deliverableCollab);
  if (n(value.ad_days)) parts.push(`${value.ad_days} ${t.deliverableAdDays}`);
  return parts.length ? parts.join(', ') : null;
}

// === SATIR SEVIYESI HATA SINIRI ===
// safeText() bilinen alanlari koruyor, ama ileride eklenecek bir alan yine nesne
// olabilir. Error boundary olmadan tek bir bozuk kayit TUM sayfayi beyaza dusuruyor.
// Bu sinir sayesinde yalnizca o satirin detayi "gosterilemedi" der, tablo ayakta kalir.
// (Error boundary React'te SADECE class bilesenle yazilabilir.)
class RowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('Master database satir render hatasi:', error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <div
          className="px-3 py-2.5 text-[12px] text-[#A34940] bg-[#F9E5E2] border-t-[0.5px] border-[#E4E1DC]"
          data-testid="master-db-row-error"
        >
          {this.props.message}
        </div>
      );
    }
    return this.props.children;
  }
}

// Auth ekranlari icin ortak kart (admin gorsel dili). Bilesen DISINDA tanimli: iceride
// tanimlansaydi her render'da yeni bir tip olusur ve React alt agaci remount ederdi.
const CenteredCard = ({ borderClass, children }) => (
  <div className="min-h-screen bg-black flex items-center justify-center p-4 relative">
    <div className="absolute inset-0 opacity-5 pointer-events-none">
      <div className="absolute top-20 left-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#FFDD59] rounded-full blur-3xl"></div>
    </div>
    <div className={`relative z-10 max-w-md w-full bg-gray-900 border-2 ${borderClass} rounded-2xl p-8 shadow-2xl text-center`}>
      {children}
    </div>
  </div>
);

// === FILTRE PANELI SABITLERI ===

// Mecra rozetleri: ana uclu + "Diger" akordiyonu. Deger = API'ye giden platforms.platform degeri.
const PLATFORM_MAIN = [
  { value: 'instagram', label: 'IG' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'youtube', label: 'YT' },
];
// "Diger" akordiyonundaki rozetler SABIT DEGIL, veriden uretilir.
// Onceden Podcast/X/Pinterest sabit listeden geliyordu ama veritabaninda bu uc
// mecradan hic kayit yok; hangisine basilsa sonuc bos donuyordu.
// Ana ucluden (IG/TikTok/YT) farkli olan ve koleksiyonda en az bir kaydi bulunan
// degerler gosterilir. Liste acilista bir kez cekilir (bkz. /master-database/cities).
const PLATFORM_MAIN_VALUES = PLATFORM_MAIN.map((p) => p.value);

// "Diger" — UC MECRANIN HICBIRINDE kullanilabilir adres yok.
// Sunucudaki MASTER_DB_PLATFORM_NONE ile AYNI deger; panel yalnizca bayragi
// gonderiyor, kurali sunucu kuruyor (mdbHandleVarIfadesi).
// TURETILMIS, saklanan bayrak DEGIL: handle girildigi an kayit bu kumeden
// kendiliginden cikar.
// "Diger" AKORDIYONUYLA KARISTIRILMAMALI — o akordiyon veriden uretilen BASKA
// MECRALARI listeler; bu rozet MECRASIZLIGI gosterir.
const PLATFORM_NONE = 'none';

// === SEGMENT ROZETLERI ===
// brand_segment TEK DEGER; sozluk sekiz etiket: A, AB, B, BC, C, MAB, MB, K.
// Rozetler sozlugun TAMAMI — her etiket dogrudan secilebilir.
//
// Secim DUZ OR, diger filtrelerle ayni: A+B secmek "A VEYA B" demektir.
//
// ONCEDEN: yalnizca alti rozet vardi (A,B,C,MAB,MB,K) ve A/B/C secimi tek bir
// etikete BIRLESIYORDU: A+B -> 'AB', B+C -> 'BC'. Bu kural KALDIRILDI, cunku
//   - AB ve BC rozet olarak yoktu; degerlere ancak DOLAYLI olarak, iki harfi
//     birlikte secerek ulasilabiliyordu (AB icin A+B, BC icin B+C);
//   - bunun bedeli OR'in kaybolmasiydi: "A veya B" (565 kayit) ifade edilemiyordu,
//     cunku A+B secimi 'AB' segmentine (163 kayit) cozuluyordu;
//   - "A veya AB", "AB veya BC" gibi secimler hic kurulamiyordu;
//   - sozluk disi kombinasyonlar (A+C, A+B+C) sessizce OR'a dusuyordu, yani ayni
//     arayuz bazen birlestirme bazen OR yapiyordu — tahmin edilemez;
//   - segment tek basina diger filtrelerden farkli davraniyordu ve bunu ekranda
//     soyleyen tek sey rozetlerin altindaki kucuk "→ AB" satiriydi.
// DAVRANIS DEGISIKLIGI: ?segment=A,B iceren eski bir baglanti artik 'AB' degil
// "A veya B" dondurur. Bilincli tercih.
//
// 'none' sozluk degeri DEGIL: brand_segment'i atanmamis kayitlari filtreler
// (backend'de null/yok/bos string). Diger rozetlerle OR'lanir: segment=A,none.
// Panelde "Yok" olarak gorunur.
const SEGMENT_NONE = 'none';
// Sozlukteki tum gecerli degerler.
// KADEME SIRASI — sunucudaki MASTER_DB_SEGMENT_SIRASI ile AYNI.
//   A · AB · MAB · B · MB · BC · MBC · C · K
// Sira kademe komsuluguna dayaniyor, alfabeye degil: MAB "muhafazakar A ve AB"
// karsiligi oldugu icin AB'den hemen sonra, MB de B'den hemen sonra.
// Hem sol paneldeki ROZETLERIN sirasi hem tablodaki SIRALAMA bu diziden
// besleniyor; iki yerde iki sira olsaydi ayni dokuz deger tabloda bir duzende,
// panelde baska duzende gorunurdu.
// Sema §3.7'nin alfabetik SOZLUK sirasiyla bilerek catisiyor: sozluk gecerli
// degerleri sayar, bu GORUNTULEME sirasi. Dogrulama sunucuda.
const SEGMENT_DICTIONARY = ['A', 'AB', 'MAB', 'B', 'MB', 'BC', 'MBC', 'C', 'K'];
const SEGMENT_CHIPS = [...SEGMENT_DICTIONARY, SEGMENT_NONE];

// FIYAT GUNCELLIGI (eski adi "veri tazeligi") — uc durum, coklu secim.
// Sunucudaki MASTER_DB_TAZELIK_DURUMLARI ile AYNI degerler; esik ve hesap
// sunucuda — arayuz kurali yeniden yazmaz, yaniti okur. [Y25, Bora 2 Kas]
// Filtre ve tablo rengi YALNIZ fiyat tarihine bakar (fiyat_durumu,
// mdbFiyatTarihiIfadesi); "Bilgi guncellendi" kolonu tarihi bes kaynaktan, renksiz.
const TAZELIK_DURUMLARI = ['taze', 'bayat', 'bilinmiyor'];
// ESIK BURADA YOK — bilerek. Kova karari SUNUCUDA veriliyor (tazelik_durumu)
// ve panel yalnizca okuyup boyuyor. Esigin bir kopyasi burada dursaydi iki
// taraf ayrisabilirdi; ustelik ilk yazimda tam da o kopya yuzunden "bilinmiyor"
// ile "bayat" ayni renge dusmustu.
const TAZELIK_GORUNUM = {
  taze: 'text-[#9B978E]',        // notr/sade — is yok
  bayat: 'text-[#8A6A20]',       // uyari — guncellenmeli
  bilinmiyor: 'text-[#C4C0B8]',  // NOTR ve SOLUK — bayat DEGIL, hic bilgi yok
};

// Secimi API'nin bekledigi virgullu listeye cevirir. Birlestirme YOK — secilen
// ne ise o gider. Sira SEGMENT_CHIPS sirasinda sabitlenir ki ayni secim her
// zaman ayni URL'i uretsin (onbellek ve paylasilan baglanti icin onemli).
function segmentsToParam(selected) {
  return SEGMENT_CHIPS.filter((s) => selected.includes(s)).join(',');
}

// Kontrollu kategori listesi
// Duzenleme formundaki secenekler — backend dogrulayicisiyla ayni degerler.
const BILLING_TYPES = ['fatura', 'istisna'];
const BARTER_VALUES = ['evet', 'hayır', 'kararsız'];

const CATEGORIES = [
  'Anne - Bebek', 'Anne - Çocuk', 'Anne - Hamile', 'Lifestyle', 'Yemek', 'Sağlık',
  'Kozmetik', 'Ev & Dekorasyon', 'Moda & Giyim', 'Seyahat', 'Spor', 'Teknoloji',
  'Eğitim', 'Bilgisel', 'Ürün İnceleme', 'Mizah & Komedi', 'Diğer',
];

// Uc kademeli uzmanlik agaci. Ust dal secilirse alt dallar da KAPSANIR (API'ye
// ust dal + tum alt dallar virgullu gider). Alt dal secilirse ust dal secimi kalkar.
const EXPERTISE_TREE = [
  { name: 'Ebe' },
  { name: 'Doktor', children: ['Çocuk doktoru', 'Kadın doğum', 'Fizyoterapist'] },
  { name: 'Hemşire', children: ['Bebek hemşiresi', 'Yenidoğan hemşiresi', 'Çocuk hemşiresi'] },
  { name: 'Emzirme danışmanı' },
  { name: 'Uyku danışmanı', children: ['Bebek uyku danışmanı', 'Bebek uyku eğitmeni'] },
  { name: 'Çocuk gelişim', children: ['Çocuk gelişim uzmanı', 'Çocuk gelişimi öğretmeni'] },
  { name: 'Psikolog', children: ['Klinik psikolog', 'Çocuk psikoloğu'] },
  { name: 'Diyetisyen' },
  { name: 'Eczacı' },
  { name: 'Ebeveyn koçu' },
  { name: 'Egzersiz uzmanı' },
  { name: 'Gıda mühendisi' },
  { name: 'Öğretmen' }, // [Y21] okuyucu v1.10.0 UZMANLIK ile ayni; alt dal yok
];
// Duzenleme formunda rozet olarak sunulan tum uzmanlik degerleri (ust + alt dallar)
const EXPERTISE_FLAT = EXPERTISE_TREE.flatMap((n) =>
  Array.isArray(n.children) ? [n.name, ...n.children] : [n.name]
);

const expertiseParentOf = (child) =>
  EXPERTISE_TREE.find((p) => Array.isArray(p.children) && p.children.includes(child));
// Secilen dugumu API degerlerine cevirir: ust dal ise kendisi + tum alt dallari
const expandExpertise = (name) => {
  const node = EXPERTISE_TREE.find((p) => p.name === name);
  return node && Array.isArray(node.children) ? [node.name, ...node.children] : [name];
};

// Segment secim kurali: duz ac/kapa. Kisit yok — her rozet serbestce secilir.
// Sira SEGMENT_CHIPS sirasinda tutulur ki secim listesi deterministik olsun.
function nextSegments(current, value) {
  const next = current.includes(value)
    ? current.filter((s) => s !== value)
    : [...current, value];
  return SEGMENT_CHIPS.filter((s) => next.includes(s));
}

// Uzmanlik agaci secim kurali (saf fonksiyon).
// Ust dal secilirse alt dallari secimden cikar; alt dal secilirse ust dali cikar.
function nextExpertise(current, name) {
  if (current.includes(name)) return current.filter((n) => n !== name);
  let next = [...current];
  const node = EXPERTISE_TREE.find((p) => p.name === name);
  if (node && node.children) {
    next = next.filter((n) => !node.children.includes(n));
  } else {
    const parent = expertiseParentOf(name);
    if (parent) next = next.filter((n) => n !== parent.name);
  }
  return [...next, name];
}

function pageCount(total, limit) {
  return Math.max(1, Math.ceil((Number(total) || 0) / limit));
}

// Acik detay paneli yeni listede de duruyor mu? Duruyorsa acik kalir, yoksa kapanir.
// Siralama/sayfa degisimi kaydi listeden cikarmayabilir — sebepsiz kapatilmasin.
function keepOpenId(prev, items) {
  if (!prev) return null;
  return (items || []).some((d) => d && d._id === prev) ? prev : null;
}

// ============================================================================
// URL DURUMU
// Filtre/arama/sekme/sayfa/siralama URL query parametrelerinde tutulur. Boylece:
//  - yenileme durumu kaybetmez,
//  - geri tusu bir onceki gorunume doner (sayfadan atmaz),
//  - ekip birbirine "su filtreyle bak" diye link gonderebilir.
// URL TEK DOGRULUK KAYNAGI; ayrica useState'te kopyasi tutulmaz (senkron hatasi olmasin).
//
// NOT: segment ve expertise URL'de KULLANICI SECIMI olarak durur (or. 'A,MAB' /
// 'Doktor'), API'ye giden turetilmis hali degil ('AB,MAB' / alt dallar dahil liste).
// Aksi halde link acildiginda panelde yanlis rozetler isaretli gorunurdu.
// ============================================================================
const URL_DEFAULT_TAB = 'all';

// === PROFIL FILTRELERI — ANNE · CINSIYET · AJANS [KARAR Bora, 26 Eki] ===
// Filtre durumunda her grup SECILI DEGERLERIN dizisi. Grup basina:
//   bir deger secili     -> o kosul (sunucu: anne=evet ...)
//   ikisi de / hicbiri   -> filtre YOK
// VARSAYILAN Kadın + Anne (Hamile kilitli ve dahil): URL'de parametre YOKSA
// gorunum bunlarla acilir ve istek bunlarla gider. Grupta hic cip secili degilse URL'ye <grup>=tumu
// yazilir — varsayilandan ayrilsin. Sunucuda parametre yoksa filtre yok;
// varsayilan YALNIZ panelin isi (Excel'e aktar ve idler de panelden ayni
// parametreleri aliyor).
// [1 Kas] anne UC degerli (Evet · Potansiyel · Hayır). Eski anne=evet
// baglantilari aynen calisir (tek deger secili).
// [Y18f, Bora 2 Kas 09:32] varsayilan Kadın + Anne: anne = ['evet'] (1 Kas -
// Y18e arasi ['evet', 'potansiyel'] idi). Hamile listeye YAZILMAZ: Anne
// seciliyken kilitli ve dahil (Y18d). anne=evet artik varsayilanla ayni,
// URL'ye yazilmaz; evet,potansiyel secilirse yazilir.
// [Y18d, Bora 2 Kas 07:56] anne grubunun DORDUNCU degeri 'hamile' (eski ayri
// "Hamile" onay kutusu kalkti). Anlam grup ici VEYA — anneFiltreDegerleri.
const PROFIL_FILTRE_DEGERLERI = {
  anne: ['evet', 'hamile', 'potansiyel', 'hayir'], cinsiyet: ['kadin', 'erkek'], ajans: ['var', 'yok'],
};
// anne_durumu'nun uc degeri (lib ANNE_DURUMLARI ile ayni; sunucu orada kuruyor).
const ANNE_DURUM_DEGERLERI = ['evet', 'potansiyel', 'hayir'];
const PROFIL_FILTRE_VARSAYILAN = { anne: ['evet'], cinsiyet: ['kadin'], ajans: [] };
const PROFIL_FILTRE_TUMU = { anne: [], cinsiyet: [], ajans: [] };
const PROFIL_TUMU = 'tumu';
// [Y32b] Anne ya da Hamile seciliyse Kadın secili ve kilitli (anne ⊂ kadın).
const anneKadinGerektirir = (anne) => Array.isArray(anne) && (anne.includes('evet') || anne.includes('hamile'));
const ayniKume = (a, b) => a.length === b.length && a.every((x) => b.includes(x));

// URL -> { anne, cinsiyet, ajans }. Parametre yok -> varsayilan; 'tumu' -> [].
// ESKI pregnant=1 BAGLANTILARI [Y18d]: anne = ['hamile']. Eski anlam
// "varsayilan anne ∩ hamile" = yalniz hamileler; sonuc ayni. Panel pregnant'i
// artik YAZMIYOR ve GONDERMIYOR (sunucu geriye uyum icin hala kabul ediyor).
function profilFiltreleriOku(params) {
  const out = {};
  for (const [g, izinli] of Object.entries(PROFIL_FILTRE_DEGERLERI)) {
    if (!params.has(g)) {
      out[g] = [...PROFIL_FILTRE_VARSAYILAN[g]];
      continue;
    }
    const v = (params.get(g) || '').split(',').map((x) => x.trim()).filter(Boolean);
    out[g] = v.includes(PROFIL_TUMU) ? [] : izinli.filter((x) => v.includes(x));
  }
  const eskiHamile = params.get('pregnant');
  if (eskiHamile === '1' || eskiHamile === 'true') out.anne = ['hamile'];
  // [Y32b, Bora 3 Kas 12:28] "Anne seciliyse Hamile ve Kadın da secili olmali."
  // Anne / Hamile secili ama Kadın yoksa (or. eski anne=evet&cinsiyet=tumu) Kadın eklenir.
  if (anneKadinGerektirir(out.anne) && !out.cinsiyet.includes('kadin')) out.cinsiyet = [...out.cinsiyet, 'kadin'];
  return out;
}

// Gorunum -> URL. Varsayilanla ayni grup yazilmaz; bos grup 'tumu'.
function profilFiltreleriYaz(p, f) {
  for (const g of Object.keys(PROFIL_FILTRE_DEGERLERI)) {
    const sec = f[g] || [];
    if (ayniKume(sec, PROFIL_FILTRE_VARSAYILAN[g])) continue;
    p.set(g, sec.length ? sec.join(',') : PROFIL_TUMU);
  }
}

// ANNE GRUBU KURALI — sunucudaki buildMasterDbQuery ile AYNI karar (test iki
// tarafi ayni girdilerde karsilastiriyor). null = filtre yok.
//   evet + potansiyel + hayir UCU secili -> filtre yok, hamile ne olursa olsun
//     (erkekler de girer — bugunku "hepsi = filtre yok").
//   hamile + evet -> hamile fazlalik, duser (hamile ⊂ anne, profil kurali 4).
//   aksi halde anne_durumu ∈ secili durumlar VEYA pregnancy.is_pregnant: true.
function anneFiltreDegerleri(secim) {
  const sec = secim || [];
  const durumlar = ANNE_DURUM_DEGERLERI.filter((x) => sec.includes(x));
  if (durumlar.length === ANNE_DURUM_DEGERLERI.length) return null;
  const hamile = sec.includes('hamile') && !durumlar.includes('evet');
  const out = PROFIL_FILTRE_DEGERLERI.anne.filter((x) => (x === 'hamile' ? hamile : durumlar.includes(x)));
  return out.length ? out : null;
}

// Gorunum -> API. Grupta 0 ya da TUM degerler secili -> parametre yok (filtre
// yok); aksi halde secilenler virgulle, grubun kendi sirasiyla. Anne grubu
// kendi kuraliyla (anneFiltreDegerleri).
function profilFiltreApi(f) {
  const p = {};
  for (const [g, izinli] of Object.entries(PROFIL_FILTRE_DEGERLERI)) {
    if (g === 'anne') {
      const a = anneFiltreDegerleri(f.anne);
      if (a) p.anne = a.join(',');
      continue;
    }
    const sec = izinli.filter((x) => (f[g] || []).includes(x));
    if (sec.length > 0 && sec.length < izinli.length) p[g] = sec.join(',');
  }
  return p;
}

// Yalnizca varsayilandan FARKLI olanlar yazilir — URL kisa ve okunur kalir.
function viewToParams(view) {
  const p = new URLSearchParams();
  const f = view.filters;
  // Tumu'de (null) parametre yok; hicbiri secili degilse sekmeler= (bos).
  if (view.sekmeler) p.set('sekmeler', view.sekmeler.join(','));
  if (view.page > 1) p.set('page', String(view.page));
  if (view.sort) {
    p.set('sort', view.sort);
    if (view.dir) p.set('dir', view.dir);
  }
  if (view.q) p.set('q', view.q);
  if (f.favorite) p.set('favorite', '1');
  if (f.platforms.length) p.set('platform', f.platforms.join(','));
  if (f.segments.length) p.set('segment', f.segments.join(','));
  if (f.categories.length) p.set('category', f.categories.join(','));
  if (f.marka) p.set('marka', f.marka);
  if (f.hediye) p.set('hediye', f.hediye);
  if (f.expert) p.set('expert', '1');
  if (f.expertise.length) p.set('expertise', f.expertise.join(','));
  if (f.tazelik.length) p.set('tazelik', f.tazelik.join(','));
  if (f.ucretYok) p.set('ucret_yok', '1');
  if (f.followersMin !== '') p.set('followers_min', String(f.followersMin));
  if (f.followersMax !== '') p.set('followers_max', String(f.followersMax));
  if (f.rateStoryMin !== '') p.set('rate_story_min', String(f.rateStoryMin));
  if (f.rateStoryMax !== '') p.set('rate_story_max', String(f.rateStoryMax));
  if (f.rateReelMin !== '') p.set('rate_reel_min', String(f.rateReelMin));
  if (f.rateReelMax !== '') p.set('rate_reel_max', String(f.rateReelMax));
  if (f.babyMin !== '') p.set('baby_min', String(f.babyMin));
  if (f.babyMax !== '') p.set('baby_max', String(f.babyMax));
  if (f.childMin !== '') p.set('child_min', String(f.childMin));
  if (f.childMax !== '') p.set('child_max', String(f.childMax));
  if (f.city) p.set('city', f.city);
  if (f.childrenMin !== '') p.set('children_min', String(f.childrenMin));
  if (f.childrenMax !== '') p.set('children_max', String(f.childrenMax));
  if (f.whatsapp) p.set('whatsapp', '1');
  if (f.barter) p.set('barter', '1');
  profilFiltreleriYaz(p, f);
  return p;
}

// URL -> sekme secimi (null = Tumu). Bilinmeyen ad atilir (sunucu 400 verirdi).
// ESKI LINKLER (Y5 ve oncesi) burada cevrilir; sunucu eski parametreleri artik
// kabul etmiyor:
//   tab=seeding    -> sekmeler=seeding
//   gizle=x,y      -> Tumu eksi x,y
const urlSekmeSecimi = (params) => {
  const csvOf = (v) => (v || '').split(',').map((x) => x.trim()).filter(Boolean);
  if (params.has('sekmeler')) return sekmeSecimi(csvOf(params.get('sekmeler')));
  const eskiTab = params.get('tab');
  if (eskiTab && SECILEBILIR_SEKMELER.includes(eskiTab)) return [eskiTab];
  const gizle = csvOf(params.get('gizle'));
  if (gizle.length) return sekmeSecimi(SECILEBILIR_SEKMELER.filter((k) => !gizle.includes(k)));
  return null;
};
const ESKI_SEKME_URL_PARAMETRELERI = ['tab', 'gizle'];

function paramsToView(params) {
  const get = (k) => params.get(k) || '';
  const csv = (k) => (get(k) ? get(k).split(',').map((x) => x.trim()).filter(Boolean) : []);
  const bool = (k) => get(k) === '1' || get(k) === 'true';
  const num = (k) => {
    const v = get(k);
    if (v === '') return '';
    const n = parseInt(v, 10);
    return Number.isNaN(n) ? '' : String(n);
  };
  const sort = SORTABLE[get('sort')] ? get('sort') : null;
  const dirRaw = get('dir');
  const pageRaw = parseInt(get('page'), 10);
  return {
    sekmeler: urlSekmeSecimi(params),
    page: Number.isNaN(pageRaw) || pageRaw < 1 ? 1 : pageRaw,
    sort,
    // dir yalnizca gecerli bir sort varsa anlamli; gecersiz deger varsayilana duser
    dir: sort ? (dirRaw === 'asc' || dirRaw === 'desc' ? dirRaw : 'desc') : 'desc',
    q: get('q'),
    filters: {
      favorite: bool('favorite'),
      platforms: csv('platform'),
      segments: csv('segment').filter((x) => SEGMENT_CHIPS.includes(x)),
      categories: csv('category'),
      marka: get('marka').trim(),
      hediye: get('hediye').trim(),
      expert: bool('expert'),
      expertise: csv('expertise'),
      tazelik: csv('tazelik').filter((x) => TAZELIK_DURUMLARI.includes(x)),
      ucretYok: bool('ucret_yok'),
      followersMin: num('followers_min'),
      followersMax: num('followers_max'),
      rateStoryMin: num('rate_story_min'),
      rateStoryMax: num('rate_story_max'),
      rateReelMin: num('rate_reel_min'),
      rateReelMax: num('rate_reel_max'),
      babyMin: num('baby_min'),
      babyMax: num('baby_max'),
      childMin: num('child_min'),
      childMax: num('child_max'),
      city: get('city'),
      childrenMin: num('children_min'),
      childrenMax: num('children_max'),
      whatsapp: bool('whatsapp'),
      barter: bool('barter'),
      ...profilFiltreleriOku(params),
    },
  };
}

// Kuyruk kartinda kac satir onizlenir. Tamami degil: bir Taslak yuzlerce satir
// olabilir ve kart okunamaz hale gelir. Kalan sayi altta yaziyor.
const UPLOAD_SATIR_ONIZLEME = 12;

// Karar VERILMIS durumlar: "Karar verildi" etiketi bunlarda gorunur.
// [Sil] bu diziden OKUMUYOR: silme kurali sunucuda (uploadSilinebilirMi) ve
// listedeki her kayda `silinebilir` olarak geliyor — satirsiz 'yuklendi'
// kaydinin olu oldugunu yalnizca sunucu bilebilir (upload_rows'u goruyor).
const UPLOAD_KARAR_VERILDI = ['yazildi', 'kismi_yazildi', 'geri_gonderildi'];

// Kimlik cakismasi satirinda mecra adi. Alanlar sunucudaki
// MDB_TEKIL_HANDLE_ALANLARI'ndan geliyor; bilinmeyen bir alan gelirse adi
// oldugu gibi basilir, satir kaybolmaz.
const KIMLIK_MECRA_ADI = { instagram_handle: 'Instagram', tiktok_handle: 'TikTok', youtube_handle: 'YouTube' };
// KISININ ADI — IG > TikTok > YouTube (sunucudaki anahtar sirasi). Instagram
// zorunlu degil (26 Ekim); IG disi ad mecra etiketiyle gosterilir: "@x · TikTok".
const KIMLIK_SIRASI = ['instagram_handle', 'tiktok_handle', 'youtube_handle'];
const ilkKimlik = (doc) => {
  const alan = KIMLIK_SIRASI.find((a) => doc && typeof doc[a] === 'string' && doc[a].trim() !== '');
  return alan ? { alan, deger: doc[alan] } : null;
};
const kimlikEtiketi = (k) => {
  if (!k || !k.deger) return '—';
  return k.alan && k.alan !== 'instagram_handle'
    ? `@${k.deger} · ${KIMLIK_MECRA_ADI[k.alan] || k.alan}`
    : `@${k.deger}`;
};
// Iki bicim: v2 (26 Ekim) girisleri k.kimlik / rakip_satir.kimlik tasiyor;
// daha once saklanmis girisler instagram_handle tasiyor — ikisi de kirilmadan.
const kimlikCakismasiMetni = (t, k) => {
  const kim = k.kimlik ? kimlikEtiketi(k.kimlik) : `@${k.instagram_handle || '—'}`;
  const ortak = (sablon) => sablon
    .replace('{kim}', kim)
    .replace('{mecra}', KIMLIK_MECRA_ADI[k.alan] || k.alan)
    .replace('{deger}', k.deger);
  if (k.rakip) {
    const rk = ilkKimlik(k.rakip);
    return ortak(t.planIdentityDb)
      .replace('{rakip}', rk ? kimlikEtiketi(rk) : '—')
      .replace('{ad}', k.rakip.full_name || '—');
  }
  const r = k.rakip_satir || {};
  if (k.kimlik) {
    return ortak(t.planIdentityFilePerson)
      .replace('{x}', k.deger)
      .replace('{y}', r.kimlik ? r.kimlik.deger : '—')
      .replace('{sheet}', r.sheet || '—')
      .replace('{satir}', r.satir != null ? r.satir : '—');
  }
  return ortak(t.planIdentityFile)
    .replace('{rakip}', r.instagram_handle || '—')
    .replace('{sheet}', r.sheet || '—')
    .replace('{satir}', r.satir != null ? r.satir : '—');
};

// Plan hucrelerinde deger gosterimi. null/undefined bos gorunmeli, nesneler
// tabloyu patlatmamali.
// === SAYI BICIMI — TEK KAYNAK ===
// [KARAR Bora, 5 Eyl] binlik = VIRGUL, ondalik = NOKTA:
//   4,700,000 · 12,000 · 12,000.50
// ⚠ Bu TURKCE STANDARDININ TERSI ve BILINCLI. Turkce'de binlik nokta,
// ondalik virguldur; arayuz dili 'tr' olsa bile bu bicim degismiyor —
// bu yuzden locale degiskeni DEGIL sabit bir locale kullaniliyor.
//
// KAPSAM YALNIZ GORUNUM. Giris kutularinin ICI bu fonksiyondan gecmez
// (istisna [Y18d]: sol paneldeki FILTRE sayi kutulari — SayiKutusu; filtre
// durumu yine ham sayi, kayda hicbir sey yazmiyor). Kayit kutusunda metne
// cevirmek YAZMA yolunu degistirirdi — canlida 12 ondalikli ucret var ve
// ucunun sebebi zaten ayrac karisikligi ("200,1000" -> 200.1). Excel disa aktarma da HAM SAYI
// yazmaya devam ediyor: Turkce Excel "12,000"i 12 diye okur (§7.9).
const SAYI_LOCALE = 'en-US';

// Tam sayida ondalik basilmaz, kesirlide TAM IKI basamak: 12,000 · 12,000.50
const fmtSayi = (n) => n.toLocaleString(SAYI_LOCALE, Number.isInteger(n)
  ? undefined
  : { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// === FILTRE SAYI KUTUSU — BINLIK AYRAC KUTUNUN ICINDE [Y18d, Bora 2 Kas 07:56] ===
// Onceden type="number" kutu + altinda "12,000" onizleme satiri vardi. Artik
// kutu metin (inputMode numeric) ve ICINDE fmtSayi bicimi duruyor — tablodaki
// "100,000" ile ayni. Filtre durumu ve URL HAM sayi tasir (rate_reel_min=100000):
// yazilan / yapistirilan metinden yalniz RAKAMLAR alinir ("100.000" ve
// "100,000" -> 100000), bastaki sifirlar atilir (tek "0" kalir), en cok 12 rakam.
// Yalniz FILTRE kutulari; kayit duzenleme kutulari (thousandsInputProps) ayri.
const SAYI_KUTUSU_EN_COK = 12;
const yalnizRakam = (metin) => String(metin ?? '').replace(/[^0-9]/g, '');
const bastakiSifirlar = (r) => r.length - r.replace(/^0+(?=[0-9])/, '').length;
const hamSayi = (metin) => {
  const r = yalnizRakam(metin);
  return r.slice(bastakiSifirlar(r)).slice(0, SAYI_KUTUSU_EN_COK);
};
// Ham ya da bicimli girdi -> kutuda gorunen metin. Bos -> bos ("0" yazilmaz).
const binlikBicim = (ham) => {
  const r = hamSayi(ham);
  return r === '' ? '' : fmtSayi(Number(r));
};
// Bicimli metinde n'inci rakamin HEMEN SAGI. Imlec bununla korunur: ayrac
// eklenince / kalkinca imlec sona ziplamaz, solundaki rakam sayisi ayni kalir.
const rakamSonrasiKonum = (bicimli, n) => {
  if (n <= 0) return 0;
  let gorulen = 0;
  for (let i = 0; i < bicimli.length; i += 1) {
    if (/[0-9]/.test(bicimli[i])) {
      gorulen += 1;
      if (gorulen === n) return i + 1;
    }
  }
  return bicimli.length;
};
// Yazilan metin + imlec -> imlecin solunda kalacak HAM rakam sayisi (atilan
// bastaki sifirlar ve 12 sinirindan sonra).
const imlecSolRakam = (metin, imlec) => {
  const sol = yalnizRakam(String(metin ?? '').slice(0, imlec ?? 0)).length;
  const ham = hamSayi(metin);
  return Math.max(0, Math.min(ham.length, sol - bastakiSifirlar(yalnizRakam(metin))));
};

// Kendi imleci oldugu icin BILESEN (ref + layout effect); panel yardimcisi
// numberInput bunu cagiriyor. min / max nitelikleri YOK: type="number"te de
// tarayici yazmayi engellemiyordu (yalniz oklar / dogrulama ipucu), davranis
// farki yok — sinirlar sunucuda.
function SayiKutusu({ value, onChange, placeholder, testId }) {
  const ref = useRef(null);
  const imlec = useRef(null);
  const [, yenile] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (imlec.current === null || !el) return;
    const k = rakamSonrasiKonum(el.value, imlec.current);
    imlec.current = null;
    if (el.ownerDocument.activeElement === el) el.setSelectionRange(k, k);
  });
  return (
    <input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={binlikBicim(value)}
      placeholder={placeholder}
      onChange={(e) => {
        const { value: metin, selectionStart } = e.target;
        imlec.current = imlecSolRakam(metin, selectionStart);
        onChange(hamSayi(metin));
        // Ham deger degismediyse (harf yazildi) de imlec yerine otursun.
        yenile((x) => x + 1);
      }}
      className="w-full text-[12px] h-[29px] px-[5px] bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] tabular-nums outline-none focus:border-[#CAC6BF]"
      data-testid={testId}
    />
  );
}

const gosterDeger = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (Array.isArray(v)) return v.join(', ');
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

// [Y31] Onay ekraninda platforms.<mecra>.bio: alan adi yerine "Instagram bio",
// deger tek satirda 80 karakterde "…" ile kesilir.
const BIO_ALAN_DESENI = /^platforms\.([a-z]+)\.bio$/;
const planBioMu = (alan) => BIO_ALAN_DESENI.test(String(alan || ''));
const planBioDegeri = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const tek = String(v).replace(/\s+/g, ' ').trim();
  return tek.length > 80 ? `${tek.slice(0, 80)}…` : tek;
};

// 409 govdesindeki ozet nesnesini tek satira indirger.
const ozetMetni = (o) => {
  if (!o) return '—';
  return [
    ['yeni_kayit', o.yeni_kayit], ['degisen_kayit', o.degisen_kayit],
    ['doldurulan', o.doldurulan], ['ezilen', o.ezilen], ['cakisan', o.cakisan],
  ].filter(([, n]) => n > 0).map(([k, n]) => `${k}: ${n}`).join(' · ') || '—';
};

// Durum rozetleri. 'kismi_yazildi' UYARI rengi: bir kismi yazildi, hepsi degil.
const UPLOAD_DURUM_SINIF = {
  yuklendi: 'bg-[#F3F1EE] text-[#6D6960]',
  plan_hazir: 'bg-[#F6EBD3] text-[#8A6A28]',
  yazildi: 'bg-[#E8F3E8] text-[#3D6B3D]',
  kismi_yazildi: 'bg-[#FAEFD5] text-[#8A6A20]',
  geri_gonderildi: 'bg-[#FBEDEC] text-[#A34940]',
  hata: 'bg-[#FBEDEC] text-[#A34940]',
};

const EMPTY_FILTERS = {
  favorite: false,
  platforms: [],
  segments: [],
  categories: [],
  marka: '',
  hediye: '',
  expert: false,
  expertise: [],
  tazelik: [],
  ucretYok: false,
  followersMin: '',
  followersMax: '',
  rateStoryMin: '',
  rateStoryMax: '',
  rateReelMin: '',
  rateReelMax: '',
  babyMin: '',
  babyMax: '',
  childMin: '',
  childMax: '',
  city: '',
  childrenMin: '',
  childrenMax: '',
  whatsapp: false,
  barter: false,
  // Profil gruplari "bos" degil VARSAYILAN: temizle Kadın + Anne'ye (Hamile dahil) doner.
  ...PROFIL_FILTRE_VARSAYILAN,
};

// Panelde kac filtre aktif? (sekme ve siralama sayilmaz)
function countActiveFilters(f) {
  let n = 0;
  if (f.favorite) n += 1;
  if (f.platforms.length) n += 1;
  if (f.segments.length) n += 1;
  if (f.categories.length) n += 1;
  if (f.marka) n += 1;
  if (f.hediye) n += 1;
  if (f.expert) n += 1;
  if (f.expertise.length) n += 1;
  if (f.tazelik.length) n += 1;
  if (f.ucretYok) n += 1;
  if (f.followersMin !== '' || f.followersMax !== '') n += 1;
  if (f.rateStoryMin !== '' || f.rateStoryMax !== '') n += 1;
  if (f.rateReelMin !== '' || f.rateReelMax !== '') n += 1;
  if (f.babyMin !== '' || f.babyMax !== '') n += 1;
  if (f.childMin !== '' || f.childMax !== '') n += 1;
  if (f.city) n += 1;
  // Sunucu alt sinir icin YALNIZCA cmin > 0 oldugunda kosul kuruyor
  // (children.{N-1} exists). childrenMin='0' tek basina hicbir sey daraltmaz;
  // sayac onu aktif sayarsa panel "1 filtre aktif" der ama sonuc degismez.
  // Yas filtrelerinde bu sorun yok — orada 0 gercek bir alt sinir.
  if (Number(f.childrenMin) > 0 || f.childrenMax !== '') n += 1;
  if (f.whatsapp) n += 1;
  if (f.barter) n += 1;
  // Profil gruplari: filtreleyen her grup bir filtre. Hamile ANNE GRUBUNDA
  // [Y18d]: ayri sayilmaz, grup filtreliyorsa 1.
  // Varsayilan gorunum bu yuzden "2 filtre aktif" der — liste gercekten daraliyor.
  n += Object.keys(profilFiltreApi(f)).length;
  return n;
}

// Filtre durumunu API sorgu parametrelerine cevirir.
function filtersToParams(f) {
  const p = {};
  if (f.favorite) p.favorite = 'true';
  if (f.platforms.length) p.platform = f.platforms.join(',');

  if (f.segments.length) {
    const seg = segmentsToParam(f.segments);
    if (seg) p.segment = seg;
  }

  if (f.categories.length) p.category = f.categories.join(',');
  if (f.marka) p.marka = f.marka;
  if (f.hediye) p.hediye = f.hediye;
  if (f.expert) p.expert = 'true';
  if (f.expertise.length) {
    const all = new Set();
    f.expertise.forEach((name) => expandExpertise(name).forEach((v) => all.add(v)));
    p.expertise = [...all].join(',');
  }
  if (f.tazelik.length) p.tazelik = f.tazelik.join(',');
  if (f.ucretYok) p.ucret_yok = '1';
  if (f.followersMin !== '') p.followers_min = String(f.followersMin);
  if (f.followersMax !== '') p.followers_max = String(f.followersMax);
  if (f.rateStoryMin !== '') p.rate_story_min = String(f.rateStoryMin);
  if (f.rateStoryMax !== '') p.rate_story_max = String(f.rateStoryMax);
  if (f.rateReelMin !== '') p.rate_reel_min = String(f.rateReelMin);
  if (f.rateReelMax !== '') p.rate_reel_max = String(f.rateReelMax);
  if (f.babyMin !== '') p.baby_min = String(f.babyMin);
  if (f.babyMax !== '') p.baby_max = String(f.babyMax);
  if (f.childMin !== '') p.child_min = String(f.childMin);
  if (f.childMax !== '') p.child_max = String(f.childMax);
  if (f.city) p.city = f.city;
  if (f.childrenMin !== '') p.children_min = String(f.childrenMin);
  if (f.childrenMax !== '') p.children_max = String(f.childrenMax);
  if (f.whatsapp) p.whatsapp = 'true';
  if (f.barter) p.barter = 'true';
  Object.assign(p, profilFiltreApi(f));
  return p;
}

const MasterDatabasePage = () => {
  const { language } = useLanguage();

  // Auth durumu: 'loading' | 'ok' | 'forbidden' | 'error'
  const [status, setStatus] = useState('loading');
  const [user, setUser] = useState(null);

  // Tablo durumu URL'den TURETILIR — useState kopyasi yok.
  // urlKey memo anahtari: URL degismedikce 'view' ayni nesne kalir, aksi halde her
  // render'da yeni filters nesnesi olusur ve fetchTable sonsuz dongude tetiklenirdi.
  const [searchParams, setSearchParams] = useSearchParams();
  const urlKey = searchParams.toString();
  const view = useMemo(() => paramsToView(new URLSearchParams(urlKey)), [urlKey]);
  const { sekmeler, page, sort, dir, q: searchQuery, filters } = view;
  // Hicbiri secili degil: liste istegi atilmaz, Excel'e aktar kapali.
  const sekmeSecilmedi = Array.isArray(sekmeler) && sekmeler.length === 0;

  // Gorunumu gunceller. push=true ise gecmise yeni giris eklenir (geri tusu doner).
  const updateView = (patch, { push = false } = {}) => {
    const next = { ...view, ...patch, filters: { ...view.filters, ...(patch.filters || {}) } };
    setSearchParams(viewToParams(next), { replace: !push });
  };

  // TOPLU SECIM SIFIRLAMA ANAHTARI: URL'in sayfa DISINDAKI her parcasi (filtre,
  // arama, sekme, siralama). Sayfa degisimi secimi korur.
  const secimAnahtari = useMemo(() => {
    const p = new URLSearchParams(urlKey);
    p.delete('page');
    return p.toString();
  }, [urlKey]);

  // Eski sekme linki (tab= / gizle=) acildiysa URL yeni bicime cevrilir (replace:
  // gecmise ayri giris olmaz). Gorunum zaten paramsToView'da cevrildi.
  useEffect(() => {
    if (ESKI_SEKME_URL_PARAMETRELERI.some((k) => searchParams.has(k))) {
      setSearchParams(viewToParams(view), { replace: true });
    }
    // eslint-disable-next-line
  }, [urlKey]);

  const [data, setData] = useState({
    items: [], total: 0, age_undated: 0,
  });
  const [tableStatus, setTableStatus] = useState('loading'); // 'loading' | 'ok' | 'error'
  const [tabCounts, setTabCounts] = useState({});

  // Filtre paneli (gorsel durum — URL'e girmez)
  const [platformOtherOpen, setPlatformOtherOpen] = useState(false);
  const [otherFiltersOpen, setOtherFiltersOpen] = useState(false);
  // Kategori akordiyonu — VARSAYILAN KAPALI. 15 rozet sol sutunu gereksiz uzatiyordu.
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [cities, setCities] = useState([]);
  // Koleksiyonda gercekten bulunan mecra degerleri (acilista bir kez cekilir)
  const [availablePlatforms, setAvailablePlatforms] = useState([]);
  // /cities basarisiz olursa sehir filtresi kullanilamaz — bunu kullaniciya SOYLE.
  // Onceden sadece console.error vardi ve acilir liste sessizce bos kaliyordu.
  const [citiesError, setCitiesError] = useState(false);
  // Tazelik esigi SUNUCUDAN gelir (GET /cities -> tazelik_ay). Panelde sabiti YOK.
  const [tazelikAy, setTazelikAy] = useState(null);

  // Arama: searchInput her tusta degisir, searchQuery 300ms sonra (debounce).
  // Istek yalnizca searchQuery'ye bagli — her tusta API cagrilmaz.
  // Kutuya yazilan ham metin (her tusta degisir). Debounce sonrasi URL'e yazilir.
  // Ilk deger URL'den gelir ki paylasilan link arama kutusunu dolu acsin.
  const [searchInput, setSearchInput] = useState(() => new URLSearchParams(window.location.search).get('q') || '');
  // [Y27] Marka filtresi kutusu (debounce'lu; URL'deki marka= ile esitlenir).
  const [markaInput, setMarkaInput] = useState(() => (new URLSearchParams(window.location.search).get('marka') || '').trim());
  // [Y32] Hediyelesme filtresi kutusu (debounce'lu; URL'deki hediye= ile esitlenir).
  const [hediyeInput, setHediyeInput] = useState(() => (new URLSearchParams(window.location.search).get('hediye') || '').trim());
  // Liste hatasinda sunucunun mesaji (or. "Marka en az 2 harf olmali").
  const [tableErrorDetay, setTableErrorDetay] = useState('');

  // Satir detay paneli — ayni anda TEK satir acik.
  const [openId, setOpenId] = useState(null);
  // Kayit silme onayi. hedef null iken pencere KAPALI ve hicbir sey silinmis olmaz.
  // onizleme: null = sunucudan bekleniyor, nesne = geldi, 'hata' = cekilemedi.
  const [silmeHedef, setSilmeHedef] = useState(null);   // { doc }
  const [silmeOnizleme, setSilmeOnizleme] = useState(null);
  const [silmeSebep, setSilmeSebep] = useState('');
  const [silmeBusy, setSilmeBusy] = useState(false);
  const [silmeHata, setSilmeHata] = useState('');
  // TOPLU SECIM / SILME (yalniz admin — sunucu da yalniz admin'e aciyor).
  // Secim SAYFA DEGISINCE KORUNUR; filtre, arama, sekme ya da siralama
  // degisince ve silmeden sonra SIFIRLANIR (bkz. secimAnahtari).
  const [secili, setSecili] = useState(() => new Set());
  const [filtreSecimi, setFiltreSecimi] = useState('idle'); // 'idle' | 'busy' | 'error'
  // topluPencere: null = kapali; { onizleme: null | nesne | 'hata', sonuc: null | nesne }
  const [topluPencere, setTopluPencere] = useState(null);
  const [topluSebep, setTopluSebep] = useState('');
  const [topluBusy, setTopluBusy] = useState(false);
  const [topluHata, setTopluHata] = useState('');
  // SILME TALEBI (ekip -> admin onayi). Acik kaydin SON talebi; liste satirlari
  // icin istek atilmaz (N+1 yok), yalniz detayi acilan kayit icin.
  const [kayitTalebi, setKayitTalebi] = useState({ id: null, durum: 'idle', talep: null });
  const [talepHedef, setTalepHedef] = useState(null);     // { doc } — talep penceresi
  const [talepSebep, setTalepSebep] = useState('');
  const [talepBusy, setTalepBusy] = useState(false);
  const [talepHata, setTalepHata] = useState('');
  const [talepRetHedef, setTalepRetHedef] = useState(null); // kuyruk kalemi — ret penceresi
  // [Y29] KART BIRLESTIRME penceresi: { kalan, giden, secimler, onizleme (null |
  // 'hata' | sunucu yaniti), hata, busy, onay, sebep, talep }. kalan/giden id ya
  // da kullanici adi; onizleme geldikten sonra id'ler onizlemeden okunur.
  const [birlestir, setBirlestir] = useState(null);
  // [Y32b] "Gecici tumu": kayda git / birlesik karta git profil gruplarini tumu
  // yapar ki kart gorunsun. Isaret varken arama bosalirsa profil VARSAYILANA doner.
  // URL'ye YAZILMAZ; profil cipine dokunmak ya da Temizle isareti kaldirir.
  const [profilGecici, setProfilGecici] = useState(false);
  // Kartta "Baska kartla birlestir" kutusu: { id (acik kart), deger }.
  const [birlestirGiris, setBirlestirGiris] = useState({ id: null, deger: '' });
  const [talepRetNot, setTalepRetNot] = useState('');
  const [talepRetBusy, setTalepRetBusy] = useState(false);
  const [talepRetHata, setTalepRetHata] = useState('');
  // Kampanya gecmisi ayri bir istek: { status: 'idle'|'loading'|'ok'|'error', items: [] }
  const [campaigns, setCampaigns] = useState({ status: 'idle', items: [] });
  // Kayit gecmisi. VARSAYILAN KAPALI ve veri yalnizca bolum ACILDIGINDA cekilir:
  // 2797 kayitlik listede her panel acilisinda ek istek atmak gereksiz.
  // Liste eslestirme. Sonuc geldiginde tablo bu kayitlari gosterir (asagida).
  const LIST_MATCH_MAX = 500;
  const [listMatchOpen, setListMatchOpen] = useState(false);
  const [listMatchText, setListMatchText] = useState('');
  const [listMatchBusy, setListMatchBusy] = useState(false);
  const [listMatchError, setListMatchError] = useState('');
  const [listMatch, setListMatch] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [exportError, setExportError] = useState('');

  // --- Taslak yukleme (1/3: dosya secimi, ayristirma, yukleme) ---
  // rows PLAN UCU ICIN saklaniyor (2/3): sunucu dosyanin aslini tutmuyor,
  // satirlari her istekte istemci gonderiyor.
  const UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
  const UPLOAD_UZANTILAR = ['.xlsx', '.xls'];
  const dosyaInputRef = useRef(null);
  const [uploadBusy, setUploadBusy] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [upload, setUpload] = useState(null);   // { upload_id, file_name, sheet_sayisi, satir_sayisi }
  const [uploadRows, setUploadRows] = useState(null);
  // Plan yaniti. Yukleme kaydi 'plan_hazir'a gectiginde dolar; plan uretilemezse
  // null kalir ve kayit 'yuklendi'de durur — bu bir HATA DURUMU DEGIL, kuyrukta
  // tekrar denenebilir bir is.
  const [plan, setPlan] = useState(null);

  // --- Elle yeni influencer kaydi ---
  // KARAR (Bora, 2 Eyl): ekip uyesi de acabilir, onaysiz.
  const [yeniKayitAcik, setYeniKayitAcik] = useState(false);

  // --- Yuklemeler kuyrugu (2/3) ---
  // Liste sunucudan uploaded_at DESC geliyor ve limit 100; ikisine de dokunulmuyor.
  const [uploadsOpen, setUploadsOpen] = useState(false);
  // Onay bekleyenler kuyrugu. Sunucu BOLUM listesi donduruyor; panel bolum
  // basliklarini metin olarak DEGIL anahtar olarak aliyor (baslik_anahtari).
  const [kuyrukOpen, setKuyrukOpen] = useState(false);
  const [kuyruk, setKuyruk] = useState({ durum: 'idle', toplam: 0, bolumler: [] });
  const [uploads, setUploads] = useState({ durum: 'idle', items: [] });
  const [acikUpload, setAcikUpload] = useState(null);   // upload_id
  const [satirlar, setSatirlar] = useState({});         // upload_id -> { durum, rows, file_name }
  const [planlar, setPlanlar] = useState({});           // upload_id -> { durum, data, hata }
  const [onayBusy, setOnayBusy] = useState(null);       // upload_id
  const [onaySonuc, setOnaySonuc] = useState({});       // upload_id -> { tur, veri }
  const [reddetHedef, setReddetHedef] = useState(null); // { id, file_name }
  const [reddetSebep, setReddetSebep] = useState('');
  const [silHedef, setSilHedef] = useState(null);       // { id, file_name, status }
  const [historyOpen, setHistoryOpen] = useState(false);
  const [history, setHistory] = useState({ status: 'idle', items: [], total: 0, truncated: false });
  // [Y33] Gecmis yenileme sayaci: kayit / segment Ata / Taslak onayi sonrasi acik Gecmis yeniden cekilir.
  const [historyYenile, setHistoryYenile] = useState(0);

  // --- Yazma akislari (duzenleme / favori / not / segment) ---
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  // MUKERRER 409 — "Kaydina git" bir DUGME, duz metin degil; saveError dizge
  // tuttugu icin hedef kaydin kimligi ayri duruyor. { id, name } ya da null.
  const [saveConflict, setSaveConflict] = useState(null);
  const [toast, setToast] = useState('');
  const [noteDraft, setNoteDraft] = useState('');
  // [Y35] Kartin metin hucrelerinde "devamı" acik mi: { '<id>:bio' | '<id>:hakkinda': true }.
  const [metinAcik, setMetinAcik] = useState({});
  const [segmentEditing, setSegmentEditing] = useState(false);
  const [segmentDraft, setSegmentDraft] = useState('');

  const content = {
    tr: {
      title: 'Master Database',
      loading: 'Yükleniyor...',
      accessDeniedTitle: 'Erişim Reddedildi',
      accessDenied: 'Bu sayfaya erişim yetkiniz yok',
      errorTitle: 'Bağlantı Hatası',
      errorMessage: 'Sayfa yüklenemedi. Lütfen tekrar deneyin.',
      retry: 'Tekrar Dene',
      logout: 'Çıkış',
      loginTitle: 'Master Database', loginSubtitle: 'Devam etmek için giriş yapın',
      loginEmail: 'E-posta', loginPassword: 'Şifre', loginButton: 'Giriş yap',
      loginFailed: 'Giriş başarısız. Tekrar deneyin.',
      pwStepTitle: 'Şifrenizi belirleyin',
      pwStepSubtitle: 'İlk girişte kendi şifrenizi kurmanız gerekiyor.',
      pwNew: 'Yeni şifre', pwRepeat: 'Yeni şifre (tekrar)',
      pwRules: 'En az 12 karakter · büyük ve küçük harf · rakam · özel karakter',
      pwMismatch: 'Şifreler eşleşmiyor', pwSave: 'Kaydet ve devam et',
      pwShow: 'Şifreyi göster', pwHide: 'Şifreyi gizle',
      queueTitle: 'Onay Bekleyenler',
      queueDrafts: 'Taslak yüklemeleri',
      queueEmpty: 'Bekleyen bir şey yok.',
      queueOpen: 'Aç',
      queueRows: 'satır',
      queueError: 'Onay bekleyenler getirilemedi.',
      cpButton: 'Şifre Değiştir', cpTitle: 'Şifre Değiştir',
      cpCurrent: 'Mevcut şifre', cpSave: 'Kaydet', cpCancel: 'Vazgeç',
      cpSuccess: '✓ Şifreniz değiştirildi', cpError: 'Şifre değiştirilemedi',
      tfaSetupTitle: 'İki adımlı doğrulama kurulumu',
      tfaSetupSubtitle: 'QR kodu doğrulama uygulamanızda okutun, sonra 6 haneli kodu girin.',
      tfaSecretLabel: 'QR okutamıyorsanız bu anahtarı elle girin:',
      tfaVerifyTitle: 'İki adımlı doğrulama',
      tfaVerifySubtitle: 'Doğrulama uygulamanızdaki 6 haneli kodu girin.',
      tfaCode: '6 haneli kod', tfaVerifyButton: 'Doğrula ve gir',
      loginStepNote: 'Bu adım atlanamaz.',
      home: 'Ana Sayfa',
      tabs: {
        all: 'Tümü', outreach: 'Outreach', inreach: 'Inreach',
        seeding: 'Seeding', talent: 'Talent', dual: 'Hem outreach hem inreach',
      },
      tabHint: 'Tıkla: seç/çıkar',
      noTabSelected: 'Sekme seçilmedi — yukarıdan en az bir sekme seçin.',
      colInfluencer: 'Influencer', colFollowers: 'Takipçi',
      handleWord: HANDLE_WORD.tr,
      colStory: 'Story ₺', colReel: 'Reel ₺', colSegment: 'Segment', colQuotedAt: 'Ücret tarihi',
      colFreshness: 'Bilgi güncellendi',
      freshnessLabel: 'Ücret güncelliği',
      noRateLabel: 'Ücreti bilinmeyenler',
      freshnessValues: { taze: '<{n} ay', bayat: '{n}+ ay', bilinmiyor: 'Bilinmiyor' },
      freshnessNoThreshold: { taze: 'Taze', bayat: 'Bayat' },
      rateStoryFilter: 'Story ücreti (₺)', rateReelFilter: 'Reel ücreti (₺)',
      followersFilter: 'Takipçi sayısı',
      matches: 'eşleşme',
      segmentNone: 'Yok',
      assignSegment: '+ ata', noDate: 'tarih yok',
      talentBadge: 'Talent', dualNote: 'Çift kaynaklı',
      monthUnit: 'ay', yearUnit: 'yaş', decimalSep: ',',
      tableLoading: 'Kayıtlar yükleniyor...', tableError: 'Kayıtlar yüklenemedi.',
      empty: 'Bu sekmede kayıt yok.',
      prev: 'Önceki', next: 'Sonraki', pageOf: 'Sayfa {p} / {n}',
      // Filtre paneli
      favorites: 'Favoriler',
      platformsLabel: 'Mecra',
      other: 'Diğer',
      segmentLabel: 'Segment',
      categoryLabel: 'Kategori',
      expertLabel: 'Uzman',
      seedingLabel: 'Seeding hesabı',
      seedingSegmentRemoved: 'Bu kaydın segmenti ({seg}) silinecek.',
      talentLabel: 'Talent',
      pregnancyLabel: 'Hamilelik',
      pregnancyFilterLabel: 'Hamile',
      babyAge: 'Bebek yaşı (ay)',
      childAge: 'Çocuk yaşı (yıl)',
      min: 'min', max: 'maks',
      otherFilters: 'Diğer filtreler',
      cityLabel: 'Şehir',
      allCities: 'Tümü',
      childrenCount: 'Çocuk sayısı ≥',
      childCountUnknown: 'bilinmiyor',
      childAgesHidden: 'Çocuk sayısı bilinmiyor — sayıyı girince yaş kutuları açılır.',
      whatsappLabel: 'WhatsApp grubunda',
      barterLabel: 'Ürün karşılığı çalışır',
      activeFilters: 'filtre aktif',
      clearFilters: 'temizle',
      // PROFIL [26 Eki] — filtre gruplari, duzenleme kartı, detay
      profileMotherLabel: 'Anne mi?',
      profileMarriedLabel: 'Evli mi?',
      potentialBadge: 'Potansiyel',
      // [Y16 kart] Anne kutulari ve bebek / cocuk
      boxMother: 'Anne',
      boxPregnant: 'Hamile',
      pregnantIncludedByMother: 'Anne seçiliyken hamileler zaten dahil',
      femaleIncludedByMother: 'Anne ya da Hamile seçiliyken Kadın da seçili',
      boxPotential: 'Potansiyel',
      boxNot: 'Değil',
      detailBabies: 'Bebek sayısı',
      detailBabyAges: 'Bebek yaşı',
      childrenClearConfirm: 'Kayıtlı {n} bebek/çocuk bilgisi silinecek. Devam edilsin mi?',
      childrenLockedNotMother: 'Potansiyel ya da Değil: bebek / çocuk girilmez.',
      profileGenderLabel: 'Cinsiyet',
      profileAgencyLabel: 'Ajans',
      genderFemale: 'Kadın',
      genderMale: 'Erkek',
      agencyWith: 'Ajanslı',
      agencyWithout: 'Ajanssız',
      editHasAgency: 'Ajansla çalışıyor',
      editAgencyName: 'Ajans adı',
      motherLockedMale: 'Erkek kayıt anne olamaz.',
      planRowDerived: 'türetildi',
      favoritesHint: 'Göçte favori işaretli kayıt yok — bu filtre şimdilik boş sonuç döner.',
      // [Y28] Arama kartin tamaminda (marka, not, kategori, uzmanlik, ajans, kampanya).
      searchPlaceholder: 'İsim, kullanıcı adı, marka, not, şehir…',
      searchPlaceholderShort: 'İsim, marka, not…',
      searchClear: 'Temizle',
      noSearchMatch: '"{q}" ile eşleşen kayıt yok',
      detailSource: 'Kaynak',
      detailCity: 'Şehir',
      detailPhone: 'Telefon',
      detailEmail: 'E-posta',
      detailChildren: 'Çocuk sayısı',
      detailChildAges: 'Çocuk yaşı',
      detailCategory: 'Kategori',
      detailExpertise: 'Uzmanlık',
      detailBrands: 'Markalar',
      // [Y32] Hediye karsiligi paylasim yapilan markalar.
      detailGifted: 'Hediyeleşme',
      giftedPlaceholder: 'ör. Chicco · virgülle birden fazla',
      markaLabel: 'Marka',
      markaPlaceholder: 'ör. Prima · virgülle birden fazla',
      detailBilling: 'Çalışma şekli',
      detailStory: 'Story ücreti',
      detailReel: 'Reel ücreti',
      detailTiktok: 'TikTok ücreti',
      detailYtVideo: 'YT Video',
      detailYtShorts: 'YT Shorts',
      detailCombo: 'Combo (reel+story)',
      detailCollab: 'Collab',
      detailAd: 'Reklamlama',
      // [Y35, Bora 3 Kas 19:47] kartta hucre yok; Gecmis / onay etiketi.
      detailQuotedAt: 'Ücret tarihi',
      detailBarter: 'Ürün karşılığı',
      detailWhatsapp: 'WhatsApp grubu',
      whatsappMember: 'Üye',
      whatsappNotMember: 'Değil',
      unknown: 'bilinmiyor',
      bool3Unknown: 'Bilinmiyor',
      yes: 'Evet',
      no: 'Hayır',
      none: 'yok',
      campaignsTitle: 'Kampanya geçmişi',
      deleteRecord: 'Kaydı sil',
      deleteRecordTitle: 'Kayıt silinecek',
      deleteRecordNoName: '(ad yok)',
      deleteRecordItems: 'Bu kayda bağlı {n} kampanya kalemi var ({m} tanesinde içerik bağlantısı var). Silinirse kalemler kampanya ekranında sahipsiz kalır. Gerçek bir kişiyse silmek yerine arşivlemeyi düşünün.',
      deleteRecordReason: 'Silme sebebi (isteğe bağlı)',
      deleteRecordReasonPlaceholder: 'Bu kayıt neden siliniyor?',
      deleteRecordAsk: 'Bu kayıt silinecektir. Onaylıyor musunuz?',
      deleteRecordCancel: 'Vazgeç',
      deleteRecordConfirm: 'Onayla',
      deleteRecordBusy: 'Siliniyor...',
      deleteRecordPreviewLoading: 'Kampanya bağı kontrol ediliyor...',
      deleteRecordPreviewError: 'Silme önizlemesi getirilemedi — bu kaydın kampanya bağı kontrol edilemedi, silme yapılamıyor. Pencereyi kapatıp tekrar deneyin.',
      deleteRecordError: 'Kayıt silinemedi.',
      deleteRequestButton: 'Silme talebi gönder',
      deleteRequestTitle: 'Silme talebi',
      deleteRequestInfo: 'Talep adminlerin onayına gider. Bir admin onaylayana kadar kayıt silinmez.',
      deleteRequestReason: 'Silme sebebi (zorunlu, en az 5 karakter)',
      deleteRequestReasonPlaceholder: 'Bu kayıt neden silinmeli?',
      deleteRequestSend: 'Gönder',
      deleteRequestSending: 'Gönderiliyor...',
      deleteRequestCancel: 'Vazgeç',
      deleteRequestPending: 'Silme talebi bekliyor',
      deleteRequestWithdraw: 'Talebi geri çek',
      deleteRequestRejected: 'Silme talebi reddedildi',
      deleteRequestSentToast: 'Silme talebi gönderildi.',
      deleteRequestWithdrawnToast: 'Silme talebi geri çekildi.',
      deleteRequestLoadError: 'Silme talebi durumu getirilemedi.',
      deleteRequestErr409: 'Bu kayıt için zaten bekleyen bir silme talebi var.',
      deleteRequestErr403: 'Bu işlem için yetkiniz yok.',
      deleteRequestErr400: 'Sebep çok kısa — en az 5 karakter yazın.',
      deleteRequestErr: 'Silme talebi işlenemedi.',
      deleteRequestReasonLabel: 'Talep sebebi',
      deleteRequestBy: 'Talep eden',
      queueDeleteRequests: 'Silme talepleri',
      // [Y29] KART BIRLESTIRME
      queueMergeRequests: 'Birleştirme talepleri',
      queueMergeOpen: 'Önizle ve birleştir',
      rejectMergeTitle: 'Birleştirme talebini reddet',
      mergeOpen: 'Kartları birleştir',
      mergeUnsavedNote: 'Kaydedilmemiş değişiklikler birleştirmeye girmez.',
      mergeOther: 'Başka kartla birleştir',
      mergeOtherPlaceholder: 'Diğer kartın kullanıcı adı ya da id’si',
      mergeOtherGo: 'Önizle',
      mergeTitle: 'Kartları birleştir',
      mergeKeep: 'Kalan kart',
      mergeDrop: 'Silinecek kart',
      mergeSwap: 'Yer değiştir',
      mergeColField: 'Alan',
      // [Y29b] Sonuc sutunu vurgulu ve aciklayici basliginda.
      mergeColResult: 'Birleştirilirse sonuç',
      mergeSame: 'Aynı olan {n} alan',
      mergePick: 'Bunu al',
      mergePickNeeded: 'Seçim gerekli',
      mergeCampaign: 'Kampanya geçmişi: {n} kalem {eski} → {yeni} taşınacak',
      mergeProfileFix: 'Profil düzeltmesi',
      mergeThirdRecord: 'Birleşik kartın kullanıcı adı başka bir kayıtta var: {name} ({handle}, id: {id}). Önce o kaydı düzeltin.',
      mergeBackupNote: 'Silinecek kartın tam kopyası saklanır; geri alınabilir.',
      mergeLoading: 'Önizleme hazırlanıyor...',
      mergePreviewError: 'Önizleme getirilemedi.',
      mergeConfirm: 'Birleştir',
      mergeConfirmAsk: 'Emin misiniz? Silinecek kart kaldırılır.',
      mergeConfirmYes: 'Evet, birleştir',
      mergeBusy: 'Birleştiriliyor...',
      mergeRequest: 'Birleştirme talebi gönder',
      mergeReason: 'Sebep (zorunlu, en az 5 karakter)',
      mergeReasonDefault: 'Aynı kişi',
      mergeDoneToast: 'Birleştirildi.',
      mergeRequestSentToast: 'Talep gönderildi.',
      mergeChanged: 'Kartlar bu arada değişti — önizleme yenilendi.',
      mergeError: 'Birleştirme yapılamadı.',
      mergeRequestPending: 'Birleştirme talebi bekliyor',
      mergeNotes: '{n} not',
      mergeNotesNew: '{n} not ({m} yeni)',
      mergeQuotedAt: 'Ücret tarihi',
      mergeLabelRates: 'Ücretler',
      mergeLabelPlatforms: 'Mecralar (takipçi)',
      mergeLabelChildren: 'Bebek / Çocuk yaşı',
      mergeLabelBirthYear: 'Doğum yılı',
      mergeLabelPet: 'Evcil hayvan',
      mergeLabelTags: 'Etiketler',
      mergeTechnical: 'Teknik alanlar ({n})',
      mergeLeftoverRates: 'Kalmayan ücretler not olarak eklenecek: {liste} (@{handle}, ücret tarihi {tarih})',
      mergeNoDate: 'yok',
      queueItemsCount: '{n} kampanya kalemi',
      queueRecordGone: 'kayıt artık yok',
      queueApprove: 'Onayla',
      queueReject: 'Reddet',
      rejectRequestTitle: 'Silme talebini reddet',
      rejectRequestNote: 'Not (isteğe bağlı)',
      rejectRequestNotePlaceholder: 'Ekibe neden reddedildiğini yazın',
      rejectRequestConfirm: 'Reddet',
      rejectRequestBusy: 'Reddediliyor...',
      rejectRequestToast: 'Silme talebi reddedildi.',
      deletedToast: '{handle} silindi.',
      bulkSelectRow: 'Kaydı seç',
      bulkSelectPage: 'Bu sayfadaki kayıtların tümünü seç',
      bulkSelectFilter: 'Filtredeki {n} kaydın tümünü seç',
      bulkSelectFilterBusy: 'Kayıtlar seçiliyor...',
      bulkSelectFilterError: 'Filtredeki kayıtlar seçilemedi.',
      bulkSelectTooMany: 'En fazla 200 kayıt birlikte silinebilir — filtreyi daraltın.',
      bulkSelected: '{n} kayıt seçili',
      bulkDeleteSelected: 'Seçilenleri sil',
      bulkClearSelection: 'Seçimi temizle',
      bulkDeleteTitle: '{n} kayıt silinecek',
      bulkDeleteMore: 've {m} kayıt daha',
      bulkDeleteMissing: '{n} seçili kayıt artık yok, atlanacak.',
      bulkDeleteItems: '{k} kayda bağlı toplam {n} kampanya kalemi var. Silinirse kalemler kampanya ekranında sahipsiz kalır.',
      bulkDeleteItemsRow: '{ad} · {n} kalem ({m} içerik bağlantılı)',
      bulkDeleteAsk: 'Bu kayıtlar silinecektir. Onaylıyor musunuz?',
      bulkDeletePreviewError: 'Toplu silme önizlemesi getirilemedi — kampanya bağı kontrol edilemedi, silme yapılamıyor.',
      bulkDeleteError: 'Kayıtlar silinemedi.',
      bulkDeletedToast: '{n} kayıt silindi.',
      bulkDeleteResult: '{n} kayıt silindi.',
      bulkDeleteFailed: 'Silinemeyenler ({n}):',
      bulkDeleteNotFound: 'Bulunamayanlar ({n}):',
      bulkDeleteClose: 'Kapat',
      campaignsLoading: 'Kampanya geçmişi yükleniyor...',
      campaignsError: 'Kampanya geçmişi yüklenemedi.',
      campaignsEmpty: 'Henüz kampanya kaydı yok',
      campaignsNoHandle: 'Bu kaydın Instagram kullanıcı adı yok — kampanya geçmişi sorgulanamıyor.',
      noHandle: 'kullanıcı adı yok',
      editIgHandle: `Instagram ${HANDLE_WORD.tr}`,
      // Cakisma mesajlari HANGI ALAN cakistiysa onu soyluyor. Alan ifadesi TEK
      // haritada; iki sablon da {alan} jetonunu ondan dolduruyor.
      handleFieldLabel: {
        instagram_handle: `Instagram ${HANDLE_WORD.trCumle}`,
        tiktok_handle: `TikTok ${HANDLE_WORD.trCumle}`,
        youtube_handle: `YouTube ${HANDLE_WORD.trCumle}`,
      },
      handleFieldFallback: HANDLE_WORD.trCumle,
      handleConflict: 'Bu {alan} zaten "{name}" kaydında kullanılıyor (@{handle}, id: {id}). Bu iki kayıt aynı kişi olabilir — birleştirmeyi değerlendirin.',
      editPlatforms: 'Mecralar (takipçi)',
      editPlatformsNote: 'Kullanıcı adı üstteki Instagram / TikTok / YouTube kutularından girilir.',
      editName: 'Ad soyad',
      editTiktokHandle: `TikTok ${HANDLE_WORD.tr}`,
      editYtHandle: `YouTube ${HANDLE_WORD.tr}`,
      platformIntersectHint: 'Birden fazla seçilince HEPSİNDE birden hesabı olanlar listelenir.',
      platformNone: 'Diğer',
      noOtherPlatforms: 'Başka mecra kaydı yok',
      edit: 'Düzenle',
      save: 'Kaydet',
      saving: 'Kaydediliyor...',
      cancel: 'Vazgeç',
      auditNote: 'Değişiklik audit log\'a yazılır',
      savedToast: '{name} güncellendi ({who})',
      saveError: 'Kaydedilemedi. Tekrar deneyin.',
      conflictError: 'Bu kayıt siz düzenlerken değiştirildi, yenileyin.',
      addFavorite: 'Favorilere ekle',
      favorited: 'Favoride',
      notePlaceholder: 'Not ekle…',
      noteAdd: 'Ekle',
      noteAddTitle: 'Not ekle',
      segmentAssignTitle: 'Segment seç',
      segmentAssign: 'Ata',
      childAgeHint: 'Bugünkü yaşını girin',
      childAgeRequired: 'Tüm çocuk yaşlarını doldurun',
      childRemoveConfirm: '{n} dolu yaş kutusu silinecek. Devam edilsin mi?',
      noAgeDate: 'tarih yok',
      // [Y28] Satirda "neden cikti" — sunucunun arama_eslesme etiketleri.
      searchMatchPrefix: 'eşleşme',
      searchMatchLabels: {
        markalar: 'Markalar', not: 'Not', kategori: 'Kategori', uzmanlik: 'Uzmanlık', ajans: 'Ajans', kampanya: 'Kampanya',
        bio: 'Bio', hediye: 'Hediyeleşme',
      },
      // [Y31] Kartta ayri Instagram bio alani.
      bioLabel: 'Instagram bio',
      // [Y35] kartin besinci kolonu
      hakkindaLabel: 'Influencer Hakkında',
      bioEmpty: 'Bio yok',
      hakkindaEmpty: 'Değerlendirme yok',
      textMore: 'devamı',
      textLess: 'daha az',
      detailBabiesAges: 'Bebek sayısı & yaşı',
      detailChildrenAges: 'Çocuk sayısı & yaşı',
      bioNeedsHandle: 'Bio için Instagram kullanıcı adı gerekli',
      childBirth: 'doğum',
      childMeasuredSuffix: 'ölçümünden',
      childNoMeasureDate: 'ölçüm tarihi bilinmiyor',
      childUnknownFormat: 'yaş bilgisi okunamadı',
      childMismatch: 'Kayıtta {len} çocuk görünüyor, tahmin {est} — mükerrer kayıt olabilir, kontrol edin.',
      undatedNote: '{n} kayıtta yaş tarihi bilinmiyor',
      deliverableCollab: 'collab',
      deliverableAdDays: 'gün reklam',
      rowError: 'Bu kaydın bilgileri gösterilemedi (bozuk veri).',
      citiesError: 'Şehir listesi yüklenemedi',
      statusOnerildi: 'Önerildi',
      statusCalisildi: 'Çalışıldı',
      notesTitle: 'Notlar',
      historyLabel: 'Geçmiş',
      // [Y33] Denetim izi
      historyCreatedBy: 'Kayıt oluşturan',
      historySourceTaslak: 'Taslak: {dosya}',
      historySourceFile: 'Kaynak dosya: {dosya}',
      historySourceMerge: 'Kart birleştirme',
      historySourceRequest: 'Talep',
      historyMigration: 'Göç',
      // [Y34] Reel metrikleri (Instagram Reels sekmesi, son 12 reel, sabitlenenler haric)
      reelTitle: 'Reel metrikleri',
      reelEmpty: 'Reel ölçümü yok',
      reelMedian: 'Medyan izlenme', reelAvg: 'Ortalama izlenme', reelMinMax: 'Min – Max',
      reelPerFollower: 'Medyan / takipçi', reelEngagement: 'Etkileşim', reelLikesHidden: 'beğeni gizli',
      reelLast3m: 'Son 3 ayda reel', reelWeekly: 'Haftalık ort. reel', reelSample: 'Örnek', reelSampleUnit: 'reel',
      reelShortMedian: 'medyan', reelShortAvg: 'ort.',
      reelAds: 'Son 12 reel\'de reklam', reelAdsHint: 'Son 12 reel (sabitlenenler hariç)', reelShortAds: 'reklam',
      // [Y36] beklenen dogum · aktiflik · onay ekrani bilgi satirlari
      dueDateLabel: 'Beklenen doğum', dueDateMonth: 'Ay', dueDateYear: 'Yıl', dueDateMonthN: '≈ {n}. ay',
      dueDatePassed: 'Beklenen doğum geçti ({tarih}) — bebek doğmuş olabilir, güncelle',
      dueDateNone: 'Beklenen doğum yok', dueDateAsk: 'Beklenen doğumu sorun (en kötü yaklaşık)',
      activity: { aktif: 'Aktif', pasif: 'Pasif', inaktif: 'İnaktif' }, activityHint: 'Son 90 günde {n} reel',
      inreachKept: 'Inreach — influencer kendisi verdi',
      planPregnantNoDue: 'Hamile ama beklenen doğum yok: {n} kişi',
      planSegmentChange: 'Segment değişecek: {n} kart',
      planFieldCounts: 'Değişecek kartlar',
      planInreachKeptTitle: 'Inreach\'te korunan: {n} kart',
      planFieldNames: { ad: 'ad', eposta: 'e-posta', telefon: 'telefon', sehir: 'şehir', kategori: 'kategori', uzmanlik: 'uzmanlık',
        anne: 'anne', cocuk: 'çocuk', segment: 'segment', beklenen_dogum: 'beklenen doğum', inreach_korunan: 'Inreach\'te korunan' },
      uploadAuditFailed: '{n} kaydın geçmiş satırı yazılamadı',
      // [Y33] Gecmis'te etiketi olmayan alanlar (ham ad kalmasin).
      auditEkEtiketler: {
        tags: 'Etiketler', focus: 'Odak', product_fit: 'Ürün uyumu', is_favorite: 'Favori', favorite_by: 'Favoriye ekleyen',
        favorite_at: 'Favori tarihi', talent: 'Talent', contact_channel: 'İletişim kanalı', manager_note: 'Yönetici notu',
        'rates.quoted_by': 'Ücreti giren', 'rates.multi_story': 'Çoklu story', 'rates.currency': 'Para birimi',
        birth_year: 'Doğum yılı', has_pet: 'Evcil hayvan',
        // PATCH / kart birlestirmenin yazdigi teknik alanlar (Y33'e kadar ham adla gorunuyordu)
        instagram_url: 'Instagram bağlantısı', 'pregnancy.measured_at': 'Hamilelik ölçüm tarihi', 'pregnancy.due_date': 'Beklenen doğum',
        'rates.quoted_at_source': 'Ücret tarihi kaynağı', segment_assigned_by: 'Segmenti atayan',
        segment_assigned_at: 'Segment atama tarihi', imported_at: 'Aktarım tarihi', last_import_at: 'Son aktarım',
        source_file: 'Kaynak dosya', possible_duplicate_of: 'Olası mükerrer', enrichment_needed: 'Zenginleştirme gerekli',
        enrichment_reason: 'Zenginleştirme sebebi', created_at: 'Oluşturma tarihi', created_by: 'Oluşturan', application: 'Başvuru',
      },
      historyEmpty: 'Henüz değişiklik yok',
      historyError: 'Kayıt geçmişi yüklenemedi.',
      exportButton: "Excel'e aktar",
      exporting: 'Hazırlanıyor...',
      exportError: 'Dışa aktarma başarısız.',
      listMatchButton: 'Liste eşleştir',
      listMatchTitle: 'Liste eşleştir',
      listMatchHint: 'Her satıra bir kişi. Kabul edilen biçimler: kullaniciadi · @kullaniciadi · instagram.com/kullaniciadi · kullaniciadi<TAB veya virgül>Ad Soyad',
      listMatchPlaceholder: 'ayse.erhann\n@mehmet\ninstagram.com/zeynep\nselin, Selin Ak',
      listMatchRun: 'Eşleştir',
      listMatchRunning: 'Eşleştiriliyor...',
      listMatchClear: 'Temizle',
      listMatchError: 'Liste eşleştirilemedi.',
      listMatchTooMany: 'En fazla {n} satır.',
      listMatchSummary: '{total} satırdan {matched} tanesi MDB\'de{ek} · {notFound} tanesi yok · {rejected} satır reddedildi',
      listMatchUcretYokCount: '{n} tanesinin ücreti yok',
      listMatchFiyatEskiCount: '{n} tanesinin ücreti {ay} aydan eski ya da tarihsiz',
      listMatchFiyatEskiCountNoThreshold: '{n} tanesinin ücreti eski ya da tarihsiz',
      listMatchUcretYok: 'MDB\'de var · ücret yok',
      listMatchFiyatEski: 'MDB\'de var · ücret eski',
      listMatchNotFound: 'MDB\'de olmayanlar',
      listMatchRejected: 'Reddedilen satırlar',
      listMatchCheck: 'Kontrol et',
      listMatchNameDiff: 'listede "{given}", kayıtta "{record}"',
      listMatchExport: 'Excel\'e aktar (4 sheet)',
      notesEmpty: 'Not yok',
      noteSourceTaslak: 'Taslak',
      uploadButton: 'Taslak yükle',
      uploadBusy: 'Yükleniyor...',
      uploadedTitle: 'Yüklendi',
      uploadedInfo: '{sheets} sayfa · {rows} satır okundu',
      uploadedDates: '{normalized} tarih hücresi günleştirildi · {kept} zaman damgası korundu',
      uploadErrExt: 'Yalnızca {list} kabul ediliyor.',
      uploadErrTooBig: 'Dosya çok büyük. En fazla 5 MB.',
      uploadErrParse: 'Dosya okunamadı — bozuk ya da desteklenmeyen bir Excel dosyası olabilir. Yükleme yapılmadı.',
      uploadErrNetwork: 'Bağlantı kurulamadı. Dosya yüklenmiş olabilir — tekrar denemeden önce yükleme listesini kontrol edin.',
      uploadErrRejected: 'Dosya kabul edilmedi. Uzantısı, içeriği ya da makro taşıması nedeniyle reddedilmiş olabilir.',
      uploadErrAuth: 'Bu işlem için yetkiniz yok.',
      uploadErrDb: 'Veritabanına ulaşılamıyor. Biraz sonra tekrar deneyin.',
      uploadErrGeneric: 'Dosya yüklenemedi.',
      uploadErrPlan: 'Dosya yüklendi ama değişiklik planı üretilemedi. Dosyayı yeniden yükleyin.',
      uploadErrPlanTooBig: 'Dosyada çok fazla satır var, plan üretilemedi. Dosyanın altındaki boş satırları silip yeniden yükleyin.',
      planTitle: 'Değişiklik planı',
      planNew: 'yeni kayıt', planChanged: 'değişecek kayıt', planFilled: 'doldurulan alan',
      planOverwritten: 'ezilen alan', planConfirmed: 'ücreti teyit edilen kayıt',
      planConflict: 'çakışan alan', planRejected: 'reddedilen satır',
      planNoChange: 'değişiklik yok',
      newRecordButton: 'Yeni Kayıt', newRecordTitle: 'Yeni influencer kaydı',
      newRecordSegmentNone: 'Seçilmedi',
      newRecordOtherPlatform: 'Diğer mecra',
      newRecordOtherPlatformPlaceholder: 'Mecra adı ve kullanıcı adı (örn: Threads @ornek.kullanici)',
      newRecordNote: 'Not',
      newRecordDuplicate: 'Bu {alan} zaten kayıtlı.',
      newRecordGoTo: 'Kaydına git',
      uploadsButton: 'Yüklemeler', uploadsTitle: 'Yükleme kuyruğu',
      uploadsRefresh: 'Yenile', uploadsEmpty: 'Henüz yükleme yok.',
      uploadsError: 'Yükleme listesi getirilemedi.',
      uploadRowsShow: 'Satırları gör', uploadRowsHide: 'Satırları gizle',
      uploadRowsError: 'Satırlar getirilemedi.',
      uploadRowsNotStored: 'Bu yüklemenin planı üretilmedi, satırlar saklanmadı.',
      uploadRowsCount: 'satır', uploadRowsMore: '+{n} satır daha',
      uploadStatus: {
        yuklendi: 'Yüklendi', plan_hazir: 'Onay bekliyor', yazildi: 'İşlendi',
        kismi_yazildi: 'Kısmen işlendi', geri_gonderildi: 'Geri gönderildi', hata: 'Hata',
      },
      planLoading: 'Plan üretiliyor...', planError: 'Plan üretilemedi.',
      planFileDate: 'Dosya tarihi',
      planDateSource: { dosya_adi: 'dosya adından', yukleme_ani: 'yükleme anından' },
      planDateWarning: 'Dosya adından tarih okunamadı, yükleme anı kullanıldı — arşivden eski bir Taslak ise ücretleri geriye yazabilir.',
      planRateWarning: '{n} ücret alanının üzerine yazılacak.',
      planRateList: 'Üzerine yazılacak ücretler',
      planRowNew: 'yeni', planRowLine: 'satır',
      planRowOverwrite: 'ÜZERİNE YAZILACAK', planRowFill: 'dolduruluyor',
      planRowConfirm: 'teyit', planRowConflict: 'çakışma', planRowNotWritten: 'yazılmayacak',
      planRowKept: 'dokunulmuyor',
      planRejectedTitle: 'Reddedilen satırlar', planSkipped: 'Atlanan sayfalar',
      planIdentityTitle: 'Kimlik çakışması — yazılmayacak', planIdentity: 'kimlik çakışması',
      planIdentityDb: '{kim} · {mecra} {deger} zaten {rakip} ({ad}) kaydında',
      planIdentityFile: '{kim} · {mecra} {deger} dosyada @{rakip} satırında da var ({sheet} · satır {satir})',
      planIdentityFilePerson: '{kim} · aynı kişiye bağlanan satırlarda farklı {mecra} adı: @{x} / @{y} ({sheet} · satır {satir})',
      uploadIdentitySkipped: '{n} kişi kimlik çakışması nedeniyle yazılmadı',
      uploadApprove: 'Onayla', uploadApproving: 'Onaylanıyor...', uploadReject: 'Geri gönder',
      uploadApproveBlocked: 'Onaylamadan önce planı görüntüleyin',
      uploadDecided: 'Karar verildi', uploadDelete: 'Sil',
      uploadWritten: '{new} yeni kayıt · {updated} güncellenen kayıt yazıldı',
      uploadPartial: 'Kısmen yazıldı — bazı kayıtlar yazılamadı:',
      uploadConflict: 'Plan değişmiş — araya bir düzenleme girdi, yazma yapılmadı. Planı yeniden üretin.',
      uploadConflictBefore: 'Önceki', uploadConflictAfter: 'Yeni',
      uploadActionError: 'İşlem tamamlanamadı.',
      rejectTitle: 'Geri gönder', rejectHint: 'Sebep zorunlu — yükleyen kişi neyi düzelteceğini bilmeli.',
      rejectPlaceholder: 'Örn. Ağustos ücretleri eski, güncel Taslak\'ı yükleyin.',
      rejectSubmit: 'Geri gönder', rejectCancel: 'Vazgeç',
      deleteTitle: 'Yüklemeyi sil',
      deleteWarning: 'Bu yüklemenin kaydı ve satırları silinecek. Artımlı yükleme audit_log\'a yazmıyor; bu kaydı silersen o Taslak\'ın MDB\'de neyi değiştirdiğinin izi kalmaz. Silme işleminin kendisi kayda geçer.',
      deleteSubmit: 'Kalıcı olarak sil', deleteCancel: 'Vazgeç',
    },
    en: {
      title: 'Master Database',
      loading: 'Loading...',
      accessDeniedTitle: 'Access Denied',
      accessDenied: 'You do not have permission to access this page',
      errorTitle: 'Connection Error',
      errorMessage: 'Could not load the page. Please try again.',
      retry: 'Try Again',
      logout: 'Log out',
      loginTitle: 'Master Database', loginSubtitle: 'Sign in to continue',
      loginEmail: 'Email', loginPassword: 'Password', loginButton: 'Sign in',
      loginFailed: 'Sign in failed. Try again.',
      pwStepTitle: 'Set your password',
      pwStepSubtitle: 'You must set your own password on first sign in.',
      pwNew: 'New password', pwRepeat: 'New password (repeat)',
      pwRules: 'At least 12 characters · upper and lower case · number · special character',
      pwMismatch: 'Passwords do not match', pwSave: 'Save and continue',
      pwShow: 'Show password', pwHide: 'Hide password',
      queueTitle: 'Pending approvals',
      queueDrafts: 'Draft uploads',
      queueEmpty: 'Nothing is waiting.',
      queueOpen: 'Open',
      queueRows: 'rows',
      queueError: 'Could not load pending approvals.',
      cpButton: 'Change Password', cpTitle: 'Change Password',
      cpCurrent: 'Current password', cpSave: 'Save', cpCancel: 'Cancel',
      cpSuccess: '✓ Your password has been changed', cpError: 'Password could not be changed',
      tfaSetupTitle: 'Two-factor setup',
      tfaSetupSubtitle: 'Scan the QR code in your authenticator app, then enter the 6-digit code.',
      tfaSecretLabel: 'If you cannot scan, enter this key manually:',
      tfaVerifyTitle: 'Two-factor verification',
      tfaVerifySubtitle: 'Enter the 6-digit code from your authenticator app.',
      tfaCode: '6-digit code', tfaVerifyButton: 'Verify and enter',
      loginStepNote: 'This step cannot be skipped.',
      home: 'Home',
      tabs: {
        all: 'All', outreach: 'Outreach', inreach: 'Inreach',
        seeding: 'Seeding', talent: 'Talent', dual: 'Both outreach and inreach',
      },
      tabHint: 'Click: select/remove',
      noTabSelected: 'No tab selected — pick at least one above.',
      colInfluencer: 'Influencer', colFollowers: 'Followers',
      handleWord: HANDLE_WORD.en,
      colStory: 'Story ₺', colReel: 'Reel ₺', colSegment: 'Segment', colQuotedAt: 'Quote date',
      colFreshness: 'Info updated',
      freshnessLabel: 'Price freshness',
      noRateLabel: 'No known fee',
      freshnessValues: { taze: '<{n} mo', bayat: '{n}+ mo', bilinmiyor: 'Unknown' },
      freshnessNoThreshold: { taze: 'Fresh', bayat: 'Stale' },
      rateStoryFilter: 'Story fee (₺)', rateReelFilter: 'Reel fee (₺)',
      followersFilter: 'Followers',
      matches: 'matches',
      segmentNone: 'None',
      assignSegment: '+ assign', noDate: 'no date',
      talentBadge: 'Talent', dualNote: 'Dual source',
      monthUnit: 'mo', yearUnit: 'yrs', decimalSep: '.',
      tableLoading: 'Loading records...', tableError: 'Could not load records.',
      empty: 'No records in this tab.',
      prev: 'Previous', next: 'Next', pageOf: 'Page {p} / {n}',
      favorites: 'Favorites',
      platformsLabel: 'Platforms',
      other: 'Other',
      segmentLabel: 'Segment',
      categoryLabel: 'Category',
      expertLabel: 'Expert',
      seedingLabel: 'Seeding account',
      seedingSegmentRemoved: "This record's segment ({seg}) will be removed.",
      talentLabel: 'Talent',
      pregnancyLabel: 'Pregnancy',
      pregnancyFilterLabel: 'Pregnant',
      babyAge: 'Baby age (months)',
      childAge: 'Child age (years)',
      min: 'min', max: 'max',
      otherFilters: 'Other filters',
      cityLabel: 'City',
      allCities: 'All',
      childrenCount: 'Children count ≥',
      childCountUnknown: 'unknown',
      childAgesHidden: 'Children count unknown — enter a count to open the age boxes.',
      whatsappLabel: 'In WhatsApp group',
      barterLabel: 'Works for barter',
      activeFilters: 'filters active',
      clearFilters: 'clear',
      // PROFILE [26 Oct] — filter groups, edit card, detail
      profileMotherLabel: 'Mother?',
      profileMarriedLabel: 'Married?',
      potentialBadge: 'Potential',
      // [Y16 card] Mother boxes and babies / children
      boxMother: 'Mother',
      boxPregnant: 'Pregnant',
      pregnantIncludedByMother: 'Included while Mother is selected',
      femaleIncludedByMother: 'Selected while Mother or Pregnant is selected',
      boxPotential: 'Potential',
      boxNot: 'Not',
      detailBabies: 'Babies',
      detailBabyAges: 'Baby ages',
      childrenClearConfirm: '{n} saved baby/child entr(ies) will be removed. Continue?',
      childrenLockedNotMother: 'Potential or Not: no babies / children.',
      profileGenderLabel: 'Gender',
      profileAgencyLabel: 'Agency',
      genderFemale: 'Female',
      genderMale: 'Male',
      agencyWith: 'With agency',
      agencyWithout: 'No agency',
      editHasAgency: 'Works with an agency',
      editAgencyName: 'Agency name',
      motherLockedMale: 'A male record cannot be marked as mother.',
      planRowDerived: 'derived',
      favoritesHint: 'No records are favorited in the migration — this filter returns empty for now.',
      searchPlaceholder: 'Name, handle, brand, note, city…',
      searchPlaceholderShort: 'Name, brand, note…',
      searchClear: 'Clear',
      noSearchMatch: 'No records match "{q}"',
      detailSource: 'Source',
      detailCity: 'City',
      detailPhone: 'Phone',
      detailEmail: 'E-mail',
      detailChildren: 'Children',
      detailChildAges: 'Child ages',
      detailCategory: 'Category',
      detailExpertise: 'Expertise',
      detailBrands: 'Brands',
      detailGifted: 'Gifted brands',
      giftedPlaceholder: 'e.g. Chicco · comma for several',
      markaLabel: 'Brand',
      markaPlaceholder: 'e.g. Prima · comma for several',
      detailBilling: 'Billing type',
      detailStory: 'Story fee',
      detailReel: 'Reel fee',
      detailTiktok: 'TikTok fee',
      detailYtVideo: 'YT Video',
      detailYtShorts: 'YT Shorts',
      detailCombo: 'Combo (reel+story)',
      detailCollab: 'Collab',
      detailAd: 'Ad placement',
      detailQuotedAt: 'Quote date',
      detailBarter: 'Barter',
      detailWhatsapp: 'WhatsApp group',
      whatsappMember: 'Member',
      whatsappNotMember: 'Not a member',
      unknown: 'unknown',
      bool3Unknown: 'Unknown',
      yes: 'Yes',
      no: 'No',
      none: 'none',
      campaignsTitle: 'Campaign history',
      deleteRecord: 'Delete record',
      deleteRecordTitle: 'Record will be deleted',
      deleteRecordNoName: '(no name)',
      deleteRecordItems: 'This record has {n} campaign items ({m} with a content link). If deleted, those items are left without an owner on the campaign screen. If this is a real person, consider archiving instead of deleting.',
      deleteRecordReason: 'Reason for deletion (optional)',
      deleteRecordReasonPlaceholder: 'Why is this record being deleted?',
      deleteRecordAsk: 'This record will be deleted. Do you confirm?',
      deleteRecordCancel: 'Cancel',
      deleteRecordConfirm: 'Confirm',
      deleteRecordBusy: 'Deleting...',
      deleteRecordPreviewLoading: 'Checking campaign links...',
      deleteRecordPreviewError: 'Could not load the deletion preview — campaign links for this record could not be checked, so deletion is blocked. Close and try again.',
      deleteRecordError: 'Could not delete the record.',
      deleteRequestButton: 'Request deletion',
      deleteRequestTitle: 'Deletion request',
      deleteRequestInfo: 'The request goes to the admins for approval. The record is not deleted until an admin approves.',
      deleteRequestReason: 'Reason for deletion (required, at least 5 characters)',
      deleteRequestReasonPlaceholder: 'Why should this record be deleted?',
      deleteRequestSend: 'Send',
      deleteRequestSending: 'Sending...',
      deleteRequestCancel: 'Cancel',
      deleteRequestPending: 'Deletion request pending',
      deleteRequestWithdraw: 'Withdraw request',
      deleteRequestRejected: 'Deletion request rejected',
      deleteRequestSentToast: 'Deletion request sent.',
      deleteRequestWithdrawnToast: 'Deletion request withdrawn.',
      deleteRequestLoadError: 'Could not load the deletion request status.',
      deleteRequestErr409: 'There is already a pending deletion request for this record.',
      deleteRequestErr403: 'You are not allowed to do this.',
      deleteRequestErr400: 'Reason too short — write at least 5 characters.',
      deleteRequestErr: 'Could not process the deletion request.',
      deleteRequestReasonLabel: 'Request reason',
      deleteRequestBy: 'Requested by',
      queueDeleteRequests: 'Deletion requests',
      queueMergeRequests: 'Merge requests',
      queueMergeOpen: 'Preview and merge',
      rejectMergeTitle: 'Reject merge request',
      mergeOpen: 'Merge cards',
      mergeUnsavedNote: 'Unsaved changes are not part of the merge.',
      mergeOther: 'Merge with another card',
      mergeOtherPlaceholder: 'Other card’s handle or id',
      mergeOtherGo: 'Preview',
      mergeTitle: 'Merge cards',
      mergeKeep: 'Card to keep',
      mergeDrop: 'Card to delete',
      mergeSwap: 'Swap',
      mergeColField: 'Field',
      mergeColResult: 'Result after merge',
      mergeSame: '{n} identical fields',
      mergePick: 'Take this',
      mergePickNeeded: 'Choice needed',
      mergeCampaign: 'Campaign history: {n} items will move {eski} → {yeni}',
      mergeProfileFix: 'Profile correction',
      mergeThirdRecord: 'A handle of the merged card is used by another record: {name} ({handle}, id: {id}). Fix that record first.',
      mergeBackupNote: 'A full copy of the deleted card is kept; it can be restored.',
      mergeLoading: 'Preparing preview...',
      mergePreviewError: 'Could not load the preview.',
      mergeConfirm: 'Merge',
      mergeConfirmAsk: 'Are you sure? The card to delete will be removed.',
      mergeConfirmYes: 'Yes, merge',
      mergeBusy: 'Merging...',
      mergeRequest: 'Send merge request',
      mergeReason: 'Reason (required, at least 5 characters)',
      mergeReasonDefault: 'Same person',
      mergeDoneToast: 'Merged.',
      mergeRequestSentToast: 'Request sent.',
      mergeChanged: 'The cards changed in the meantime — preview refreshed.',
      mergeError: 'Could not merge.',
      mergeRequestPending: 'Merge request pending',
      mergeNotes: '{n} notes',
      mergeNotesNew: '{n} notes ({m} new)',
      mergeQuotedAt: 'Price date',
      mergeLabelRates: 'Rates',
      mergeLabelPlatforms: 'Platforms (followers)',
      mergeLabelChildren: 'Baby / child age',
      mergeLabelBirthYear: 'Birth year',
      mergeLabelPet: 'Pet',
      mergeLabelTags: 'Tags',
      mergeTechnical: 'Technical fields ({n})',
      mergeLeftoverRates: 'Rates that do not carry over will be added as a note: {liste} (@{handle}, price date {tarih})',
      mergeNoDate: 'none',
      queueItemsCount: '{n} campaign items',
      queueRecordGone: 'record no longer exists',
      queueApprove: 'Approve',
      queueReject: 'Reject',
      rejectRequestTitle: 'Reject deletion request',
      rejectRequestNote: 'Note (optional)',
      rejectRequestNotePlaceholder: 'Tell the team why it was rejected',
      rejectRequestConfirm: 'Reject',
      rejectRequestBusy: 'Rejecting...',
      rejectRequestToast: 'Deletion request rejected.',
      deletedToast: '{handle} deleted.',
      bulkSelectRow: 'Select record',
      bulkSelectPage: 'Select all records on this page',
      bulkSelectFilter: 'Select all {n} records in this filter',
      bulkSelectFilterBusy: 'Selecting records...',
      bulkSelectFilterError: 'Could not select the records in this filter.',
      bulkSelectTooMany: 'At most 200 records can be deleted together — narrow the filter.',
      bulkSelected: '{n} records selected',
      bulkDeleteSelected: 'Delete selected',
      bulkClearSelection: 'Clear selection',
      bulkDeleteTitle: '{n} records will be deleted',
      bulkDeleteMore: 'and {m} more',
      bulkDeleteMissing: '{n} selected records no longer exist and will be skipped.',
      bulkDeleteItems: '{k} of these records have {n} campaign items in total. If deleted, those items are left without an owner on the campaign screen.',
      bulkDeleteItemsRow: '{ad} · {n} items ({m} with a content link)',
      bulkDeleteAsk: 'These records will be deleted. Do you confirm?',
      bulkDeletePreviewError: 'Could not load the bulk deletion preview — campaign links could not be checked, so deletion is blocked.',
      bulkDeleteError: 'Could not delete the records.',
      bulkDeletedToast: '{n} records deleted.',
      bulkDeleteResult: '{n} records deleted.',
      bulkDeleteFailed: 'Not deleted ({n}):',
      bulkDeleteNotFound: 'Not found ({n}):',
      bulkDeleteClose: 'Close',
      campaignsLoading: 'Loading campaign history...',
      campaignsError: 'Could not load campaign history.',
      campaignsEmpty: 'No campaign records yet',
      campaignsNoHandle: 'This record has no Instagram handle — campaign history cannot be queried.',
      noHandle: 'no handle',
      editIgHandle: 'Instagram handle',
      handleFieldLabel: {
        instagram_handle: `Instagram ${HANDLE_WORD.en}`,
        tiktok_handle: `TikTok ${HANDLE_WORD.en}`,
        youtube_handle: `YouTube ${HANDLE_WORD.en}`,
      },
      handleFieldFallback: HANDLE_WORD.en,
      handleConflict: 'This {alan} is already used by "{name}" (@{handle}, id: {id}). These two records may be the same person — consider merging.',
      editPlatforms: 'Platforms (followers)',
      editPlatformsNote: 'Handles are entered in the Instagram / TikTok / YouTube boxes above.',
      editName: 'Full name',
      editTiktokHandle: 'TikTok handle',
      editYtHandle: 'YouTube handle',
      platformIntersectHint: 'When several are selected, only accounts present on ALL of them are listed.',
      platformNone: 'Other',
      noOtherPlatforms: 'No other platforms in the data',
      edit: 'Edit',
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      auditNote: 'Changes are written to the audit log',
      savedToast: '{name} updated ({who})',
      saveError: 'Could not save. Try again.',
      conflictError: 'This record was changed while you were editing, please refresh.',
      addFavorite: 'Add to favorites',
      favorited: 'Favorited',
      notePlaceholder: 'Add a note…',
      noteAdd: 'Add',
      noteAddTitle: 'Add note',
      segmentAssignTitle: 'Select segment',
      segmentAssign: 'Assign',
      childAgeHint: 'Enter current age',
      childAgeRequired: 'Fill in all child ages',
      childRemoveConfirm: '{n} filled age box(es) will be removed. Continue?',
      noAgeDate: 'no date',
      searchMatchPrefix: 'match',
      searchMatchLabels: {
        markalar: 'Brands', not: 'Note', kategori: 'Category', uzmanlik: 'Expertise', ajans: 'Agency', kampanya: 'Campaign',
        bio: 'Bio', hediye: 'Gifted brands',
      },
      bioLabel: 'Instagram bio',
      // [Y35]
      hakkindaLabel: 'About the influencer',
      bioEmpty: 'No bio',
      hakkindaEmpty: 'No assessment',
      textMore: 'more',
      textLess: 'less',
      detailBabiesAges: 'Babies & ages',
      detailChildrenAges: 'Children & ages',
      bioNeedsHandle: 'Instagram handle required for bio',
      childBirth: 'born',
      childMeasuredSuffix: 'measured',
      childNoMeasureDate: 'measurement date unknown',
      childUnknownFormat: 'age could not be read',
      childMismatch: 'Record shows {len} children, estimate is {est} — possible duplicates, please check.',
      undatedNote: '{n} records with unknown age date',
      deliverableCollab: 'collab',
      deliverableAdDays: 'ad days',
      rowError: 'This record could not be displayed (malformed data).',
      citiesError: 'Could not load city list',
      statusOnerildi: 'Proposed',
      statusCalisildi: 'Worked',
      notesTitle: 'Notes',
      historyLabel: 'History',
      historyCreatedBy: 'Record created by',
      historySourceTaslak: 'Taslak: {dosya}',
      historySourceFile: 'Source file: {dosya}',
      historySourceMerge: 'Card merge',
      historySourceRequest: 'Request',
      historyMigration: 'Migration',
      reelTitle: 'Reel metrics',
      reelEmpty: 'No reel measurement',
      reelMedian: 'Median views', reelAvg: 'Average views', reelMinMax: 'Min – Max',
      reelPerFollower: 'Median / followers', reelEngagement: 'Engagement', reelLikesHidden: 'likes hidden',
      reelLast3m: 'Reels in last 3 months', reelWeekly: 'Weekly avg. reels', reelSample: 'Sample', reelSampleUnit: 'reels',
      reelShortMedian: 'median', reelShortAvg: 'avg.',
      reelAds: 'Ads in last 12 reels', reelAdsHint: 'Last 12 reels (pinned excluded)', reelShortAds: 'ads',
      dueDateLabel: 'Due date', dueDateMonth: 'Month', dueDateYear: 'Year', dueDateMonthN: '≈ month {n}',
      dueDatePassed: 'Due date passed ({tarih}) — the baby may have been born, update',
      dueDateNone: 'No due date', dueDateAsk: 'Ask for the due date (rough is fine)',
      activity: { aktif: 'Active', pasif: 'Passive', inaktif: 'Inactive' }, activityHint: '{n} reels in the last 90 days',
      inreachKept: 'Inreach — given by the influencer',
      planPregnantNoDue: 'Pregnant but no due date: {n} people',
      planSegmentChange: 'Segment will change: {n} cards',
      planFieldCounts: 'Cards to change',
      planInreachKeptTitle: 'Kept on Inreach: {n} cards',
      planFieldNames: { ad: 'name', eposta: 'e-mail', telefon: 'phone', sehir: 'city', kategori: 'category', uzmanlik: 'expertise',
        anne: 'mother', cocuk: 'children', segment: 'segment', beklenen_dogum: 'due date', inreach_korunan: 'kept on Inreach' },
      uploadAuditFailed: 'History rows could not be written for {n} records',
      auditEkEtiketler: {
        tags: 'Tags', focus: 'Focus', product_fit: 'Product fit', is_favorite: 'Favorite', favorite_by: 'Favorited by',
        favorite_at: 'Favorited at', talent: 'Talent', contact_channel: 'Contact channel', manager_note: 'Manager note',
        'rates.quoted_by': 'Rate entered by', 'rates.multi_story': 'Multi story', 'rates.currency': 'Currency',
        birth_year: 'Birth year', has_pet: 'Pet',
        instagram_url: 'Instagram link', 'pregnancy.measured_at': 'Pregnancy measured at', 'pregnancy.due_date': 'Due date',
        'rates.quoted_at_source': 'Rate date source', segment_assigned_by: 'Segment assigned by',
        segment_assigned_at: 'Segment assigned at', imported_at: 'Imported at', last_import_at: 'Last import',
        source_file: 'Source file', possible_duplicate_of: 'Possible duplicate of', enrichment_needed: 'Enrichment needed',
        enrichment_reason: 'Enrichment reason', created_at: 'Created at', created_by: 'Created by', application: 'Application',
      },
      historyEmpty: 'No changes yet',
      historyError: 'Could not load record history.',
      exportButton: 'Export to Excel',
      exporting: 'Preparing...',
      exportError: 'Export failed.',
      listMatchButton: 'Match list',
      listMatchTitle: 'Match list',
      listMatchHint: 'One person per line. Accepted: handle · @handle · instagram.com/handle · handle<TAB or comma>Full Name',
      listMatchPlaceholder: 'ayse.erhann\n@mehmet\ninstagram.com/zeynep\nselin, Selin Ak',
      listMatchRun: 'Match',
      listMatchRunning: 'Matching...',
      listMatchClear: 'Clear',
      listMatchError: 'Could not match the list.',
      listMatchTooMany: 'At most {n} lines.',
      listMatchSummary: '{matched} of {total} lines are in the MDB{ek} · {notFound} missing · {rejected} rejected',
      listMatchUcretYokCount: '{n} without rates',
      listMatchFiyatEskiCount: '{n} with rates older than {ay} months or undated',
      listMatchFiyatEskiCountNoThreshold: '{n} with old or undated rates',
      listMatchUcretYok: 'In the MDB · no rates',
      listMatchFiyatEski: 'In the MDB · old rates',
      listMatchNotFound: 'Not in the MDB',
      listMatchRejected: 'Rejected lines',
      listMatchCheck: 'Check',
      listMatchNameDiff: 'list says "{given}", record says "{record}"',
      listMatchExport: 'Export to Excel (4 sheets)',
      notesEmpty: 'No notes',
      noteSourceTaslak: 'Draft upload',
      uploadButton: 'Upload draft',
      uploadBusy: 'Uploading...',
      uploadedTitle: 'Uploaded',
      uploadedInfo: '{sheets} sheets · {rows} rows read',
      uploadedDates: '{normalized} date cells normalized · {kept} timestamps kept',
      uploadErrExt: 'Only {list} are accepted.',
      uploadErrTooBig: 'File is too large. 5 MB maximum.',
      uploadErrParse: 'Could not read the file — it may be corrupt or an unsupported Excel format. Nothing was uploaded.',
      uploadErrNetwork: 'Could not reach the server. The file may have been uploaded — check the upload list before trying again.',
      uploadErrRejected: 'File was rejected. It may be the extension, the contents, or an embedded macro.',
      uploadErrAuth: 'You do not have permission for this action.',
      uploadErrDb: 'Cannot reach the database. Please try again shortly.',
      uploadErrGeneric: 'Could not upload the file.',
      uploadErrPlan: 'The file was uploaded but no change plan could be produced. Upload the file again.',
      uploadErrPlanTooBig: 'The file has too many rows; no plan could be produced. Delete the empty rows at the bottom of the file and upload it again.',
      planTitle: 'Change plan',
      planNew: 'new records', planChanged: 'records changing', planFilled: 'fields filled',
      planOverwritten: 'fields overwritten', planConfirmed: 'records with confirmed price',
      planConflict: 'conflicting fields', planRejected: 'rejected rows',
      planNoChange: 'no changes',
      newRecordButton: 'New record', newRecordTitle: 'New influencer record',
      newRecordSegmentNone: 'Not selected',
      newRecordOtherPlatform: 'Other platform',
      newRecordOtherPlatformPlaceholder: 'Platform and username (e.g. Threads @example.user)',
      newRecordNote: 'Note',
      newRecordDuplicate: 'This {alan} is already registered.',
      newRecordGoTo: 'Go to record',
      uploadsButton: 'Uploads', uploadsTitle: 'Upload queue',
      uploadsRefresh: 'Refresh', uploadsEmpty: 'No uploads yet.',
      uploadsError: 'Could not load the upload list.',
      uploadRowsShow: 'Show rows', uploadRowsHide: 'Hide rows',
      uploadRowsError: 'Could not load the rows.',
      uploadRowsNotStored: 'No plan was produced for this upload, so no rows were stored.',
      uploadRowsCount: 'rows', uploadRowsMore: '+{n} more rows',
      uploadStatus: {
        yuklendi: 'Uploaded', plan_hazir: 'Awaiting approval', yazildi: 'Applied',
        kismi_yazildi: 'Partially applied', geri_gonderildi: 'Sent back', hata: 'Error',
      },
      planLoading: 'Producing plan...', planError: 'Could not produce the plan.',
      planFileDate: 'File date',
      planDateSource: { dosya_adi: 'from file name', yukleme_ani: 'from upload time' },
      planDateWarning: 'No date could be read from the file name, upload time was used — if this is an old draft from the archive it may write prices backwards.',
      planRateWarning: '{n} fee fields will be overwritten.',
      planRateList: 'Fees to be overwritten',
      planRowNew: 'new', planRowLine: 'row',
      planRowOverwrite: 'WILL BE OVERWRITTEN', planRowFill: 'filling',
      planRowConfirm: 'confirmed', planRowConflict: 'conflict', planRowNotWritten: 'not written',
      planRowKept: 'untouched',
      planRejectedTitle: 'Rejected rows', planSkipped: 'Skipped sheets',
      planIdentityTitle: 'Identity conflict — will not be written', planIdentity: 'identity conflicts',
      planIdentityDb: '{kim} · {mecra} {deger} is already on the {rakip} ({ad}) record',
      planIdentityFile: '{kim} · {mecra} {deger} also appears on @{rakip} in this file ({sheet} · row {satir})',
      planIdentityFilePerson: '{kim} · rows linked to the same person carry different {mecra} handles: @{x} / @{y} ({sheet} · row {satir})',
      uploadIdentitySkipped: '{n} people not written because of identity conflicts',
      uploadApprove: 'Approve', uploadApproving: 'Approving...', uploadReject: 'Send back',
      uploadApproveBlocked: 'View the plan before approving',
      uploadDecided: 'Decided', uploadDelete: 'Delete',
      uploadWritten: '{new} new · {updated} updated records written',
      uploadPartial: 'Partially written — some records could not be written:',
      uploadConflict: 'The plan changed — an edit came in between, nothing was written. Produce the plan again.',
      uploadConflictBefore: 'Before', uploadConflictAfter: 'After',
      uploadActionError: 'The action could not be completed.',
      rejectTitle: 'Send back', rejectHint: 'A reason is required — the uploader needs to know what to fix.',
      rejectPlaceholder: 'e.g. August prices are stale, please upload the current draft.',
      rejectSubmit: 'Send back', rejectCancel: 'Cancel',
      deleteTitle: 'Delete upload',
      deleteWarning: 'This upload record and its rows will be deleted. Incremental uploads are not written to audit_log; if you delete this record there will be no trace of what that draft changed in the MDB. The deletion itself is recorded.',
      deleteSubmit: 'Delete permanently', deleteCancel: 'Cancel',
    },
  };

  const t = content[language];
  const locale = language === 'tr' ? 'tr-TR' : 'en-US';
  const activeFilterCount = countActiveFilters(filters);
  const filtrelerVarsayilan =
    new URLSearchParams(filtersToParams(filters)).toString()
    === new URLSearchParams(filtersToParams(EMPTY_FILTERS)).toString();
  // Onay BEKLEYEN yukleme sayisi: plani uretilmis ama karar verilmemis olanlar.
  const bekleyenUpload = uploads.items.filter((u) => u.status === 'plan_hazir').length;
  // Ana ucluden farkli olan ve veride gercekten bulunan mecralar
  const otherPlatforms = availablePlatforms.filter((p) => !PLATFORM_MAIN_VALUES.includes(p));

  // Dil context'ten DEGIL pathname'den okunuyor: LanguageRouter'daki language state'i 'tr'
  // ile basliyor ve bir effect'te guncelleniyor; cocuk effect'leri parent'tan once calistigi
  // icin mount aninda context henuz 'en' olmayabilir. pathname her zaman dogru.
  const authToken = mdbTokenOku;

  // === GIRIS AKISI ===
  // Adimi ARAYUZ KENDI SECMEZ: sunucudan gelen bayraklar (requires_*) belirler.
  // Sira zorunlu — sifre degistirme ve 2FA tamamlanmadan kalici token gelmez.
  const [girisAdim, setGirisAdim] = useState('giris'); // giris | sifre | 2fa-kurulum | 2fa-dogrula
  const [girisEmail, setGirisEmail] = useState('');
  const [girisSifre, setGirisSifre] = useState('');
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');
  const [totpKod, setTotpKod] = useState('');
  const [qrKod, setQrKod] = useState('');
  const [gizliAnahtar, setGizliAnahtar] = useState('');
  const [girisHata, setGirisHata] = useState('');
  const [girisMesgul, setGirisMesgul] = useState(false);
  // Goster/gizle bayraklari: HER ALAN ICIN AYRI. Tek bayrak ucunu birden acardi;
  // ayrica "yeni sifre" ile "tekrar" ayri ayri gorulebilmeli ki kullanici uyusmazlik
  // cikinca hangisinde yazim hatasi yaptigini karsilastirabilsin.
  const [girisSifreGoster, setGirisSifreGoster] = useState(false);
  const [yeniSifreGoster, setYeniSifreGoster] = useState(false);
  const [yeniSifreTekrarGoster, setYeniSifreTekrarGoster] = useState(false);
  // Gecici token STATE'te tutulur, localStorage'a YAZILMAZ: yarim kalmis bir giris
  // sekmede kalici iz birakmasin. Sayfa yenilenirse akis bastan baslar.
  const [gecici, setGecici] = useState('');

  // === OTURUM ICINDE SIFRE DEGISTIRME ===
  // Giris akisindaki state'lerden AYRI tutuluyor. Ortak kullanilsaydi acik bir
  // oturumda pencereyi kapatmak giris akisinin durumunu da silerdi ve iki akis
  // birbirinin alanlarini gorurdu.
  const [sifreModal, setSifreModal] = useState(false);
  const [sdMevcut, setSdMevcut] = useState('');
  const [sdYeni, setSdYeni] = useState('');
  const [sdTekrar, setSdTekrar] = useState('');
  const [sdMevcutGoster, setSdMevcutGoster] = useState(false);
  const [sdYeniGoster, setSdYeniGoster] = useState(false);
  const [sdTekrarGoster, setSdTekrarGoster] = useState(false);
  const [sdHata, setSdHata] = useState('');
  const [sdMesgul, setSdMesgul] = useState(false);
  const [sdOnay, setSdOnay] = useState('');

  // Sunucunun soyledigi adima gec.
  const adimUygula = (d) => {
    setGecici(d.temp_token || '');
    setGirisHata('');
    if (d.requires_password_change) setGirisAdim('sifre');
    else if (d.requires_2fa_setup) setGirisAdim('2fa-kurulum');
    else if (d.requires_2fa_verify) setGirisAdim('2fa-dogrula');
    else setGirisAdim('giris');
  };

  const girisTemizle = () => {
    setGirisSifre('');
    setYeniSifre('');
    setYeniSifreTekrar('');
    setGirisSifreGoster(false);
    setYeniSifreGoster(false);
    setYeniSifreTekrarGoster(false);
    setTotpKod('');
    setQrKod('');
    setGizliAnahtar('');
    setGecici('');
  };

  const girisYap = async (e) => {
    e.preventDefault();
    setGirisMesgul(true);
    setGirisHata('');
    try {
      const res = await axios.post(`${API}/mdb-login`, {
        email: girisEmail,
        password: girisSifre,
      });
      setGirisSifre(''); // sifre state'te birakilmaz
      adimUygula(res.data);
    } catch (err) {
      setGirisHata(err.response?.data?.error || t.loginFailed);
    } finally {
      setGirisMesgul(false);
    }
  };

  const sifreDegistir = async (e) => {
    e.preventDefault();
    if (yeniSifre !== yeniSifreTekrar) {
      setGirisHata(t.pwMismatch);
      return;
    }
    setGirisMesgul(true);
    setGirisHata('');
    try {
      const res = await axios.post(
        `${API}/mdb-change-password`,
        { new_password: yeniSifre },
        { headers: { Authorization: `Bearer ${gecici}` } }
      );
      setYeniSifre('');
      setYeniSifreTekrar('');
      adimUygula(res.data);
    } catch (err) {
      setGirisHata(err.response?.data?.error || t.loginFailed);
    } finally {
      setGirisMesgul(false);
    }
  };

  // 2FA kurulum adimina gelindiginde QR'i getir.
  useEffect(() => {
    if (girisAdim !== '2fa-kurulum' || !gecici || qrKod) return;
    let iptal = false;
    (async () => {
      try {
        const res = await axios.post(`${API}/mdb-2fa-setup`, {}, {
          headers: { Authorization: `Bearer ${gecici}` },
        });
        if (iptal) return;
        setQrKod(res.data.qr_code);
        setGizliAnahtar(res.data.secret);
      } catch (err) {
        if (!iptal) setGirisHata(err.response?.data?.error || t.loginFailed);
      }
    })();
    return () => { iptal = true; };
  }, [girisAdim, gecici, qrKod, t.loginFailed]);

  const kodDogrula = async (e) => {
    e.preventDefault();
    setGirisMesgul(true);
    setGirisHata('');
    try {
      const res = await axios.post(
        `${API}/mdb-2fa-verify`,
        { code: totpKod },
        { headers: { Authorization: `Bearer ${gecici}` } }
      );
      // KALICI token ancak burada geliyor.
      mdbTokenYaz(res.data.token);
      girisTemizle();
      setGirisAdim('giris');
      loadMe();
    } catch (err) {
      setGirisHata(err.response?.data?.error || t.loginFailed);
      setTotpKod('');
    } finally {
      setGirisMesgul(false);
    }
  };

  const sifreModalKapat = () => {
    setSifreModal(false);
    setSdMevcut('');
    setSdYeni('');
    setSdTekrar('');
    setSdMevcutGoster(false);
    setSdYeniGoster(false);
    setSdTekrarGoster(false);
    setSdHata('');
  };

  // Oturum ici sifre degistirme. Kalici token ile /api/mdb-update-password'e gider —
  // giris akisindaki /api/mdb-change-password DEGIL (o gecici token bekliyor).
  // Basarili olunca token DEGISMEZ ve silinmez: kullanici sayfada kalir.
  const sifreDegistirOturum = async (e) => {
    e.preventDefault();
    setSdHata('');
    if (sdYeni !== sdTekrar) {
      setSdHata(t.pwMismatch);
      return;
    }
    setSdMesgul(true);
    try {
      await axios.post(
        `${API}/mdb-update-password`,
        { current_password: sdMevcut, new_password: sdYeni },
        { headers: { Authorization: `Bearer ${authToken()}` } }
      );
      sifreModalKapat();
      setSdOnay(t.cpSuccess);
    } catch (err) {
      setSdHata(err?.response?.data?.error || t.cpError);
    } finally {
      setSdMesgul(false);
    }
  };

  // Onay mesaji kendiliginden kaybolur; kullanicinin kapatmasi gereken bir sey degil.
  useEffect(() => {
    if (!sdOnay) return undefined;
    const zamanlayici = setTimeout(() => setSdOnay(''), 4000);
    return () => clearTimeout(zamanlayici);
  }, [sdOnay]);

  const cikisYap = () => {
    mdbTokenSil();
    girisTemizle();
    sifreModalKapat();
    setSdOnay('');
    setGirisEmail('');
    setGirisAdim('giris');
    setUser(null);
    setStatus('giris');
  };

  // Sayfa/gorunum sifirlama — sayfa numarasi cagiran tarafta URL'e yaziliyor.
  const resetView = () => {
    // Filtre/arama/sekme degisiminde acik kayit listeden dusmus olabilir -> panel kapanir.
    // (Siralama ve sayfa degisimi bunu CAGIRMAZ; orada panel kaydi listede kaldigi surece acik kalir.)
    setOpenId(null);
  };

  const patchFilters = (patch) => {
    updateView({ filters: patch, page: 1 });
    resetView();
  };

  const toggleInList = (key, value) => {
    const list = filters[key];
    const next = list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
    updateView({ filters: { [key]: next }, page: 1 });
    resetView();
  };

  // ANNE GRUBU [Y18d]: Anne (evet) secilince Hamile temizlenir — hamile ⊂ anne;
  // cip secili gorunur ve devre disidir. Anne kaldirilinca Hamile secili DEGIL.
  // [Y32b] Sonucta Anne ya da Hamile varsa Kadın da secilir — iki grup TEK updateView.
  const toggleAnne = (value) => {
    const list = filters.anne;
    let next = list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
    if (next.includes('evet')) next = next.filter((v) => v !== 'hamile');
    const patch = { anne: next };
    if (anneKadinGerektirir(next) && !filters.cinsiyet.includes('kadin')) patch.cinsiyet = [...filters.cinsiyet, 'kadin'];
    setProfilGecici(false);
    updateView({ filters: patch, page: 1 });
    resetView();
  };
  // Profil cipine dokunmak "gecici tumu" isaretini kaldirir: kullanicinin secimi gecerli.
  const toggleProfil = (key, value) => {
    setProfilGecici(false);
    toggleInList(key, value);
  };

  const toggleSegment = (value) => {
    updateView({ filters: { segments: nextSegments(filters.segments, value) }, page: 1 });
    resetView();
  };

  const toggleExpertise = (name) => {
    updateView({ filters: { expertise: nextExpertise(filters.expertise, name) }, page: 1 });
    resetView();
  };

  const clearFilters = () => {
    setProfilGecici(false);
    updateView({ filters: EMPTY_FILTERS, page: 1 });
    resetView();
  };

  // === YAZMA ALTYAPISI ===
  // Dort akis da ayni PATCH ucunu kullanir. Yanittaki guncel belge listeye islenir ki
  // yeniden istek atmadan ekran tazelensin (ve updated_at damgasi guncel kalsin).
  const actorName = () => {
    const local = String(user?.email || '').split('@')[0];
    return local ? local.charAt(0).toUpperCase() + local.slice(1) : '';
  };

  // Guncellenen satiri listeye yazar.
  //
  // TAM DEGISTIRME DEGIL, KORUMALI DEGISTIRME. Sunucudan donen belge SAKLANAN
  // veriyi birebir yansitir; turetilmis alanlar (tazelik_tarihi, tazelik_durumu
  // gibi) ise sorgu aninda hesaplanir. Yanit bir turetilmis alani tasimiyorsa
  // satirdaki ESKI degeri korunur — aksi halde o kolon kaydettikten sonra
  // bosalir (13 Eyl'de "Bilgi guncellendi" — o zamanki adiyla Guncellik —
  // kolonunda tam olarak bu yasandi).
  //
  // ALAN ADLARI BURADA YAZILI DEGIL: liste sunucudan geliyor (derived_fields),
  // cunku hangi alanin turetilmis oldugunu bilen taraf orasi. Yarin yeni bir
  // $addFields eklenirse panelde hicbir sey degismesi gerekmez.
  //
  // KOR BIRLESTIRME YAPILMIYOR — yalnizca TURETILMIS alanlar korunuyor. Butun
  // belgeyi birlestirmek $unset edilen alanlari ekranda diriltirdi (uc bugun
  // instagram_handle, instagram_url ve cocuk_sayisi_tahmini icin $unset yapiyor).
  const applyUpdatedDoc = (fresh, turetilmis) => {
    if (!fresh) return;
    const swap = (list) => list.map((d) => {
      if (d._id !== fresh._id) return d;
      const korunan = {};
      for (const alan of turetilmis || []) {
        if (fresh[alan] === undefined && d[alan] !== undefined) korunan[alan] = d[alan];
      }
      return { ...fresh, ...korunan };
    });
    setData((prev) => ({ ...prev, items: swap(prev.items) }));
  };

  const showToast = (text) => {
    setToast(text);
    // ~2.6 sn sonra kaybolur (mock'taki sure)
    setTimeout(() => setToast(''), 2600);
  };

  // body: { fields?, add_note?, favorite?, updated_at? }
  const patchRecord = async (doc, body) => {
    const token = authToken();
    if (!token) {
      setStatus('giris');
      return false;
    }
    setSaving(true);
    setSaveError('');
    try {
      const res = await axios.patch(`${API}/master-database/influencers/${doc._id}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      applyUpdatedDoc(res.data.document, res.data.derived_fields);
      if (res.data.updated) {
        // uyari: kayit yazildi ama yan is (or. kampanya kalemi tasima) olmadi.
        showToast(res.data.uyari
          || t.savedToast.replace('{name}', safeText(doc.full_name) || '—').replace('{who}', actorName()));
        // Sekme sayilarini tazele. YALNIZCA gercekten bir sey degistiyse
        // (res.data.updated) — sunucu degisiklik yoksa updated:false donuyor ve o
        // durumda alti istek atmanin karsiligi yok.
        // Beklenmiyor: sayilar arka planda guncellenir, kaydetme onu beklemez.
        fetchTabCounts();
        // [Y33] Acik Gecmis bu degisikligi hemen gostersin.
        if (historyOpen) setHistoryYenile((n) => n + 1);
      }
      return true;
    } catch (err) {
      const code = err.response?.status;
      if (code === 401) {
        mdbTokenSil();
        setStatus('giris');
      } else if (code === 409) {
        // Cakisma — bu bir ENGEL degil SINYAL: ayni kullanici adini girmeye
        // calismak "bu iki kayit ayni kisi" demektir. Cozucu ORTAK: POST'un
        // { existing_id } bicimini de PATCH'in { conflict } bicimini de okuyor.
        if (cakismayiOku(err.response?.data)) {
          // mesaj kuruldu
        } else {
          // Baskasi ayni kaydi duzenlemis — sessiz veri kaybi yerine acik uyari
          setSaveError(t.conflictError);
        }
      } else {
        setSaveError(err.response?.data?.error || t.saveError);
      }
      return false;
    } finally {
      setSaving(false);
    }
  };

  // Duzenleme taslagi: belgeden okunur, kaydederken yalnizca DEGISENLER gonderilir.
  const startEdit = (doc) => {
    const rates = doc.rates || {};
    // Yeni kayit startEdit({}) ile acilir: _id yok.
    const yeniTaslak = !doc._id;
    setDraft({
      instagram_handle: doc.instagram_handle || '',
      full_name: doc.full_name || '',
      tiktok_handle: doc.tiktok_handle || '',
      youtube_handle: doc.youtube_handle || '',
      // UC DURUM — okuma bool3Oku'dan, put3'un prev argumaniyla AYNI fonksiyon.
      brand_segment: doc.brand_segment || '',
      // YALNIZ YENI KAYITTA gorunen iki alan. Duzenleme kartinda karsiliklari YOK
      // ve eklenmedi; taslakta bos duruyorlar, govdeye de girmiyorlar.
      diger_mecra: '',
      note: '',
      is_expert: bool3Oku(doc.is_expert),
      is_seeding_account: bool3Oku(doc.is_seeding_account),
      is_talent: bool3Oku(doc.is_talent),
      pregnancy_is_pregnant: bool3Oku(doc.pregnancy?.is_pregnant),
      // Hamile kutusu kaldirilinca: kayitta alan yoktuysa bos'a doner (hamileKapat).
      hamile_ilk: bool3Oku(doc.pregnancy?.is_pregnant),
      // [Y36] beklenen dogum — ay / yil secimi (bos = yok).
      dogum_ay: dogumAyYil(doc.pregnancy?.due_date) ? String(dogumAyYil(doc.pregnancy.due_date).ay) : '',
      dogum_yil: dogumAyYil(doc.pregnancy?.due_date) ? String(dogumAyYil(doc.pregnancy.due_date).yil) : '',
      whatsapp_member: bool3Oku(doc.whatsapp_community?.member),
      // PROFIL [26 Eki]: yeni kayitta Kadın + Anne onceden secili (sunucu da ayni
      // varsayilani uyguluyor). Mevcut kayitta alan yoksa bos kalir; dokunulmazsa
      // govdeye girmez.
      gender: doc.gender || (yeniTaslak ? 'kadın' : ''),
      // [1 Kas] Anne mi? uc degerli (anneMiOku); Evli mi? saklanan is_married.
      anne_mi: yeniTaslak ? 'evet' : anneMiOku(doc),
      is_married: bool3Oku(doc.is_married),
      has_agency: bool3Oku(doc.has_agency),
      agency_name: doc.agency_name || '',
      // [Y35] iki metin kutusu (kartin besinci kolonu)
      influencer_hakkinda: doc.influencer_hakkinda || '',
      instagram_bio: igBioOku(doc),
      city: doc.city || '',
      phone: doc.phone || '',
      email: doc.email || '',
      billing_type: doc.billing_type || '',
      barter_open: doc.barter_open || '',
      category: Array.isArray(doc.category) ? doc.category.filter(Boolean) : [],
      expertise: Array.isArray(doc.expertise) ? doc.expertise.filter(Boolean) : [],
      // [Y27] Markalar — tek satir metin; mdbGovdeKur ayni markaMetni ile karsilastirir.
      markalar: markaMetni(doc),
      // [Y32] Hediyelesme — ayni desen.
      hediyeler: hediyeMetni(doc),
      ig_story: rates.ig_story ?? '',
      ig_reel: rates.ig_reel ?? '',
      tiktok_video: rates.tiktok_video ?? '',
      youtube_video: rates.youtube_video ?? '',
      youtube_shorts: rates.youtube_shorts ?? '',
      combo_reel_story: rates.combo_reel_story ?? '',
      ig_collab: rates.ig_collab ?? '',
      ig_ad_15day: rates.ig_ad_15day ?? '',
      // Platformlar: UC SATIR DA her zaman acilir — kayitta olmayan platform dahil.
      // Mecralar satirinda YALNIZ TAKIPCI girilir. Kullanici adi ust kutulardan
      // (instagram_handle, ...) gelir; sunucu platforms girisini ondan aynalar
      // (Y10, mdbKimlikAynasi) — ust kutuya ad girilince giris de acilir.
      platforms: Object.fromEntries(
        FOLLOWER_ORDER.map((pf) => {
          const e = platformEntry(doc, pf);
          return [pf, { followers: e?.followers ?? '' }];
        })
      ),
      // Cocuklar [Y16]: bebek (AY) ve cocuk (YAS) iki grup; BUGUNKU yas girilir,
      // measured_at'i sunucu yazar. Her giris orijinal indeksini (ref) tasir.
      // UC DURUM: kayitta children yoksa iki sayac da bos (bilinmiyor).
      // HAM AY ve DOKUNULDU BAYRAGI: kutu yuvarli gorunebilir; kullanici SAYIYA
      // dokunmadikca kaydedilen deger ham aydan gelir (sema §3.6).
      cocuk: cocukTaslagiOku(doc.children, new Date(), t.decimalSep),
    });
    setSaveError('');
    setSaveConflict(null);
    setEditing(true);
  };

  const cancelEdit = () => {
    setEditing(false);
    setDraft(null);
    setSaveError('');
    // saveError ile BIRLIKTE temizlenir; ikisi ayni hata kutusunu besliyor ve
    // biri kalirsa "Kaydina git" dugmesi sahipsiz bir mesajla asili kalir.
    setSaveConflict(null);
  };

  // KARTI KAPAT — TEK CIKIS YOLU. Yeni kayit modunda taslagi temizlemek YETMEZ:
  // yeniKayitAcik true kalirsa kart ekrandan kalkar ama bayrak asili kalir ve
  // baska bir satirda "Duzenle"ye basildiginda (editing yeniden true) BOS yeni
  // kayit karti o duzenlemenin USTUNE acilir.
  const kartiKapat = (yeniMi) => {
    cancelEdit();
    if (yeniMi) setYeniKayitAcik(false);
  };

  // KULLANICININ kapatma istegi. UC CIKIS YOLU DA (Vazgec · arka plan · ESC)
  // BURADAN geciyor ve UCU DE saving'e AYNI bakiyor — kontrol tek yerde.
  // Kaydetme surerken kapatmak: POST devam eder, setOpenId kapali karta gider
  // ve finally setSaving(false) sokulmus bir bilesene yazar.
  // BASARI YOLU bu kapidan GECMEZ (kartiKapat'i dogrudan cagirir): orada saving
  // zaten true ve kapanis istenen seydir.
  //
  // KAPANDI MI BILGISINI DONDURUYOR. Cagiran kapanisin ARDINDAN baska bir sey
  // yapiyorsa (or. "Kaydina git" panel aciyor) kapi dondugunde onun da donmesi
  // gerekir; yoksa kart KAPANMADAN panel ACILIR ve ikisi ust uste biner.
  const kapatmaIstegi = (yeniMi) => {
    if (saving) return false;
    kartiKapat(yeniMi);
    return true;
  };

  // ESC. Bagimlilik [yeniKayitAcik, saving]: dinleyici kart acikken bagli olmali
  // ve kapanis kararini verirken GUNCEL saving'i gormeli — eski bir kapanista
  // takili kalirsa kaydetme surerken karti kapatir.
  useEffect(() => {
    if (!yeniKayitAcik) return undefined;
    const kapat = (e) => { if (e.key === 'Escape') kapatmaIstegi(true); };
    window.addEventListener('keydown', kapat);
    return () => window.removeEventListener('keydown', kapat);
  }, [yeniKayitAcik, saving]);

  // Onay sorulan iki yer: sayac azalinca dolu kutu gidecekse ve Potansiyel /
  // Degil secilince kayitli bebek/cocuk bosaltilacaksa. Kurallar saf
  // fonksiyonlarda (cocukSayiUygula, anneKutuSec); burada yalniz soru.
  const childOnaySor = (n) => window.confirm(t.childRemoveConfirm.replace('{n}', n));
  const cocukSayisiDegis = (grup, ham) => {
    const k = cocukSayiUygula(draft.cocuk, grup, ham, childOnaySor);
    if (k) setDraft({ ...draft, cocuk: k });
  };
  const onayliUygula = ({ d, onay }) => {
    if (onay > 0 && !window.confirm(t.childrenClearConfirm.replace('{n}', onay))) return;
    setDraft(d);
  };

  // Bebek / cocuk yas kutulari — grup basina. Birim seciciyi GRUP belirler:
  // bebek AY (tam sayi, 0-35), cocuk YAS (3-18, yarim kabul). Iki form (duzenleme
  // ve Yeni Kayit) AYNI karti kullaniyor; kutular tek yerde.
  // Sayaclar bilinmiyorken kutular GIZLENIR ama taslakta DURUR — hucre kaybolmaz
  // (panelde hicbir hucre gizlenmez, KARAR Bora 1 Eylul).
  // "yas" grubunda type="number" KULLANILMIYOR: HTML sayi girdisi virgullu "3,5"i
  // DOM'a yazmaz; inputMode="decimal" mobilde yine sayisal klavye acar.
  const cocukKutulari = (grup, kilitli) => {
    const k = draft.cocuk;
    if (cocukBilinmiyor(k)) {
      return (
        <div className="text-[12px] text-[#9B978E]" data-testid={`master-db-edit-${grup}-ages-hidden`}>
          {t.childAgesHidden}
        </div>
      );
    }
    const yas = grup === 'cocuk';
    if (!k[grup].length) return <div className="text-[12px] text-[#9B978E]">—</div>;
    return (
      <div className="flex flex-wrap gap-1.5">
        {k[grup].map((x, i) => (
          <div key={i} className="flex items-center gap-[3px]">
            <input
              {...(yas
                ? { type: 'text', inputMode: 'decimal' }
                : { type: 'number', min: '0', max: String(CHILD_YEAR_THRESHOLD - 1), step: '1' })}
              value={x.deger}
              disabled={kilitli}
              placeholder={yas ? `${CHILD_YEAR_MIN}-${CHILD_YEAR_MAX}` : `0-${CHILD_YEAR_THRESHOLD - 1}`}
              onChange={(e) => setDraft({ ...draft, cocuk: cocukDegerYaz(k, grup, i, e.target.value) })}
              className="w-[60px] text-[12px] h-[29px] px-[5px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] disabled:opacity-60"
              data-testid={`master-db-edit-${grup}-${i}`}
            />
            <span className="text-[11px] text-[#9B978E]">{yas ? t.yearUnit : t.monthUnit}</span>
          </div>
        ))}
      </div>
    );
  };


  // MUKERRER 409 — IKI BICIM, TEK COZUCU.
  //   POST  -> { field, existing_id, existing_name }   (yeni kayit)
  //   PATCH -> { conflict: { _id, field, full_name, ... } }
  // Iki ayri catch yazilsaydi mesaj metni iki yerde yasardi; burada tek yerde.
  const cakismayiOku = (veri) => {
    const c = veri?.conflict;
    if (c) {
      // [Y29] Kutuda "Kartlari birlestir": KALAN = adi tasiyan kart (c._id).
      setSaveConflict(c._id ? { id: c._id, name: c.full_name || null, birlestir: true } : null);
      setSaveError(
        t.handleConflict
          .replace('{alan}', t.handleFieldLabel[c.field] || t.handleFieldFallback)
          .replace('{name}', c.full_name || '—')
          .replace('{handle}', c[c.field] || c.instagram_handle || '—')
          .replace('{id}', c._id || '—')
      );
      return true;
    }
    if (veri?.existing_id) {
      // "Kaydina git" DUGMESI icin hedef ayri state'te: saveError dizge tutuyor.
      setSaveConflict({ id: veri.existing_id, name: veri.existing_name || null });
      setSaveError(
        t.newRecordDuplicate.replace('{alan}', t.handleFieldLabel[veri.field] || t.handleFieldFallback)
        + (veri.existing_name ? ` — ${veri.existing_name}` : '')
      );
      return true;
    }
    return false;
  };

  const saveEdit = async (doc, yeniMi = false) => {
    setSaveConflict(null);
    // Zorunluluk TEK YUKLEMDEN (P3) ve yalnizca yeni kayitta.
    if (mdbHandleEksik(draft, yeniMi)) return;
    const kurulum = mdbGovdeKur(draft, yeniMi ? {} : doc);
    if (kurulum.hata === 'cocukYas') {
      setSaveError(t.childAgeRequired);
      return;
    }
    const { fields, acikCevaplar, instagramBio } = kurulum;

    // Platformlar: yalnizca takipcisi DEGISENLER, yalnizca followers.
    // handle GONDERILMEZ: kullanici adi ust seviye alanda (fields) duruyor,
    // platforms[].handle'i sunucu ondan aynalar; govdede handle gelirse 400.
    const platformsPatch = {};
    for (const pf of FOLLOWER_ORDER) {
      const e = platformEntry(doc, pf);
      const d0 = draft.platforms[pf];
      const oncekiF = e?.followers ?? '';
      if (String(d0.followers) !== String(oncekiF)) {
        platformsPatch[pf] = { followers: d0.followers };
      }
    }

    // "Diger mecra" ve not TEK add_note'ta birlesir; mecra satiri basa gelir.
    // Ikisi de yeniMi'ye bagli alanlar, o yuzden yalnizca yeni kayitta doluyor.
    const notParcalari = [];
    if (draft.diger_mecra.trim()) notParcalari.push(`Diğer mecra: ${draft.diger_mecra.trim()}`);
    if (draft.note.trim()) notParcalari.push(draft.note.trim());

    // TEK IF. Govde kurulumu ZATEN ortak (P2); ayrisan yalnizca uc ve
    // ucun okudugu anahtarlar.
    if (yeniMi) {
      // platforms YENI KAYITTA GONDERILMEZ: POST ucu req.body.platforms'u
      // OKUMUYOR (olculdu). Gonderilseydi sessizce yok sayilirdi.
      const govde = { fields };
      if (instagramBio) govde.instagram_bio = instagramBio;
      if (notParcalari.length) govde.add_note = notParcalari.join('\n\n');
      if (acikCevaplar.length) govde.explicit_fields = acikCevaplar;
      setSaving(true);
      setSaveError('');
      try {
        const token = authToken();
        const res = await axios.post(`${API}/master-database/influencers`, govde, {
          headers: { Authorization: `Bearer ${token}` },
        });
        // BASARI YOLU kapatmaIstegi'nden GECMEZ: burada saving true ve kapanis
        // istenen sey. Kapi yalnizca KULLANICI cikislari icin.
        kartiKapat(true);
        // SIRA: once TABLO, sonra acilis. setOpenId tablodan once cagrilirsa
        // kayit henuz listede yokken acilmaya calisilir ve panel kapali kalir
        // (keepOpenId acik kaydi listede bulamayinca dusuruyor).
        //
        // res.data._id OLCULDU: POST 201 govdesi
        // { _id: String(sonuc.insertedId), instagram_handle, ignored_fields }.
        // Alan gercekten var; yine de savunma kondu — yoksa panel sessizce
        // kapanir, kayit acilmaz ve kimse sebebini anlamaz.
        await fetchTable();
        if (res.data?._id) setOpenId(res.data._id);
        // Sekme sayaclari da BEKLENIR: await edilmezse "Talent 0" bir sure bayat
        // kalir ve kimse sebebini anlamaz (madde 49 sinifi).
        await fetchTabCounts();
      } catch (err) {
        const kod = err?.response?.status;
        if (kod === 401) {
          mdbTokenSil();
          setStatus('giris');
        } else if (kod === 409 && cakismayiOku(err.response?.data)) {
          // cakismayiOku mesaji ve "Kaydina git" hedefini kurdu
        } else {
          setSaveError(err?.response?.data?.error || t.saveError);
        }
      } finally {
        setSaving(false);
      }
      return;
    }

    const body = { updated_at: doc.updated_at || null };
    if (Object.keys(fields).length) body.fields = fields;
    // Bos gonderilmez: hicbir uc durumlu alan degismediyse anahtar hic olusmaz ve
    // sunucu bugunku korumanin tam altinda kalir.
    if (acikCevaplar.length) body.explicit_fields = acikCevaplar;
    if (Object.keys(platformsPatch).length) body.platforms = platformsPatch;
    if (instagramBio !== undefined) body.instagram_bio = instagramBio;
    if (!body.fields && !body.platforms && body.instagram_bio === undefined) {
      cancelEdit();
      return;
    }
    const ok = await patchRecord(doc, body);
    if (ok) cancelEdit();
  };

  // --- Yetki kontrolu (mount) ---
  const loadMe = async (isActive = () => true) => {
    setStatus('loading');
    const token = authToken();
    if (!token) {
      // Admin paneline YONLENDIRILMEZ: master-database'in kendi girisi var.
      setStatus('giris');
      return;
    }
    try {
      const res = await axios.get(`${API}/master-database/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!isActive()) return;
      setUser({ email: res.data.email, role: res.data.role });
      setStatus('ok');
    } catch (err) {
      if (!isActive()) return;
      const code = err.response?.status;
      if (code === 401) {
        mdbTokenSil();
        setStatus('giris');
      } else if (code === 403) {
        setStatus('forbidden');
      } else {
        console.error('Master database /me error:', err);
        setStatus('error');
      }
    }
  };

  useEffect(() => {
    let active = true;
    loadMe(() => active);
    return () => {
      active = false;
    };
    // Sadece mount'ta calisir.
  }, []);

  // --- Tablo verisi ---
  const fetchTable = useCallback(
    async (isActive = () => true) => {
      const token = authToken();
      if (!token) {
        setStatus('giris');
        return;
      }
      // Hicbiri secili degil: istek ATILMAZ, liste bos ve mesaj gosterilir.
      if (sekmeSecilmedi) {
        setData({ items: [], total: 0, age_undated: 0 });
        setTableStatus('ok');
        setOpenId(null);
        return;
      }
      setTableStatus('loading');
      try {
        const params = listeParams();
        params.set('page', String(page));
        params.set('limit', String(PAGE_LIMIT));
        if (sort) {
          params.set('sort', SORTABLE[sort]);
          params.set('dir', dir);
        }
        const res = await axios.get(`${API}/master-database/influencers?${params.toString()}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!isActive()) return;
        const nextItems = res.data.items || [];
        setData({
          items: nextItems,
          total: res.data.total || 0,
          age_undated: res.data.age_undated || 0,
        });
        setTableStatus('ok');
        setTableErrorDetay('');
        // Acik detay paneli: kayit YENI listede de varsa acik kalir, yoksa kapanir.
        // Siralama degisimi kaydi listeden cikarmaz — panelin kapanmasi icin sebep yok.
        // Filtre/arama/sekme degisiminde resetView() zaten paneli kapatiyor (kayit
        // gercekten listeden dusmus olabilir).
        setOpenId((prev) => keepOpenId(prev, nextItems));
      } catch (err) {
        if (!isActive()) return;
        const code = err.response?.status;
        if (code === 401) {
          mdbTokenSil();
          setStatus('giris');
        } else if (code === 403) {
          setStatus('forbidden');
        } else {
          console.error('Master database influencers error:', err);
          // [Y27] Dogrulama hatasi (400) sunucunun mesajiyla gosterilir.
          setTableErrorDetay(code === 400 ? (err?.response?.data?.error || '') : '');
          setTableStatus('error');
        }
      }
    },
    // urlKey: filtre/arama/sekme/sayfa/siralama hepsi URL'de; tek bagimlilik yeter.
    // (Nesne kimligi degil string karsilastirmasi -> gereksiz yeniden istek yok.)
    // eslint-disable-next-line
    [urlKey]
  );

  useEffect(() => {
    if (status !== 'ok') return undefined;
    let active = true;
    fetchTable(() => active);
    return () => {
      active = false;
    };
  }, [status, fetchTable]);

  // --- Sekme sayilari ---
  // Her sekme icin ayri bir countDocuments gerekiyor; limit=1 ile sadece 'total' okunur.
  // Panel filtrelerinden BAGIMSIZ: sekme rozetleri o kaynaktaki toplam kisiyi gosterir.
  //
  // Fonksiyona cikarildi cunku YAZMA SONRASI da cagriliyor (bkz. patchRecord):
  // bir kayda Talent isaretlenip kaydedildiginde panel ve audit_log guncelleniyordu
  // ama sekme cubugu "Talent 0" kaliyordu — sayilar yalnizca sayfa acilisinda
  // cekiliyordu. Ayni sorun Seeding, favori ve kaynak sekmeleri icin de gecerliydi;
  // hepsi bu tek cagriyla tazeleniyor.
  //
  // NEDEN ISTEMCIDE HESAPLAMIYORUZ: PATCH yaniti guncel belgeyi donduruyor, yani
  // sayaci yerelde ±1 oynatmak teknik olarak mumkun. Ama o zaman her sekmenin
  // "uyelik" kurali (dual, outreach/inreach, seeding...) SUNUCUDAKI filtreyle
  // birlikte ISTEMCIDE de tanimlanmis olurdu — bu oturumda tam olarak bu tur
  // ikinci kopyalarin nasil sessizce ayristigini defalarca gorduk.
  // Yeniden okumak alti tane limit=1 istegi; yalnizca YAZMA BASARILI oldugunda
  // atiliyor, panel her acilisinda degil.
  const fetchTabCounts = useCallback(async (isActive = () => true) => {
    const token = authToken();
    if (!token) return;
    const results = await Promise.all(
      TABS.map(async (tb) => {
        try {
          const params = new URLSearchParams({ page: '1', limit: '1' });
          // Her sekme TEK BASINA secili: sayac = o sekmenin kendi toplami.
          if (tb.key !== URL_DEFAULT_TAB) params.set('sekmeler', tb.key);
          const res = await axios.get(`${API}/master-database/influencers?${params.toString()}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          return [tb.key, res.data.total ?? null];
        } catch {
          return [tb.key, null];
        }
      })
    );
    if (!isActive()) return;
    setTabCounts(Object.fromEntries(results));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (status !== 'ok') return undefined;
    let active = true;
    fetchTabCounts(() => active);
    return () => {
      active = false;
    };
  }, [status, fetchTabCounts]);

  // useCallback — KIMLIGI SABIT. Asagidaki effect bunu bagimlilik olarak
  // listeliyor; her renderda yeniden uretilseydi effect her renderda kosar ve
  // setUploads yeni bir render tetikledigi icin SONSUZ DONGU olurdu.
  // Bagimlilik dizisi bos: govdesindeki her sey ya modul duzeyinde (axios, API)
  // ya da kimligi degismeyen bir setState (setUploads). authToken da modul
  // fonksiyonuna (mdbTokenOku) sabitlenmis bir referans.
  // fetchTabCounts ile ayni desen (bkz. yukarisi).
  //
  // TANIM, KULLANIMDAN ONCE OLMAK ZORUNDA. Onceden bu blok dosyanin cok
  // asagisindaydi ve asagidaki effect bagimlilik dizisinde ona atif yapiyordu:
  // const TDZ'ye takiliyor ve sayfa "Cannot access 'uploadsYukle' before
  // initialization" ile HIC RENDER EDILMIYORDU. Derleme bunu YAKALAMAZ —
  // calisma ani hatasi; CI=true npm run build sorunsuz gecmisti.

  const uploadsYukle = useCallback(async () => {
    const token = authToken();
    if (!token) return;
    setUploads((o) => ({ ...o, durum: 'loading' }));
    try {
      const res = await axios.get(`${API}/master-database/uploads`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUploads({ durum: 'ok', items: res.data.items || [] });
    } catch (err) {
      console.error('Master database uploads list error:', err);
      setUploads({ durum: 'error', items: [] });
    }
  }, []);

  // --- Yukleme kuyrugu (SAYFA BASINA BIR KEZ) ---
  // Rozetin varlik sebebi "kac yukleme onay bekliyor"u PANELI ACMADAN
  // gostermek; liste yalnizca dugmeye basilinca cekilseydi rozet hep bos
  // kalirdi ve kimse bekleyen isi gormezdi.
  //
  // KAYIT GECMISINDEKI TERS KARARLA CELISMEZ — "veri yalnizca bolum
  // acildiginda cekilir" karari 2.802 kayitlik influencer listesi icindi ve
  // HER PANEL ACILISINDA istek atiyordu. Burasi sayfa basina TEK istek ve
  // sunucu tarafinda limit 100. Iki durum ayni degil.
  //
  // BIR KEZ KOSAR: uploadsYukle useCallback ile sabit kimlikli, status ise
  // 'ok'a bir kez geciyor. Effect gövdesi setUploads cagiriyor ve yeni bir
  // render tetikliyor ama bagimliliklarin ikisi de degismedigi icin effect
  // TEKRAR KOSMAZ. eslint-disable YOK: iki bagimlilik da listede.
  useEffect(() => {
    if (status !== 'ok') return;
    uploadsYukle();
  }, [status, uploadsYukle]);

  // Onay bekleyenler kuyrugu. Sunucu neyin "karar bekliyor" oldugunu kendi
  // biliyor (ONAY_BEKLEYEN_TASLAK_DURUMLARI); panel o kurali TEKRAR ETMIYOR,
  // yalnizca donen bolumleri ciziyor.
  const kuyrukYukle = useCallback(async () => {
    const token = authToken();
    if (!token) return;
    setKuyruk((k) => ({ ...k, durum: 'loading' }));
    try {
      const res = await axios.get(`${API}/master-database/onay-bekleyenler`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setKuyruk({
        durum: 'ok',
        toplam: res.data.toplam || 0,
        bolumler: Array.isArray(res.data.bolumler) ? res.data.bolumler : [],
      });
    } catch (err) {
      console.error('Master database onay bekleyenler error:', err);
      // Rozet SIFIRLANMAZ, 'error' durumu ayri: "bekleyen yok" ile
      // "cekilemedi" ayni gorunmesin.
      setKuyruk((k) => ({ ...k, durum: 'error' }));
    }
  }, []);

  // Kuyruktaki bir kalemden Taslak'in KENDI plan/onay ekranina gecis.
  // YENI BIR ONAY EKRANI YOK: bugun calisan akisin ta kendisi aciliyor —
  // kart genisletme dugmesinin yaptigi ne ise aynisi.
  const kuyruktanAc = async (kalem) => {
    setKuyrukOpen(false);
    setUploadsOpen(true);
    await uploadsYukle();
    setAcikUpload(kalem._id);
    satirlariYukle(kalem._id, kalem.durum);
    if (kalem.durum === 'plan_hazir' && !planlar[kalem._id]) planiUret(kalem._id);
  };

  // Kuyruk: sayfa acilisinda BIR KEZ. Her liste istegiyle DEGIL — rozet
  // sayfa boyunca sabit kalir, panel her acildiginda ayrica tazeleniyor.
  // ROL KAPISI: uc requireMasterDbAdmin. Admin olmayan bir kullanici icin
  // istek atmak her sayfa acilisinda bir 403 uretirdi; dugme de zaten
  // gorunmuyor.
  useEffect(() => {
    if (status !== 'ok' || user?.role !== 'admin') return;
    kuyrukYukle();
  }, [status, user, kuyrukYukle]);

  // --- Sehir listesi (bir kez) ---
  useEffect(() => {
    if (status !== 'ok') return undefined;
    let active = true;
    (async () => {
      const token = authToken();
      if (!token) return;
      try {
        const res = await axios.get(`${API}/master-database/cities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (active) {
          setCities(res.data.cities || []);
          setAvailablePlatforms(res.data.platforms || []);
          setTazelikAy(typeof res.data.tazelik_ay === 'number' ? res.data.tazelik_ay : null);
          setCitiesError(false);
        }
      } catch (err) {
        console.error('Master database cities error:', err);
        if (active) setCitiesError(true);
      }
    })();
    return () => {
      active = false;
    };
  }, [status]);

  // Sekme + filtreler + arama TEK YERDEN. Listeleme ve disa aktarma AYNI
  // parametreleri gonderiyor; ayri kurulsalardi indirilen dosya ekrandakinden
  // farkli olabilirdi. Sayfalama ve siralama disarida: disa aktarmada ikisi de yok.
  const listeParams = () => {
    const p = new URLSearchParams(filtersToParams(filters));
    // Secili sekmeler — liste ve Excel'e aktar AYNI parametreyi gonderir.
    // Sekme sayaclari (fetchTabCounts) bunu GONDERMEZ: her sekme kendi toplami.
    if (sekmeler) p.set('sekmeler', sekmeler.join(','));
    // Turkce normalizasyon sunucuda yapiliyor (İ/ı sorunu) — burada ham metin gider.
    if (searchQuery) p.set('q', searchQuery);
    return p;
  };

  // --- Excel'e aktar: EKRANDAKI listenin aynisi ---
  // --- TASLAK YUKLEME (1/3) ---
  // AYRISTIRMA SECENEKLERI GOC SCRIPT'IYLE BIREBIR AYNI.
  // Ayrisirlarsa ayni dosya CLI'dan baska, arayuzden baska cikar; bu projede
  // "ayni kural iki yerde yazilirsa ayrisir" defalarca yasandi.
  //   scripts/import-influencers.js:607,777 -> XLSX.readFile(f, { cellDates: true })
  //   scripts/import-influencers.js:481-486 readSheetRows():
  //     range A1'e SABITLENIR (r.s.r = 0; r.s.c = 0)
  //     sheet_to_json(ws, { header: 1, raw: true, defval: null, blankrows: true, range })
  //
  // range SABITLEMESI KRITIK: SheetJS varsayilan olarak sheet'in kullanilan
  // araligindan baslar (or. B9). Sabitlenmezse profildeki header_row ve kolon
  // sirasi KAYAR ve esleme profili tutmaz.
  // cellDates: true -> tarih hucreleri seri numarasi degil Date olur.
  //
  // ⚠ BILINEN AYRISMA — burada DEGIL, mdb-tarama.parseDateLoose'da.
  // Satirlar sunucuya JSON ile gidiyor ve Date hucreleri ISO DIZGEYE donuyor.
  // parseDateLoose ikisine FARKLI davraniyor: Date girdisinde saat KORUNUYOR,
  // ISO dizgede gun basina INIYOR.
  //     2026-07-31T19:59:48Z  ->  Date:   2026-07-31T19:59:48Z
  //                           ->  dizge:  2026-07-31T00:00:00Z
  // OLCULDU (40 gercek dosya): 15.396 belgenin 987'sinde fark var (%6,4) —
  // rates.quoted_at, platforms.measured_at, children.measured_at,
  // notes.created_at. Dosyalardaki 1119 Date hucresinin %100'u saat tasiyor;
  // "19:59:48" gibi degerler Excel seri numarasi -> Date donusumunun yerel
  // saat + yuvarlama artigi, gercek veri degil. Yani web ciktisi daha DOGRU
  // olan (sema gun hassasiyeti istiyor), CLI'inki gurultulu.
  //
  // TARAYICI SECENEKLERI BUNUN ICIN DEGISTIRILMEDI: seceneklerle oynamak
  // ayrismayi ortmek olurdu ve CLI paritesini kirardi. Yukaridaki secenekler
  // goc script'iyle birebir ayni ve satir ciktisi da birebir ayni dogrulandi
  // (40 dosya, 104 sheet, 16.672 satir). Duzeltme parseDateLoose'da —
  // Date girdisi de dizge gibi gune normalize edilmeli — ve o dosya
  // Cowork'un turunda.
  const taslakAyristir = async (file) => {
    const buf = await file.arrayBuffer();
    // cellDates: true KALIYOR. Kaldirilirsa hucreler ham seri SAYI gelir ve
    // gunlestirme onlari hic gormez — duzeltilecek Date kalmaz, artefakt
    // sunucuya sayi olarak gider.
    const wb = XLSX.read(buf, { type: 'array', cellDates: true });
    let gunlesenToplam = 0;
    let bozulmayanToplam = 0;
    const sayfalar = wb.SheetNames.map((sheetAdi) => {
      // '_' ile baslayan sheet'ler BURADA ATLANMIYOR: sunucu (profilBul) zaten
      // atliyor ve raporunda sebebini yaziyor. Iki yerde kural olmasin.
      const ws = wb.Sheets[sheetAdi];
      if (!ws || !ws['!ref']) return { sheet: sheetAdi, satirlar: [] };
      const r = XLSX.utils.decode_range(ws['!ref']);
      r.s.r = 0; r.s.c = 0;
      const ham = XLSX.utils.sheet_to_json(ws, {
        header: 1, raw: true, defval: null, blankrows: true, range: r,
      });
      // GUNLESTIRME TAM BURADA — sheet_to_json'dan SONRA, POST'tan ONCE.
      // Donen dizi kullanilir; ham'i gondermek duzeltmeyi iptal ederdi.
      const g = satirlariGunlestir(ham);
      gunlesenToplam += g.gunlesen;
      bozulmayanToplam += g.bozulmayan;
      return {
        sheet: sheetAdi,
        // BASLIK SATIRI DAHIL, ayiklama YOK: profilBul ilk 15 satiri tarayip
        // basligi imzadan kendisi buluyor.
        satirlar: g.satirlar,
      };
    });
    return { sayfalar, gunlesen: gunlesenToplam, bozulmayan: bozulmayanToplam };
  };

  const uploadHataMetni = (err) => {
    // HAM GOVDE BASILMAZ: sunucunun ic mesaji kullaniciya bir sey anlatmaz.
    const kod = err?.response?.status;
    if (kod === 413) return t.uploadErrTooBig;
    if (kod === 400) return t.uploadErrRejected;
    if (kod === 401 || kod === 403) return t.uploadErrAuth;
    if (kod === 503) return t.uploadErrDb;
    return t.uploadErrGeneric;
  };

  const dosyaSecildi = async (e) => {
    const file = e.target.files && e.target.files[0];
    // Ayni dosya art arda secilebilsin diye input sifirlanir.
    e.target.value = '';
    if (!file || uploadBusy) return;

    setUploadError('');
    // ISTEMCI ON KONTROLU — sunucu zaten dogruluyor (uzanti + MIME + magic-byte
    // + makro izi). Buradaki tek amac hizli geri bildirim: 5 MB'lik bir dosyayi
    // yukleyip 413 beklemek gereksiz.
    // Dosya adina DOKUNULMUYOR: cift kodlama duzeltmesi sunucuda (0e6f54c).
    const nokta = file.name.lastIndexOf('.');
    const uzanti = nokta === -1 ? '' : file.name.slice(nokta).toLowerCase();
    if (!UPLOAD_UZANTILAR.includes(uzanti)) {
      setUploadError(t.uploadErrExt.replace('{list}', UPLOAD_UZANTILAR.join(', ')));
      return;
    }
    if (file.size > UPLOAD_MAX_BYTES) {
      setUploadError(t.uploadErrTooBig);
      return;
    }

    const token = authToken();
    if (!token) return;
    setUploadBusy(true);
    setUpload(null);
    setUploadRows(null);
    setPlan(null);
    try {
      // ONCE AYRISTIR, SONRA YUKLE. Tersi olsaydi bozuk bir dosya once
      // uploads'a kayit acar, ayristirma patlayinca kuyrukta plani hic
      // uretilemeyecek bir satir kalirdi.
      //
      // AYRISTIRMA KENDI try BLOGUNDA: tek blok olsaydi ag kopmasi da
      // "dosya bozuk, yukleme yapilmadi" diye gorunurdu. Ikisi de yanlis
      // olurdu — dosya saglam ve istek sunucuya ULASMIS, uploads kaydi
      // ACILMIS olabilir. Kullanici "yapilmadi" okuyup tekrar dener ve
      // ikinci bir kayit olusur.
      let ayristirma;
      try {
        ayristirma = await taslakAyristir(file);
      } catch (parseErr) {
        console.error('Master database taslak ayristirma hatasi:', parseErr);
        // Burada istek HIC atilmadi; "yukleme yapilmadi" demek dogru.
        setUploadError(t.uploadErrParse);
        return;
      }

      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(`${API}/master-database/uploads`, fd, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUploadRows(ayristirma.sayfalar);
      setUpload({
        upload_id: res.data.upload_id,
        file_name: res.data.file_name || file.name,
        sheet_sayisi: ayristirma.sayfalar.length,
        satir_sayisi: ayristirma.sayfalar.reduce((n, x) => n + x.satirlar.length, 0),
        gunlesen: ayristirma.gunlesen,
        bozulmayan: ayristirma.bozulmayan,
      });

      // PLAN HEMEN URETILIR. Yukleme tek basina zinciri tamamlamiyor: approve ucu
      // status === 'plan_hazir' sarti koyuyor ve yukleme kaydi 'yuklendi'de kaliyor.
      // Ayrica plan GORULMEDEN onay verilmemeli — ucret ve segment artik KOSULSUZ
      // eziyor (sema §3.4), onay ekrani TEK KORUMA.
      //
      // AYRI try: plan cagrisi patlarsa YUKLEME BASARILIDIR, kayit 'yuklendi'de
      // kalir. Ama kuyruktan TEKRAR DENENEMEZ: dosyanin asli saklanmiyor ve
      // upload_rows yalnizca plan BASARILI olunca yaziliyor — satir yok. Tek yol
      // dosyayi yeniden yuklemek; metin de bunu soyluyor. Geride kalan olu kaydi
      // admin silebilir (sunucu: uploadSilinebilirMi).
      //
      // 413 AYRI METIN: plan govdesi dosyanin tum satirlarini tasiyor ve sunucu
      // siniri asildi. Kullanicinin yapabilecegi tek sey satiri azaltmak —
      // genellikle Excel'in altinda bicimli kalmis bos satirlar.
      try {
        const planRes = await axios.post(
          `${API}/master-database/uploads/${res.data.upload_id}/plan`,
          { rows: ayristirma.sayfalar },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPlan(planRes.data);
      } catch (planErr) {
        console.error('Master database plan error:', planErr);
        setUploadError(planErr?.response?.status === 413 ? t.uploadErrPlanTooBig : t.uploadErrPlan);
      }
    } catch (err) {
      console.error('Master database upload error:', err);
      // response VARSA sunucu yanit vermis, kodu ne dediyse o.
      // response YOKSA istegin sunucuya ulasip ulasmadigini BILMIYORUZ —
      // "yapilmadi" demek yanlis olur, kullaniciya listeyi kontrol ettiren
      // ayri bir metin gidiyor.
      setUploadError(err && err.response ? uploadHataMetni(err) : t.uploadErrNetwork);
    } finally {
      setUploadBusy(false);
    }
  };

  // Satirlar SALT OKUMA ve TUM EKIP gorebilir (Bora karari): ekip bugune kadar
  // birbirinin yuklemesini goremiyordu, ayni dosya iki kez yukleniyordu.
  // uploadDurum: cagiran kartin status'u. 404 TEK BASINA hata demek degil —
  // hangi durumda geldigi belirliyor (asagiya bkz.).
  const satirlariYukle = async (uploadId, uploadDurum) => {
    const token = authToken();
    if (!token || (satirlar[uploadId] && satirlar[uploadId].durum === 'ok')) return;
    setSatirlar((o) => ({ ...o, [uploadId]: { durum: 'loading' } }));
    try {
      const res = await axios.get(`${API}/master-database/uploads/${uploadId}/rows`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSatirlar((o) => ({ ...o, [uploadId]: { durum: 'ok', ...res.data } }));
    } catch (err) {
      // 404 + status 'yuklendi' BEKLENEN DURUM, ariza degil: upload_rows yalnizca
      // PLAN ucu kostugunda yaziliyor, plani hic uretilmemis bir yuklemede satir
      // saklanmamistir ve sunucu dogru olarak 404 doner. Ekranin bunu
      // "getirilemedi" diye okumasi kullaniciyi olmayan bir arizaya bakmaya
      // gonderiyordu (canlida goruldu, 2 Eyl).
      // BASKA bir kod ya da BASKA bir durum ise gercekten ariza var — o zaman
      // eski metin kaliyor.
      const planYok = err?.response?.status === 404 && uploadDurum === 'yuklendi';
      if (!planYok) console.error('Master database upload rows error:', err);
      setSatirlar((o) => ({ ...o, [uploadId]: { durum: planYok ? 'plan_yok' : 'error' } }));
    }
  };

  // PLANI YENIDEN URET.
  // OLCULDU: plan ucu HALA govdede rows bekliyor — govde bos gelince 400 doner
  // ("rows gerekli"), upload_rows'tan OKUMUYOR. (upload_rows'a YAZIYOR ama
  // okuma yalnizca approve ucuna girdi.) O yuzden once satirlar cekilir, sonra
  // govdede gonderilir. Sunucu sadelesirse burasi tek satira iner.
  const planiUret = async (uploadId) => {
    const token = authToken();
    if (!token) return;
    setPlanlar((o) => ({ ...o, [uploadId]: { durum: 'loading' } }));
    try {
      const rowsRes = await axios.get(`${API}/master-database/uploads/${uploadId}/rows`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const planRes = await axios.post(
        `${API}/master-database/uploads/${uploadId}/plan`,
        { rows: rowsRes.data.rows },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPlanlar((o) => ({ ...o, [uploadId]: { durum: 'ok', data: planRes.data } }));
    } catch (err) {
      console.error('Master database plan detay error:', err);
      setPlanlar((o) => ({ ...o, [uploadId]: { durum: 'error' } }));
    }
  };

  const onayla = async (uploadId) => {
    const token = authToken();
    if (!token || onayBusy) return;
    setOnayBusy(uploadId);
    setOnaySonuc((o) => ({ ...o, [uploadId]: null }));
    try {
      // GOVDE BOS: satirlar sunucuda (upload_rows). Govdede rows gonderilse bile
      // onay ucu req.body'ye HIC bakmiyor.
      const res = await axios.post(`${API}/master-database/uploads/${uploadId}/approve`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // 207 = KISMI YAZMA. Basarisizlik DEGIL: kayitlarin bir kismi yazildi ve
      // hangilerinin yazilamadigi govdede duruyor.
      setOnaySonuc((o) => ({ ...o, [uploadId]: { tur: res.status === 207 ? 'kismi' : 'ok', veri: res.data } }));
      await uploadsYukle();
      // [Y33] Taslak onayi acik bir kartin Gecmis'ini de degistirmis olabilir.
      if (historyOpen) setHistoryYenile((n) => n + 1);
    } catch (err) {
      const kod = err?.response?.status;
      if (kod === 409) {
        // Plan degismis: araya elle bir duzenleme girmis. YAZMA YAPILMADI.
        setOnaySonuc((o) => ({ ...o, [uploadId]: { tur: 'catisma', veri: err.response.data } }));
      } else {
        console.error('Master database approve error:', err);
        setOnaySonuc((o) => ({ ...o, [uploadId]: { tur: 'hata', veri: null } }));
      }
    } finally {
      setOnayBusy(null);
    }
  };

  const geriGonder = async () => {
    const token = authToken();
    const sebep = reddetSebep.trim();
    if (!token || !reddetHedef || !sebep) return;
    setOnayBusy(reddetHedef.id);
    try {
      await axios.post(`${API}/master-database/uploads/${reddetHedef.id}/reject`,
        { reason: sebep }, { headers: { Authorization: `Bearer ${token}` } });
      setReddetHedef(null);
      setReddetSebep('');
      await uploadsYukle();
    } catch (err) {
      console.error('Master database reject error:', err);
      setOnaySonuc((o) => ({ ...o, [reddetHedef.id]: { tur: 'hata', veri: null } }));
    } finally {
      setOnayBusy(null);
    }
  };

  // --- KAYIT SILME (detay paneli) ---
  // Dugmeye basmak HICBIR SEY SILMEZ: yalnizca onizlemeyi ceker ve pencereyi acar.
  // Onizleme sunucudan gelir (GET .../silme-onizleme); kalem sayilari orada
  // hesaplanir, panelde ikinci bir kural yazilmaz.
  // talep: onay kuyrugundan acildiysa onaylanan silme talebi. Pencere AYNI;
  // [Onayla] o zaman DELETE yerine talebin onay ucunu cagirir.
  const silmeAc = async (doc, talep = null) => {
    setSilmeHedef({ doc, talep });
    setSilmeOnizleme(null);
    setSilmeSebep('');
    setSilmeHata('');
    const token = authToken();
    if (!token) { setStatus('giris'); return; }
    try {
      const res = await axios.get(`${API}/master-database/influencers/${doc._id}/silme-onizleme`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSilmeOnizleme(res.data);
    } catch (err) {
      console.error('Master database silme onizleme error:', err);
      // Onizleme cekilemedi: pencere ACIK KALIR ve hata gorunur. Kapatmak,
      // kullanicinin "sildim mi?" diye emin olamamasina yol acardi.
      setSilmeOnizleme('hata');
    }
  };

  const silmeKapat = () => {
    setSilmeHedef(null);
    setSilmeOnizleme(null);
    setSilmeSebep('');
    setSilmeHata('');
  };

  // "Onizleme gorulmeden silinmez" kurali TEK YERDE. Hem dugmenin
  // pasifligi hem handler'in guard'i buradan okur; ikisi ayri yazilirsa
  // biri degistiginde digeri sessizce geride kalir.
  const silmeOnizlemeHazir = silmeOnizleme !== null && silmeOnizleme !== 'hata';

  // === TOPLU SECIM / SILME ===
  const topluYetki = user?.role === 'admin';
  useEffect(() => {
    setSecili(new Set());
    setFiltreSecimi('idle');
  }, [secimAnahtari]);
  const seciliDegistir = (id) => setSecili((onceki) => {
    const yeni = new Set(onceki);
    if (yeni.has(id)) yeni.delete(id); else yeni.add(id);
    return yeni;
  });
  const sayfaSec = (kayitlar, sec) => setSecili((onceki) => {
    const yeni = new Set(onceki);
    for (const d of kayitlar) { if (sec) yeni.add(d._id); else yeni.delete(d._id); }
    return yeni;
  });
  // "Filtredeki {n} kaydin tumunu sec": liste ucuyla AYNI parametreler (listeParams).
  const filtreTumunuSec = async () => {
    const token = authToken();
    if (!token || filtreSecimi === 'busy') return;
    setFiltreSecimi('busy');
    try {
      const res = await axios.get(`${API}/master-database/influencers/idler?${listeParams().toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!Array.isArray(res.data.idler)) { setFiltreSecimi('error'); return; }
      setSecili(new Set(res.data.idler));
      setFiltreSecimi('idle');
    } catch (err) {
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      setFiltreSecimi('error');
    }
  };
  const topluKapat = () => {
    setTopluPencere(null);
    setTopluSebep('');
    setTopluHata('');
  };
  const topluSilAc = async () => {
    const token = authToken();
    if (!token || !secili.size) return;
    setTopluPencere({ onizleme: null, sonuc: null });
    setTopluSebep('');
    setTopluHata('');
    try {
      const res = await axios.post(`${API}/master-database/influencers/toplu-silme-onizleme`,
        { ids: [...secili] }, { headers: { Authorization: `Bearer ${token}` } });
      setTopluPencere({ onizleme: res.data, sonuc: null });
    } catch (err) {
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      setTopluPencere({ onizleme: 'hata', sonuc: null });
      setTopluHata(err.response?.data?.error || '');
    }
  };
  // Onizleme gorulmeden silinmez — tekli silmeyle ayni kural.
  const topluOnizlemeHazir = Boolean(topluPencere && topluPencere.onizleme && topluPencere.onizleme !== 'hata'
    && !topluPencere.sonuc && topluPencere.onizleme.kayit_sayisi > 0);
  const topluSil = async () => {
    const token = authToken();
    if (!token || topluBusy || !topluOnizlemeHazir) return;
    const onizleme = topluPencere.onizleme;
    setTopluBusy(true);
    setTopluHata('');
    try {
      const res = await axios.post(`${API}/master-database/influencers/toplu-sil`,
        { ids: [...secili], sebep: topluSebep.trim() }, { headers: { Authorization: `Bearer ${token}` } });
      const r = res.data;
      setSecili(new Set());     // silmeden sonra secim SIFIRLANIR
      setOpenId((acik) => (r.silinen.some((x) => x._id === acik) ? null : acik));
      await fetchTable();
      fetchTabCounts();
      if (kuyrukOpen) kuyrukYukle(); // bekleyen silme talepleri kapanmis olabilir
      showToast(t.bulkDeletedToast.replace('{n}', fmtSayi(r.silinen.length)));
      // Hatali / bulunamayan varsa pencere ADLARIYLA acik kalir; yoksa kapanir.
      if (r.hatali.length || r.bulunamayan.length) setTopluPencere({ onizleme, sonuc: r });
      else topluKapat();
    } catch (err) {
      console.error('Master database toplu silme error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      setTopluHata(err.response?.data?.error || t.bulkDeleteError);
    } finally {
      setTopluBusy(false);
    }
  };
  // Pencerede kayit adi: onizlemenin kayitlar listesinden (secim sayfa disina
  // tasabildigi icin ekrandaki satirlar yetmez).
  const topluAd = (k) => {
    if (!k) return '—';
    const ad = safeText(k.full_name);
    const kim = k.kimlik ? kimlikEtiketi(k.kimlik) : null;
    return ad && kim ? `${ad} (${kim})` : (ad || kim || t.deleteRecordNoName);
  };
  const topluAdById = (id) => {
    const o = topluPencere && topluPencere.onizleme && topluPencere.onizleme !== 'hata' ? topluPencere.onizleme : null;
    const k = o && (o.kayitlar || []).find((x) => x._id === id);
    return k ? topluAd(k) : id;
  };

  const kayitSil = async () => {
    const token = authToken();
    const sebep = silmeSebep.trim();
    if (!token || !silmeHedef || silmeBusy) return;
    // Dugme tek yol degil: form Enter ile de gonderilebilir.
    if (!silmeOnizlemeHazir) return;
    const doc = silmeHedef.doc;
    const talep = silmeHedef.talep;
    setSilmeBusy(true);
    setSilmeHata('');
    try {
      if (talep) {
        // Silme sebebini SUNUCU kurar (talep sebebi + talep eden + onaylayan).
        await axios.post(`${API}/master-database/kayit-talepleri/${talep._id}/onayla`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.delete(`${API}/master-database/influencers/${doc._id}`, {
          headers: { Authorization: `Bearer ${token}` },
          data: { sebep },
        });
      }
      const handle = doc.instagram_handle || safeText(doc.full_name) || '—';
      silmeKapat();
      setOpenId(null);          // detay paneli kapanir: kayit artik yok
      await fetchTable();       // liste tazelenir
      fetchTabCounts();         // sekme rozetleri de; kayit sayilardan dustu
      if (talep || kuyrukOpen) kuyrukYukle(); // kuyruk rozeti de
      showToast(t.deletedToast.replace('{handle}', handle));
    } catch (err) {
      console.error('Master database influencer delete error:', err);
      if (err.response?.status === 401) {
        mdbTokenSil();
        setStatus('giris');
        return;
      }
      // PENCERE ACIK KALIR ve sebep alani DOLU durur: kullanici yazdigini
      // kaybetmeden tekrar deneyebilsin.
      setSilmeHata(talep ? talepHataMetni(err) : (err.response?.data?.error || t.deleteRecordError));
    } finally {
      setSilmeBusy(false);
    }
  };

  // --- SILME TALEBI ---
  // Hata metni durum koduna gore TR/EN: 409 zaten bekleyen talep / karar
  // verilmis, 403 yetki, 400 sebep kisa. Sunucu metni yedek.
  const talepHataMetni = (err) => {
    const kod = err?.response?.status;
    if (kod === 409) return t.deleteRequestErr409;
    if (kod === 403) return t.deleteRequestErr403;
    if (kod === 400) return t.deleteRequestErr400;
    return err?.response?.data?.error || t.deleteRequestErr;
  };

  const kayitTalebiYukle = async (id) => {
    const token = authToken();
    if (!token || !id) return;
    setKayitTalebi({ id, durum: 'loading', talep: null });
    try {
      const res = await axios.get(`${API}/master-database/influencers/${encodeURIComponent(id)}/silme-talebi`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setKayitTalebi((k) => (k.id === id
        ? { id, durum: 'ok', talep: res.data.talep || null, birlestirme: res.data.birlestirme_talebi || null } : k));
    } catch (err) {
      console.error('Master database silme talebi durumu error:', err);
      setKayitTalebi((k) => (k.id === id ? { id, durum: 'error', talep: null } : k));
    }
  };

  // Detay acilinca TEK istek; kapaninca temizlenir.
  useEffect(() => {
    if (!openId) { setKayitTalebi({ id: null, durum: 'idle', talep: null }); return; }
    kayitTalebiYukle(openId);
    // eslint-disable-next-line
  }, [openId]);

  const talepAc = (doc) => {
    setTalepHedef({ doc });
    setTalepSebep('');
    setTalepHata('');
  };
  const talepKapat = () => {
    setTalepHedef(null);
    setTalepSebep('');
    setTalepHata('');
  };
  const talepGonder = async () => {
    const token = authToken();
    if (!token || !talepHedef || talepBusy) return;
    // Uzunluk kurali sunucuda (400); burada yalniz bos gonderim engelleniyor.
    if (!talepSebep.trim()) return;
    const doc = talepHedef.doc;
    setTalepBusy(true);
    setTalepHata('');
    try {
      const res = await axios.post(`${API}/master-database/influencers/${doc._id}/silme-talebi`,
        { sebep: talepSebep }, { headers: { Authorization: `Bearer ${token}` } });
      setKayitTalebi({ id: doc._id, durum: 'ok', talep: res.data.talep || null });
      talepKapat();
      showToast(t.deleteRequestSentToast);
    } catch (err) {
      console.error('Master database silme talebi error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      // 409: baskasi az once talep acti — detaydaki satir onu gostersin.
      if (err.response?.status === 409 && err.response?.data?.talep) {
        setKayitTalebi({ id: doc._id, durum: 'ok', talep: err.response.data.talep });
      }
      setTalepHata(talepHataMetni(err));
    } finally {
      setTalepBusy(false);
    }
  };
  const talepGeriCek = async (talep) => {
    const token = authToken();
    if (!token || !talep || talepBusy) return;
    setTalepBusy(true);
    try {
      const res = await axios.post(`${API}/master-database/kayit-talepleri/${talep._id}/iptal`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setKayitTalebi((k) => ({ ...k, talep: res.data.talep || null }));
      showToast(t.deleteRequestWithdrawnToast);
    } catch (err) {
      console.error('Master database silme talebi iptal error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      showToast(talepHataMetni(err));
      kayitTalebiYukle(talep.influencer_id);
    } finally {
      setTalepBusy(false);
    }
  };

  // Kuyruk: talebin kaydina git — arama kaydin handle'i, diger filtreler
  // sifirlanir (kayit bir filtreye takilip gorunmez olmasin), detay acilir.
  const talepKaydinaGit = (kalem) => {
    const handle = kalem.kayit_ozeti?.instagram_handle || kalem.kayit?.instagram_handle;
    if (!handle) return;
    setKuyrukOpen(false);
    setSearchInput(handle);
    // Profil gruplari da KAPANIR ('tumu'): varsayilan Kadın + Anne (Hamile dahil) erkek ya da
    // anne olmayan bir kaydi gizlerdi.
    const bos = paramsToView(new URLSearchParams());
    updateView({ ...bos, filters: { ...bos.filters, ...PROFIL_FILTRE_TUMU }, q: handle }, { push: true });
    setProfilGecici(true);
    setOpenId(kalem.influencer_id);
  };
  const talepOnayAc = (kalem) => {
    const oz = kalem.kayit_ozeti || kalem.kayit || {};
    silmeAc({ _id: kalem.influencer_id, full_name: oz.full_name, instagram_handle: oz.instagram_handle }, kalem);
  };
  const talepRetAc = (kalem) => {
    setTalepRetHedef(kalem);
    setTalepRetNot('');
    setTalepRetHata('');
  };
  const talepRetKapat = () => {
    setTalepRetHedef(null);
    setTalepRetNot('');
    setTalepRetHata('');
  };
  const talepReddet = async () => {
    const token = authToken();
    if (!token || !talepRetHedef || talepRetBusy) return;
    setTalepRetBusy(true);
    setTalepRetHata('');
    try {
      await axios.post(`${API}/master-database/kayit-talepleri/${talepRetHedef._id}/reddet`,
        { not: talepRetNot }, { headers: { Authorization: `Bearer ${token}` } });
      talepRetKapat();
      kuyrukYukle();
      showToast(t.rejectRequestToast);
    } catch (err) {
      console.error('Master database silme talebi ret error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      setTalepRetHata(talepHataMetni(err));
    } finally {
      setTalepRetBusy(false);
    }
  };

  // === [Y29] KART BIRLESTIRME ===
  // Onizleme her secimde / yer degisiminde SUNUCUDAN yeniden istenir — kural
  // panelde yazilmaz (lib/mdb-kayit-birlestir.js). Admin birlestirir; ekip uyesi
  // talep gonderir. 409 (kartlar degisti) gelirse onizleme yenilenir.
  const birlestirOnizle = async (kalan, giden, secimler, ek = {}) => {
    const token = authToken();
    if (!token) return;
    setBirlestir((b) => ({ ...(b || {}), kalan, giden, secimler, onizleme: null, hata: '', onay: false, ...ek }));
    try {
      const res = await axios.post(`${API}/master-database/birlestir/onizleme`, { kalan, giden, secimler }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBirlestir((b) => (b && b.kalan === kalan && b.giden === giden && b.secimler === secimler
        ? { ...b, onizleme: res.data } : b));
    } catch (err) {
      console.error('Master database birlestirme onizleme error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      setBirlestir((b) => (b && b.kalan === kalan && b.giden === giden
        ? { ...b, onizleme: 'hata', hata: err.response?.data?.error || t.mergePreviewError } : b));
    }
  };
  const birlestirAc = (kalan, giden, ek = {}) => {
    setBirlestirGiris({ id: null, deger: '' });
    birlestirOnizle(String(kalan), String(giden), ek.secimler || {},
      { sebep: t.mergeReasonDefault, talep: null, busy: false, ...ek });
  };
  const birlestirKapat = () => { if (!birlestir?.busy) setBirlestir(null); };
  const birlestirIdleri = () => {
    const o = birlestir?.onizleme && birlestir.onizleme !== 'hata' ? birlestir.onizleme : null;
    return o ? { kalan: String(o.kalan._id), giden: String(o.giden._id) } : { kalan: birlestir.kalan, giden: birlestir.giden };
  };
  const birlestirSec = (alan, taraf) => {
    if (!birlestir || birlestir.busy) return;
    const { kalan, giden } = birlestirIdleri();
    birlestirOnizle(kalan, giden, { ...(birlestir.secimler || {}), [alan]: taraf });
  };
  const birlestirYerDegistir = () => {
    if (!birlestir || birlestir.busy) return;
    const { kalan, giden } = birlestirIdleri();
    birlestirOnizle(giden, kalan, {});
  };
  // Birlesik kart acilir: arama kalan kartin adi, filtreler sifir (talepKaydinaGit deseni).
  const birlesikKartaGit = (id, handle) => {
    setEditing(false);
    setDraft(null);
    setSaveError('');
    setSaveConflict(null);
    if (handle) {
      setSearchInput(handle);
      const bos = paramsToView(new URLSearchParams());
      updateView({ ...bos, filters: { ...bos.filters, ...PROFIL_FILTRE_TUMU }, q: handle }, { push: true });
      setProfilGecici(true);
    }
    setOpenId(id);
  };
  const birlestirGonder = async () => {
    const token = authToken();
    const o = birlestir?.onizleme && birlestir.onizleme !== 'hata' ? birlestir.onizleme : null;
    if (!token || !o || birlestir.busy) return;
    const adminMi = user?.role === 'admin';
    // Admin: ilk tik soruyu gosterir, ikinci tik birlestirir.
    if (adminMi && !birlestir.onay) { setBirlestir((b) => ({ ...b, onay: true })); return; }
    const govde = {
      kalan_id: String(o.kalan._id), giden_id: String(o.giden._id),
      secimler: birlestir.secimler || {}, imza: o.imza,
    };
    setBirlestir((b) => ({ ...b, busy: true, hata: '' }));
    try {
      if (adminMi) {
        const res = await axios.post(`${API}/master-database/birlestir`,
          { ...govde, ...(birlestir.talep ? { talep_id: birlestir.talep._id } : {}) },
          { headers: { Authorization: `Bearer ${token}` } });
        const talepliydi = Boolean(birlestir.talep);
        setBirlestir(null);
        birlesikKartaGit(res.data.kalan_id, o.sonuc?.instagram_handle || null);
        await fetchTable();
        fetchTabCounts();
        if (talepliydi || kuyrukOpen) kuyrukYukle();
        showToast(t.mergeDoneToast);
      } else {
        await axios.post(`${API}/master-database/birlestir/talep`, { ...govde, sebep: birlestir.sebep },
          { headers: { Authorization: `Bearer ${token}` } });
        setBirlestir(null);
        if (openId) kayitTalebiYukle(openId);
        showToast(t.mergeRequestSentToast);
      }
    } catch (err) {
      console.error('Master database birlestirme error:', err);
      if (err.response?.status === 401) { mdbTokenSil(); setStatus('giris'); return; }
      const veri = err.response?.data || {};
      if (err.response?.status === 409 && /değişti/.test(veri.error || '')) {
        // Imza ya da KALAN degisti: onizleme yeniden kurulur, uyari kalir.
        const { kalan, giden } = { kalan: govde.kalan_id, giden: govde.giden_id };
        await birlestirOnizle(kalan, giden, birlestir.secimler || {}, { busy: false });
        setBirlestir((b) => (b ? { ...b, hata: t.mergeChanged } : b));
        return;
      }
      setBirlestir((b) => (b ? { ...b, busy: false, onay: false, hata: veri.error || t.mergeError } : b));
    }
  };
  // Kuyruk satiri: talebin kalan / giden / secimleriyle ayni pencere.
  const talepBirlestirmeAc = (kalem) => {
    setKuyrukOpen(false);
    birlestirAc(kalem.kalan_id, kalem.influencer_id, { secimler: kalem.secimler || {}, talep: kalem });
  };

  // Esc ile kapanir; kapanma = VAZGECME, silme yapilmaz.
  // Silme surerken (silmeBusy) Esc yok sayilir: istek yolda, pencereyi kapatmak
  // sonucu gizlerdi.
  useEffect(() => {
    if (!silmeHedef) return undefined;
    const esc = (e) => { if (e.key === 'Escape' && !silmeBusy) silmeKapat(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [silmeHedef, silmeBusy]);

  const yuklemeSil = async () => {
    const token = authToken();
    if (!token || !silHedef) return;
    setOnayBusy(silHedef.id);
    try {
      await axios.delete(`${API}/master-database/uploads/${silHedef.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSilHedef(null);
      setAcikUpload(null);
      await uploadsYukle();
    } catch (err) {
      console.error('Master database upload delete error:', err);
      setOnaySonuc((o) => ({ ...o, [silHedef.id]: { tur: 'hata', veri: null } }));
    } finally {
      setOnayBusy(null);
    }
  };

  const exportExcel = async () => {
    const token = authToken();
    if (!token || exporting || sekmeSecilmedi) return;
    setExporting(true);
    setExportError('');
    try {
      const res = await axios.get(`${API}/master-database/export?${listeParams().toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `master-database-${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      // Blob URL'i serbest birak: birakilmazsa sekme kapanana kadar bellekte kalir.
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Master database export error:', err);
      setExportError(t.exportError);
    } finally {
      setExporting(false);
    }
  };

  // --- Liste eslestirme ---
  // Satirlar ISTEMCIDE bolunur, ayristirma SUNUCUDA yapilir: handle normalizasyonu
  // ve isim dogrulamasi tek yerde kalsin (sunucudaki normalizeHandle).
  const listMatchLines = () =>
    listMatchText.split('\n').map((x) => x.trim()).filter(Boolean);

  const runListMatch = async () => {
    const token = authToken();
    const lines = listMatchLines();
    if (!token || listMatchBusy || !lines.length) return;
    if (lines.length > LIST_MATCH_MAX) {
      setListMatchError(t.listMatchTooMany.replace('{n}', LIST_MATCH_MAX));
      return;
    }
    setListMatchBusy(true);
    setListMatchError('');
    try {
      const res = await axios.post(
        `${API}/master-database/list-match`,
        { lines },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setListMatch(res.data);
      setListMatchOpen(false);
      // Acik detay paneli kapanir: tablo artik baska kayitlari gosteriyor.
      setOpenId(null);
    } catch (err) {
      console.error('Master database list-match error:', err);
      setListMatchError(err?.response?.data?.error || t.listMatchError);
    } finally {
      setListMatchBusy(false);
    }
  };

  // UCUNU BIRDEN sifirlar: yapistirilan metin, sonuc kumesi, reddedilen satirlar.
  // setListMatchText BURADA EKSIKTI: sonuc temizleniyordu ama panel yeniden
  // acildiginda eski 120 satir oldugu gibi duruyordu. Yarisini temizleyen bir
  // dugme hic olmayandan kotu — kullanici temizlendigini sanip eski listeye bakar.
  // (Reddedilen satirlar ayri bir state DEGIL: sonuc nesnesinin icinde geliyor,
  //  setListMatch(null) ucunu birden dusuruyor.)
  const clearListMatch = () => {
    setListMatchText('');
    setListMatch(null);
    setListMatchError('');
    setOpenId(null);
  };

  const exportListMatch = async () => {
    const token = authToken();
    const lines = listMatchLines();
    if (!token || exporting || !lines.length) return;
    setExporting(true);
    setExportError('');
    try {
      const res = await axios.post(
        `${API}/master-database/list-match/export`,
        { lines },
        { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `liste-eslestirme-${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Master database list-match export error:', err);
      setExportError(t.exportError);
    } finally {
      setExporting(false);
    }
  };

  // --- [Y27] Marka filtresi debounce (300ms) — arama kutusuyla ayni desen ---
  // Kutu yerel durum; URL'ye 300 ms sonra yazilir. URL disaridan degisirse
  // (temizle, geri tusu) kutu ona esitlenir.
  useEffect(() => {
    const id = setTimeout(() => {
      const next = markaInput.trim();
      if (next !== filters.marka) patchFilters({ marka: next });
    }, 300);
    return () => clearTimeout(id);
  }, [markaInput]);
  useEffect(() => {
    setMarkaInput((onceki) => (onceki.trim() === filters.marka ? onceki : filters.marka));
  }, [filters.marka]);
  // [Y32] Hediyelesme filtresi — ayni debounce deseni.
  useEffect(() => {
    const id = setTimeout(() => {
      const next = hediyeInput.trim();
      if (next !== filters.hediye) patchFilters({ hediye: next });
    }, 300);
    return () => clearTimeout(id);
  }, [hediyeInput]);
  useEffect(() => {
    setHediyeInput((onceki) => (onceki.trim() === filters.hediye ? onceki : filters.hediye));
  }, [filters.hediye]);

  // --- [Y32b] Gecici "tumu"dan donus: kayda git / birlesik karta git sonrasi arama
  // bosalirsa (yazarak silme ya da temizle) profil gruplari VARSAYILANA doner. ---
  useEffect(() => {
    if (!profilGecici || searchQuery) return;
    setProfilGecici(false);
    updateView({ filters: { ...PROFIL_FILTRE_VARSAYILAN }, page: 1 });
    // eslint-disable-next-line
  }, [searchQuery, profilGecici]);

  // --- Arama debounce (300ms) ---
  useEffect(() => {
    const id = setTimeout(() => {
      const next = searchInput.trim();
      if (next !== searchQuery) updateView({ q: next, page: 1 });
    }, 300);
    return () => clearTimeout(id);
  }, [searchInput]);

  const clearSearch = () => {
    // Temizlemede debounce beklenmez — aninda uygulanir.
    setSearchInput('');
    updateView({ q: '', page: 1 });
    resetView();
  };

  // --- Kampanya gecmisi (detay paneli acilinca) ---
  useEffect(() => {
    if (!openId) return undefined;
    const doc = data.items.find((d) => d._id === openId);
    const handle = doc?.instagram_handle;
    if (!handle) {
      // Handle yoksa kampanya SORGULANAMAZ. Bunu "kampanyasi yok" ile ayni gostermek
      // yaniltici olurdu (122 kayitta handle yok) — ayri bir durum olarak isaretlenir.
      setCampaigns({ status: 'no_handle', items: [] });
      return undefined;
    }
    let active = true;
    (async () => {
      const token = authToken();
      if (!token) return;
      setCampaigns({ status: 'loading', items: [] });
      try {
        const res = await axios.get(
          `${API}/master-database/influencers/${encodeURIComponent(handle)}/campaigns`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (active) setCampaigns({ status: 'ok', items: res.data.campaigns || [] });
      } catch (err) {
        console.error('Master database campaigns error:', err);
        if (active) setCampaigns({ status: 'error', items: [] });
      }
    })();
    return () => {
      active = false;
    };
    // data degisince (sayfa/filtre) panel zaten kapaniyor; sadece openId'ye bagli.
  }, [openId]);

  // --- Kayit gecmisi (YALNIZCA bolum acilinca) ---
  // Kampanya gecmisinden farkli olarak openId'ye DEGIL historyOpen'a bagli:
  // panel her acildiginda degil, kullanici "Gecmis" bolumunu actiginda cekilir.
  useEffect(() => {
    if (!openId || !historyOpen) return undefined;
    let active = true;
    (async () => {
      const token = authToken();
      if (!token) return;
      setHistory({ status: 'loading', items: [], total: 0, truncated: false });
      try {
        const res = await axios.get(
          `${API}/master-database/influencers/${encodeURIComponent(openId)}/audit`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (active) {
          setHistory({
            status: 'ok',
            items: res.data.items || [],
            total: res.data.total || 0,
            truncated: Boolean(res.data.truncated),
          });
        }
      } catch (err) {
        console.error('Master database audit error:', err);
        if (active) setHistory({ status: 'error', items: [], total: 0, truncated: false });
      }
    })();
    return () => {
      active = false;
    };
  }, [openId, historyOpen, historyYenile]);

  // Satir degisince gecmis bolumu KAPANIR ve veri temizlenir: aksi halde yeni
  // kaydin panelinde bir oncekinin gecmisi bir an gorunurdu.
  useEffect(() => {
    setHistoryOpen(false);
    setHistory({ status: 'idle', items: [], total: 0, truncated: false });
  }, [openId]);

  const toggleRow = (id) => {
    // Satir degisince acik duzenleme/atama modlari kapanir — yarim kalmis taslak tasinmaz.
    setEditing(false);
    setDraft(null);
    setSegmentEditing(false);
    setSegmentDraft('');
    setSaveError('');
    setNoteDraft('');
    setOpenId((prev) => (prev === id ? null : id));
  };

  const handleSort = (colKey) => {
    if (sort === colKey) {
      updateView({ dir: dir === 'desc' ? 'asc' : 'desc', page: 1 });
    } else {
      updateView({ sort: colKey, dir: 'desc', page: 1 }); // ilk tiklamada azalan
    }
  };

  // SEKME TIKLARI [Bora, 25 Ekim] — coklu secim, tek tik:
  //   Tumu secili degilken Tumu'ye tik -> hepsi secili (Tumu).
  //   Tumu seciliyken Tumu'ye tik      -> hicbiri secili degil.
  //   Tumu seciliyken sekmeye tik      -> o sekme cikar.
  //   Tumu secili degilken sekmeye tik -> secili degilse secilir, seciliyse cikar.
  // Tek tek secilip hepsi secili olursa gorunum Tumu olur (sekmeSecimi).
  // Secim gecmise GIRER (push): geri tusu bir onceki secime doner.
  const sekmeTik = (key) => {
    let yeni;
    if (key === URL_DEFAULT_TAB) {
      yeni = sekmeler === null ? [] : null;
    } else {
      const mevcut = sekmeler === null ? SECILEBILIR_SEKMELER : sekmeler;
      yeni = sekmeSecimi(mevcut.includes(key) ? mevcut.filter((k) => k !== key) : [...mevcut, key]);
    }
    updateView({ sekmeler: yeni, page: 1 }, { push: true });
    resetView();
  };

  const fmtNumber = (n) => (typeof n === 'number' && Number.isFinite(n) ? fmtSayi(n) : null);

  // Takipci sayisi mockup'taki gibi kisaltilir: 127000 -> "127K".
  // 1000'in altinda kisaltma yapilmaz ("0K" yaniltici olurdu).
  const fmtFollowers = (n) => {
    if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
    return n >= 1000 ? `${fmtSayi(Math.round(n / 1000))}K` : fmtNumber(n);
  };

  const fmtMoney = (value, currency) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) return null;
    const text = fmtSayi(value);
    // Kolon basligi ₺ diyor; para birimi TRY degilse kodu ekle ki yanlis okunmasin.
    const cur = String(currency || '').trim().toUpperCase();
    return cur && !TRY_CODES.includes(cur) ? `${text} ${cur}` : text;
  };

  const fmtDate = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString(locale);
  };

  // [Y31/Y32] Onay ekraninda alan adi yerine okunur etiket: Instagram bio, Hediyelesme;
  // eslemesi olmayan alan HAM adiyla kalir.
  const planAlanEtiketi = (alan) => (planBioMu(alan) ? t.bioLabel
    : /^platforms\.[a-z]+\.reel_olcum$/.test(String(alan || '')) ? t.reelTitle
      : ({ gifted_brands: t.detailGifted, worked_brands: t.detailBrands, influencer_hakkinda: t.hakkindaLabel,
        'pregnancy.due_date': t.dueDateLabel })[alan] || alan);
  // [Y34] REEL OLCUMU — Turkce binlik / ondalik virgul (panelin geri kalanindan bilerek farkli: Bora'nin
  // istedigi bicim "1.233.956", "× 1,62", "%1,62"); tarih GG.AA.YYYY.
  const reelSayi = (v) => (typeof v === 'number' && Number.isFinite(v) ? v.toLocaleString('tr-TR', { maximumFractionDigits: 2 }) : null);
  const reelGun = (v) => {
    if (!v) return null;
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString('tr-TR', { timeZone: DISPLAY_TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
  };
  // Onay ekrani ve Gecmis icin kisa ozet: "medyan 1.233.956 · ort. 1.685.956 · %1,62 · 03.11.2026".
  const reelOzet = (o) => {
    if (!o || typeof o !== 'object') return '—';
    return [
      reelSayi(o.medyan) != null ? `${t.reelShortMedian} ${reelSayi(o.medyan)}` : null,
      reelSayi(o.ortalama) != null ? `${t.reelShortAvg} ${reelSayi(o.ortalama)}` : null,
      reelSayi(o.etkilesim) != null ? `%${reelSayi(o.etkilesim)}` : null,
      reelGun(o.tarih),
      // [Y34b] reklam sayisi (0 da deger): "reklam 3/12"
      typeof o.reklam_sayisi === 'number' ? `${t.reelShortAds} ${o.reklam_sayisi}/12` : null,
    ].filter(Boolean).join(' · ') || '—';
  };
  // [Y35] Influencer Hakkinda da bio gibi: tek satir, 80 karakter + "…".
  const planDegeri = (alan, v) => (planBioMu(alan) || alan === 'influencer_hakkinda' ? planBioDegeri(v)
    : alan === 'pregnancy.due_date' ? (dogumMetni(dogumAyYil(v)) || gosterDeger(v))
    : /^platforms\.[a-z]+\.reel_olcum$/.test(String(alan || '')) ? reelOzet(v) : gosterDeger(v));
  // [Y36] ONAY EKRANI BILGI SATIRLARI (sunucu: mdbTaslakBilgisi) — alan alan degisecek
  // kart sayilari, hamile + beklenen dogum yok, segment degisecek, Inreach'te korunan.
  const planBilgiKutusu = (B, planSatirlari) => {
    if (!B || typeof B !== 'object') return null;
    const sayilar = B.alan_sayilari || {};
    const parcalar = Object.keys(t.planFieldNames).filter((k) => sayilar[k] > 0)
      .map((k) => `${t.planFieldNames[k]} ${sayilar[k]}`);
    const hamile = Array.isArray(B.hamile_dogumsuz) ? B.hamile_dogumsuz : [];
    const segment = Array.isArray(B.segment_degisecek) ? B.segment_degisecek : [];
    const korunan = (Array.isArray(planSatirlari) ? planSatirlari : []).flatMap((r) =>
      (r.dokunulmayan || []).filter((x) => x.sebep === INREACH_SEBEP)
        .map((x) => ({ kim: r.kimlik && r.kimlik.alan !== 'instagram_handle' ? kimlikEtiketi(r.kimlik) : r.handle, ...x })));
    if (!parcalar.length && !hamile.length && !segment.length && !korunan.length) return null;
    return (
      <div className="mb-2 p-[9px] rounded-[6px] bg-[#F7F5F2] border-[0.5px] border-[#E4E1DC] text-[11px] leading-snug" data-testid="master-db-plan-bilgi">
        {parcalar.length > 0 && (
          <div className="text-[#232019]" data-testid="master-db-plan-alan-sayilari">
            <span className="font-medium">{t.planFieldCounts}:</span> {parcalar.join(' · ')}
          </div>
        )}
        {hamile.length > 0 && (
          <div className="mt-1 text-[#8A6A20]" data-testid="master-db-plan-hamile-dogumsuz">
            ⚠ {t.planPregnantNoDue.replace('{n}', hamile.length)}
            <span className="text-[#6D6960]"> — {hamile.map((h) => (h.kimlik ? `@${h.kimlik}` : h.full_name || '—')).join(' · ')}</span>
          </div>
        )}
        {segment.length > 0 && (
          <div className="mt-1 text-[#232019]" data-testid="master-db-plan-segment">
            {t.planSegmentChange.replace('{n}', segment.length)}
            <span className="text-[#6D6960]"> — {segment.map((x) => `@${x.kimlik} ${x.eski} → ${x.yeni}`).join(' · ')}</span>
          </div>
        )}
        {korunan.length > 0 && (
          <div className="mt-1 text-[#6A5A8C]" data-testid="master-db-plan-inreach">
            {t.planInreachKeptTitle.replace('{n}', new Set(korunan.map((x) => x.kim)).size)}
            <span className="text-[#6D6960]"> — {korunan.map((x) => `${x.kim} · ${planAlanEtiketi(x.alan)}: ${planDegeri(x.alan, x.eski)} (${planDegeri(x.alan, x.gelen)} ${t.planRowNotWritten})`).join(' · ')}</span>
          </div>
        )}
      </div>
    );
  };
  // [Y29] Birlestirme tablosu: etiket kartin sozlugunden (AUDIT_ETIKETLERI),
  // karsiligi yoksa alan adi. Degerler mevcut yardimcilarla bicimlenir.
  const birlestirEtiketi = (alan) => ({
    rates: t.mergeLabelRates, platforms: t.mergeLabelPlatforms, worked_brands: t.detailBrands, gifted_brands: t.detailGifted,
    children: t.mergeLabelChildren, brand_segment: t.segmentLabel, birth_year: t.mergeLabelBirthYear,
    has_pet: t.mergeLabelPet, tags: t.mergeLabelTags,
    // Kartin "Anne mi?" / "Evli mi?" etiketi — denetim sozlugundeki AYNI anahtar.
    anne_mi: AUDIT_ETIKETLERI.is_mother, evli_mi: AUDIT_ETIKETLERI.is_married,
  })[alan] || auditAlanEtiketi(alan);
  // [Y29b] Her zaman gorunen satirlar (iki kartta ayni olsalar bile), bu sirayla.
  // anne_mi / evli_mi SUNUCUNUN profil_ozeti'nden (PATCH'in turetilmis alanlariyla ayni kaynak).
  const BIRLESTIR_HEP = ['full_name', 'instagram_handle', 'tiktok_handle', 'youtube_handle', 'platforms',
    'brand_segment', 'anne_mi', 'gender', 'evli_mi', 'has_agency', 'agency_name', 'rates', 'children'];
  // Teknik alanlar — birlesmeye AYNEN girer, pencerede ayri katlanir satirda.
  const BIRLESTIR_TEKNIK = ['imported_at', 'enrichment_needed', 'enrichment_reason', 'possible_duplicate_of',
    'segment_assigned_at', 'segment_assigned_by', 'source_file', 'cocuk_sayisi_tahmini', 'instagram_url', 'last_import_at'];
  // profil_ozeti[taraf] -> kartin etiketleri: Anne · Hamile · Potansiyel · Degil (erkekte —).
  const birlestirProfilDegeri = (alan, oz, d) => {
    if (!oz) return '—';
    if (alan === 'anne_mi') {
      if (d && d.gender === 'erkek') return '—';
      if (oz.hamile) return `${t.boxMother} · ${t.boxPregnant}`;
      return ({ evet: t.boxMother, potansiyel: t.boxPotential, hayir: t.boxNot })[oz.anne_durumu] || '—';
    }
    return ({ evet: t.yes, hayir: t.no })[oz.evli_durumu] || '—';
  };
  const birlestirTakipci = (n) => (typeof n === 'number' && n >= 1e6
    ? `${(n / 1e6).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}M`
    : fmtFollowers(n));
  const birlestirDegeri = (alan, v, kalanDegeri) => {
    const bos = v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
    if (bos) return '—';
    if (alan === 'rates' && typeof v === 'object') {
      const parcalar = Object.entries(v)
        .filter(([k, x]) => typeof x === 'number' && AUDIT_ETIKETLERI[`rates.${k}`])
        .map(([k, x]) => `${AUDIT_ETIKETLERI[`rates.${k}`]} ${fmtMoney(x, v.currency)}`);
      const tarih = formatMonthYear(v.quoted_at);
      if (tarih) parcalar.push(`${t.mergeQuotedAt} ${tarih}`);
      return parcalar.join(' · ') || '—';
    }
    if (alan === 'children' && Array.isArray(v)) {
      const now = new Date();
      return v.map((c) => childAgeInfo(c, now)).filter(Boolean).map((a) => monthsToText(a.months, t)).join(', ') || '—';
    }
    if (alan === 'platforms') {
      const liste = Array.isArray(v) ? v : Object.entries(v || {}).map(([platform, x]) => ({ platform, ...(x || {}) }));
      return liste.map((p) => [platformLabel(p.platform), p.handle ? `@${p.handle}` : null,
        typeof p.followers === 'number' ? birlestirTakipci(p.followers) : null].filter(Boolean).join(' ')).join(' · ') || '—';
    }
    if (alan === 'notes' && Array.isArray(v)) {
      if (kalanDegeri === undefined) return t.mergeNotes.replace('{n}', v.length);
      const eski = new Set((Array.isArray(kalanDegeri) ? kalanDegeri : []).map((n) => String(n?.text ?? '').trim()));
      const yeni = v.filter((n) => !eski.has(String(n?.text ?? '').trim())).length;
      return t.mergeNotesNew.replace('{n}', v.length).replace('{m}', yeni);
    }
    if (Array.isArray(v)) return v.map((x) => (x && typeof x === 'object' ? JSON.stringify(x) : safeText(x))).join(', ');
    if (typeof v === 'boolean') return v ? t.yes : t.no;
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(v)) return fmtDate(v) || v;
    if (typeof v === 'object') return JSON.stringify(v);
    return safeText(v) || String(v);
  };

  // === Auth ekranlari (admin gorsel dili — kasitli) ===
  // === GIRIS EKRANLARI ===
  // Gorsel dil master-database'in kendi dili: acik zemin #FAF9F7, beyaz kart.
  // Admin panelinin siyah + sari temasi BILEREK kullanilmiyor — iki ayri kapi,
  // iki ayri kullanici grubu; ayni gorunmeleri karisikliga yol acar.
  if (status === 'giris') {
    const kartClass =
      'w-full max-w-sm bg-white border-[0.5px] border-[#E4E1DC] rounded-2xl p-7 shadow-sm';
    const inputClass =
      'w-full px-3 py-2.5 text-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[8px] text-[#232019] outline-none focus:border-[#CAC6BF]';
    // Goster/gizle dugmesi tasiyan alanlar: ikonun altina metin girmesin diye sagdan bosluk.
    // Yerlesim AdminPage.js'teki desenin AYNISI (relative sarmalayici + absolute sag dugme,
    // Eye/EyeOff); yalnizca renkler bu sayfanin acik zeminine uyarlandi.
    const sifreInputClass = `${inputClass} pr-10`;
    const gozBtnClass =
      'absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9B978E] hover:text-[#232019] transition';
    const labelClass = 'block text-[12px] text-[#6D6960] mb-1.5';
    const btnClass =
      'w-full py-2.5 text-[13px] bg-[#E8C35C] text-[#2A2317] font-semibold rounded-[8px] hover:brightness-95 transition disabled:opacity-40';

    const hataKutusu = girisHata ? (
      <div
        className="mb-4 px-3 py-2.5 text-[12px] bg-[#FAEFD5] border-[0.5px] border-[#E8C35C] text-[#8A6A20] rounded-[8px]"
        data-testid="mdb-login-error"
      >
        {girisHata}
      </div>
    ) : null;

    return (
      <div className="min-h-screen bg-[#FAF9F7] flex items-center justify-center p-4">
        {girisAdim === 'giris' && (
          <form onSubmit={girisYap} className={kartClass} data-testid="mdb-login-form">
            <h1 className="text-[19px] font-semibold text-[#232019] mb-1">{t.loginTitle}</h1>
            <p className="text-[12px] text-[#6D6960] mb-5">{t.loginSubtitle}</p>
            {hataKutusu}
            <div className="mb-3">
              <label className={labelClass}>{t.loginEmail}</label>
              <input
                type="email"
                required
                autoComplete="username"
                value={girisEmail}
                onChange={(e) => setGirisEmail(e.target.value)}
                className={inputClass}
                data-testid="mdb-login-email"
              />
            </div>
            <div className="mb-5">
              <label className={labelClass}>{t.loginPassword}</label>
              <div className="relative">
                <input
                  type={girisSifreGoster ? 'text' : 'password'}
                  required
                  autoComplete="current-password"
                  value={girisSifre}
                  onChange={(e) => setGirisSifre(e.target.value)}
                  className={sifreInputClass}
                  data-testid="mdb-login-password"
                />
                <button
                  type="button"
                  onClick={() => setGirisSifreGoster(!girisSifreGoster)}
                  className={gozBtnClass}
                  aria-label={girisSifreGoster ? t.pwHide : t.pwShow}
                  data-testid="mdb-login-password-toggle"
                >
                  {girisSifreGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={girisMesgul} className={btnClass} data-testid="mdb-login-submit">
              {girisMesgul ? <Loader2 className="mx-auto animate-spin" size={16} /> : t.loginButton}
            </button>
          </form>
        )}

        {girisAdim === 'sifre' && (
          <form onSubmit={sifreDegistir} className={kartClass} data-testid="mdb-password-form">
            <h1 className="text-[19px] font-semibold text-[#232019] mb-1">{t.pwStepTitle}</h1>
            <p className="text-[12px] text-[#6D6960] mb-1">{t.pwStepSubtitle}</p>
            <p className="text-[11px] text-[#9B978E] mb-5">{t.loginStepNote}</p>
            {hataKutusu}
            <div className="mb-3">
              <label className={labelClass}>{t.pwNew}</label>
              <div className="relative">
                <input
                  type={yeniSifreGoster ? 'text' : 'password'}
                  required
                  minLength={12}
                  autoComplete="new-password"
                  value={yeniSifre}
                  onChange={(e) => setYeniSifre(e.target.value)}
                  className={sifreInputClass}
                  data-testid="mdb-new-password"
                />
                <button
                  type="button"
                  onClick={() => setYeniSifreGoster(!yeniSifreGoster)}
                  className={gozBtnClass}
                  aria-label={yeniSifreGoster ? t.pwHide : t.pwShow}
                  data-testid="mdb-new-password-toggle"
                >
                  {yeniSifreGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <div className="mb-2">
              <label className={labelClass}>{t.pwRepeat}</label>
              <div className="relative">
                <input
                  type={yeniSifreTekrarGoster ? 'text' : 'password'}
                  required
                  minLength={12}
                  autoComplete="new-password"
                  value={yeniSifreTekrar}
                  onChange={(e) => setYeniSifreTekrar(e.target.value)}
                  className={sifreInputClass}
                  data-testid="mdb-new-password-repeat"
                />
                <button
                  type="button"
                  onClick={() => setYeniSifreTekrarGoster(!yeniSifreTekrarGoster)}
                  className={gozBtnClass}
                  aria-label={yeniSifreTekrarGoster ? t.pwHide : t.pwShow}
                  data-testid="mdb-new-password-repeat-toggle"
                >
                  {yeniSifreTekrarGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <p className="text-[11px] text-[#9B978E] mb-5 leading-snug">{t.pwRules}</p>
            <button type="submit" disabled={girisMesgul} className={btnClass} data-testid="mdb-password-submit">
              {girisMesgul ? <Loader2 className="mx-auto animate-spin" size={16} /> : t.pwSave}
            </button>
          </form>
        )}

        {(girisAdim === '2fa-kurulum' || girisAdim === '2fa-dogrula') && (
          <form onSubmit={kodDogrula} className={kartClass} data-testid="mdb-2fa-form">
            <h1 className="text-[19px] font-semibold text-[#232019] mb-1">
              {girisAdim === '2fa-kurulum' ? t.tfaSetupTitle : t.tfaVerifyTitle}
            </h1>
            <p className="text-[12px] text-[#6D6960] mb-1">
              {girisAdim === '2fa-kurulum' ? t.tfaSetupSubtitle : t.tfaVerifySubtitle}
            </p>
            <p className="text-[11px] text-[#9B978E] mb-5">{t.loginStepNote}</p>
            {hataKutusu}
            {girisAdim === '2fa-kurulum' && (
              <div className="mb-5 text-center">
                {qrKod ? (
                  <img
                    src={qrKod}
                    alt="QR"
                    className="mx-auto w-44 h-44 border-[0.5px] border-[#E4E1DC] rounded-[8px] bg-white"
                    data-testid="mdb-2fa-qr"
                  />
                ) : (
                  <Loader2 className="mx-auto animate-spin text-[#9B978E]" size={28} />
                )}
                {gizliAnahtar && (
                  <>
                    <p className="text-[11px] text-[#9B978E] mt-3 mb-1">{t.tfaSecretLabel}</p>
                    <code
                      className="text-[12px] text-[#232019] break-all select-all"
                      data-testid="mdb-2fa-secret"
                    >
                      {gizliAnahtar}
                    </code>
                  </>
                )}
              </div>
            )}
            <div className="mb-5">
              <label className={labelClass}>{t.tfaCode}</label>
              <input
                type="text"
                inputMode="numeric"
                required
                pattern="\d{6}"
                maxLength={6}
                autoComplete="one-time-code"
                value={totpKod}
                onChange={(e) => setTotpKod(e.target.value.replace(/\D/g, '').slice(0, 6))}
                className={`${inputClass} tracking-[0.3em] text-center`}
                data-testid="mdb-2fa-code"
              />
            </div>
            <button type="submit" disabled={girisMesgul} className={btnClass} data-testid="mdb-2fa-submit">
              {girisMesgul ? <Loader2 className="mx-auto animate-spin" size={16} /> : t.tfaVerifyButton}
            </button>
          </form>
        )}
      </div>
    );
  }

  if (status === 'loading') {
    return (
      <CenteredCard borderClass="border-[#FFDD59]">
        <Loader2 className="mx-auto mb-4 animate-spin text-[#FFDD59]" size={48} />
        <p className="text-gray-300" data-testid="master-db-loading">{t.loading}</p>
      </CenteredCard>
    );
  }

  if (status === 'forbidden') {
    return (
      <CenteredCard borderClass="border-red-500/50">
        <AlertTriangle className="mx-auto mb-4 text-red-400" size={48} />
        <h1 className="text-2xl font-bold text-white mb-3">{t.accessDeniedTitle}</h1>
        <p className="text-gray-300 mb-6" data-testid="master-db-forbidden">{t.accessDenied}</p>
        <button
          type="button"
          onClick={cikisYap}
          className="w-full py-3 bg-gray-700 text-white font-medium rounded-lg hover:bg-gray-600 transition"
          data-testid="master-db-back-to-admin"
        >
          {t.logout}
        </button>
      </CenteredCard>
    );
  }

  if (status === 'error') {
    return (
      <CenteredCard borderClass="border-red-500/50">
        <AlertTriangle className="mx-auto mb-4 text-red-400" size={48} />
        <h1 className="text-2xl font-bold text-white mb-3">{t.errorTitle}</h1>
        <p className="text-gray-300 mb-6" data-testid="master-db-error">{t.errorMessage}</p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => loadMe()}
            className="flex-1 py-3 bg-[#FFDD59] text-black font-bold rounded-lg hover:bg-yellow-500 transition"
            data-testid="master-db-retry"
          >
            {t.retry}
          </button>
          <button
            type="button"
            onClick={cikisYap}
            className="flex-1 py-3 bg-gray-700 text-white font-medium rounded-lg hover:bg-gray-600 transition"
          >
            {t.logout}
          </button>
        </div>
      </CenteredCard>
    );
  }

  // === Tablo + filtre paneli (acik zemin) ===
  // Duzen docs/mockups/01-ana-ekran.html'den: 216px panel + esnek tablo, <table> degil CSS grid.
  // Mecra kolonu KALDIRILDI — ayni bilgi Takipci kolonunda mecra etiketleriyle
  // zaten gosteriliyor, iki kez gostermenin anlami yok. Takipci kolonu genisledi.
  // [Y26 ek] Son kolon ("Bilgi güncellendi") 70 -> 76px: OLCULDU (headless Chrome,
  // build CSS, 12px) — "güncellendi ↕" 75,1px; 76px baslik 2 satir ("Bilgi" /
  // "güncellendi ↕"), 75px ve alti 3 satir (ok tek basina). Diger kolonlar ayni;
  // esnek ilk kolon 6px daralir.
  // [Y35, Bora 3 Kas 19:45] Sira: Influencer · Takipci · Segment · Story ₺ · Reel ₺ ·
  // Ucret tarihi · Bilgi guncellendi — Segment'in 58px'i kolonuyla birlikte tasindi.
  const GRID =
    'grid grid-cols-[minmax(0,1fr)_150px_58px_62px_62px_70px_76px] gap-1.5 px-3 py-2.5 items-start';

  const now = new Date();
  const totalPages = pageCount(data.total, PAGE_LIMIT);
  // Ekrandaki satirlar (eslestirme modunda eslesenler). "Tumunu sec" bunlari secer.
  const gorunenKayitlar = listMatch ? listMatch.matched.map((m) => m.doc) : data.items;
  // [Y24] Liste eslestir: MDB'de olup ucreti bilinmeyenler (sunucu isaretliyor).
  const listMatchUcretYok = listMatch ? (listMatch.matched || []).filter((m) => m.ucret_yok === true) : [];
  // [Y24 ek] Ucret var, fiyat tarihi esikten once ya da yok.
  const listMatchFiyatEski = listMatch ? (listMatch.matched || []).filter((m) => m.fiyat_eski === true) : [];
  // Ozet parantezi. Esik sayisi SOZLUKTE DEGIL, sunucudan gelen tazelikAy'dan;
  // gelmediyse uydurma sayi yazilmaz (tazelik rozetleriyle ayni ilke).
  const listMatchEkParcalar = [
    listMatchUcretYok.length ? t.listMatchUcretYokCount.replace('{n}', listMatchUcretYok.length) : null,
    listMatchFiyatEski.length
      ? (tazelikAy === null
        ? t.listMatchFiyatEskiCountNoThreshold.replace('{n}', listMatchFiyatEski.length)
        : t.listMatchFiyatEskiCount.replace('{n}', listMatchFiyatEski.length).replace('{ay}', String(tazelikAy)))
      : null,
  ].filter(Boolean);
  const listMatchEk = listMatchEkParcalar.length ? ` (${listMatchEkParcalar.join(', ')})` : '';
  const sayfaTumuSecili = gorunenKayitlar.length > 0 && gorunenKayitlar.every((d) => secili.has(d._id));
  const sayfaKismenSecili = gorunenKayitlar.some((d) => secili.has(d._id));

  // --- Panel yardimcilari ---
  // disabled VARSAYILAN false [Y18d]: diger cagrilar degismeden calisiyor.
  // Devre disi cip (Anne seciliyken Hamile) SECILI GORUNUR ama tiklanmaz —
  // uzmanlik agacindaki "ust dal seciliyse alt dal kapsanir" deseni.
  // [Y18f, Bora 2 Kas 09:32] disabled + active: secili ciple BIREBIR ayni renk,
  // soluklastirma YOK (yalniz cursor-default) — kilitli Hamile Anne'yle ayni
  // gorunur. disabled + secili degil: opacity-60 kalir. title: aciklama.
  // genis: hucreyi doldurur, metin ortada (Anne grubu 2 x 2 izgarasi).
  const chip = (key, label, active, onClick, testId, disabled = false, genis = false, title = undefined) => (
    <button
      key={key}
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`text-[12px] px-[9px] py-[3px] rounded-[6px] border-[0.5px] transition ${genis ? 'w-full text-center' : 'text-left'} ${
        active
          ? 'bg-[#F6EBD3] text-[#8A6A28] border-transparent'
          : 'bg-white border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE]'
      } ${disabled ? (active ? 'cursor-default' : 'cursor-default opacity-60') : ''}`}
      data-testid={testId}
    >
      {label}
    </button>
  );

  // disabled VARSAYILAN false: yardimcinin diger 8 cagrisi tek karakter degismeden
  // ayni sekilde calisiyor. Devre disiyken imlec pointer OLMAZ ve satir solar —
  // tiklanabilir gorunup tiklandiginda hicbir sey yapmayan kontrol bozuk okunur.
  const checkbox = (checked, onChange, label, testId, extraClass = '', disabled = false) => (
    <label
      className={`flex items-center gap-[7px] text-[13px] ${
        disabled ? 'cursor-default opacity-50' : 'cursor-pointer'
      } ${extraClass}`}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="w-auto m-0 accent-[#E8C35C]"
        data-testid={testId}
      />
      {label}
    </label>
  );

  // [Y18d] Ayrac kutunun ICINDE (SayiKutusu); alttaki onizleme satiri kalkti.
  const numberInput = (value, onChange, placeholder, testId) => (
    <SayiKutusu value={value} onChange={onChange} placeholder={placeholder} testId={testId} />
  );

  const section = (children, key) => (
    <div key={key} className="border-t-[0.5px] border-[#E4E1DC] mt-[11px] pt-[11px]">
      {children}
    </div>
  );

  const sectionTitle = (text) => (
    <div className="text-[12px] text-[#6D6960] mb-1.5">{text}</div>
  );

  // Tazelik rozeti etiketi. Sayi SOZLUKTE DEGIL, sunucudan gelen esikten geliyor
  // (GET /cities -> tazelik_ay). [Y18d] Cipler kisa ve tek satir: "<{n} ay" ·
  // "{n}+ ay" · "Bilinmiyor". Esik henuz gelmediyse UYDURMA SAYI YAZILMAZ:
  // "Taze" / "Bayat" — "<6 ay" yanlis olabilir, "Taze" olamaz.
  const tazelikEtiketi = (d) => {
    const ham = t.freshnessValues[d];
    if (!ham.includes('{n}')) return ham;
    if (tazelikAy === null) return t.freshnessNoThreshold[d];
    return ham.replace('{n}', String(tazelikAy));
  };

  // Mockup'taki ok gosterimi: pasif ↕, azalan ↓, artan ↑
  const sortArrow = (colKey) => {
    if (sort !== colKey) return <span className="text-[#9B978E]">↕</span>;
    return <span>{dir === 'desc' ? '↓' : '↑'}</span>;
  };

  // Fonksiyon olarak cagrilir (<SortHeader /> DEGIL): bilesen olarak tanimlansaydi her
  // render'da yeni bir tip olusur ve React tum tablo alt agacini remount ederdi.
  const renderSortHeader = (colKey, label) => (
    <button
      key={colKey}
      type="button"
      onClick={() => handleSort(colKey)}
      className={`text-left cursor-pointer hover:text-[#8A6A28] transition ${
        sort === colKey ? 'text-[#8A6A28] font-medium' : ''
      }`}
      data-testid={`master-db-sort-${colKey}`}
    >
      {label} {sortArrow(colKey)}
    </button>
  );

  // --- Detay paneli yardimcilari ---
  const capitalize = (s) => (s ? String(s).charAt(0).toUpperCase() + String(s).slice(1) : '');
  // Dizi elemanlari nesne olabilir — safeText her birini guvenli metne cevirir.
  const listOrDash = (arr) => safeText(arr) || '—';
  const valueOrUnknown = (v) => safeText(v) || t.unknown;

  const detailField = (label, value) => (
    <div key={label}>
      <span className="text-[#6D6960]">{label}:</span> <span>{value}</span>
    </div>
  );

  // Duzenlenemeyen hucre. Salt-okuma modunda siradan bir hucreden AYIRT EDILMEZ;
  // duzenleme modunda ayni yerde durur ama solar — boylece "Duzenle"ye basildiginda
  // altindaki hucreler kaymaz ve kullanici bu alani elle degistiremeyecegini gorur.
  const readOnlyCell = (label, value, testId) =>
    editing && draft ? (
      // Hucre isaretlemesi TEK YERDE kalir: cikti yine detailField'in. Burasi
      // yalnizca solduran bir kap ekliyor. Ikinci bir <span> ciftini burada
      // tanimlamak ayni hucrenin gorunumunu iki yere yazardi ve ikisi zamanla
      // ayrisirdi. Soldurma opacity ile: dosyadaki mevcut "soluk" deyimi bu
      // (bkz. satirdaki opacity-[.66]) ve etiket + degeri birlikte soldurdugu
      // icin detailField'in kendi etiket rengine dokunmak gerekmiyor.
      <div key={label} className="opacity-60" data-testid={testId}>
        {detailField(label, value)}
      </div>
    ) : (
      detailField(label, value)
    );

  // status -> rozet. onerildi notr, calisildi yesil.
  const campaignStatusBadge = (status) => {
    // status nesne olursa safeText null doner ve '—' basilir; ham nesne JSX'e GIRMEZ.
    const text = safeText(status);
    const key = String(text || '').trim().toLowerCase();
    const worked = key === 'calisildi';
    const label = worked ? t.statusCalisildi : key === 'onerildi' ? t.statusOnerildi : text || '—';
    return (
      <span
        className={`text-[11px] px-1.5 py-px rounded-[6px] ${
          worked ? 'bg-[#E5F1E7] text-[#3D7A52]' : 'bg-[#F3F1EE] text-[#6D6960]'
        }`}
      >
        {label}
      </span>
    );
  };

  // === PANELDE GIZLENEN GOC NOTLARI ===
  // Notlarin bir kismi not degil: gocte serbest metne cevrilmis ALAN DEGERLERI.
  // Asagidakiler panelde hicbir is bilgisi tasimiyor, yalnizca yer kapliyor.
  //
  // VERITABANINDAN SILINMIYOR — bu yalnizca bir GOSTERIM filtresi. Notlar
  // silinemez (yanlis yazilirsa yenisi eklenir) ve goc verisi de oyle kalir.
  //
  // Kural TEK YERDE: yeni bir desen gizlemek ya da birini geri getirmek isteyen
  // kisi dosyayi taramak zorunda kalmasin.
  // GIZLENMEYENLER bilerek disarida: "Durum: tekrar" ve "Durum: ÖDENDİ" is
  // durumu tasiyor; "Marka onay durumu", "İçerik durumu", "Produksiyon ile
  // İlgili Notlar", "Odaklananacak Ürünler", "Influencer cevabı", "Daha önceki
  // iş birlikleri" ve onek tasimayan notlar da oyle.
  const GIZLI_NOT_DESENLERI = [
    // Metni TAM OLARAK "Durum: +" olanlar. "Durum: tekrar" / "Durum: ÖDENDİ"
    // bu desene UYMAZ ve gorunmeye devam eder.
    /^Durum:\s*\+$/,
    // "Segment: Muhafazakâr ..." ile BASLAYANLAR — hepsi ayni cumle:
    // kademe belirtilmemis, segment atanmadi.
    /^Segment:\s*Muhafazakâr/,
  ];
  const gorunurNot = (n) => {
    const metin = String(n?.text ?? '').trim();
    return !GIZLI_NOT_DESENLERI.some((desen) => desen.test(metin));
  };

  // Notlar: en yeni ustte. created_at olmayanlar SONA.
  const sortNotes = (notes) =>
    [...(Array.isArray(notes) ? notes : [])].sort((a, b) => {
      const ta = a?.created_at ? new Date(a.created_at).getTime() : NaN;
      const tb = b?.created_at ? new Date(b.created_at).getTime() : NaN;
      const va = Number.isNaN(ta) ? null : ta;
      const vb = Number.isNaN(tb) ? null : tb;
      if (va === null && vb === null) return 0;
      if (va === null) return 1; // tarihsiz sona
      if (vb === null) return -1;
      return vb - va; // en yeni once
    });

  // --- Duzenleme formu alan yardimcilari ---
  const editLabel = (text) => <div className="text-[#6D6960] mb-[3px]">{text}</div>;
  const editInputCls =
    'w-full text-[12px] h-[30px] px-[7px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF]';

  const editText = (label, key) => (
    <div key={key}>
      {editLabel(label)}
      <input
        type="text"
        value={draft[key]}
        onChange={(e) => setDraft({ ...draft, [key]: e.target.value })}
        className={editInputCls}
        data-testid={`master-db-edit-${key}`}
      />
    </div>
  );

  // Ucret kutulari da binlik ayiricili: 45000 ile 4500 arasindaki fark bir bakista
  // gorulmuyor ve yanlis basamak markaya YANLIS TEKLIF olarak gidiyor.
  // Kutuda ham rakam tutulur; money() zaten Number('45000') ile calisiyor.
  const editMoney = (label, key) => (
    <div key={key}>
      {editLabel(label)}
      <input
        {...thousandsInputProps(draft[key], (ham) => setDraft({ ...draft, [key]: ham }))}
        className={editInputCls}
        data-testid={`master-db-edit-${key}`}
      />
    </div>
  );

  // UC DURUMLU BOOLEAN KONTROLU — BES ALANIN TEKI DE BUNU CAGIRIR.
  // KONTROL SECIMI: uclu <select>. Onay kutusu uc durumu ifade EDEMEZ; tri-state
  // dugme bu panelde hic kullanilmayan yeni bir desen acardi. Select ise karttaki
  // MEVCUT deyim — billing_type ve barter_open zaten ayni isaretlemeyle
  // (editInputCls) basiliyor ve barter_open da tam olarak boyle uc degerli.
  // Cocuk sayisi kutusuyla da tutarli: BOS = bilinmiyor.
  const editBool3 = (label, key, testId) => (
    <div key={key}>
      {editLabel(label)}
      <select
        value={draft[key]}
        onChange={(e) => setDraft({ ...draft, [key]: e.target.value })}
        className={editInputCls}
        data-testid={testId}
      >
        <option value="">{t.bool3Unknown}</option>
        <option value="evet">{t.yes}</option>
        <option value="hayir">{t.no}</option>
      </select>
    </div>
  );

  const editSelect = (label, key, options) => (
    <div key={key}>
      {editLabel(label)}
      <select
        value={draft[key]}
        onChange={(e) => setDraft({ ...draft, [key]: e.target.value })}
        className={editInputCls}
        data-testid={`master-db-edit-${key}`}
      >
        <option value="">—</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );

  // NOT: ust bosluk YOK — bu blok artik izgara hucresinin icinde duruyor ve
  // bosluk kolonun kendi gap'inden geliyor.
  const editChips = (label, key, options) => (
    <div key={key}>
      {editLabel(label)}
      <div className="flex flex-wrap gap-[5px]">
        {options.map((o) => {
          const on = draft[key].includes(o);
          return (
            <button
              key={o}
              type="button"
              onClick={() =>
                setDraft({
                  ...draft,
                  [key]: on ? draft[key].filter((x) => x !== o) : [...draft[key], o],
                })
              }
              className={`text-[12px] px-[9px] py-[3px] rounded-[6px] border-[0.5px] transition ${
                on
                  ? 'bg-[#F6EBD3] text-[#8A6A28] border-transparent'
                  : 'bg-white border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE]'
              }`}
            >
              {o}
            </button>
          );
        })}
      </div>
    </div>
  );

  // === KAYIT GECMISI BICIMLENDIRME ===
  // Alan yolu -> INSAN ETIKETI. Tabloda olmayan alan icin HAM YOL basilir
  // (kaybolmasin): yeni bir alan duzenlenebilir yapildiginda gecmis satiri
  // "yeni_alan: ... -> ..." diye gorunur, sessizce dusmez.
  const AUDIT_ETIKETLERI = {
    full_name: t.editName,
    instagram_handle: t.editIgHandle,
    tiktok_handle: t.editTiktokHandle,
    youtube_handle: t.editYtHandle,
    city: t.detailCity,
    phone: t.detailPhone,
    email: t.detailEmail,
    billing_type: t.detailBilling,
    barter_open: t.detailBarter,
    category: t.detailCategory,
    expertise: t.detailExpertise,
    children: t.detailChildAges,
    is_expert: t.expertLabel,
    is_seeding_account: t.seedingLabel,
    is_talent: t.talentLabel,
    'whatsapp_community.member': t.detailWhatsapp,
    'pregnancy.is_pregnant': t.pregnancyLabel,
    gender: t.profileGenderLabel,
    is_mother: t.profileMotherLabel,
    is_married: t.profileMarriedLabel,
    has_agency: t.editHasAgency,
    agency_name: t.editAgencyName,
    'rates.ig_story': t.detailStory,
    'rates.ig_reel': t.detailReel,
    'rates.tiktok_video': t.detailTiktok,
    'rates.youtube_video': t.detailYtVideo,
    'rates.youtube_shorts': t.detailYtShorts,
    'rates.combo_reel_story': t.detailCombo,
    'rates.ig_collab': t.detailCollab,
    'rates.ig_ad_15day': t.detailAd,
    'rates.quoted_at': t.detailQuotedAt,
    notes: t.notesTitle,
    // [Y33] Gecmis'te ham alan adi kalmasin.
    brand_segment: t.segmentLabel,
    sources: t.detailSource,
    pregnancy: t.boxPregnant,
    cocuk_sayisi_tahmini: t.detailChildren,
    ...t.auditEkEtiketler,
    // [Y32] kart duzenlemesinin gecmis satirlari
    worked_brands: t.detailBrands,
    gifted_brands: t.detailGifted,
    // [Y35] Influencer Hakkinda — tek satir, kisa ozet (auditDeger).
    influencer_hakkinda: t.hakkindaLabel,
  };
  // platforms.<mecra>.<followers|handle> dinamik: her mecra icin ayri satir yazmak
  // yerine yol cozumleniyor.
  const auditAlanEtiketi = (field) => {
    const yol = String(field || '');
    if (AUDIT_ETIKETLERI[yol]) return AUDIT_ETIKETLERI[yol];
    const m = yol.match(/^platforms\.([a-z]+)\.(followers|handle|bio|reel_olcum)$/);
    if (m) {
      if (m[2] === 'bio') return m[1] === 'instagram' ? t.bioLabel : `${platformLabel(m[1])} bio`;
      if (m[2] === 'reel_olcum') return t.reelTitle;
      return `${platformLabel(m[1])} ${m[2] === 'followers' ? t.colFollowers : t.handleWord}`;
    }
    return yol || '—';
  };

  // Para ve tarih alanlari, panelde nasil basiliyorsa gecmiste de oyle basilir.
  const AUDIT_PARA_ALANLARI = [
    'rates.ig_story', 'rates.ig_reel', 'rates.tiktok_video',
    'rates.combo_reel_story', 'rates.ig_collab', 'rates.ig_ad_15day',
    'rates.youtube_video', 'rates.youtube_shorts',
  ];
  const auditTarihAlanMi = (field) => /(^|\.)(measured_at|quoted_at|_at)$/.test(String(field || ''));

  // UC DURUM DISIPLINI BURADA DA GECERLI.
  // old_value null/tanimsizsa "—" DEGIL "bilinmiyor" yazilir. Sebep somut: bu
  // oturumda duzenlenebilir yapilan bes alanin hepsinde eski deger YOKTU —
  // is_expert 2496 kayitta, pregnancy.is_pregnant 2643 kayitta hic yoktu.
  // "Uzman: — → Evet" satiri alanin onceden "hayir" oldugunu IMA EDER; dogrusu
  // "Uzman: bilinmiyor → Evet".
  const auditKisa = (metin) => {
    const tek = String(metin ?? '').replace(/\s+/g, ' ').trim();
    return tek.length > 80 ? `${tek.slice(0, 80)}…` : tek;
  };
  const auditDeger = (field, value, cur) => {
    if (value === null || value === undefined) return t.unknown;
    // [Y33] notlar METINLERIYLE ve kisaltilmis; bio kisaltilmis.
    if (field === 'notes' && Array.isArray(value)) {
      return value.length ? auditKisa(value.map((n) => (n && typeof n === 'object' ? n.text : n)).filter(Boolean).join(' · ')) : t.none;
    }
    if (/^platforms\.[a-z]+\.bio$/.test(String(field || '')) || field === 'influencer_hakkinda') return auditKisa(value);
    if (/^platforms\.[a-z]+\.reel_olcum$/.test(String(field || ''))) return reelOzet(value);
    if (field === 'pregnancy.due_date') return dogumMetni(dogumAyYil(value)) || String(value);
    if (typeof value === 'boolean') return value ? t.yes : t.no;
    if (AUDIT_PARA_ALANLARI.includes(field)) return fmtMoney(value, cur) ?? String(value);
    // Takipci sayilari da binlik ayiricili: 100000000 ile 1100000 arasindaki fark
    // ham basildiginda okunmuyor — canlida duzeltilen hata tam olarak buydu.
    // Kisaltma (127K) YAPILMAZ: gecmis satirinda tam deger onemli.
    if (/^platforms\.[a-z]+\.followers$/.test(String(field || ''))) {
      return fmtNumber(value) ?? safeText(value) ?? t.unknown;
    }
    if (auditTarihAlanMi(field)) return formatMonthYear(value) || safeText(value) || t.unknown;
    // children gibi nesne dizilerinde safeText null doner; yasi olan girisler
    // okunabilir bir listeye cevrilir, digerlerinde ham yol yerine sayi basilir.
    if (Array.isArray(value)) {
      const yazi = safeText(value);
      if (yazi) return yazi;
      const yaslar = value
        .map((c) => (c && typeof c === 'object' && Number.isFinite(c.age_months) ? monthsToText(c.age_months, t) : null))
        .filter(Boolean);
      if (yaslar.length) return yaslar.join(', ');
      return value.length ? String(value.length) : t.none;
    }
    return safeText(value) ?? t.unknown;
  };

  // Satirin KENDI tarihi: gun + saat. Bu bir OLAY zamani, olcum degil —
  // notlarda ve cocuk yaslarinda uygulanan "ay + yil" kurali buraya UYGULANMAZ;
  // orada gun bilgisi goc yuvarlamasiydi, burada gercek bir zaman damgasi.
  const auditZaman = (value) => {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleString(locale, {
      timeZone: DISPLAY_TZ,
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // yeniMi: kart HENUZ VAR OLMAYAN bir kayit icin aciliyor (P4'te "Yeni Kayit"
  // bu karti bos bir belgeyle acacak). Bugun hicbir cagiran gondermiyor —
  // varsayilan false, davranis aynen duruyor.
  const renderDetail = (doc, { yeniMi = false } = {}) => {
    // Tek bayrak: kimlik satiri, izgara hucreleri ve alt bolumler hep ayni kosula bakar.
    const duzenleme = Boolean(editing && draft);

    // === VAR OLAN BIR KAYDA YAPILAN ISLEMLER — TEK KAPI ===
    // Bes blok (segment atama · favori · not ekleme · kayit gecmisi · silme)
    // _id'si olan bir belge gerektiriyor: yeni kayit modunda ya 404 uretirler ya
    // da olmayan bir kayda islem yapiliyor izlenimi verirler.
    // §7.4 ("panelde hicbir hucre gizlenmez") IHLAL EDILMIYOR: o karar ALANLAR
    // icin — bunlar alan degil, var olan bir kayda yapilan ISLEM.
    // TEK KAPI: yarin altinci blok eklenirse yine bu yardimcidan gecer; ayrica
    // mdb-taslak-testi sarmalanmamis islem tetigi kalmadigini kontrol ediyor.
    const kayitIslemi = (icerik) => (yeniMi ? null : icerik);
    // AYNASI: yalnizca YENI KAYITTA gorunen alanlar. Duzenleme kartina yeni alan
    // EKLENMIYOR — bunlar eski yeni-kayit penceresinden tasindi ve orada
    // olduklari gibi kaliyorlar.
    const yeniKayitAlani = (icerik) => (yeniMi ? icerik : null);
    const children = Array.isArray(doc.children) ? doc.children : [];
    const rates = doc.rates || {};
    const cur = rates.currency;
    // Gizli desenler once elenir; geriye hic not kalmazsa asagidaki
    // notes.length === 0 dali calisir ve "Not yok" gosterilir — bos baslik kalmaz.
    const notes = sortNotes(doc.notes).filter(gorunurNot);
    // HAMILELIK — deger + olcum damgasi.
    // Damga ay+yil: hamilelik BAYATLAYAN tek veri, ekip hangi kaydin kontrol
    // gerektirdigini damgadan gorur. Gun gosterilmez; goc degerlerinin hepsi ayin
    // ilk gunu (2025-07-01) — gun bilgisi olcum anini degil yuvarlamayi tasiyor.
    // 1 OCAK ISTISNASI UYGULANMAZ: pregnancy'de source alani yok, tarihin goc
    // kaynakli oldugu iddia edilemez (children'da alinan kararin aynisi).
    const hamile = doc.pregnancy?.is_pregnant;
    const hamileDamga = formatMonthYear(doc.pregnancy?.measured_at);
    // [Y16] Hamilelik ayri hucre DEGIL: Anne kutularinin "Hamile"si, yaninda bu damga.
    // Giris basina yas metni; kaynagi belirsiz olanlar icin uyari eki korunur.
    const cocukYasMetni = (c) => {
      const info = childAgeInfo(c, now);
      if (!info) return t.childUnknownFormat;
      const yas = monthsToText(info.months, t);
      // Etiketler KORUNUR: parantez icindeki tarihin ne oldugunu soylemezsek
      // "18 ay (12.03.2026)" okuyan kisi tarihi dogum tarihi saniyor.
      //
      // TARIHLER AY + YIL. Gun bilgisi olcum anini degil "su aya ait"
      // yuvarlamasini tasiyor: measured_at dolu girislerin buyuk cogunlugu ayin
      // ilk ya da son gununde ve saat bileseni yalnizca iki degerden biri —
      // notlarda ve platforms[].measured_at'te teshis edilen goc artefaktinin
      // aynisi. Gun gostermek sahte kesinlik olurdu.
      //
      // 1 OCAK ISTISNASI UYGULANMAZ: children girislerinde source alani yok,
      // dolayisiyla tarihin goc kaynakli oldugu IDDIA EDILEMEZ. formatMonthYear'in
      // varsayilani zaten "istisna yok", ikinci arguman bilerek gecilmiyor.
      //
      // SAKLANAN DEGER DEGISMIYOR — yalnizca gosterim yuvarlaniyor. Yas hesabi
      // (childAgeInfo) tam damgadan yapilmaya devam ediyor; ay hassasiyetine
      // indirilseydi bebeklerde bir aylik belirsizlik girerdi.
      if (info.kind === 'birth') {
        // birth_year/birth_month bir zaman damgasi DEGIL, iki sayi. Ay yoksa
        // uydurulmaz: yalnizca yil basilir. (childAgeInfo yas hesabi icin eksik
        // ayi Ocak varsayiyor; o varsayim GOSTERIME tasinmamali.)
        const ay =
          typeof c.birth_month === 'number' && c.birth_month >= 1 && c.birth_month <= 12
            ? String(c.birth_month).padStart(2, '0')
            : null;
        const dogum = ay ? `${ay}.${c.birth_year}` : String(c.birth_year);
        return `${yas} (${t.childBirth} ${dogum})`;
      }
      if (info.kind === 'measured') {
        return `${yas} (${formatMonthYear(info.measuredAt)} ${t.childMeasuredSuffix})`;
      }
      return `${yas} (${t.childNoMeasureDate})`;
    };
    // [Y16] Bebek (< 36 ay) ve cocuk (>= 36 ay) AYRI: sayi ve yaslar gruptan.
    // Cocuk verisi bossa iki sayi da 0 (5 Eyl karari, onceki "Cocuk sayisi 0").
    const cocukGruplari = cocukGrupla(children, now);
    const bebekSatiri = [cocukGruplari.bebek.length, ...cocukGruplari.bebek.map((x) => cocukYasMetni(children[x.ref]))].join(' & ');
    // [Y35, Bora 3 Kas 19:37] Kampanya gecmisi YALNIZ kalem varsa (ya da hata metniyle)
    // gorunur; yukleniyor / bos / kullanici adi yok -> bolum hic basilmaz, Not yeri alir.
    const kampanyaGorunur = !yeniMi && (campaigns.status === 'error'
      || (campaigns.status !== 'loading' && campaigns.status !== 'no_handle' && Array.isArray(campaigns.items) && campaigns.items.length > 0));
    const cocukSatiri = [cocukGruplari.cocuk.length, ...cocukGruplari.cocuk.map((x) => cocukYasMetni(children[x.ref]))].join(' & ');

    return (
      <div
        className="border-t-[0.5px] border-[#E4E1DC] bg-[#F3F1EE] px-[14px] py-3"
        data-testid="master-db-detail"
      >
        {/* === SEGMENT ATAMA ===
            "+ ata" rozetine (ya da mevcut segmente) tiklayinca acilir. Tek secim —
            brand_segment tek deger. Aninda kaydetmez; "Ata" ile onaylanir. */}
        {kayitIslemi(segmentEditing && doc.is_seeding_account !== true && (
          <div className="mb-3 pb-2.5 border-b-[0.5px] border-[#E4E1DC]" data-testid="master-db-segment-assign">
            <div className="text-[12px] text-[#6D6960] mb-1.5">{t.segmentAssignTitle}</div>
            <div className="flex flex-wrap gap-[5px] mb-2">
              {SEGMENT_DICTIONARY.map((sg) => (
                <button
                  key={sg}
                  type="button"
                  onClick={() => setSegmentDraft(sg)}
                  className={`text-[12px] px-[9px] py-[3px] rounded-[6px] border-[0.5px] transition ${
                    segmentDraft === sg
                      ? 'bg-[#F6EBD3] text-[#8A6A28] border-transparent'
                      : 'bg-white border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE]'
                  }`}
                  data-testid={`master-db-segment-assign-${sg}`}
                >
                  {sg}
                </button>
              ))}
            </div>
            <div className="flex gap-[7px] items-center flex-wrap">
              <button
                type="button"
                disabled={saving || !segmentDraft}
                onClick={async () => {
                  const ok = await patchRecord(doc, {
                    fields: { brand_segment: segmentDraft },
                    updated_at: doc.updated_at || null,
                  });
                  if (ok) {
                    setSegmentEditing(false);
                    setSegmentDraft('');
                  }
                }}
                className="text-[12px] px-[13px] py-[5px] rounded-[6px] bg-[#E8C35C] text-[#2A2317] font-medium hover:brightness-95 transition disabled:opacity-40"
                data-testid="master-db-segment-save"
              >
                {saving ? t.saving : t.segmentAssign}
              </button>
              <button
                type="button"
                onClick={() => {
                  setSegmentEditing(false);
                  setSegmentDraft('');
                }}
                className="text-[12px] text-[#9B978E] hover:text-[#232019] transition"
              >
                {t.cancel}
              </button>
              <span className="text-[12px] text-[#9B978E]">{t.auditNote}</span>
            </div>
          </div>
        ))}

        {/* === KIMLIK SATIRI ===
            IKI MODDA DA panelin en ustunde, ayni dort kolonda. Ad soyad ve uc handle
            duzenleme formunun grid'inden BURAYA TASINDI (kopyalanmadi).
            Onceden bu uc kutu ucret/siniflandirma hucreleriyle ayni izgaraya
            giriyordu; "Duzenle"ye basildiginda alttaki her hucre uc sira kayiyordu. */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-4 ${KART_KOLONLARI} gap-x-[12px] gap-y-2 text-[12px] mb-2.5 pb-2.5 border-b-[0.5px] border-[#E4E1DC]`}
          data-testid="master-db-identity"
        >
          {/* [Y35, Bora 3 Kas 19:41] OKUMADA "Ad soyad" YOK — ad kartin basliginda.
              Duzenlemede / yeni kayitta Ad soyad DORDUNCU hucre (YouTube'dan sonra):
              kullanici adi kutulari iki modda da ayni yerde. */}
          {duzenleme
            ? editText(t.editIgHandle, 'instagram_handle')
            : detailField(t.editIgHandle, safeText(doc.instagram_handle) || '—')}
          {duzenleme
            ? editText(t.editTiktokHandle, 'tiktok_handle')
            : detailField(t.editTiktokHandle, safeText(doc.tiktok_handle) || '—')}
          {/* YOUTUBE HANDLE — IG ve TikTok ile AYNI desen (KARAR Bora, 7 Eyl:
              "IG ve TikTok icin neyse aynisi"). Alan canlida 121 kayitta dolu ve
              MASTER_DB_EDITABLE'da vHandle(60) ile kabul ediliyordu (f36d5a6),
              ama kimlik satirinda GORUNMUYORDU: ekip degeri goremedigi icin
              duzeltemiyordu da.
              Sira MASTER_DB_FOLLOWER_ORDER ile ayni yonde: IG > TikTok > YouTube.
              Bos deger GIZLENMEZ, kardesleriyle ayni bosluk gostergesi basilir
              (sema §7.4 — panelde hicbir hucre gizlenmez). */}
          {duzenleme
            ? editText(t.editYtHandle, 'youtube_handle')
            : detailField(t.editYtHandle, safeText(doc.youtube_handle) || '—')}
          {duzenleme && editText(t.editName, 'full_name')}
        </div>

        {/* [Y31] tam genislik bio blogu KALKTI [Y35]: besinci kolona TASINDI (kopyalanmadi). */}

        {/* BES KOLON [Y35; Y18c'de dort] — sabit dagilim, IKI MODDA DA AYNI
            HUCRELER, AYNI SIRA (sema §7.4): her hucre kendi yerinde giris alanina
            donusur, "Duzenle" bir yerlesim degisikligi gibi gorunmez.
              1 — Ucretler (8)
              2 — Profil: cinsiyet, evli, anne kutulari, bebek / cocuk, kategori (8)
              3 — Uzmanlik ve calisma: uzman, uzmanlik, fiyat alinma, calisma
                  sekli, ajans, kaynak (6)
              4 — Iletisim ve durum (7)
              5 — [Y35] Metin: Instagram bio (ustte) · Influencer Hakkinda (altta)
            [Y35] Evli mi? ve Ucret alinma karttan KALKTI; bebek / cocuk iki satir.
            Kategori Cocuk yasi'nin hemen altinda; duzenlemede iki uzun cip blogu
            (Kategori K2, Uzmanlik K3) ayri kolonlarda. Not ekle 4. kolondaydi
            [Y17]; artik izgaranin ALTINDA tam genislikte bir serit.
            Ayri "Hamilelik" hucresi YOK: Anne kutularinin "Hamile"si.
            Dar ekranda tek, orta genislikte iki, genis ekranda dort kolon. */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 ${KART_KOLONLARI} gap-x-[12px] gap-y-1.5 text-[12px] [overflow-wrap:anywhere]`}
          data-testid="master-db-detail-grid"
        >
          {/* === KOLON 1 · UCRETLER === */}
          <div className={`flex flex-col ${duzenleme ? 'gap-y-2' : 'gap-y-1.5'}`} data-testid="master-db-col-rates">
            {duzenleme
              ? editMoney(t.detailStory, 'ig_story')
              : detailField(t.detailStory, fmtMoney(rates.ig_story, cur) || '—')}
            {duzenleme
              ? editMoney(t.detailReel, 'ig_reel')
              : detailField(t.detailReel, fmtMoney(rates.ig_reel, cur) || '—')}
            {duzenleme
              ? editMoney(t.detailCombo, 'combo_reel_story')
              : detailField(t.detailCombo, fmtMoney(rates.combo_reel_story, cur) || '—')}
            {duzenleme
              ? editMoney(t.detailCollab, 'ig_collab')
              : detailField(t.detailCollab, fmtMoney(rates.ig_collab, cur) || '—')}
            {/* ALAN ADI YANILTICI: alan rates.ig_ad_15day ama etiket "Reklamlama".
                Anlasilan sure DEGISKEN (bazen 1 hafta, bazen 15 gun, bazen 1 ay) ve bu
                turda hicbir yerde tutulmuyor; etikete "15 gun" yazmak veriyi yanlis
                anlatirdi. Alan 108 kayit tasidigi icin yeniden ADLANDIRILMIYOR. */}
            {duzenleme
              ? editMoney(t.detailAd, 'ig_ad_15day')
              : detailField(t.detailAd, fmtMoney(rates.ig_ad_15day, cur) || '—')}
            {duzenleme
              ? editMoney(t.detailTiktok, 'tiktok_video')
              : detailField(t.detailTiktok, fmtMoney(rates.tiktok_video, cur) || '—')}
            {/* YOUTUBE UCRETLERI — TikTok'un hemen altinda. Ucret hucrelerinin
                sirasi Instagram > TikTok > YouTube; bunu tanimlayan bir sabit
                YOK, hucreler burada elle siralanmis. Bosluk gostergesi kardes
                ucret hucreleriyle AYNI: '—'. Binlik ayraci fmtMoney -> fmtSayi'den. */}
            {duzenleme
              ? editMoney(t.detailYtVideo, 'youtube_video')
              : detailField(t.detailYtVideo, fmtMoney(rates.youtube_video, cur) || '—')}
            {duzenleme
              ? editMoney(t.detailYtShorts, 'youtube_shorts')
              : detailField(t.detailYtShorts, fmtMoney(rates.youtube_shorts, cur) || '—')}
            {/* TAKIPCI OLCUMU karttan KALKTI [Y18b, Bora 1 Kas 22:56]: kartta uc tarih
                yan yana (Fiyat alinma · Bilgi guncellendi · Takipci olcumu) kafa karistiriyordu;
                olcum hicbir filtreye ya da karara girmiyor. VERI ve HESAP AYNI:
                platforms[].measured_at saklaniyor ve sunucuda "Bilgi guncellendi"ye
                (mdbTazelikIfadesi) girmeye devam ediyor. */}
          </div>

          {/* === KOLON 2 · PROFIL === */}
          <div className={`flex flex-col ${duzenleme ? 'gap-y-2' : 'gap-y-1.5'}`} data-testid="master-db-col-profile">
            {/* CINSIYET. Erkek secilince Anne mi? Hayir olur (is_mother false gider —
                "erkek anne olamaz"), Hamile kalkar; kural cinsiyetSec'te. */}
            {duzenleme ? (
              <div key="gender">
                {editLabel(t.profileGenderLabel)}
                <select
                  value={draft.gender}
                  onChange={(e) => setDraft(cinsiyetSec(draft, e.target.value))}
                  className={editInputCls}
                  data-testid="master-db-edit-gender"
                >
                  {draft.gender === '' && <option value="">—</option>}
                  <option value="kadın">{t.genderFemale}</option>
                  <option value="erkek">{t.genderMale}</option>
                </select>
              </div>
            ) : (
              detailField(
                t.profileGenderLabel,
                doc.gender === 'erkek' ? t.genderMale : doc.gender === 'kadın' ? t.genderFemale : '—'
              )
            )}
            {/* [Y35, Bora 3 Kas 19:40] "Evli mi?" KALKTI: Potansiyel zaten evli demek.
                is_married saklanir; kutular (anneKutuSec / anneEvliYaz) yazar. */}
            {/* ANNE KUTULARI — tek satir: Anne · Hamile · Potansiyel · Degil.
                Okuma: tiklanamaz (anneKutulariOku); Hamile'nin yaninda olcum damgasi.
                Duzenleme: gecisler anneKutuSec'te; Potansiyel / Degil kayitli
                bebek/cocuk bilgisini ONAYLA bosaltir. Erkekte kutular kilitli ve bos
                (okumada "—"). Sunucu 400 donerse (4. kural) mesaj kartin hata kutusunda. */}
            {(() => {
              // [Y18] "Anne mi?" etiketi KARTTAN kalkti: dort kutu etiketsiz,
              // dogrudan satir (filtre grubu ve audit etiketi KALIR). Erkekte
              // okumada da dort kutu BOS ve soluk — etiketsiz tek "—" anlamsizdi.
              const isaret = duzenleme ? anneKutulariTaslak(draft) : anneKutulariOku(doc);
              const kutular = isaret || { anne: false, hamile: false, potansiyel: false, degil: false };
              const tiklanir = duzenleme && isaret !== null;
              return (
                <div key="mother-boxes" className={!duzenleme && isaret === null ? 'opacity-50' : ''}>
                  <div className="flex flex-wrap gap-x-3 gap-y-1" data-testid="master-db-mother-boxes">
                    {[
                      ['anne', t.boxMother],
                      ['hamile', t.boxPregnant],
                      ['potansiyel', t.boxPotential],
                      ['degil', t.boxNot],
                    ].map(([kutu, etiket]) => (duzenleme ? (
                      <label
                        key={kutu}
                        className={`inline-flex items-center gap-1 ${tiklanir ? 'cursor-pointer' : 'opacity-80'}`}
                      >
                        <input
                          type="checkbox"
                          checked={kutular[kutu]}
                          disabled={!tiklanir}
                          onChange={() => onayliUygula(anneKutuSec(draft, kutu))}
                          className="accent-[#A34940]"
                          data-testid={`master-db-mother-box-${kutu}`}
                        />
                        <span>{etiket}</span>
                      </label>
                    ) : (
                      /* OKUMA [Y17]: disabled input DEGIL — tarayici isaretli
                         kutuyu da soluk ciziyordu, "Anne" isareti zor goruluyordu.
                         Isaretli: dolu koyu kutu + ✓, etiket koyu; isaretsiz:
                         ince acik cerceve, etiket soluk. */
                      <span
                        key={kutu}
                        role="checkbox"
                        aria-checked={kutular[kutu]}
                        aria-disabled="true"
                        className={`inline-flex items-center gap-1 ${kutular[kutu] ? 'text-[#232019] font-medium' : 'text-[#9B978E]'}`}
                        data-testid={`master-db-mother-box-${kutu}`}
                      >
                        <span
                          aria-hidden="true"
                          className={`inline-flex items-center justify-center w-[13px] h-[13px] rounded-[3px] text-[10px] leading-none ${
                            kutular[kutu]
                              ? 'bg-[#A34940] border border-[#A34940] text-white'
                              : 'bg-white border-[0.5px] border-[#CAC6BF]'
                          }`}
                        >
                          {kutular[kutu] ? '✓' : ''}
                        </span>
                        <span>
                          {etiket}
                          {kutu === 'hamile' && kutular.hamile && hamileDamga ? ` · ${hamileDamga}` : ''}
                        </span>
                      </span>
                    )))}
                  </div>
                  {/* [Y36] BEKLENEN DOGUM — Hamile kutusunun hemen altinda. */}
                  {(() => {
                    if (duzenleme) {
                      if (!isaret || draft.pregnancy_is_pregnant !== 'evet') return null;
                      const buYil = new Date().getFullYear();
                      const yillar = [buYil, buYil + 1];
                      if (draft.dogum_yil && !yillar.includes(Number(draft.dogum_yil))) yillar.unshift(Number(draft.dogum_yil));
                      const bosDogum = !draft.dogum_ay || !draft.dogum_yil;
                      return (
                        <div className="mt-1.5" data-testid="master-db-edit-dogum">
                          <div className="flex items-center gap-1.5">
                            <span className="text-[11px] text-[#6D6960]">{t.dueDateLabel}</span>
                            <select
                              value={draft.dogum_ay}
                              onChange={(e) => setDraft({ ...draft, dogum_ay: e.target.value })}
                              className="text-[12px] border-[0.5px] border-[#CAC6BF] rounded-[6px] px-1 py-0.5 bg-white"
                              data-testid="master-db-edit-dogum-ay"
                            >
                              <option value="">{t.dueDateMonth}</option>
                              {Array.from({ length: 12 }, (_, i) => i + 1).map((ay) => (
                                <option key={ay} value={String(ay)}>{String(ay).padStart(2, '0')}</option>
                              ))}
                            </select>
                            <select
                              value={draft.dogum_yil}
                              onChange={(e) => setDraft({ ...draft, dogum_yil: e.target.value })}
                              className="text-[12px] border-[0.5px] border-[#CAC6BF] rounded-[6px] px-1 py-0.5 bg-white"
                              data-testid="master-db-edit-dogum-yil"
                            >
                              <option value="">{t.dueDateYear}</option>
                              {yillar.map((y) => <option key={y} value={String(y)}>{y}</option>)}
                            </select>
                          </div>
                          {bosDogum && (
                            <div className="text-[11px] text-[#8A6A20] mt-0.5" data-testid="master-db-edit-dogum-ipucu">
                              {t.dueDateAsk}
                            </div>
                          )}
                        </div>
                      );
                    }
                    if (!kutular.hamile) return null;
                    const dy = dogumAyYil(doc.pregnancy?.due_date);
                    if (!dy) {
                      return (
                        <div className="text-[11px] text-[#9B978E] mt-1" data-testid="master-db-card-dogum-yok">{t.dueDateNone}</div>
                      );
                    }
                    if (dogumaKalanAy(dy) < 0) {
                      return (
                        <div className="text-[11px] mt-1 px-1.5 py-0.5 rounded-[6px] bg-[#FAEFD5] text-[#8A6A20] inline-block" data-testid="master-db-card-dogum-gecti">
                          {t.dueDatePassed.replace('{tarih}', dogumMetni(dy))}
                        </div>
                      );
                    }
                    return (
                      <div className="text-[11px] text-[#6D6960] mt-1" data-testid="master-db-card-dogum">
                        {t.dueDateLabel} {dogumMetni(dy)} ({t.dueDateMonthN.replace('{n}', hamilelikAyi(dy))})
                      </div>
                    );
                  })()}
                </div>
              );
            })()}

            {/* BEBEK / COCUK [Y16 — "cok onemli eksiklik", Bora]. Saklama ayni
                (children[].age_months); bebek < 36 ay, cocuk >= 36 ay TURETILIR.
                IKI MODDA DA DORT HUCRE basilir (panelde hicbir hucre gizlenmez).
                Duzenlemede bebek kutulari AY, cocuk kutulari YAS — birimi grup
                belirler. Potansiyel ya da Degil iken dort alan INAKTIF (tanim
                geregi cocugu yok); erkekte ACIK (baba profilleri). Sayaclar UC
                DURUMLU: ikisi de bos = bilinmiyor, children govdeye girmez. */}
            {(() => {
              const kilitli = duzenleme && cocukAlanlariKilitli(draft);
              const sayac = (grup, etiket, testId, w) => (
                <div key={testId}>
                  {editLabel(etiket)}
                  <input
                    type="number"
                    min="0"
                    max="12"
                    value={draft.cocuk[`${grup}Sayi`]}
                    disabled={kilitli}
                    onChange={(e) => cocukSayisiDegis(grup, e.target.value)}
                    placeholder={t.childCountUnknown}
                    // 86px: "bilinmiyor" placeholder'i kirpilmasin (OLCULDU: 70px'te
                    // 3,3 px pay kaliyordu, canlida "bilinmiy" gorundu).
                    className={`${w} text-[12px] h-[29px] px-[5px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] disabled:opacity-60`}
                    data-testid={testId}
                  />
                </div>
              );
              const yaslar = (grup, etiket, testId) => (
                <div key={testId} className={kilitli ? 'opacity-60' : ''} data-testid={testId}>
                  {editLabel(
                    <>
                      {etiket}
                      <span className="text-[#9B978E]"> · {t.childAgeHint}</span>
                    </>
                  )}
                  {cocukKutulari(grup, kilitli)}
                </div>
              );
              return duzenleme ? (
                <>
                  {sayac('bebek', t.detailBabies, 'master-db-edit-baby-count', 'w-[86px]')}
                  {sayac('cocuk', t.detailChildren, 'master-db-edit-child-count', 'w-[86px]')}
                  {yaslar('bebek', t.detailBabyAges, 'master-db-edit-baby-ages')}
                  {yaslar('cocuk', t.detailChildAges, 'master-db-edit-child-ages')}
                  {kilitli && (
                    <div className="text-[11px] text-[#9B978E] -mt-1" data-testid="master-db-children-locked">
                      {t.childrenLockedNotMother}
                    </div>
                  )}
                </>
              ) : (
                <>
                  {/* [Y35, Bora 3 Kas 19:44] iki satir: "sayi & yas & yas"; 0 ise yalniz "0". */}
                  <div key="babies" data-testid="master-db-card-babies">
                    <span className="text-[#6D6960]">{t.detailBabiesAges}:</span> <span>{bebekSatiri}</span>
                  </div>
                  <div key="children" data-testid="master-db-card-children">
                    <span className="text-[#6D6960]">{t.detailChildrenAges}:</span> <span>{cocukSatiri}</span>
                  </div>
                </>
              );
            })()}
            {duzenleme
              ? editChips(t.detailCategory, 'category', CATEGORIES)
              : detailField(t.detailCategory, listOrDash(doc.category))}
          </div>

          {/* === KOLON 3 · UZMANLIK VE CALISMA [Y18c] === */}
          <div className={`flex flex-col ${duzenleme ? 'gap-y-2' : 'gap-y-1.5'}`} data-testid="master-db-col-work">
            {duzenleme ? (
              editBool3(t.expertLabel, 'is_expert', 'master-db-edit-is_expert')
            ) : (
              detailField(
                t.expertLabel,
                // IKI DURUM [KARAR Bora, 5 Eyl]: tikli degilse "degil" okunur.
                // GOSTERIM DEGISTI, SAKLAMA DEGISMEDI: alan hala uc durum tasiyor.
                doc.is_expert === true ? t.yes : t.no
              )
            )}
            {duzenleme
              ? editChips(t.detailExpertise, 'expertise', EXPERTISE_FLAT)
              : detailField(t.detailExpertise, listOrDash(doc.expertise))}
            {/* [Y27, Bora 2 Kas 20:01] MARKALAR — Uzmanlik'in hemen alti. Okumada ilk 8
                marka + "+N", tamami title'da. Duzenlemede tek satir metin; dokunulmazsa
                govdeye girmez (mdbGovdeKur). Yeni kayit formu da bu karti kullaniyor. */}
            {duzenleme ? (
              <div key="markalar">
                {editLabel(t.detailBrands)}
                <input
                  type="text"
                  value={draft.markalar}
                  maxLength={2000}
                  placeholder="Prima, Dalin"
                  onChange={(e) => setDraft({ ...draft, markalar: e.target.value })}
                  className={editInputCls}
                  data-testid="master-db-edit-markalar"
                />
              </div>
            ) : (() => {
              const markalar = (Array.isArray(doc.worked_brands) ? doc.worked_brands : []).map(safeText).filter(Boolean);
              const gorunen = markalar.length > 8
                ? `${markalar.slice(0, 8).join(', ')} +${markalar.length - 8}`
                : (markalar.join(', ') || '—');
              return (
                <div key="markalar" data-testid="master-db-markalar" title={markalar.length ? markalar.join(', ') : undefined}>
                  <span className="text-[#6D6960]">{t.detailBrands}:</span> <span>{gorunen}</span>
                </div>
              );
            })()}
            {/* [Y32, Bora 3 Kas 12:08] HEDIYELESME — Markalar'in hemen alti, ayni gorunum
                ve duzenleme. Markalar yalniz UCRETLI is birligi; burasi hediye karsiligi
                paylasim yapilan markalar. */}
            {duzenleme ? (
              <div key="hediyeler">
                {editLabel(t.detailGifted)}
                <input
                  type="text"
                  value={draft.hediyeler ?? ''}
                  maxLength={2000}
                  placeholder="Chicco, Dalin"
                  onChange={(e) => setDraft({ ...draft, hediyeler: e.target.value })}
                  className={editInputCls}
                  data-testid="master-db-edit-gifted"
                />
              </div>
            ) : (() => {
              const hediyeler = (Array.isArray(doc.gifted_brands) ? doc.gifted_brands : []).map(safeText).filter(Boolean);
              const gorunen = hediyeler.length > 8
                ? `${hediyeler.slice(0, 8).join(', ')} +${hediyeler.length - 8}`
                : (hediyeler.join(', ') || '—');
              return (
                <div key="hediyeler" data-testid="master-db-card-gifted" title={hediyeler.length ? hediyeler.join(', ') : undefined}>
                  <span className="text-[#6D6960]">{t.detailGifted}:</span> <span>{gorunen}</span>
                </div>
              );
            })()}
            {/* [Y35, Bora 3 Kas 19:47] "Ucret alinma" hucresi KALKTI: ucret tarihi listede,
                kim neyi degistirdi Gecmis'te ("Ucret tarihi" etiketi). */}
            {duzenleme
              ? editSelect(t.detailBilling, 'billing_type', BILLING_TYPES)
              : detailField(t.detailBilling, valueOrUnknown(doc.billing_type))}
            {/* AJANS [26 Eki]. Ad yazilinca "Ajansla calisiyor" Evet olur; Hayir
                secilince ad temizlenir (sunucu da ayni kurali uyguluyor). */}
            {duzenleme ? (
              <>
                <div key="has_agency">
                  {editLabel(t.editHasAgency)}
                  <select
                    value={draft.has_agency}
                    onChange={(e) => {
                      const v = e.target.value;
                      setDraft({ ...draft, has_agency: v, ...(v === 'hayir' ? { agency_name: '' } : {}) });
                    }}
                    className={editInputCls}
                    data-testid="master-db-edit-has_agency"
                  >
                    {draft.has_agency === '' && <option value="">—</option>}
                    <option value="evet">{t.yes}</option>
                    <option value="hayir">{t.no}</option>
                  </select>
                </div>
                <div key="agency_name">
                  {editLabel(t.editAgencyName)}
                  <input
                    type="text"
                    maxLength={120}
                    value={draft.agency_name}
                    onChange={(e) => {
                      const v = e.target.value;
                      setDraft({ ...draft, agency_name: v, ...(v.trim() ? { has_agency: 'evet' } : {}) });
                    }}
                    className={editInputCls}
                    data-testid="master-db-edit-agency_name"
                  />
                </div>
              </>
            ) : (
              detailField(
                t.profileAgencyLabel,
                doc.has_agency === true || doc.agency_name
                  ? (doc.agency_name ? `${t.agencyWith} · ${doc.agency_name}` : t.agencyWith)
                  : doc.has_agency === false ? t.agencyWithout : '—'
              )
            )}
            {readOnlyCell(
              t.detailSource,
              Array.isArray(doc.sources) && doc.sources.length
                ? doc.sources.map((x) => capitalize(safeText(x))).filter(Boolean).join(' + ') || '—'
                : '—',
              'master-db-readonly-source'
            )}
          </div>

          {/* === KOLON 4 · ILETISIM VE DURUM === */}
          <div className={`flex flex-col ${duzenleme ? 'gap-y-2' : 'gap-y-1.5'}`} data-testid="master-db-col-contact">
            {duzenleme
              ? editText(t.detailPhone, 'phone')
              : detailField(t.detailPhone, safeText(doc.phone) || '—')}
            {duzenleme
              ? editText(t.detailEmail, 'email')
              : detailField(t.detailEmail, safeText(doc.email) || '—')}
            {duzenleme
              ? editText(t.detailCity, 'city')
              : detailField(t.detailCity, safeText(doc.city) || '—')}
            {duzenleme ? (
              <>
                {editBool3(t.seedingLabel, 'is_seeding_account', 'master-db-edit-is_seeding_account')}
                {/* Seeding isareti ACILIYOR ve kayitta segment var: sunucu kaydetmede
                    segmenti siliyor — once soyle. */}
                {draft.is_seeding_account === 'evet' && doc.is_seeding_account !== true && segmentLabel(doc) && (
                  <div className="text-[11px] text-[#A34940] -mt-1" data-testid="master-db-seeding-segment-warning">
                    {t.seedingSegmentRemoved.replace('{seg}', segmentLabel(doc))}
                  </div>
                )}
              </>
            ) : (
              detailField(
                t.seedingLabel,
                // IKI DURUM — ucuncu durum YOK. OLCULDU (canli, 2797 kayit): true=42,
                // false=2755, alan hic yok=0. Bu alan influencer hakkinda degil BIZIM
                // hakkimizda; "sorulmadi" durumu yok, false mesru varsayilan.
                doc.is_seeding_account === true ? t.yes : t.no
              )
            )}
            {duzenleme ? (
              editBool3(t.talentLabel, 'is_talent', 'master-db-edit-is_talent')
            ) : (
              detailField(
                t.talentLabel,
                // IKI DURUM. OLCULDU (canli, 2797 kayit): true=0, false=2797.
                doc.is_talent === true ? t.yes : t.no
              )
            )}
            {duzenleme ? (
              editBool3(t.detailWhatsapp, 'whatsapp_member', 'master-db-edit-whatsapp')
            ) : (
              detailField(
                t.detailWhatsapp,
                // IKI DURUM [KARAR Bora, 5 Eyl]: tikli degilse "uye degil" okunur.
                doc.whatsapp_community?.member === true
                  ? t.whatsappMember
                  : t.whatsappNotMember
              )
            )}
            {duzenleme
              ? editSelect(t.detailBarter, 'barter_open', BARTER_VALUES)
              : detailField(t.detailBarter, valueOrUnknown(doc.barter_open))}
          </div>

          {/* === KOLON 5 · METIN [Y35, Bora 3 Kas 19:47-19:49] ===
              Ustte Instagram bio (· AA.YYYY, bio_measured_at), altta Influencer
              Hakkinda. Bos iken soluk "Bio yok" / "Degerlendirme yok" — hucre
              gizlenmez. Okumada en cok 6 satir; uzunsa "devamı" / "daha az".
              Duzenlemede AYNI hucreler metin kutusu: bio Instagram adi yoksa kapali. */}
          <div className={`flex flex-col ${duzenleme ? 'gap-y-2' : 'gap-y-2.5'} min-w-0`} data-testid="master-db-col-text">
            {(() => {
              const ig = igGirisi(doc);
              const bio = igBioOku(doc).trim();
              const ay = formatMonthYear(ig?.bio_measured_at);
              const hakkinda = String(doc.influencer_hakkinda || '').trim();
              const metinHucresi = (anahtar, etiket, metin, bosMetin, testId) => {
                const acik = Boolean(metinAcik[`${doc._id}:${anahtar}`]);
                const uzun = metinUzunMu(metin);
                return (
                  <div key={anahtar} className="min-w-0">
                    <div className="text-[#6D6960] mb-0.5">{etiket}</div>
                    {metin ? (
                      <>
                        <div
                          className={`text-[12px] text-[#232019] whitespace-pre-line break-words ${uzun && !acik ? 'line-clamp-6' : ''}`}
                          data-testid={testId}
                        >
                          {metin}
                        </div>
                        {uzun && (
                          <button
                            type="button"
                            onClick={() => setMetinAcik((m) => ({ ...m, [`${doc._id}:${anahtar}`]: !acik }))}
                            className="text-[11px] text-[#8A6A28] hover:underline mt-0.5"
                            data-testid={`${testId}-more`}
                          >
                            {acik ? t.textLess : t.textMore}
                          </button>
                        )}
                      </>
                    ) : (
                      <div className="text-[12px] text-[#9B978E]" data-testid={`${testId}-empty`}>{bosMetin}</div>
                    )}
                  </div>
                );
              };
              if (!duzenleme) {
                return (
                  <>
                    {metinHucresi('bio', ay ? `${t.bioLabel} · ${ay}` : t.bioLabel, bio, t.bioEmpty, 'master-db-card-bio')}
                    {metinHucresi('hakkinda', t.hakkindaLabel, hakkinda, t.hakkindaEmpty, 'master-db-card-hakkinda')}
                  </>
                );
              }
              const handleYok = String(draft.instagram_handle || '').trim() === '';
              const uzunluk = String(draft.influencer_hakkinda || '').length;
              return (
                <>
                  <div key="bio-edit">
                    {editLabel(ay ? `${t.bioLabel} · ${ay}` : t.bioLabel)}
                    <textarea
                      rows="4"
                      maxLength={BIO_EN_COK}
                      value={draft.instagram_bio ?? ''}
                      disabled={handleYok}
                      title={handleYok ? t.bioNeedsHandle : undefined}
                      onChange={(e) => setDraft({ ...draft, instagram_bio: e.target.value })}
                      className="w-full text-[12px] px-[7px] py-[5px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] resize-y disabled:opacity-60"
                      data-testid="master-db-edit-bio"
                    />
                    {handleYok && (
                      <div className="text-[11px] text-[#9B978E]" data-testid="master-db-bio-needs-handle">{t.bioNeedsHandle}</div>
                    )}
                  </div>
                  <div key="hakkinda-edit">
                    {editLabel(t.hakkindaLabel)}
                    <textarea
                      rows="6"
                      maxLength={HAKKINDA_EN_COK}
                      value={draft.influencer_hakkinda ?? ''}
                      onChange={(e) => setDraft({ ...draft, influencer_hakkinda: e.target.value })}
                      className="w-full text-[12px] px-[7px] py-[5px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] resize-y"
                      data-testid="master-db-edit-influencer_hakkinda"
                    />
                    <div
                      className={`text-[11px] text-right tabular-nums ${uzunluk > HAKKINDA_YUMUSAK_SINIR ? 'text-[#B7791F] font-medium' : 'text-[#9B978E]'}`}
                      data-testid="master-db-hakkinda-sayac"
                      data-asti={uzunluk > HAKKINDA_YUMUSAK_SINIR ? 'evet' : 'hayir'}
                    >
                      {/* Turkce binlik nokta ("1.234 / 1.000") — reel olcumuyle ayni bicim. */}
                      {uzunluk.toLocaleString('tr-TR')} / {HAKKINDA_YUMUSAK_SINIR.toLocaleString('tr-TR')}
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>

        {/* Dizi uzunlugu tahminden farkliysa: mukerrer kayit is kuyrugu.
            Kolon icinde degil ALTINDA — uyari kutusu, alan degil. YALNIZ OKUMADA;
            [Y18c] okuma parcasindan seridin USTUNE tasindi, icerik ayni. */}
        {!duzenleme && children.length > 0 && childCountMismatch(doc) && (
          <div
            className="text-[12px] text-[#8A6A20] mt-1.5 px-[7px] py-[5px] rounded-[6px] bg-[#FAEFD5]"
            data-testid="master-db-child-mismatch"
          >
            {t.childMismatch
              .replace('{len}', childCountMismatch(doc).len)
              .replace('{est}', childCountMismatch(doc).est)}
          </div>
        )}

        {/* === NOT EKLE SERIDI [Y18c, Bora 2 Kas 07:47] ===
            Izgaranin hemen ALTINDA, IKI MODDA DA AYNI YERDE (okumada Duzenle'nin
            ustu, duzenlemede Platformlar'in ustu). Ayni izgara sistemi: Not ekle
            ilk uc kolon genisliginde tek yatay sira (textarea solda, [Ekle]
            sagda; tam genislikte 2 satir ≈ dar kolondaki 8 satirin kapasitesi),
            kampanya gecmisi 4. hucrede. Var olan kayitta not EKLEME ISLEMI
            (add_note -> PATCH, _id ister; kayitIslemi); yeni kayitta POST
            govdesindeki Not ALANI (yeniKayitAlani), tam genislik. Not LISTESI
            asagida, Duzenle'nin altinda. */}
        <div
          className={`grid grid-cols-1 sm:grid-cols-2 ${KART_KOLONLARI} gap-x-[12px] gap-y-1.5 text-[12px] mt-2.5 pt-2.5 border-t-[0.5px] border-[#E4E1DC] [overflow-wrap:anywhere]`}
          data-testid="master-db-note-strip"
        >
          {kayitIslemi(
            <div className={`sm:col-span-2 ${kampanyaGorunur ? 'xl:col-span-3' : 'xl:col-span-5'} flex items-start gap-x-[7px]`}>
              <textarea
                rows="2"
                aria-label={t.noteAddTitle}
                value={noteDraft}
                onChange={(e) => setNoteDraft(e.target.value)}
                placeholder={t.notePlaceholder}
                className="flex-1 min-w-0 text-[12px] px-[9px] py-[7px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] resize-y"
                data-testid="master-db-note-input"
              />
              <button
                type="button"
                disabled={saving || !noteDraft.trim()}
                onClick={async () => {
                  const ok = await patchRecord(doc, { add_note: noteDraft.trim() });
                  if (ok) setNoteDraft('');
                }}
                className="shrink-0 text-[12px] px-[13px] py-[6px] h-fit rounded-[6px] border-[0.5px] border-[#CAC6BF] hover:bg-white transition disabled:opacity-40"
                data-testid="master-db-note-add"
              >
                {t.noteAdd}
              </button>
            </div>
          )}
          {/* KAMPANYA GECMISI [Y18b, Bora 1 Kas 22:52] — "hangi markaya kimi
              onerdik". Kolonlarin altinda tam genislikte duruyordu; cogu kayitta
              yalniz "Henuz kampanya kaydi yok" yaziyordu. [Y18c] Seridin 4.
              hucresi, Not ekle'nin SAGINDA. Dar hucre: satir iki satirli — ustte
              kampanya (+ teslimatlar), altta tarih · ucret · durum. Uzun ad kolonu tasirmaz (min-w-0 +
              [overflow-wrap:anywhere] izgaradan).
              YENI KAYITTA GIZLI: patlamiyor ama YANLIS SEY SOYLUYOR — "Henuz
              kampanya kaydi yok" derken ortada KAYIT bile yok. */}
          {kampanyaGorunur && kayitIslemi(
            <div className="sm:col-span-2 xl:col-span-2 min-w-0" data-testid="master-db-campaigns">
              <div className="text-[12px] text-[#6D6960] mb-1.5">{t.campaignsTitle}</div>
              {campaigns.status === 'error' ? (
                <div className="text-[12px] text-[#A34940]" data-testid="master-db-campaigns-error">{t.campaignsError}</div>
              ) : (
                campaigns.items.map((c, i) => (
                  <div
                    key={c._id || `${c.campaign_key}-${i}`}
                    className="text-[12px] py-[3px] min-w-0 border-t-[0.5px] border-[#E4E1DC] first:border-t-0"
                    data-testid="master-db-campaign-row"
                  >
                    <div className="min-w-0">
                      {safeText(c.campaign_key) || '—'}
                      {deliverablesText(c.deliverables, t) && (
                        <span className="text-[#9B978E]"> · {deliverablesText(c.deliverables, t)}</span>
                      )}
                    </div>
                    <div className="text-[#6D6960] flex items-center flex-wrap gap-x-1.5 gap-y-0.5 mt-0.5">
                      {[formatMonthYear(c.proposed_at), fmtMoney(c.agreed_fee, cur) || '—']
                        .filter(Boolean)
                        .join(' · ')}
                      {campaignStatusBadge(c.status)}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
          {/* NOT — P1'in gizledigi "not EKLEME" ISLEMI DEGIL. O islem
              add_note ile PATCH'e gider ve _id ister; burasi POST govdesinde
              add_note olarak giden bir ALAN. Ayni kelime, farkli sey.
              ⚠ [Y17b] yeniKayitAlani bir FONKSIYON: argumani OKUMA modunda da
              degerlendirilir ve orada draft null'dir. `draft.note` butun
              sayfayi beyaza ceviriyordu — sarmanin icinde yalniz `draft?.`. */}
          {yeniKayitAlani(
            <div className="sm:col-span-2 xl:col-span-5">
              {editLabel(t.newRecordNote)}
              <textarea
                rows="2"
                value={draft?.note ?? ''}
                onChange={(e) => setDraft({ ...draft, note: e.target.value.slice(0, 4000) })}
                className="w-full text-[12px] p-2 bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF]"
                data-testid="master-db-new-note"
              />
            </div>
          )}
        </div>

        {duzenleme ? (
          <>
            {/* Platformlar: uc satir da her zaman gorunur. Yalnizca takipci
                duzenlenir; measured_at ve source damgasini sunucu yazar.
                KULLANICI ADI BURADA GIRILMEZ [Bora, 26 Eki]: ustteki
                Instagram/TikTok/YouTube kutusunun degeri salt-okunur gosterilir
                (draft'tan, yazarken canli). Iki ayri kutu vardi ve bagli degildi;
                buraya yazilan ad kimlige ulasmiyordu. */}
            <div className="mt-2.5">
              <div className="text-[#6D6960] text-[12px]">{t.editPlatforms}</div>
              <div className="text-[#6D6960] mb-1 text-[11px]">{t.editPlatformsNote}</div>
              {FOLLOWER_ORDER.map((pf) => (
                <div key={pf} className="flex items-center gap-1.5 mb-1.5">
                  <span className="text-[11px] w-[52px] text-[#6D6960]">{platformLabel(pf)}</span>
                  <span
                    className="w-[130px] text-[12px] truncate text-[#6D6960]"
                    data-testid={`master-db-edit-handle-${pf}`}
                  >
                    {String(draft[`${pf}_handle`] || '').trim() || '—'}
                  </span>
                  {/* Ayirici GORUNUMDE; taslakta ve govdede ham rakam durur.
                      Rakam disi her karakter (harf, sembol, eksi, nokta) dusurulur —
                      engelleme onChange'de oldugu icin yapistirma da temizlenir. */}
                  <input
                    {...thousandsInputProps(draft.platforms[pf].followers, (ham) =>
                      setDraft({
                        ...draft,
                        platforms: { ...draft.platforms, [pf]: { ...draft.platforms[pf], followers: ham } },
                      })
                    )}
                    placeholder={t.colFollowers}
                    className="w-[110px] text-[12px] h-[29px] px-[5px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF]"
                    data-testid={`master-db-edit-followers-${pf}`}
                  />
                </div>
              ))}
            </div>

            {yeniKayitAlani(
              <div className="mt-3 pt-2.5 border-t-[0.5px] border-[#E4E1DC] flex flex-col gap-y-2">
                {/* SEGMENT — duzenleme kartinda AYRI bir akista atanir (rozete
                    tiklayinca) ve o akis yeni kayitta yok; alan tasinmasaydi yeni
                    kayitta segment HIC girilemezdi. */}
                <div>
                  {editLabel(t.colSegment)}
                  {/* Seeding secildiyse KAPALI: seeding hesaplarina segment atanmaz
                      (sunucu 400 doner). Secili deger gonderilmez — saveEdit. */}
                  <select
                    value={draft?.is_seeding_account === 'evet' ? '' : draft?.brand_segment}
                    onChange={(e) => setDraft({ ...draft, brand_segment: e.target.value })}
                    disabled={draft?.is_seeding_account === 'evet'}
                    className={`${editInputCls} disabled:opacity-50`}
                    data-testid="master-db-new-segment"
                  >
                    <option value="">{t.newRecordSegmentNone}</option>
                    {SEGMENT_DICTIONARY.map((sg) => (
                      <option key={sg} value={sg}>{sg}</option>
                    ))}
                  </select>
                </div>
                {/* DIGER MECRA — serbest metin, NOTA yazilir (13 Eyl karari).
                    Alan degil not oldugu icin kimlik satirina konmadi. */}
                <div>
                  {editLabel(t.newRecordOtherPlatform)}
                  <input
                    type="text"
                    value={draft?.diger_mecra}
                    onChange={(e) => setDraft({ ...draft, diger_mecra: e.target.value })}
                    placeholder={t.newRecordOtherPlatformPlaceholder}
                    className={editInputCls}
                    data-testid="master-db-new-other-platform"
                  />
                </div>
                {/* Not ALANI Not ekle seridinde [Y18c]. */}
              </div>
            )}

            {saveError && (
              <div
                className="mt-2.5 text-[12px] px-[7px] py-[5px] rounded-[6px] bg-[#F9E5E2] text-[#A34940]"
                data-testid="master-db-save-error"
              >
                {saveError}
                {saveConflict && saveConflict.birlestir && (
                  <>
                    <button
                      type="button"
                      onClick={() => birlestirAc(saveConflict.id, doc._id)}
                      className="ml-1.5 underline font-medium hover:text-[#232019] transition"
                      data-testid="master-db-merge-open"
                    >
                      {t.mergeOpen}
                    </button>
                    <div className="text-[11px] text-[#8A6A20] mt-0.5">{t.mergeUnsavedNote}</div>
                  </>
                )}
                {saveConflict && !saveConflict.birlestir && (
                  <button
                    type="button"
                    onClick={() => {
                      // Kapi donerse panel de ACILMAZ. Bugun ulasilamaz —
                      // olculdu: 409'da finally setSaving(false) kosuyor, yani
                      // dugme gorundugunde saving false. Ama olu kod yolu
                      // guvenli degildir; kosul burada duruyor.
                      const hedef = saveConflict.id;
                      if (kapatmaIstegi(true)) setOpenId(hedef);
                    }}
                    className="ml-1.5 underline hover:text-[#232019] transition"
                    data-testid="master-db-new-goto-existing"
                  >
                    {t.newRecordGoTo}
                  </button>
                )}
              </div>
            )}

            <div className="mt-3 flex gap-[7px] items-center flex-wrap">
              <button
                type="button"
                // GORUNEN KAPI. saveEdit icindeki erken donus sessizdir: kullanici
                // bos formda Kaydet'e basip hicbir sey olmadigini gorurdu.
                // AYNI YUKLEM (P3) — elle yazilmis ikinci bir kosul YOK.
                disabled={saving || mdbHandleEksik(draft, yeniMi)}
                onClick={() => saveEdit(doc, yeniMi)}
                className="text-[12px] px-[13px] py-[5px] rounded-[6px] bg-[#E8C35C] text-[#2A2317] font-medium hover:brightness-95 transition disabled:opacity-50"
                data-testid="master-db-save"
              >
                {saving ? t.saving : t.save}
              </button>
              <button
                type="button"
                disabled={saving}
                onClick={() => kapatmaIstegi(yeniMi)}
                className="text-[12px] text-[#9B978E] hover:text-[#232019] transition"
                data-testid="master-db-cancel"
              >
                {t.cancel}
              </button>
              <span className="text-[12px] text-[#9B978E]">{t.auditNote}</span>
            </div>
          </>
        ) : (
        <>
        {/* Duzenle + Favori (ORTAK favori: ekipten herkes isaretler/kaldirir) */}
        <div className="mt-3 flex gap-[7px] items-center flex-wrap">
          <button
            type="button"
            onClick={() => startEdit(doc)}
            className="text-[12px] px-3 py-[5px] rounded-[6px] border-[0.5px] border-[#CAC6BF] hover:bg-white transition"
            data-testid="master-db-edit"
          >
            ✎ {t.edit}
          </button>
          {kayitIslemi(
            <button
              type="button"
              disabled={saving}
              onClick={() => patchRecord(doc, { favorite: !doc.is_favorite })}
              className={`text-[12px] px-3 py-[5px] rounded-[6px] transition disabled:opacity-50 ${
                doc.is_favorite
                  ? 'bg-[#F6EBD3] text-[#8A6A28] border-[0.5px] border-transparent'
                  : 'border-[0.5px] border-[#CAC6BF] text-[#6D6960] hover:bg-white'
              }`}
              data-testid="master-db-favorite"
            >
              {doc.is_favorite ? `★ ${t.favorited}` : `☆ ${t.addFavorite}`}
            </button>
          )}
          {saveError && <span className="text-[12px] text-[#A34940]">{saveError}</span>}
        </div>
        </>
        )}


        {/* Kampanya gecmisi Not ekle seridinde [Y18b -> Y18c]. */}

        {/* Notlar — LISTE ve EKLEME.
            YENI KAYITTA TAMAMI GIZLI. P1'deki "liste ALAN, ekleme ISLEM" ayrimi
            BOZULMADI: sarma listenin kendisine degil yeniMi'ye bagli, yani
            duzenlemede liste gorunmeye devam ediyor. Yeni kayitta gizlenmesinin
            sebebi baska: hemen ustunde kullanicinin DOLDURDUGU Not alani
            dururken altinda "Not yok" yazmak yanlis sey soyluyordu. */}
        {/* [Y34, Bora 3 Kas 17:38] "Notlarin yanina ayni satirda 2 kolon": solda Notlar (icerik ve
            davranis AYNEN), sagda Reel metrikleri. Dar ekranda alt alta; duzenlemede de ayni yerlesim. */}
        {kayitIslemi(
        <div className="mt-[11px] pt-[9px] border-t-[0.5px] border-[#E4E1DC] grid grid-cols-1 sm:grid-cols-2 gap-x-[12px] gap-y-2.5" data-testid="master-db-notes-reel">
        <div className="min-w-0" data-testid="master-db-notes">
          <div className="text-[12px] text-[#6D6960] mb-1.5">{t.notesTitle}</div>
          {notes.length === 0 ? (
            <div className="text-[12px] text-[#9B978E]" data-testid="master-db-notes-empty">
              {t.notesEmpty}
            </div>
          ) : (
            notes.map((n, i) => (
              <div key={i} className="py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0">
                <div className="text-[12px] leading-relaxed">{safeText(n?.text) || '—'}</div>
                {/* Not tarihi AY + YIL. Gun bilgisi gercek degil: 1158 tarihli not
                    yalnizca 24 farkli deger tasiyor, saat bileseni iki tane
                    (00:00:00 ve 20:59:04 UTC = 23:59:04 Istanbul) ve degerlerin
                    cogu ayin ilk ya da son gunu — yani "bu not su aya ait"
                    bilgisinin yuvarlanmis hali. Gun gostermek olmayan bir
                    kesinlik iddia ederdi.
                    created_at null olan 1989 notta formatMonthYear null doner,
                    filter(Boolean) tarihi tamamen dusurur: "tarih yok" gibi bir
                    etiket basilmaz, satir yalnizca yazari gosterir. */}
                {/* Taslak yuklemesinden gelen not [Y20]: "Taslak · yukleyen · AA.YYYY".
                    Sunucu author'u yukleyenle, created_at'i yukleme aniyla damgaliyor. */}
                <div className="text-[11px] text-[#9B978E] mt-0.5" data-testid="master-db-note-meta">
                  {[n?.kaynak === 'taslak' ? t.noteSourceTaslak : null,
                    safeText(n?.author), formatMonthYear(n?.created_at, notGocKaynakli(n))]
                    .filter(Boolean)
                    .join(' · ') || '—'}
                </div>
              </div>
            ))
          )}
          {/* Not EKLEME Duzenle'nin ustundeki seritte [Y18c] — silme yok; yanlis yazilirsa yeni not eklenir. */}
        </div>
        {(() => {
          const ig = (Array.isArray(doc.platforms) ? doc.platforms : [])
            .find((p) => String(p?.platform || '').trim().toLowerCase() === 'instagram');
          const o = ig && ig.reel_olcum && typeof ig.reel_olcum === 'object' ? ig.reel_olcum : null;
          if (!o) {
            return (
              <div className="min-w-0" data-testid="master-db-card-reel-empty">
                <div className="text-[12px] text-[#6D6960] mb-1.5">{t.reelTitle}</div>
                <div className="text-[12px] text-[#9B978E]">{t.reelEmpty}</div>
              </div>
            );
          }
          const v = (x) => reelSayi(x) ?? '—';
          const satirlar = [
            [t.reelMedian, v(o.medyan)],
            [t.reelAvg, v(o.ortalama)],
            [t.reelMinMax, `${v(o.min)} – ${v(o.max)}`],
            [t.reelPerFollower, reelSayi(o.medyan_takipci) != null ? `× ${reelSayi(o.medyan_takipci)}` : '—'],
            [t.reelEngagement, reelSayi(o.etkilesim) != null ? `%${reelSayi(o.etkilesim)}` : t.reelLikesHidden],
            [t.reelLast3m, v(o.son3ay)],
            [t.reelWeekly, v(o.haftalik)],
            [t.reelSample, reelSayi(o.ornek) != null ? `${reelSayi(o.ornek)} ${t.reelSampleUnit}` : '—'],
            // [Y36, Bora 23:03] son 12 NORMAL reel'de reklam (sabitlenenler HARIC); 0 gosterilir, alan yoksa satir yok.
            ...(typeof o.reklam_sayisi === 'number' ? [[t.reelAds, reelSayi(o.reklam_sayisi), t.reelAdsHint]] : []),
          ];
          return (
            <div className="min-w-0" data-testid="master-db-card-reel">
              <div className="text-[12px] text-[#6D6960] mb-1.5 flex items-center gap-1.5 flex-wrap">
                <span>{[t.reelTitle, reelGun(o.tarih)].filter(Boolean).join(' · ')}</span>
                {/* [Y36] aktiflik rozeti — son 90 gun reel sayisindan, otomatik. */}
                {aktiflikDurumu(o.son3ay) && (
                  <span
                    className={`text-[10px] px-1.5 py-[1px] rounded-[6px] ${AKTIFLIK_SINIF[aktiflikDurumu(o.son3ay)]}`}
                    title={t.activityHint.replace('{n}', o.son3ay)}
                    data-testid="master-db-card-aktiflik"
                    data-aktiflik={aktiflikDurumu(o.son3ay)}
                  >
                    {t.activity[aktiflikDurumu(o.son3ay)]}
                  </span>
                )}
              </div>
              <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-[12px]">
                {satirlar.map(([etiket, deger, ipucu]) => (
                  <React.Fragment key={etiket}>
                    <span className="text-[#6D6960]" title={ipucu}>{etiket}</span>
                    <span className="tabular-nums" title={ipucu} data-testid={ipucu ? 'master-db-card-reel-ads' : undefined}>{deger}</span>
                  </React.Fragment>
                ))}
              </div>
            </div>
          );
        })()}
        </div>
        )}

        {/* === KAYIT GECMISI ===
            Sema §12 oncelik 1: dort ekip uyesi 23 alani duzenleyebiliyor, kademe
            ayrimi yok ve tek koruma olan audit_log hicbir yerden goruntulenemiyordu.
            Katlanabilir, VARSAYILAN KAPALI; veri yalnizca acilinca cekiliyor.
            Satir yoksa baslik yine basilir — panelde hicbir bolum gizlenmez (§7.4). */}
        {kayitIslemi(
        <div className="mt-[11px] pt-[9px] border-t-[0.5px] border-[#E4E1DC]">
          <button
            type="button"
            onClick={() => setHistoryOpen((o) => !o)}
            className="text-[12px] text-[#6D6960] flex items-center gap-1 hover:text-[#8A6A28] transition"
            data-testid="master-db-history-toggle"
          >
            {/* SAYI ANCAK CEKILDIKTEN SONRA BILINIR. Veri bolum acilinca cekiliyor
                (panel acilisinda degil), dolayisiyla kapaliyken N gosterilemez —
                gostermek icin 2797 kayitlik listede her panel acilisinda bir istek
                daha atmak gerekirdi. Kapaliyken yalnizca baslik, yuklenirken "…",
                yuklendikten sonra gercek sayi basiliyor. */}
            <span>
              {t.historyLabel}
              {history.status === 'loading' ? ' (…)' : history.status === 'ok' ? ` (${history.total})` : ''}
            </span>
            <span className="text-[11px] text-[#9B978E]">{historyOpen ? '▴' : '▾'}</span>
          </button>

          {historyOpen && (
            <div className="mt-1.5" data-testid="master-db-history">
              {history.status === 'loading' ? (
                <div className="text-[12px] text-[#9B978E] flex items-center gap-1.5" data-testid="master-db-history-loading">
                  <Loader2 className="animate-spin" size={13} />
                  {t.loading}
                </div>
              ) : history.status === 'error' ? (
                <div className="text-[12px] text-[#A34940]" data-testid="master-db-history-error">
                  {t.historyError}
                </div>
              ) : history.items.length === 0 ? (
                <div className="text-[12px] text-[#9B978E]" data-testid="master-db-history-empty">
                  {t.historyEmpty}
                </div>
              ) : (
                <>
                  {/* [Y33] Denetim izi: en yeni ustte, "Kayit olusturan" HER ZAMAN en altta.
                      Kisi = degisikligi YAPTIRAN (onaylayan gosterilmez); yol eki Taslak /
                      Kart birlestirme / Talep. */}
                  {[...history.items.filter((h) => h.action !== 'create'), ...history.items.filter((h) => h.action === 'create')].map((h, i) => {
                    const yolEki = h.kaynak === 'taslak' && h.dosya ? t.historySourceTaslak.replace('{dosya}', h.dosya)
                      : h.kaynak === 'dosya' && h.dosya ? t.historySourceFile.replace('{dosya}', h.dosya)
                        : h.kaynak === 'birlestirme' ? t.historySourceMerge
                          : h.kaynak === 'talep' ? t.historySourceRequest : null;
                    // [Y33b] Goc dosyasindan gelen kayitta kisi yerine "Göç".
                    const alt = [h.goc ? t.historyMigration : shortUser(h.user_email), auditZaman(h.timestamp), yolEki].filter(Boolean).join(' · ');
                    if (h.action === 'create') {
                      return (
                        <div
                          key={h._id || i}
                          className="py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0 text-[12px]"
                          data-testid="master-db-history-created"
                        >
                          <span className="text-[#6D6960]">{t.historyCreatedBy}:</span> <span>{alt || t.unknown}</span>
                        </div>
                      );
                    }
                    return (
                      <div
                        key={h._id || i}
                        className="py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0"
                        data-testid="master-db-history-row"
                      >
                        <div className="text-[12px] leading-relaxed">
                          <span className="text-[#6D6960]">{auditAlanEtiketi(h.field)}:</span>{' '}
                          <span className="text-[#9B978E]">{auditDeger(h.field, h.old_value, cur)}</span>
                          <span className="text-[#9B978E]"> → </span>
                          <span>{auditDeger(h.field, h.new_value, cur)}</span>
                        </div>
                        <div className="text-[11px] text-[#9B978E] mt-0.5">{alt || '—'}</div>
                      </div>
                    );
                  })}
                  {/* Kesilme GIZLENMEZ: baslikta toplam sayi duruyor ama listede 50 satir
                      var; kullanici eksigin farkinda olmali. */}
                  {history.truncated && (
                    <div className="text-[11px] text-[#8A6A20] mt-1.5" data-testid="master-db-history-truncated">
                      {history.items.length} / {history.total}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        )}

        {/* === KAYIT SILME ===
            Sema §9.9: silme yalnizca admin. Rol kontrolu panelin baska
            yerlerindekiyle AYNI degisken (user?.role) — ikinci bir kural yok.
            EN ALTTA ve kendi ayirici cizgisinin altinda duruyor: kaydet/iptal
            dugmelerinin yanina konsaydi yanlislikla basilirdi. Tiklamak HICBIR
            SEY SILMEZ, yalnizca onay penceresini acar. */}
        {/* SILME TALEBI SATIRI — admin de ekip de gorur. Durum kayit detayi
            acilinca TEK istekle gelir (kayitTalebi). Ekip [Silme talebi gonder]
            ile admin onayina gonderir; admin'in [Sil]'i aynen kalir. */}
        {kayitIslemi((() => {
          const ktHazir = kayitTalebi.id === doc._id && kayitTalebi.durum === 'ok';
          const kt = ktHazir ? kayitTalebi.talep : null;
          const bekliyor = Boolean(kt) && (kt.durum === 'bekliyor' || kt.durum === 'onaylaniyor');
          const reddedildi = Boolean(kt) && kt.durum === 'reddedildi';
          const adminMi = user?.role === 'admin';
          const tarih = (v) => (v ? new Date(v).toLocaleString(locale) : null);
          return (
            <div className="mt-[11px] pt-[9px] border-t-[0.5px] border-[#E4E1DC] flex items-center gap-2 flex-wrap justify-end">
              {kayitTalebi.id === doc._id && kayitTalebi.durum === 'error' && (
                <span className="text-[12px] text-[#A34940] mr-auto" data-testid="master-db-delete-request-load-error">
                  {t.deleteRequestLoadError}
                </span>
              )}
              {bekliyor && (
                <span className="text-[12px] text-[#8A6A20] mr-auto" data-testid="master-db-delete-request-pending">
                  {[t.deleteRequestPending, kt.talep_eden, tarih(kt.talep_tarihi)].filter(Boolean).join(' · ')}
                  {kt.talep_eden && kt.talep_eden === user?.email && kt.durum === 'bekliyor' && (
                    <button
                      type="button"
                      onClick={() => talepGeriCek(kt)}
                      disabled={talepBusy}
                      className="ml-2 text-[12px] underline text-[#6D6960] hover:text-[#232019] disabled:opacity-40"
                      data-testid="master-db-delete-request-withdraw"
                    >
                      {t.deleteRequestWithdraw}
                    </button>
                  )}
                </span>
              )}
              {ktHazir && kayitTalebi.birlestirme && (
                <span className="text-[12px] text-[#8A6A20] mr-auto" data-testid="master-db-merge-request-pending">
                  {[
                    t.mergeRequestPending,
                    `@${kayitTalebi.birlestirme.kayit?.instagram_handle || '—'} → @${kayitTalebi.birlestirme.kalan_kayit?.instagram_handle || '—'}`,
                    kayitTalebi.birlestirme.talep_eden,
                    tarih(kayitTalebi.birlestirme.talep_tarihi),
                  ].filter(Boolean).join(' · ')}
                </span>
              )}
              {reddedildi && (
                <span className="text-[12px] text-[#6D6960] mr-auto" data-testid="master-db-delete-request-rejected">
                  {[t.deleteRequestRejected, kt.karar_veren, kt.karar_notu].filter(Boolean).join(' · ')}
                </span>
              )}
              {!adminMi && (ktHazir || (kayitTalebi.id === doc._id && kayitTalebi.durum === 'error')) && !bekliyor && (
                <button
                  type="button"
                  onClick={() => talepAc(doc)}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4B8B2] text-[#A34940] hover:bg-[#FBEFED] transition"
                  data-testid="master-db-delete-request-button"
                >
                  {t.deleteRequestButton}
                </button>
              )}
              {/* [Y29] BASKA KARTLA BIRLESTIR — ekip ve admin; KALAN = bu kart. */}
              {birlestirGiris.id === doc._id ? (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (birlestirGiris.deger.trim()) birlestirAc(doc._id, birlestirGiris.deger.trim());
                  }}
                  className="flex items-center gap-1.5"
                >
                  <input
                    type="text"
                    autoFocus
                    value={birlestirGiris.deger}
                    onChange={(e) => setBirlestirGiris({ id: doc._id, deger: e.target.value.slice(0, 80) })}
                    placeholder={t.mergeOtherPlaceholder}
                    className="text-[12px] h-7 px-2 w-[200px] bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                    data-testid="master-db-merge-other-input"
                  />
                  <button
                    type="submit"
                    disabled={!birlestirGiris.deger.trim()}
                    className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                    data-testid="master-db-merge-other-go"
                  >
                    {t.mergeOtherGo}
                  </button>
                </form>
              ) : (
                <button
                  type="button"
                  onClick={() => setBirlestirGiris({ id: doc._id, deger: '' })}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition"
                  data-testid="master-db-merge-other"
                >
                  {t.mergeOther}
                </button>
              )}
              {adminMi && (
                <button
                  type="button"
                  onClick={() => silmeAc(doc)}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4B8B2] text-[#A34940] hover:bg-[#FBEFED] transition"
                  data-testid="master-db-delete-button"
                >
                  {t.deleteRecord}
                </button>
              )}
            </div>
          );
        })())}
      </div>
    );
  };

  const renderRow = (doc) => {
    const segment = segmentLabel(doc);
    const expertise = Array.isArray(doc.expertise) ? doc.expertise.filter(Boolean) : [];
    const children = Array.isArray(doc.children) ? doc.children : [];
    // Gosterilecek mecralar: filtre aktifse yalnizca secililer, degilse ucu birden —
    // ve YALNIZCA KAYDI OLANLAR.
    //
    // Onceden kaydi olmayan mecra icin "n/a" basiliyordu, yani her satir kosulsuz
    // UC satir yuksekligindeydi ve cogunda ikisi n/a idi: 2797 kayitlik bir tabloda
    // ekrana dokuz satir sigiyordu. Canli veride kayitlarin 1840'inda tek mecra,
    // 382'sinde hic mecra yok; bos satirlari atmak basilan satir sayisini
    // 8391'den 3018'e dusuruyor (%64 azalma).
    //
    // "Kaydi yok" ile "kaydi var ama sayisi bilinmiyor" AYRIMI KORUNUR: ilki hic
    // basilmaz, ikincisi "—" olarak gorunur (canli veride 101 giris). Ikincisi
    // gercek bir bilgi — hesap var, sayisini bilmiyoruz.
    // 'none' bir MECRA DEGIL, mecrasizlik bayragi: gosterimi daraltmaz.
    // Ayiklanmasaydi yalnizca "Diger" secili iken hicbir mecra satiri basilmazdi
    // — oysa o kumedeki 6 kayitta giris VAR (handle'i yok).
    const secilenMecralar = filters.platforms.filter((p) => p !== PLATFORM_NONE);
    const shownPlatforms = (
      secilenMecralar.length
        ? FOLLOWER_ORDER.filter((p) => secilenMecralar.includes(p))
        : FOLLOWER_ORDER
    ).filter((p) => platformEntry(doc, p) !== null);
    const ageInfos = children.map((c) => childAgeInfo(c, now)).filter(Boolean);
    const hasUndatedAge = ageInfos.some((a) => a.kind === 'undated');
    const isDual = Array.isArray(doc.sources) && doc.sources.length > 1;
    const story = fmtMoney(doc.rates?.ig_story, doc.rates?.currency);
    const reel = fmtMoney(doc.rates?.ig_reel, doc.rates?.currency);
    const quotedAt = formatMonthYear(doc.rates?.quoted_at, ucretGocKaynakli(doc.rates));
    // Ikisi de SUNUCUDAN gelir; panel HICBIR HESAP YAPMAZ — yalnizca
    // bicimlendirir ve boyar.
    const tazelikTarihi = formatMonthYear(doc.tazelik_tarihi);
    // [Y25] Kova rengi FIYAT tarihinden (sunucu: fiyat_durumu). Esik panelde yok.
    const fiyatDurumu = doc.fiyat_durumu || 'bilinmiyor';
    const quotedBy = shortUser(doc.rates?.quoted_by);

    // Handle eksikligi GORUNUR olmali: sessizce atlanirsa kayit eksiksiz sanilir,
    // oysa o kayitta kampanya gecmisi sorgulanamiyor. Uyari renginde ayri gosterilir.
    // "kullanici adi yok" YALNIZ uc ad da bossa (Instagram zorunlu degil, 26 Ekim).
    const satirKimligi = ilkKimlik(doc);
    // Cocuk bilgisi yoksa HICBIR SEY yazilmaz. Bos children dizisi "cocugu yok"
    // DEMEK DEGIL: goc verisinde 1819 kayitta dizi bos ve hicbirinde bu onay
    // alinmadi — dosyada sutun bostu ya da sutun hic yoktu, ikisi de []'e dondu.
    // "cocuk yok" yazmak, sorulmamis kisiyle onaylanmis kisiyi ayni gosteriyordu.
    // Yerine "bilinmiyor"/"—" de yazilmaz: bos alan zaten bilgi olmadigini soyler.
    const agesText = ageInfos.length
      ? ageInfos.map((a) => monthsToText(a.months, t)).join(', ')
      : '';
    const meta = [safeText(doc.city), agesText].filter(Boolean).join(' · ');
    // [Y28] Arama hangi ek alanda tuttu (ad / kullanici adi / sehir etiket uretmez).
    const aramaEslesme = searchQuery && Array.isArray(doc.arama_eslesme)
      ? doc.arama_eslesme.map((e) => t.searchMatchLabels[e]).filter(Boolean)
      : [];

    const isOpen = openId === doc._id;

    return (
      <RowErrorBoundary key={doc._id} message={t.rowError}>
      <div
        onClick={() => toggleRow(doc._id)}
        className={`${GRID} border-t-[0.5px] border-[#E4E1DC] cursor-pointer hover:bg-[#F3F1EE] transition-colors ${
          isOpen ? 'bg-[#F3F1EE]' : ''
        }`}
        data-testid="master-db-row"
      >
        <div className="min-w-0">
          <div className="text-[13px]">
            {/* TOPLU SECIM — kutuya tiklamak kaydi ACMAZ (satir tiklamasina gitmez). */}
            {topluYetki && (
              <input
                type="checkbox"
                checked={secili.has(doc._id)}
                onClick={(e) => e.stopPropagation()}
                onChange={() => seciliDegistir(doc._id)}
                aria-label={t.bulkSelectRow}
                className="mr-1.5 align-middle cursor-pointer accent-[#A34940]"
                data-testid="master-db-row-select"
              />
            )}
            <span>{safeText(doc.full_name) || '—'}</span>
            {doc.is_talent === true && (
              <span className="ml-1.5 text-[11px] px-1.5 py-px rounded-[6px] bg-[#EEE9F6] text-[#6A5A8C]">
                {t.talentBadge}
              </span>
            )}
            {/* [1 Kas] Potansiyel anne (kadin, anne degil, evli) — turetilmis anne_durumu. */}
            {doc.anne_durumu === 'potansiyel' && (
              <span
                className="ml-1.5 text-[11px] px-1.5 py-px rounded-[6px] bg-[#FBEFE3] text-[#9A5B23]"
                data-testid="master-db-row-potential"
              >
                {t.potentialBadge}
              </span>
            )}
            {expertise.length > 0 && (
              <span className="ml-1.5 text-[11px] px-1.5 py-px rounded-[6px] bg-[#E5F1E7] text-[#3D7A52]">
                {safeText(expertise[0]) || '—'}
                {expertise.length > 1 ? ` +${expertise.length - 1}` : ''}
              </span>
            )}
            {/* PROFIL BAGLANTILARI — detay panelinden buraya tasindi.
                Paneli acmak icin satiri tiklamak, sonra baglantiyi aramak iki adimdi;
                ekip tabloyu tararken profile dogrudan gitmek istiyor.
                Etiket mecra adi: hangi baglantinin nereye gittigi belli olsun.
                Kendi handle'i olmayan mecra icin bag URETILMEZ (bkz. platformProfileUrl):
                tiklanip var olmayan bir kanala giden oge basilmaz. */}
            {FOLLOWER_ORDER.map((pf) => {
              const url = platformProfileUrl(doc, pf, platformEntry(doc, pf));
              if (!url) return null;
              return (
                <a
                  key={pf}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="ml-1.5 text-[11px] px-1.5 py-px rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#6D6960] hover:text-[#8A6A28] hover:bg-[#F3F1EE] transition"
                  data-testid={`master-db-profile-${pf}`}
                >
                  {platformLabel(pf)} ↗
                </a>
              );
            })}
          </div>
          <div className="text-[12px] text-[#9B978E]">
            {satirKimligi ? (
              // Handle artik LINK DEGIL: Instagram bagi ustte mecra rozeti olarak
              // duruyor ve ayni satirda ayni adrese iki bag basmak gereksizdi.
              // Buradaki metin kimligi gosteriyor, bagi degil.
              <span data-testid="master-db-handle-text">
                {kimlikEtiketi({ ...satirKimligi, deger: safeText(satirKimligi.deger) })}
              </span>
            ) : (
              <span className="text-[#8A6A20]" data-testid="master-db-no-handle">
                {t.noHandle}
              </span>
            )}
            {meta && ` · ${meta}`}
            {/* Yasin olcum tarihi yoksa deger bayat olabilir — satirda da gorunur olsun */}
            {hasUndatedAge && (
              <span className="text-[#8A6A20]" data-testid="master-db-age-undated"> ({t.noAgeDate})</span>
            )}
            {aramaEslesme.length > 0 && (
              <span data-testid="master-db-row-match"> · {t.searchMatchPrefix}: {aramaEslesme.join(' · ')}</span>
            )}
          </div>
          {/* Cift kaynak notu — yalniz 'dual' secili iken gosterilmez (orada zaten hepsi cift kaynakli) */}
          {isDual && !(sekmeler && sekmeler.length === 1 && sekmeler[0] === 'dual') && (
            <div className="text-[12px] text-[#6A5A8C]">
              {/* "— talent adayi" YORUMU KALDIRILDI: rozet zaten cift kaynagi
                  gosteriyor, talent adayligi ekibin kendi cikaracagi sonuc.
                  Sema §3.2'deki sinyal tanimi yerinde; dusen yalnizca ekran metni. */}
              ⇄ {t.dualNote}
            </div>
          )}
        </div>

        {/* Takipci: mecra bazinda, sabit sirada (IG > TikTok > YT).
            Mecra filtresi aktifse yalnizca secililer gosterilir. */}
        <div className="flex flex-col gap-0.5" data-testid="master-db-followers">
          {shownPlatforms.map((pf) => {
            // shownPlatforms zaten filtreledi: buraya YALNIZCA kaydi olan mecra gelir.
            const entry = platformEntry(doc, pf);
            return (
              <div key={pf} className="flex items-center gap-1 text-[13px] tabular-nums leading-tight">
                <span className={entry.followers !== null ? 'text-[#232019]' : 'text-[#9B978E]'}>
                  {/* kayit var, deger bos -> "—" (hesap var, sayisini bilmiyoruz) */}
                  {entry.followers === null ? '—' : fmtFollowers(entry.followers)}
                </span>
                {/* Mecra etiketi artik LINK DEGIL, duz metin: profil baglantilari
                    ismin yanina tasindi. Ayni satirda iki ayri tiklanabilir oge
                    (biri sayinin yaninda biri ismin yaninda) gereksiz tekrardi. */}
                <span className="text-[10px] px-1 py-px rounded-[4px] bg-[#F3F1EE] text-[#6D6960]">
                  {platformLabel(pf)}
                </span>
              </div>
            );
          })}
        </div>
        <div>
          {/* SEEDING HESABINA SEGMENT YOK: kural sunucuda (mdb-segment-kurali);
              panel yalnizca is_seeding_account'u okur. Rozet de "+ ata" da yok. */}
          {doc.is_seeding_account === true ? (
            <span className="text-[13px] text-[#9B978E]" data-testid="master-db-segment-seeding">—</span>
          ) : (
          /* Rozete tiklamak satirin ac/kapa davranisini TETIKLEMEZ (stopPropagation);
              detay panelini acip segment atama modunu baslatir. */
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setOpenId(doc._id);
              setSegmentDraft(segment || '');
              setSegmentEditing(true);
            }}
            className={
              segment
                ? 'text-[11px] px-1.5 py-0.5 rounded-[6px] bg-[#F6EBD3] text-[#8A6A28] hover:brightness-95 transition'
                : 'text-[12px] px-[7px] py-px rounded-[6px] border-[0.5px] border-dashed border-[#DDBE7A] text-[#8A6A20] hover:bg-[#FAEFD5] transition'
            }
            data-testid={segment ? 'master-db-segment-badge' : 'master-db-segment-assign'}
          >
            {segment || t.assignSegment}
          </button>
          )}
        </div>

        <span className="text-[13px] text-[#6D6960] tabular-nums">{story || '—'}</span>
        <span className="text-[13px] text-[#6D6960] tabular-nums">{reel || '—'}</span>

        {/* [Y25, Bora 2 Kas] "Bayat" = FIYATIN bayat olmasi: taze / bayat /
            bilinmiyor RENGI burada, fiyat_durumu'ndan (sunucu). Tarih yoksa
            bugunku "tarih yok" gosterimi aynen. */}
        <span
          className={`text-[12px] ${quotedAt ? TAZELIK_GORUNUM[fiyatDurumu] : 'text-[#8A6A20]'} leading-tight`}
          data-testid="master-db-quoted-at"
          data-fiyat={fiyatDurumu}
        >
          {quotedAt || t.noDate}
          {/* quoted_by bossa HICBIR SEY gosterilmez — gocten gelen kayitlarda kisi
              bilgisi yok, uydurma bir deger yazilmaz. */}
          {quotedAt && quotedBy && (
            <span className="block text-[10px] text-[#9B978E]" data-testid="master-db-quoted-by">
              {quotedBy}
            </span>
          )}
        </span>

        {/* BILGI GUNCELLENDI [Y26, Bora 2 Kas 19:57; eski adi Guncellik]: kartta
            her degisiklik, fiyat dahil. Tarih sunucudan (tazelik_tarihi, bes kaynagin en yenisi) —
            panel max() kuralini bilmiyor. Bilinmiyorsa t.noDate.
            [Y25, Bora 2 Kas] KOVA RENGI YOK: notr gri. Taze / bayat / bilinmiyor
            rengi "Fiyat tarihi" kolonunda (fiyat_durumu). Uc kovanin uc ayri
            gorunumu (bilinmiyor SOLUK, bayat uyari) orada aynen gecerli. */}
        <span
          className="text-[12px] leading-tight text-[#9B978E]"
          data-testid="master-db-freshness"
        >
          {tazelikTarihi || t.noDate}
        </span>
      </div>
      {isOpen && renderDetail(doc)}
      </RowErrorBoundary>
    );
  };

  return (
    <div className="min-h-screen bg-[#FAF9F7] text-[#232019] p-4 sm:p-7">
      <div className="max-w-[1400px] mx-auto">
        {/* Baslik */}
        <div className="flex items-center justify-between gap-2.5 flex-wrap mb-3 pb-2.5 border-b-[0.5px] border-[#E4E1DC]">
          <div className="flex items-center gap-2.5">
            <Database className="text-[#8A6A28]" size={17} />
            <span className="text-[15px] font-medium">{t.title}</span>
            {user && (
              <span
                className="text-[12px] px-2 py-0.5 rounded-[6px] bg-[#F6EBD3] text-[#8A6A28]"
                data-testid="master-db-current-email"
              >
                {user.role} · {user.email}
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            {sdOnay && (
              <span
                className="text-[12px] px-2.5 py-[5px] rounded-[6px] bg-[#E8F3E8] border-[0.5px] border-[#BFD9BF] text-[#3D6B3D]"
                data-testid="master-db-password-success"
              >
                {sdOnay}
              </span>
            )}
            {/* YENI KAYIT — Taslak Yukle'nin SOLUNDA. HERKESE gorunur:
                ekip uyesi de kayit acabilir, onaysiz (Bora, 2 Eyl). Kapinin
                arkasinda 2FA'li dort kisi var; tek tek kayit acmak toplu
                yuklemeden farkli bir risk. */}
            <button
              type="button"
              onClick={() => { startEdit({}); setYeniKayitAcik(true); }}
              className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
              data-testid="master-db-new-influencer"
            >
              <Plus size={14} />
              {t.newRecordButton}
            </button>
            {/* TASLAK YUKLE — Sifre Degistir'in SOLUNDA.
                HERKESE GORUNUR: ekip uyesi de yukler (sema §8,
                requireMasterDbAccess). Onay ayri bir uc ve yalnizca admin. */}
            <input
              ref={dosyaInputRef}
              type="file"
              accept=".xlsx,.xls"
              onChange={dosyaSecildi}
              className="hidden"
              data-testid="master-db-upload-input"
            />
            <button
              type="button"
              onClick={() => dosyaInputRef.current && dosyaInputRef.current.click()}
              disabled={uploadBusy}
              className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40 flex items-center gap-1.5"
              data-testid="master-db-upload-button"
            >
              {uploadBusy ? <Loader2 className="animate-spin" size={14} /> : <Upload size={14} />}
              {uploadBusy ? t.uploadBusy : t.uploadButton}
            </button>
            {/* YUKLEMELER — kuyruk paneli. HERKESE gorunur: ekip birbirinin
                Taslak'ini gorebilsin (salt okuma). Onay ve silme ayri uclarda
                ve yalnizca admin. Rozet: plani hazir, onay BEKLEYEN sayisi. */}
            <button
              type="button"
              onClick={() => {
                const yeni = !uploadsOpen;
                setUploadsOpen(yeni);
                if (yeni) uploadsYukle();
              }}
              className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
              data-testid="master-db-uploads-button"
            >
              <ClipboardList size={14} />
              {t.uploadsButton}
              {bekleyenUpload > 0 && (
                <span
                  className="text-[11px] px-1.5 rounded-[6px] bg-[#F6EBD3] text-[#8A6A28]"
                  data-testid="master-db-uploads-badge"
                >
                  {bekleyenUpload}
                </span>
              )}
            </button>
            {/* ONAY BEKLEYENLER — Sifre Degistir'in SOLUNDA. Yalniz admin gorur:
                uc de requireMasterDbAdmin, burasi ekipte islevsiz dugme
                gostermemek icin. [Yuklemeler]den AYRI bir soruya cevap veriyor —
                orasi gecmis listesi, burasi "benden ne bekleniyor". */}
            {user?.role === 'admin' && (
              <button
                type="button"
                onClick={() => {
                  const yeni = !kuyrukOpen;
                  setKuyrukOpen(yeni);
                  if (yeni) kuyrukYukle();   // panel her acildiginda tazelenir
                }}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
                data-testid="master-db-queue-button"
              >
                <Inbox size={14} />
                {t.queueTitle}
                {/* SIFIR ISE ROZET CIZILMEZ: "bekleyen yok" ile "henuz
                    bakilmadi" ayni gorunmesin. Dugme yine de duruyor. */}
                {kuyruk.toplam > 0 && (
                  <span
                    className="text-[11px] px-1.5 rounded-[6px] bg-[#F6EBD3] text-[#8A6A28]"
                    data-testid="master-db-queue-badge"
                  >
                    {kuyruk.toplam}
                  </span>
                )}
              </button>
            )}
            {/* Sifre Degistir — Cikis'in SOLUNDA. Ekip ilk giriste sifresini kuruyordu
                ama sonrasinda degistirecek yeri yoktu. */}
            <button
              type="button"
              onClick={() => { setSdHata(''); setSifreModal(true); }}
              className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
              data-testid="master-db-change-password"
            >
              <Key size={14} />
              {t.cpButton}
            </button>
            {/* "Ana Sayfa" yerine CIKIS: sayfanin artik kendi girisi var, kullanicinin
                oturumu kapatabilmesi gerekiyor. */}
            <button
              type="button"
              onClick={cikisYap}
              className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
              data-testid="master-db-logout"
            >
              <LogOut size={14} />
              {t.logout}
            </button>
          </div>
        </div>

        {/* YUKLEMELER KUYRUGU. Sunucudan uploaded_at DESC ve limit 100 geliyor;
            sirayi ve limiti arayuz DEGISTIRMIYOR. */}
        {uploadsOpen && (
          <div
            className="mb-3 p-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-xl"
            data-testid="master-db-uploads-panel"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-[12px] text-[#232019] font-medium">{t.uploadsTitle}</span>
              <button
                type="button"
                onClick={uploadsYukle}
                className="text-[12px] text-[#6D6960] hover:text-[#8A6A28] underline transition"
                data-testid="master-db-uploads-refresh"
              >
                {t.uploadsRefresh}
              </button>
            </div>

            {uploads.durum === 'loading' && (
              <div className="text-[12px] text-[#9B978E]">{t.loading}</div>
            )}
            {uploads.durum === 'error' && (
              <div className="text-[12px] text-[#A34940]">{t.uploadsError}</div>
            )}
            {uploads.durum === 'ok' && uploads.items.length === 0 && (
              <div className="text-[12px] text-[#9B978E]">{t.uploadsEmpty}</div>
            )}

            {uploads.items.map((u) => {
              const id = String(u._id);
              const acik = acikUpload === id;
              const oz = u.plan_ozeti || {};
              const sr = satirlar[id];
              // Plan GERCEKTEN goruntulendi mi: kart acik VE plan basariyla uretilmis.
              const planGorundu = acik && !!planlar[id] && planlar[id].durum === 'ok';
              return (
                <div
                  key={id}
                  className="border-[0.5px] border-[#E4E1DC] rounded-[8px] p-[11px] mb-2"
                  data-testid="master-db-upload-card"
                >
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[12px] font-medium text-[#232019]">{u.file_name}</span>
                    <span
                      className={`text-[11px] px-2 py-0.5 rounded-[6px] ${UPLOAD_DURUM_SINIF[u.status] || 'bg-[#F3F1EE] text-[#6D6960]'}`}
                      data-testid="master-db-upload-status"
                    >
                      {t.uploadStatus[u.status] || u.status}
                    </span>
                  </div>
                  <div className="text-[11px] text-[#9B978E] mt-0.5">
                    {u.uploaded_by}
                    {' · '}
                    {u.uploaded_at ? new Date(u.uploaded_at).toLocaleString(locale) : '—'}
                  </div>

                  {/* PLAN OZETI. "degisecek kayit" degisen_kayit'ten geliyor:
                      doldurulan / ezilen / cakisan ALAN sayar, KAYIT degil. */}
                  {u.plan_ozeti && (
                    <div className="text-[11px] text-[#6D6960] mt-1.5" data-testid="master-db-upload-ozet">
                      {[
                        [oz.yeni_kayit, t.planNew],
                        [oz.degisen_kayit, t.planChanged],
                        [oz.doldurulan, t.planFilled],
                        [oz.ezilen, t.planOverwritten],
                        [oz.teyit_edilen_kayit, t.planConfirmed],
                        [oz.cakisan, t.planConflict],
                        [(u.rejected_rows || []).length, t.planRejected],
                        [(u.kimlik_cakismalari || []).length, t.planIdentity],
                      ]
                        .filter(([n]) => n > 0)
                        .map(([n, etiket]) => `${n} ${etiket}`)
                        .join(' · ') || t.planNoChange}
                    </div>
                  )}

                  <div className="flex items-center gap-2 mt-2 flex-wrap">
                    <button
                      type="button"
                      onClick={() => {
                        const yeni = acik ? null : id;
                        setAcikUpload(yeni);
                        if (yeni) {
                          satirlariYukle(id, u.status);
                          // Plan YENIDEN uretilir: kaydedilen plana guvenilmiyor,
                          // araya elle bir duzenleme girmis olabilir.
                          if (u.status === 'plan_hazir' && !planlar[id]) planiUret(id);
                        }
                      }}
                      className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition"
                      data-testid="master-db-upload-rows-toggle"
                    >
                      {acik ? t.uploadRowsHide : t.uploadRowsShow}
                    </button>

                    {/* KARAR DUGMELERI — yalnizca admin. Sunucu da ayni kapiyi
                        tutuyor (requireMasterDbAdmin); burasi ekipte gereksiz
                        dugme gostermemek icin. */}
                    {user?.role === 'admin' && u.status === 'plan_hazir' && (
                      <>
                        {/* ONAY, PLAN GORULMEDEN VERILEMEZ.
                            Uyari blogu (dosya tarihi kaynagi, ezilecek ucret sayisi,
                            reel<story isaretleri) yalnizca plan detayi ACIKKEN
                            ciziliyor. Dugme kart kapaliyken de aktif olsaydi admin
                            hicbirini gormeden onaylayabilirdi — §3.4'ten sonra bu
                            ekran TEK KORUMA ve varlik sebebi tam olarak buydu.
                            'error' de yeterli DEGIL: plan uretilemediyse neyin
                            yazilacagi bilinmiyor. */}
                        <button
                          type="button"
                          onClick={() => onayla(id)}
                          disabled={onayBusy === id || !planGorundu}
                          title={planGorundu ? undefined : t.uploadApproveBlocked}
                          className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-[#E8F3E8] border-[0.5px] border-[#BFD9BF] text-[#3D6B3D] hover:bg-[#DCEBDC] transition disabled:opacity-40"
                          data-testid="master-db-upload-approve"
                        >
                          {onayBusy === id ? t.uploadApproving : t.uploadApprove}
                        </button>
                        {/* GERI GONDER plan sartina BAGLI DEGIL: yanlis ya da eski
                            bir dosyayi planina bakmadan geri gondermek mesru. */}
                        <button
                          type="button"
                          onClick={() => { setReddetSebep(''); setReddetHedef({ id, file_name: u.file_name }); }}
                          disabled={onayBusy === id}
                          className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                          data-testid="master-db-upload-reject"
                        >
                          {t.uploadReject}
                        </button>
                        {!planGorundu && (
                          <span
                            className="text-[11px] text-[#9B978E]"
                            data-testid="master-db-upload-approve-blocked"
                          >
                            {t.uploadApproveBlocked}
                          </span>
                        )}
                      </>
                    )}

                    {/* KARAR VERILMIS kayitlar: PASIF etiket. [Sil] sunucunun
                        `silinebilir` alanindan okur — karar verilmisler ve
                        satirsiz (olu) 'yuklendi' kayitlar. DELETE ucu ayni
                        kurali taze okumayla bir kez daha uygular. */}
                    {UPLOAD_KARAR_VERILDI.includes(u.status) && (
                      <span
                        className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-[#F3F1EE] text-[#9B978E]"
                        data-testid="master-db-upload-decided"
                      >
                        {t.uploadDecided}
                      </span>
                    )}
                    {user?.role === 'admin' && u.silinebilir === true && (
                      <button
                        type="button"
                        onClick={() => setSilHedef({ id, file_name: u.file_name, status: u.status })}
                        disabled={onayBusy === id}
                        className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E3B6B1] text-[#A34940] hover:bg-[#FBEDEC] transition disabled:opacity-40"
                        data-testid="master-db-upload-delete"
                      >
                        {t.uploadDelete}
                      </button>
                    )}
                  </div>

                  {/* ONAY SONUCU */}
                  {onaySonuc[id] && (
                    <div className="mt-2 text-[11px]" data-testid="master-db-upload-result">
                      {onaySonuc[id].tur === 'ok' && (
                        <div className="text-[#3D6B3D]">
                          {t.uploadWritten
                            .replace('{new}', onaySonuc[id].veri.written_counts.yeni)
                            .replace('{updated}', onaySonuc[id].veri.written_counts.guncellenen)}
                        </div>
                      )}
                      {(onaySonuc[id].tur === 'ok' || onaySonuc[id].tur === 'kismi') &&
                        onaySonuc[id].veri.written_counts.kimlik_cakismasi > 0 && (
                        <div className="text-[#A34940]" data-testid="master-db-upload-identity-skipped">
                          {t.uploadIdentitySkipped.replace('{n}', onaySonuc[id].veri.written_counts.kimlik_cakismasi)}
                        </div>
                      )}
                      {(onaySonuc[id].tur === 'ok' || onaySonuc[id].tur === 'kismi') &&
                        onaySonuc[id].veri.denetim_yazilamadi > 0 && (
                        <div className="text-[#8A6A20]" data-testid="master-db-upload-audit-failed">
                          {t.uploadAuditFailed.replace('{n}', onaySonuc[id].veri.denetim_yazilamadi)}
                        </div>
                      )}
                      {onaySonuc[id].tur === 'kismi' && (
                        <div className="text-[#8A6A20]">
                          <div className="font-medium">{t.uploadPartial}</div>
                          <div>
                            {t.uploadWritten
                              .replace('{new}', onaySonuc[id].veri.written_counts.yeni)
                              .replace('{updated}', onaySonuc[id].veri.written_counts.guncellenen)}
                          </div>
                          {(onaySonuc[id].veri.write_errors || []).map((w, i) => (
                            <div key={i} className="text-[#A34940]">
                              {w.kimlik ? kimlikEtiketi(w.kimlik) : (w.handle || '—')} · {w.message}
                            </div>
                          ))}
                        </div>
                      )}
                      {onaySonuc[id].tur === 'catisma' && (
                        <div className="text-[#8A6A20]">
                          <div className="font-medium">{t.uploadConflict}</div>
                          <div className="text-[#6D6960]">
                            {t.uploadConflictBefore}: {ozetMetni(onaySonuc[id].veri.onceki_ozet)}
                          </div>
                          <div className="text-[#6D6960]">
                            {t.uploadConflictAfter}: {ozetMetni(onaySonuc[id].veri.yeni_ozet)}
                          </div>
                        </div>
                      )}
                      {onaySonuc[id].tur === 'hata' && (
                        <div className="text-[#A34940]">{t.uploadActionError}</div>
                      )}
                    </div>
                  )}

                  {acik && planlar[id] && (
                    <div className="mt-2" data-testid="master-db-plan-detay">
                      {planlar[id].durum === 'loading' && (
                        <div className="text-[11px] text-[#9B978E]">{t.planLoading}</div>
                      )}
                      {planlar[id].durum === 'error' && (
                        <div className="text-[11px] text-[#A34940]">{t.planError}</div>
                      )}
                      {planlar[id].durum === 'ok' && (() => {
                        const P = planlar[id].data;
                        // rates.* icin BIRLESTIRICIDE hicbir koruma yok (§9.3
                        // 'taslak_her_zaman_kazanir'); tek koruma bu ekran. Ezilecek
                        // ucretler bu yuzden plan tablosunun icine gomulu birakilmiyor,
                        // uyari kutusunda TEK YERDE toplaniyor: onaylayan kisi 100
                        // satirlik tabloyu tarayarak aramak zorunda kalmasin.
                        const ezilenUcretler = (P.plan || []).flatMap((r) =>
                          (r.ezilen || [])
                            .filter((x) => String(x.alan).startsWith('rates.'))
                            .map((x) => ({ handle: r.handle, ...x })));
                        const ezilenUcret = ezilenUcretler.length;
                        const uyarilar = (P.plan || []).flatMap((r) =>
                          (r.uyarilar || []).map((u2) => ({ handle: r.handle, ...u2 })));
                        return (
                          <>
                            {/* [Y36] BILGI SATIRLARI — imzaya girmez, yazmayi engellemez. Eski
                                (zenginlestirme bayrakli) kayitli planlarda plan_bilgisi yok: kutu basilmaz. */}
                            {planBilgiKutusu(P.plan_bilgisi, P.plan)}
                            {/* UYARILAR — sema §12, oncelik 1. Karar vermeden ONCE gorunur. */}
                            <div className="mb-2 p-[9px] rounded-[6px] bg-[#FAEFD5]/60 border-[0.5px] border-[#E8C35C]">
                              <div className="text-[11px] text-[#8A6A20]">
                                {t.planFileDate}: {P.dosya_tarihi ? new Date(P.dosya_tarihi).toLocaleDateString(locale) : '—'}
                                {' · '}
                                {t.planDateSource[P.dosya_tarihi_kaynagi] || P.dosya_tarihi_kaynagi}
                              </div>
                              {P.dosya_tarihi_kaynagi === 'yukleme_ani' && (
                                <div className="text-[11px] text-[#8A6A20] mt-1 leading-snug" data-testid="master-db-plan-date-warning">
                                  ⚠ {t.planDateWarning}
                                </div>
                              )}
                              {ezilenUcret > 0 && (
                                <div className="text-[11px] text-[#A34940] mt-1 font-medium" data-testid="master-db-plan-rate-warning">
                                  ⚠ {t.planRateWarning.replace('{n}', ezilenUcret)}
                                </div>
                              )}
                              {ezilenUcret > 0 && (
                                <div className="mt-1">
                                  <div className="text-[11px] text-[#8A6A20] mb-0.5">{t.planRateList}</div>
                                  {/* Uzun plan ekrani tasirmasin: liste KENDI icinde kayar. */}
                                  <div className="max-h-[200px] overflow-y-auto pr-1">
                                    {ezilenUcretler.map((x, i) => (
                                      <div key={i} className="text-[11px] text-[#A34940] leading-snug" data-testid="master-db-plan-rate-overwrite">
                                        {x.handle} · {x.alan}: {gosterDeger(x.eski)} → <span className="font-medium">{gosterDeger(x.yeni)}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {uyarilar.map((u2, i) => (
                                <div key={i} className="text-[11px] text-[#8A6A20] mt-1">
                                  ⚠ {u2.handle} · {u2.mesaj || u2.alan || JSON.stringify(u2)}
                                </div>
                              ))}
                            </div>

                            {/* PLAN TABLOSU — satir satir, handle ile. */}
                            {(P.plan || []).map((r, i) => (
                              <div key={i} className="mb-1.5 pb-1.5 border-b-[0.5px] border-[#E4E1DC]" data-testid="master-db-plan-row">
                                <div className="text-[11px] text-[#232019]">
                                  <span className="font-medium" data-testid="master-db-plan-row-identity">
                                    {r.kimlik && r.kimlik.alan !== 'instagram_handle' ? kimlikEtiketi(r.kimlik) : r.handle}
                                  </span>
                                  {r.yeni_kayit && (
                                    <span className="ml-1.5 text-[10px] px-1.5 rounded-[6px] bg-[#E8F3E8] text-[#3D6B3D]">
                                      {t.planRowNew}
                                    </span>
                                  )}
                                  <span className="ml-1.5 text-[#9B978E]">{r.sheet} · {t.planRowLine} {r.satir}</span>
                                </div>
                                {/* rates.* YUKARIDA tek listede basildi; burada tekrar
                                    edilmiyor. Ucret disi ezilen alanlar burada kaliyor. */}
                                {(r.ezilen || []).filter((x) => !String(x.alan).startsWith('rates.')).map((x, j) => (
                                  <div key={`e${j}`} className="text-[11px] text-[#A34940]" data-testid="master-db-plan-overwrite">
                                    {t.planRowOverwrite} {planAlanEtiketi(x.alan)}: {planDegeri(x.alan, x.eski)} → <span className="font-medium">{planDegeri(x.alan, x.yeni)}</span>
                                  </div>
                                ))}
                                {(r.doldurulan || []).map((x, j) => (
                                  <div key={`d${j}`} className="text-[11px] text-[#3D6B3D]">
                                    {t.planRowFill} {planAlanEtiketi(x.alan)} → {planDegeri(x.alan, x.yeni)}
                                  </div>
                                ))}
                                {/* TURETILMIS: dosyadan gelmeyen, sunucunun hesapladigi
                                    yazmalar (cocuk sayisi tahmini; yeni kisiye profil
                                    varsayilani; "erkek anne olamaz" duzeltmesi). */}
                                {(r.turetilmis || []).map((x, j) => (
                                  <div key={`r${j}`} className="text-[11px] text-[#6D6960]" data-testid="master-db-plan-derived">
                                    {t.planRowDerived} {x.alan}: {gosterDeger(x.eski)} → {gosterDeger(x.yeni)}{x.sebep ? ` — ${x.sebep}` : ''}
                                  </div>
                                ))}
                                {(r.teyit_edilen || []).map((x, j) => (
                                  <div key={`t${j}`} className="text-[11px] text-[#6D6960]">
                                    {t.planRowConfirm} {planAlanEtiketi(x.alan)} · {planDegeri(x.alan, x.deger)} · {x.eski_tarih || '—'} → {x.yeni_tarih || '—'}
                                  </div>
                                ))}
                                {(r.cakisan || []).map((x, j) => (
                                  <div key={`c${j}`} className="text-[11px] text-[#8A6A20]">
                                    {t.planRowConflict} {planAlanEtiketi(x.alan)}: {gosterDeger(x.eski)} ↔ {gosterDeger(x.gelen)} ({t.planRowNotWritten})
                                  </div>
                                ))}
                                {(r.dokunulmayan || []).map((x, j) => (
                                  <div key={`k${j}`} className="text-[11px] text-[#9B978E]">
                                    {t.planRowKept} {planAlanEtiketi(x.alan)} — {x.sebep === INREACH_SEBEP ? t.inreachKept : x.sebep}
                                  </div>
                                ))}
                              </div>
                            ))}

                            {/* KIMLIK CAKISMASI — bu kisiler YAZILMAYACAK. Satirlari
                                yukaridaki plan listesinde YOK; sunucu onlari plandan
                                cikardi ve onay da yazmiyor. Onay yine calisir:
                                yalniz cakismayanlar yazilir. */}
                            {(P.kimlik_cakismalari || []).length > 0 && (
                              <div className="mt-2" data-testid="master-db-plan-identity">
                                <div className="text-[11px] text-[#A34940] mb-1">
                                  {t.planIdentityTitle} ({P.kimlik_cakismalari.length})
                                </div>
                                {P.kimlik_cakismalari.map((k, i) => (
                                  <div key={i} className="text-[11px] text-[#6D6960]">
                                    {kimlikCakismasiMetni(t, k)}
                                    <span className="ml-1.5 text-[#9B978E]">{k.sheet} · {t.planRowLine} {k.satir}</span>
                                  </div>
                                ))}
                              </div>
                            )}

                            {(P.rejected_rows || []).length > 0 && (
                              <div className="mt-2" data-testid="master-db-plan-rejected">
                                <div className="text-[11px] text-[#A34940] mb-1">
                                  {t.planRejectedTitle} ({P.rejected_rows.length})
                                </div>
                                {P.rejected_rows.map((r, i) => (
                                  <div key={i} className="text-[11px] text-[#6D6960]">
                                    {r.sheet} · {t.planRowLine} {r.satir} — {r.sebep}
                                  </div>
                                ))}
                              </div>
                            )}

                            {(P.skipped_sheets || []).length > 0 && (
                              <div className="mt-2 text-[11px] text-[#9B978E]">
                                {t.planSkipped}: {P.skipped_sheets.map((x) => `${x.sheet} (${x.sebep})`).join(' · ')}
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  )}

                  {acik && (
                    <div className="mt-2" data-testid="master-db-upload-rows">
                      {sr && sr.durum === 'loading' && (
                        <div className="text-[11px] text-[#9B978E]">{t.loading}</div>
                      )}
                      {sr && sr.durum === 'plan_yok' && (
                        <div className="text-[11px] text-[#9B978E]" data-testid="master-db-upload-rows-none">
                          {t.uploadRowsNotStored}
                        </div>
                      )}
                      {sr && sr.durum === 'error' && (
                        <div className="text-[11px] text-[#A34940]">{t.uploadRowsError}</div>
                      )}
                      {sr && sr.durum === 'ok' && (sr.rows || []).map((parca) => (
                        <div key={parca.sheet} className="mb-2">
                          <div className="text-[11px] text-[#6D6960] mb-1">
                            {parca.sheet} · {parca.satirlar.length} {t.uploadRowsCount}
                          </div>
                          {/* Genis tablo KENDI icinde kayar; sayfa yatay kaymaz. */}
                          <div className="overflow-x-auto border-[0.5px] border-[#E4E1DC] rounded-[6px]">
                            <table className="text-[11px] border-collapse">
                              <tbody>
                                {parca.satirlar.slice(0, UPLOAD_SATIR_ONIZLEME).map((satir, i) => (
                                  <tr key={i} className={i === 0 ? 'bg-[#F3F1EE]' : ''}>
                                    {(satir || []).map((h, j) => (
                                      <td key={j} className="px-1.5 py-0.5 border-[0.5px] border-[#E4E1DC] whitespace-nowrap text-[#232019]">
                                        {h === null || h === undefined ? '' : String(h)}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {parca.satirlar.length > UPLOAD_SATIR_ONIZLEME && (
                            <div className="text-[11px] text-[#9B978E] mt-1">
                              {t.uploadRowsMore.replace('{n}', parca.satirlar.length - UPLOAD_SATIR_ONIZLEME)}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* Yukleme durumu. Plan paneli 2/3'te gelecek; simdilik dosyanin
            alindigi ve kac satir okundugu gorunuyor. */}
        {uploadError && (
          <div
            className="mb-3 p-[11px] text-[12px] bg-[#FBEDEC] border-[0.5px] border-[#E3B6B1] text-[#A34940] rounded-xl"
            data-testid="master-db-upload-error"
          >
            {uploadError}
          </div>
        )}
        {upload && (
          <div
            className="mb-3 p-[13px] bg-[#E8F3E8] border-[0.5px] border-[#BFD9BF] rounded-xl"
            data-testid="master-db-upload-result"
          >
            <div className="text-[12px] text-[#3D6B3D] font-medium">
              {t.uploadedTitle} — {upload.file_name}
            </div>
            <div className="text-[11px] text-[#6D6960] mt-0.5">
              {t.uploadedInfo
                .replace('{sheets}', upload.sheet_sayisi)
                .replace('{rows}', upload.satir_sayisi)}
              {/* Gunlesen: Excel seri numarasi artefakti geri alinan hucre sayisi.
                  Bozulmayan: gercek bir ZAMAN damgasi tasidigi icin dokunulmayan
                  hucre — Date olarak sunucuya gidiyor, DOGRU davranis. Uyari degil,
                  o yuzden ayni sade renkte duruyor. */}
              {(upload.gunlesen > 0 || upload.bozulmayan > 0) && (
                <span data-testid="master-db-upload-gunlestirme">
                  {' · '}
                  {t.uploadedDates
                    .replace('{normalized}', upload.gunlesen)
                    .replace('{kept}', upload.bozulmayan)}
                </span>
              )}
            </div>

            {/* PLAN OZETI — yukleme ozetinin ALTINDA, onu degistirmeden.
                "degisecek kayit" icin degisen_kayit kullaniliyor: doldurulan,
                ezilen ve cakisan ALAN sayar, KAYIT degil. */}
            {plan && plan.plan_ozeti && (
              <div
                className="mt-2 pt-2 border-t-[0.5px] border-[#BFD9BF] text-[11px] text-[#3D6B3D]"
                data-testid="master-db-plan-ozeti"
              >
                <span className="font-medium">{t.planTitle}</span>
                {' — '}
                {[
                  [plan.plan_ozeti.yeni_kayit, t.planNew],
                  [plan.plan_ozeti.degisen_kayit, t.planChanged],
                  [plan.plan_ozeti.doldurulan, t.planFilled],
                  [plan.plan_ozeti.ezilen, t.planOverwritten],
                  [plan.plan_ozeti.teyit_edilen_kayit, t.planConfirmed],
                  [plan.plan_ozeti.cakisan, t.planConflict],
                  [(plan.rejected_rows || []).length, t.planRejected],
                  [(plan.kimlik_cakismalari || []).length, t.planIdentity],
                ]
                  .filter(([n]) => n > 0)
                  .map(([n, etiket]) => `${n} ${etiket}`)
                  .join(' · ')}
                {planBilgiKutusu(plan.plan_bilgisi, plan.plan)}
              </div>
            )}
          </div>
        )}

        {listMatchOpen && (
          <div
            className="mb-3 p-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-xl"
            data-testid="master-db-list-match-panel"
          >
            <div className="text-[12px] text-[#232019] mb-1">{t.listMatchTitle}</div>
            <div className="text-[11px] text-[#9B978E] mb-2 leading-snug">{t.listMatchHint}</div>
            <textarea
              rows="6"
              value={listMatchText}
              onChange={(e) => setListMatchText(e.target.value)}
              placeholder={t.listMatchPlaceholder}
              className="w-full text-[12px] px-[9px] py-[7px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF] resize-y font-mono"
              data-testid="master-db-list-match-input"
            />
            <div className="flex items-center gap-2 mt-2 flex-wrap">
              <button
                type="button"
                onClick={runListMatch}
                disabled={listMatchBusy || listMatchLines().length === 0}
                className="text-[12px] px-[13px] py-[5px] rounded-[6px] bg-[#E8C35C] text-[#2A2317] font-medium hover:brightness-95 transition disabled:opacity-40"
                data-testid="master-db-list-match-run"
              >
                {listMatchBusy ? t.listMatchRunning : t.listMatchRun}
              </button>
              <span className="text-[11px] text-[#9B978E]" data-testid="master-db-list-match-count">
                {listMatchLines().length} / {LIST_MATCH_MAX}
              </span>
              {listMatchError && (
                <span className="text-[12px] text-[#A34940]" data-testid="master-db-list-match-error">
                  {listMatchError}
                </span>
              )}
            </div>
          </div>
        )}

        {/* Sonuc ozeti — tablo artik eslesen kayitlari gosteriyor. */}
        {listMatch && (
          <div
            className="mb-3 p-[13px] bg-[#FAEFD5]/50 border-[0.5px] border-[#E8C35C] rounded-xl"
            data-testid="master-db-list-match-result"
          >
            <div className="text-[12px] text-[#8A6A20] font-medium" data-testid="master-db-list-match-summary">
              {t.listMatchSummary
                .replace('{total}', listMatch.total_lines)
                .replace('{matched}', listMatch.matched.length)
                // [Y24] Parantez: sifir olan parca yazilmaz, ikisi de sifirsa parantez
                // yok. ucret_yok / fiyat_eski sunucuda (mdbUcretYokMu / mdbFiyatEskiMi).
                .replace('{ek}', listMatchEk)
                .replace('{notFound}', listMatch.notFound.length)
                .replace('{rejected}', listMatch.rejected.length)}
            </div>

            {/* "Kontrol et" — handle tuttu ama isim tutmadi. Eslesme DUSURULMEDI,
                yalnizca vurgulaniyor; handle degismis de olabilir, liste yanlis
                isim tasiyor da olabilir. Ayirt etmeyi insan yapar. */}
            {listMatch.nameMismatch.length > 0 && (
              <div className="mt-2" data-testid="master-db-list-match-mismatch">
                <div className="text-[12px] text-[#A34940] mb-1">
                  {t.listMatchCheck} ({listMatch.nameMismatch.length})
                </div>
                {listMatch.nameMismatch.map((m) => (
                  <div key={m.lineNo} className="text-[11px] text-[#6D6960]">
                    #{m.lineNo} @{m.handle} —{' '}
                    {t.listMatchNameDiff
                      .replace('{given}', m.given_name)
                      .replace('{record}', m.record_name || '—')}
                  </div>
                ))}
              </div>
            )}

            {/* [Y24] MDB'de var ama ucret yok — "olmayanlar" ile ayni desen, ustunde.
                Ekip bunlara da dogrudan yazmali (Bora: "MDB'de olmasa da ayni"). */}
            {listMatchUcretYok.length > 0 && (
              <div className="mt-2" data-testid="master-db-listmatch-ucret-yok">
                <div className="text-[12px] text-[#6D6960] mb-1">
                  {t.listMatchUcretYok} ({listMatchUcretYok.length})
                </div>
                <div className="text-[11px] text-[#6D6960] leading-relaxed">
                  {listMatchUcretYok.map((x) => `@${x.handle}`).join(' · ')}
                </div>
              </div>
            )}

            {/* [Y24 ek] MDB'de var · fiyat eski — ucret var ama fiyat tarihi esikten
                once ya da yok; fiyat yeniden sorulmali. "ucret yok" listesinin altinda. */}
            {listMatchFiyatEski.length > 0 && (
              <div className="mt-2" data-testid="master-db-listmatch-fiyat-eski">
                <div className="text-[12px] text-[#6D6960] mb-1">
                  {t.listMatchFiyatEski} ({listMatchFiyatEski.length})
                </div>
                <div className="text-[11px] text-[#6D6960] leading-relaxed">
                  {listMatchFiyatEski.map((x) => `@${x.handle}`).join(' · ')}
                </div>
              </div>
            )}

            {listMatch.notFound.length > 0 && (
              <div className="mt-2" data-testid="master-db-list-match-notfound">
                <div className="text-[12px] text-[#6D6960] mb-1">
                  {t.listMatchNotFound} ({listMatch.notFound.length})
                </div>
                <div className="text-[11px] text-[#6D6960] leading-relaxed">
                  {listMatch.notFound.map((x) => `@${x.handle}`).join(' · ')}
                </div>
              </div>
            )}

            {listMatch.rejected.length > 0 && (
              <div className="mt-2" data-testid="master-db-list-match-rejected">
                <div className="text-[12px] text-[#A34940] mb-1">
                  {t.listMatchRejected} ({listMatch.rejected.length})
                </div>
                {listMatch.rejected.map((r) => (
                  <div key={r.lineNo} className="text-[11px] text-[#6D6960]">
                    #{r.lineNo} — {r.line} ({r.reason})
                  </div>
                ))}
              </div>
            )}

            <div className="flex items-center gap-2 mt-2.5 flex-wrap">
              <button
                type="button"
                onClick={exportListMatch}
                disabled={exporting}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40 flex items-center gap-1.5"
                data-testid="master-db-list-match-export"
              >
                {exporting ? <Loader2 className="animate-spin" size={14} /> : <Download size={14} />}
                {exporting ? t.exporting : t.listMatchExport}
              </button>
              {/* TEMIZLE — ust arac cubugundan BURAYA tasindi.
                  Dugme yalnizca listMatch doluyken cikiyor ve o anda yapistirma
                  paneli kapanmis oluyor; var oldugu her anda ekrandaki tek kutu
                  bu sari panel. Ust cubukta durdugunda gorulmuyordu: 120 satirlik
                  bir liste eslestirildi ve temizlemek icin sayfa yenilendi.
                  Sinifi "Excel'e aktar" ile AYNI: cercevesiz gri metin,
                  tiklanabilir bir seyi tiklanamaz gosteriyordu (sema §7.5 —
                  tiklanamayani tiklanabilir gostermekle ayni derecede bozuk). */}
              <button
                type="button"
                onClick={clearListMatch}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5"
                data-testid="master-db-list-match-clear"
              >
                <X size={14} />
                {t.listMatchClear}
              </button>
            </div>
          </div>
        )}

        {/* Sekmeler — sayilar KESISIR: outreach+inreach+seeding toplami tekil kisi sayisini asar */}
        <div className="flex gap-1.5 flex-wrap items-center mb-3" data-testid="master-db-tabs">
          {TABS.map((tb) => {
            // SECILI GORUNUM: Tumu'de (null) hepsi secili; aksi halde secim listesi.
            const activeTab = tb.key === URL_DEFAULT_TAB
              ? sekmeler === null
              : sekmeler === null || sekmeler.includes(tb.key);
            const count = tabCounts[tb.key];
            return (
              <button
                key={tb.key}
                type="button"
                onClick={() => sekmeTik(tb.key)}
                title={tb.key === URL_DEFAULT_TAB ? undefined : t.tabHint}
                aria-pressed={activeTab}
                className={`text-[13px] px-3 py-1.5 rounded-[6px] border-[0.5px] transition select-none ${
                  activeTab
                    ? 'bg-[#F6EBD3] text-[#8A6A28] border-transparent'
                    : 'bg-white text-[#232019] border-[#E4E1DC] hover:bg-[#F3F1EE]'
                }`}
                data-testid={`master-db-tab-${tb.key}`}
              >
                {tb.key === 'dual' && <span className="mr-1">⇄</span>}
                {t.tabs[tb.key]}{' '}
                {typeof count === 'number' && (
                  <span className="text-[#9B978E]">{fmtSayi(count)}</span>
                )}
              </button>
            );
          })}
        </div>

        {/* Arama — sekmelerin altinda, tablonun ustunde. 300ms debounce.
            GENISLIK SINIRLI: kutu tum satiri kaplamasi gerekmiyor, aranan sey kisa
            bir dizge. Daraltinca tam ipucu metni sigmiyor; yer tutucu KISALTILDI ve
            tam metin title'a alindi — bilgi kaybolmuyor, uzerine gelince gorunuyor.
            Mevcut searchPlaceholder cevirisinin DEGERI degismedi, yanina
            searchPlaceholderShort eklendi. */}
        <div className="flex items-start gap-2 mb-3 flex-wrap">
        <div className="relative flex-1 min-w-[220px] max-w-[360px]">
          <Search
            className="absolute left-[9px] top-1/2 -translate-y-1/2 text-[#9B978E] pointer-events-none"
            size={15}
          />
          <input
            type="search"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            placeholder={t.searchPlaceholderShort}
            title={t.searchPlaceholder}
            className="w-full text-[13px] h-8 pl-[30px] pr-[76px] bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
            data-testid="master-db-search"
          />
          {searchInput && (
            <button
              type="button"
              onClick={clearSearch}
              className="absolute right-[6px] top-1/2 -translate-y-1/2 text-[12px] px-2 py-1 rounded-[6px] text-[#6D6960] hover:bg-[#E4E1DC] transition"
              data-testid="master-db-search-clear"
            >
              {t.searchClear}
            </button>
          )}
        </div>
        {/* Liste eslestir + Excel'e aktar — AYNI SATIRDA, yan yana.
            Ikisi de ayni isin parcasi: listeyi disari cikarmak. Once "Liste eslestir"
            gelir (elindeki listeyi getirirsin), sonra "Excel'e aktar" (ekrandakini
            alirsin). Ayri satirlarda dururken ayri isler gibi okunuyorlardi.
            Prosedur §13: brief geldiginde Ekip-1'in ilk isi "bu 100 kisiden hangileri
            bizde var". GIRIS YAPISTIRMA, dosya yukleme DEGIL — dosya yukleme §9.5'teki
            uc katmanli kontrolu gerektirirdi, yapistirma ayni isi goruyor.
            Indirilen dosya EKRANDAKI listenin aynisi: ayni sekme, ayni filtreler, ayni
            arama (listeParams). Sayfalama YOK — filtreye uyan her kayit. */}
        <div className="flex items-center gap-2 flex-wrap">
          <button
            type="button"
            onClick={() => setListMatchOpen((o) => !o)}
            className="text-[12px] px-[11px] h-8 rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition flex items-center gap-1.5 whitespace-nowrap"
            data-testid="master-db-list-match-toggle"
          >
            <ClipboardList size={14} />
            {t.listMatchButton}
          </button>
          <button
            type="button"
            onClick={exportExcel}
            disabled={exporting || sekmeSecilmedi}
            className="text-[12px] px-[11px] h-8 rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40 flex items-center gap-1.5 whitespace-nowrap"
            data-testid="master-db-export"
          >
            {exporting ? <Loader2 className="animate-spin" size={14} /> : <Download size={14} />}
            {exporting ? t.exporting : t.exportButton}
          </button>
          {exportError && (
            <span className="text-[12px] text-[#A34940]" data-testid="master-db-export-error">
              {exportError}
            </span>
          )}
        </div>
        </div>

        {/* SOL KOLON GENISLIGI SABIT: 232px icerik + 16px kaydirma cubugu olugu.
            Panel kendi icinde kaydiriliyor (asagida). Uzmanlik agaci acilinca panel
            gorunur alandan uzuyor ve dikey kaydirma cubugu beliriyor; klasik (uste
            binmeyen) kaydirma cubuklarinda bu cubuk ICERIK KUTUSUNDAN yer yiyor,
            yani panelin ic genisligi agac acilip kapandikca degisiyordu — Segment
            rozetleri iki satirdan uce dusuyordu.
            Cozum iki parca: (1) kolon 216 -> 232px, (2) asagida scrollbar-gutter:stable
            ile oluk HER ZAMAN ayrilir. Boylece icerik genisligi 232px'te SABIT kalir,
            agac acik da olsa kapali da. Farki tablo yutuyor: minmax(0,1fr) daralabilir.
            Uste binen (overlay) kaydirma cubugu olan sistemlerde oluk ayrilmaz ve
            icerik 16px genisler — orada da agac acilip kapandikca DEGISMEZ.

            232 -> 248px [KARAR Bora, 8 Eyl]: mecra satirina dorduncu rozet ("Diger")
            eklendi ve IG · TikTok · YT · Diger toplami ~191px, o zamanki 216px'lik
            ic genisligin oluk sonrasi kalanina SINIRDA sigmiyordu — "Diger" alt
            satira sariyordu. 16px daha: ic genislik 232px, pay ~15px.
            flex-wrap BILEREK KALDI (nowrap REDDEDILDI): Ingilizce "Other" daha genis
            ve overlay kaydirma cubugu olan makinede oluk ayrilmadigi icin davranis
            makineye gore degisiyor — nowrap bazi makinede SESSIZCE KIRPARDI.
            Sarma gorunur bir basarisizlik, kirpma sessiz olani.
            chip bilesenine DOKUNULMADI: alti cagri yeri var (mecra, segment,
            kategori, tazelik, Diger-akordiyon), dolgu/yazi boyutu degisimi
            hepsini birden etkilerdi.
            Tabloya bedeli 16px ve YALNIZCA esneyen ilk kolondan gidiyor; yedi
            kolonun alti sabit (150/62/62/58/70/70) ve tablo kutusu zaten
            min-w-[860px] + overflow-auto ile kendi icinde kayiyor. */}
        <div className="grid grid-cols-1 md:grid-cols-[248px_minmax(0,1fr)] gap-4">
          {/* === SOL FILTRE PANELI === */}
          {/* Sol panel md+ ekranlarda SABIT (sticky).
              Tek basina sticky yetmiyor: panel ekrandan uzun oldugu icin alt kismina
              (Kategori, Diger filtreler) erisilemez hale gelirdi. Bu yuzden yuksekligi
              gorunur alanla sinirlanip kendi icinde kaydiriliyor.
              Mobilde (tek kolon) panel zaten tablonun ustunde; orada sticky uygulanmaz. */}
          <aside
            className="bg-white border-[0.5px] border-[#E4E1DC] rounded-xl p-[13px] h-fit md:sticky md:top-7 md:max-h-[calc(100vh-3.5rem)] md:overflow-y-auto md:[scrollbar-gutter:stable]"
            data-testid="master-db-filters"
          >
            {/* Aktif filtre sayaci */}
            <div className="flex items-center justify-between gap-2 pb-[11px] border-b-[0.5px] border-[#E4E1DC] mb-[11px]">
              <span className="text-[12px] text-[#6D6960]">
                {activeFilterCount > 0 ? (
                  <span className="text-[#8A6A28] font-medium" data-testid="master-db-active-count">
                    {activeFilterCount} {t.activeFilters}
                  </span>
                ) : (
                  <span className="text-[#9B978E]">0 {t.activeFilters}</span>
                )}
              </span>
              {/* Varsayilan gorunumde (Kadın + Anne, Hamile dahil) temizle GORUNMEZ: zaten oradasin. */}
              {!filtrelerVarsayilan && (
                <button
                  type="button"
                  onClick={clearFilters}
                  className="text-[12px] text-[#6D6960] hover:text-[#8A6A28] underline transition"
                  data-testid="master-db-clear-filters"
                >
                  {t.clearFilters}
                </button>
              )}
            </div>

            {/* Mecra */}
            {section(
              <>
                {sectionTitle(t.platformsLabel)}
                <div className="flex flex-wrap gap-[5px] mb-1.5">
                  {PLATFORM_MAIN.map((p) =>
                    chip(
                      p.value,
                      p.label,
                      filters.platforms.includes(p.value),
                      () => toggleInList('platforms', p.value),
                      `master-db-platform-${p.value}`
                    )
                  )}
                  {/* "Diger" — YT'den SONRA, ayni satirda, ayni rozet deseni.
                      Segment satirindaki "Yok" rozetiyle ayni mantik: sozluk disi
                      ozel deger, coklu secime ve kesisim ipucuna dahil. */}
                  {chip(
                    PLATFORM_NONE,
                    t.platformNone,
                    filters.platforms.includes(PLATFORM_NONE),
                    () => toggleInList('platforms', PLATFORM_NONE),
                    `master-db-platform-${PLATFORM_NONE}`
                  )}
                </div>
                {/* Birden fazla mecra secilince KESISIM uygulanir — kullanici 2.401'den
                    88'e dustugunde sebebini bilsin. */}
                {filters.platforms.length > 1 && (
                  <p className="text-[11px] text-[#8A6A28] mb-1.5 leading-snug" data-testid="master-db-platform-hint">
                    {t.platformIntersectHint}
                  </p>
                )}
                {/* "Diger" bagi YALNIZCA gercekten baska mecra varsa basilir.
                    otherPlatforms veriden uretiliyor (availablePlatforms - ana uclu).
                    Podcast/X/Pinterest koleksiyonda 0 kayitta gectigi icin dizi bos
                    donuyordu; bag yine de basiliyor ve tiklayana "Baska mecra kaydi
                    yok" diyordu. Tiklanacak tek seyi "burada bir sey yok" olan bir
                    bag, olmayan bagdan kotudur.
                    ICERIDEKI BOS DAL KALDIRILDI: bu noktadan sonra dizi zaten dolu.
                    (t.noOtherPlatforms cevirisi artik kullanilmiyor; anahtar duruyor.) */}
                {otherPlatforms.length > 0 && (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        // Akordiyon kapatilinca gizlenen secimler de temizlenir (mockup davranisi)
                        if (platformOtherOpen) {
                          patchFilters({
                            platforms: filters.platforms.filter((v) => !otherPlatforms.includes(v)),
                          });
                        }
                        setPlatformOtherOpen((o) => !o);
                      }}
                      className="text-[12px] text-[#6D6960] flex items-center gap-1 mb-1.5 hover:text-[#8A6A28] transition"
                      data-testid="master-db-platform-other-toggle"
                    >
                      <span>{t.other}</span>
                      <span className="text-[11px] text-[#9B978E]">{platformOtherOpen ? '▴' : '▾'}</span>
                    </button>
                    {platformOtherOpen && (
                      <div className="flex flex-wrap gap-[5px]">
                        {otherPlatforms.map((value) =>
                          chip(
                            value,
                            platformLabel(value),
                            filters.platforms.includes(value),
                            () => toggleInList('platforms', value),
                            `master-db-platform-${value}`
                          )
                        )}
                      </div>
                    )}
                  </>
                )}
              </>,
              'platforms'
            )}

            {/* 3. Segment */}
            {section(
              <>
                {sectionTitle(t.segmentLabel)}
                <div className="flex flex-wrap gap-[5px]">
                  {SEGMENT_CHIPS.map((s) =>
                    chip(
                      s,
                      s === SEGMENT_NONE ? t.segmentNone : s,
                      filters.segments.includes(s),
                      () => toggleSegment(s),
                      `master-db-segment-${s}`
                    )
                  )}
                </div>
              </>,
              'segment'
            )}

            {/* PROFIL — Segment'in HEMEN ALTINDA [Y18e, Bora 2 Kas 09:04]; TEK bolum,
                BASLIKSIZ. Varsayilan Kadın + Anne, Hamile kilitli ve dahil [Y18f]
                (URL'de parametre yoksa). Grupta hic cip secili degilse ya da hepsi seciliyse o grup
                filtrelemez (anne: anneFiltreDegerleri).
                Uc grup alt alta, HEPSI ayni iki kolonlu cip izgarasinda (genis
                cipler) — sutunlar hizali:
                  Anne · Hamile / Potansiyel · Değil (etiketler karttaki kutularla
                    ayni; Anne seciliyken Hamile secili gorunur ve devre disi,
                    hamile ⊂ anne)
                  Kadın · Erkek ("Cinsiyet" yazisi YOK [Y18e]: zaten anlasiliyor)
                  Ajanslı · Ajanssız */}
            {section(
              <div className="flex flex-col gap-y-[7px]">
                <div className="grid grid-cols-2 gap-[5px]" data-testid="master-db-filter-anne-grid">
                  {[
                    ['evet', t.boxMother],
                    ['hamile', t.boxPregnant],
                    ['potansiyel', t.boxPotential],
                    ['hayir', t.boxNot],
                  ].map(([deger, etiket]) => {
                    const kapsandi = deger === 'hamile' && filters.anne.includes('evet');
                    return chip(
                      deger,
                      etiket,
                      kapsandi || filters.anne.includes(deger),
                      () => toggleAnne(deger),
                      `master-db-filter-anne-${deger}`,
                      kapsandi,
                      true,
                      kapsandi ? t.pregnantIncludedByMother : undefined
                    );
                  })}
                </div>
                <div className="grid grid-cols-2 gap-[5px]">
                  {[['kadin', t.genderFemale], ['erkek', t.genderMale]].map(([deger, etiket]) => {
                    // [Y32b] Anne ya da Hamile seciliyken Kadın secili ve devre disi (Hamile'nin kilit deseni).
                    const kilitli = deger === 'kadin' && anneKadinGerektirir(filters.anne);
                    return chip(
                      deger,
                      etiket,
                      kilitli || filters.cinsiyet.includes(deger),
                      () => toggleProfil('cinsiyet', deger),
                      `master-db-filter-cinsiyet-${deger}`,
                      kilitli,
                      true,
                      kilitli ? t.femaleIncludedByMother : undefined
                    );
                  })}
                </div>
                <div className="grid grid-cols-2 gap-[5px]">
                  {[['var', t.agencyWith], ['yok', t.agencyWithout]].map(([deger, etiket]) =>
                    chip(
                      deger,
                      etiket,
                      filters.ajans.includes(deger),
                      () => toggleProfil('ajans', deger),
                      `master-db-filter-ajans-${deger}`,
                      false,
                      true
                    )
                  )}
                </div>
              </div>,
              'profil'
            )}

            {/* TAKIPCI SAYISI | UZMAN + FAVORILER — tek bolum, iki kolon [Y18e, Bora
                2 Kas 09:04]; Ucret ve Yas satirlariyla AYNI izgara.
                Sol: Takipci sayisi — min USTTE, maks ALTTA. Zincir IG > TikTok > YT,
                  siralamanin kullandigi onceligin aynisi (tek kaynak: sunucuda
                  mdbFollowersExpr); mecra filtresi aktifse zincir yalnizca secili
                  mecralar uzerinde isler.
                Sag: Uzman USTTE, Favoriler ALTTA. Ustte baslik yuksekliginde bos
                  satir (bosluk karakterli sectionTitle — ayni yukseklik, ikinci
                  metin yok); her satir kutu yuksekliginde (h-[29px]) ve dikeyde
                  ortali: Uzman min kutusuyla, Favoriler maks kutusuyla hizali.
                Favoriler ipucu ve uzmanlik agaci izgaranin ALTINDA, TAM GENISLIKTE —
                dar sag kolona girmez. Ikisi de tek onay kutusu; Favoriler v0.9'da
                Uzman'in yanina alinmisti. */}
            {section(
              <>
                <div className="grid grid-cols-2 gap-x-[9px]">
                  <div className="flex flex-col gap-y-[5px] min-w-0">
                    {sectionTitle(t.followersFilter)}
                    {numberInput(filters.followersMin, (v) => patchFilters({ followersMin: v }), t.min, 'master-db-followers-min')}
                    {numberInput(filters.followersMax, (v) => patchFilters({ followersMax: v }), t.max, 'master-db-followers-max')}
                  </div>
                  <div className="flex flex-col gap-y-[5px] min-w-0" data-testid="master-db-expert-col">
                    {sectionTitle('\u00a0')}
                    <div className="h-[29px] flex items-center" data-hiza="uzman">
                      {checkbox(
                        filters.expert,
                        (v) =>
                          // Uzman kaldirilinca agac secimleri de temizlenir
                          patchFilters(v ? { expert: true } : { expert: false, expertise: [] }),
                        t.expertLabel,
                        'master-db-filter-expert'
                      )}
                    </div>
                    {/* IKON YOK: sol paneldeki diger hicbir onay kutusunda ikon
                        yok; Uzman'la ayni desen. Tablodaki ★/☆ favori isareti
                        AYRI bir sey ve duruyor. */}
                    <div className="h-[29px] flex items-center" data-hiza="favori">
                      {checkbox(
                        filters.favorite,
                        (v) => patchFilters({ favorite: v }),
                        t.favorites,
                        'master-db-filter-favorite'
                      )}
                    </div>
                  </div>
                </div>
                {filters.favorite && (
                  <p className="text-[11px] text-[#8A6A20] mt-1.5 leading-snug">{t.favoritesHint}</p>
                )}
                {/* Agac SADECE "Uzman" isaretliyken render edilir.
                    Onceden soluk halde de duruyordu ama 12 ust dal bosuna yer kapliyor ve
                    panel gereksiz uzuyordu. Alt dallar yine varsayilan KAPALI — ok isaretiyle
                    acilir; ust dali secmek zaten alt dallari kapsiyor. */}
                {filters.expert && (
                <div
                  className="mt-[7px]"
                  data-testid="master-db-expertise-tree"
                >
                  {EXPERTISE_TREE.map((node) => {
                    const open = expandedNodes.includes(node.name);
                    const parentOn = filters.expertise.includes(node.name);
                    return (
                      <div key={node.name} className="py-[3px]">
                        <div className="flex items-center gap-1.5">
                          {node.children ? (
                            <button
                              type="button"
                              onClick={() =>
                                setExpandedNodes((prev) =>
                                  prev.includes(node.name)
                                    ? prev.filter((n) => n !== node.name)
                                    : [...prev, node.name]
                                )
                              }
                              className="relative text-[#9B978E] w-[13px] text-[18px] leading-none text-left"
                            >
                              {/* TIK ALANI GENISLETICI — kaplama position:absolute,
                                  akistan cikar; satirin yuksekligini de genisligini de
                                  DEGISTIREMEZ. Butonun KENDISI buyutulemezdi: sol kolon
                                  248px'te sabit (8 Eyl) ve alt dal girintisi ml-[19px] =
                                  13px ok + 6px gap-1.5 esitligine bagli.
                                  OLCULDU (headless Chrome, uretim CSS'i):
                                  tik alani 13x16,5 -> 23x24 px; glif 5,27x13 -> 8,02x21 px.
                                  leading-none ok kutusunu tam satir yuksekligine esitler
                                  (18 px): olculen EN BUYUK punto, satiri buyutmeyen.
                                  Sinirlar kasitli: kaplama satirin py-[3px] dolgusunun
                                  ICINDE kalir — komsu okun alaniyla cakismaz — ve sagda
                                  onay kutusuna degmez. */}
                              <span
                                className="absolute inset-y-[-3px] left-[-5px] right-[-5px]"
                                aria-hidden="true"
                              />
                              {open ? '▾' : '▸'}
                            </button>
                          ) : (
                            <span className="w-[13px] inline-block" />
                          )}
                          {/* Kutucuk: paneldeki diger filtrelerle AYNI desen (ortak
                              checkbox yardimcisi). Onceden secim yalnizca metnin
                              renginden/kalinligindan anlasiliyordu; 25 dalli bir
                              agacta bu okunmuyordu. */}
                          {checkbox(
                            parentOn,
                            () => toggleExpertise(node.name),
                            <span
                              className={`text-[12px] ${
                                parentOn ? 'text-[#8A6A28] font-medium' : 'text-[#232019]'
                              }`}
                            >
                              {node.name}
                            </span>,
                            `master-db-expertise-${node.name}`
                          )}
                        </div>
                        {node.children && open && (
                          <div className="ml-[19px] border-l-[0.5px] border-[#E4E1DC] pl-[9px]">
                            {node.children.map((child) => {
                              // Ust dal seciliyse alt dallar da KAPSANIR — gorsel olarak da isaretli
                              const on = filters.expertise.includes(child) || parentOn;
                              // UST DAL SECILIYKEN ALT DAL KUTUCUGU DEVRE DISI.
                              // Sebep: kutu "isaretli" gorunuyordu ama tiklamak GORUNUMU
                              // DEGISTIRMIYORDU — toggleExpertise(child) listeyi degistiriyor,
                              // parentOn hala true oldugu icin kutu isaretli kaliyor.
                              // Kullanici basiyor, hicbir sey olmuyor; tiklanabilir gorunup
                              // tiklandiginda is yapmayan kontrol bozuk okunur.
                              // Kapsanma bilgisi GIZLENMIYOR (kutu isaretli kaliyor), sahte
                              // tiklama vaadi de verilmiyor. Alt dali ayrica secmek isteyen
                              // once ust dali kaldirir.
                              const kilitli = parentOn;
                              return (
                                <div key={child} className="py-[3px]">
                                  {checkbox(
                                    on,
                                    () => toggleExpertise(child),
                                    <span
                                      className={`text-[12px] ${
                                        on ? 'text-[#8A6A28] font-medium' : 'text-[#6D6960]'
                                      }`}
                                    >
                                      {child}
                                    </span>,
                                    `master-db-expertise-${child}`,
                                    '',
                                    kilitli
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                )}
              </>,
              'followers'
            )}

            {/* UCRET — yasin HEMEN USTUNDE. Konum kasitli: para alanlari
                demografiden once gelmeli, marka brief'i butceyle geliyor.
                [Y18d] Iki kolon: solda Story, sagda Reel; her birinde min ustte,
                maks altta. */}
            {section(
              <div className="grid grid-cols-2 gap-x-[9px]">
                <div className="flex flex-col gap-y-[5px] min-w-0">
                  {sectionTitle(t.rateStoryFilter)}
                  {numberInput(filters.rateStoryMin, (v) => patchFilters({ rateStoryMin: v }), t.min, 'master-db-rate-story-min')}
                  {numberInput(filters.rateStoryMax, (v) => patchFilters({ rateStoryMax: v }), t.max, 'master-db-rate-story-max')}
                </div>
                <div className="flex flex-col gap-y-[5px] min-w-0">
                  {sectionTitle(t.rateReelFilter)}
                  {numberInput(filters.rateReelMin, (v) => patchFilters({ rateReelMin: v }), t.min, 'master-db-rate-reel-min')}
                  {numberInput(filters.rateReelMax, (v) => patchFilters({ rateReelMax: v }), t.max, 'master-db-rate-reel-max')}
                </div>
              </div>,
              'rates'
            )}

            {/* Bebek / cocuk yasi — iki kolon [Y18d]. Hamile onay kutusu
                BURADAN KALKTI: Anne grubunun dorduncu cipi (Profil bolumu). */}
            {section(
              <div className="grid grid-cols-2 gap-x-[9px]">
                <div className="flex flex-col gap-y-[5px] min-w-0">
                  {sectionTitle(t.babyAge)}
                  {numberInput(filters.babyMin, (v) => patchFilters({ babyMin: v }), t.min, 'master-db-baby-min')}
                  {numberInput(filters.babyMax, (v) => patchFilters({ babyMax: v }), t.max, 'master-db-baby-max')}
                </div>
                <div className="flex flex-col gap-y-[5px] min-w-0">
                  {sectionTitle(t.childAge)}
                  {numberInput(filters.childMin, (v) => patchFilters({ childMin: v }), t.min, 'master-db-child-min')}
                  {numberInput(filters.childMax, (v) => patchFilters({ childMax: v }), t.max, 'master-db-child-max')}
                </div>
              </div>,
              'ages'
            )}

            {/* 6. Kategori — akordiyon.
                SECILI FILTRE ASLA GIZLENMEZ: bir veya daha fazla kategori
                secildiginde bolum acik KILITLENIR ve kapatilamaz. Kullanici az
                sonuc gelmesinin sebebini goremezse yanlis karar verir — kapali bir
                akordiyonun ardindaki secili filtre tam olarak bunu yapardi.
                Secim temizlenince kilit kalkar ve bolum yeniden kapatilabilir.
                Bu bolum, mecra akordiyonundan FARKLI olarak kapanirken secimleri
                TEMIZLEMEZ; zaten secim varken kapanamiyor. */}
            {section(
              (() => {
                const kilitli = filters.categories.length > 0;
                const acik = kilitli || categoryOpen;
                return (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        if (kilitli) return; // secili filtre gizlenemez
                        setCategoryOpen((o) => !o);
                      }}
                      className="w-full flex items-center justify-between text-[12px] text-[#6D6960] hover:text-[#8A6A28] transition mb-1.5"
                      data-testid="master-db-category-toggle"
                    >
                      <span>{t.categoryLabel}</span>
                      {/* Kilitliyken ok YOK: tiklanabilir gibi gorunmesin. */}
                      {!kilitli && (
                        <span className="text-[11px] text-[#9B978E]">{acik ? '▴' : '▾'}</span>
                      )}
                    </button>
                    {acik && (
                      <div className="flex flex-wrap gap-[5px]" data-testid="master-db-category-list">
                        {CATEGORIES.map((c) =>
                          chip(c, c, filters.categories.includes(c), () => toggleInList('categories', c))
                        )}
                      </div>
                    )}
                  </>
                );
              })(),
              'category'
            )}

            {/* [Y27, Bora 2 Kas 20:01] MARKA — Kategori'nin alti, Fiyat guncelligi'nin
                ustu. Buyuk/kucuk ve Turkce harf farki, bosluk/tire farki gozetmeden
                o markayla calismis influencerlar (sunucu: mdbMarkaCoz). Virgulle
                birden fazla marka = herhangi biri. 300 ms debounce, URL marka=. */}
            {section(
              <>
                {sectionTitle(t.markaLabel)}
                <input
                  type="text"
                  value={markaInput}
                  onChange={(e) => setMarkaInput(e.target.value)}
                  placeholder={t.markaPlaceholder}
                  maxLength={700}
                  className="w-full text-[12px] h-[29px] px-[7px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-filter-marka"
                />
              </>,
              'marka'
            )}

            {/* [Y32] HEDIYELESME — Marka kutusunun hemen alti; ayni cozumleyici,
                gifted_brands uzerinde. 300 ms debounce, URL hediye=. */}
            {section(
              <>
                {sectionTitle(t.detailGifted)}
                <input
                  type="text"
                  value={hediyeInput}
                  onChange={(e) => setHediyeInput(e.target.value)}
                  placeholder={t.giftedPlaceholder}
                  maxLength={700}
                  className="w-full text-[12px] h-[29px] px-[7px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[6px] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-filter-gifted"
                />
              </>,
              'hediye'
            )}

            {/* VERI TAZELIGI — prosedur "Veri Guncelligi" kolonu.
                KONUM: Kategori'nin altinda [Y18d]; panelin sonu artik Profil +
                Diger filtreler. Yalnizca SIRA degisti, davranis degil.
                Ekip-1'in haftalik akisi buna dayaniyor: hangi kaydin bilgisi
                bayatladi? Rozet deseni segment secimindekiyle ayni.
                BILINMIYOR BAYAT DEGIL, ayri kova — "hic fiyat alinmamis kisi"
                demek ve Ekip-1 icin en degerli kova o olabilir. */}
            {section(
              <>
                {sectionTitle(t.freshnessLabel)}
                <div className="flex flex-wrap gap-[5px]">
                  {TAZELIK_DURUMLARI.map((d) =>
                    chip(
                      d,
                      tazelikEtiketi(d),
                      filters.tazelik.includes(d),
                      () => toggleInList('tazelik', d),
                      `master-db-freshness-${d}`
                    )
                  )}
                </div>
              </>,
              'tazelik'
            )}

            {/* UCRETI BILINMEYENLER — veri gunceliliginin ALTINDA.
                Aralik degil ONAY KUTUSU (Uzman/Favori deseni): "ucret araligi"
                sorusu degil "hic ucret var mi" sorusu.

                Neden DAR degil GENIS: story+reel bos ama baska ucret alani
                dolu olan 46 kayit var ve 46'sinda da YALNIZ TEK alan dolu,
                43'unde quoted_at de dolu. 42'si tiktok_video — yani dar
                tanim, TikTok'ta calisan birini "ucreti bilinmiyor" listesine
                dusururdu ve 5 Eyl mecra-bagimsizlik karariyla ters duserdi.
                [G40 @ 2026-09-01 · 2797]
                [DB @ 2026-09-05 · 2802] ayni olcum canlida: fark 50 kayit —
                tiktok_video 42 · combo_reel_story 6 · multi_story 1 ·
                ig_collab 1 · ig_ad_15day 1. 49'unda yalniz tek alan dolu,
                47'sinde quoted_at de dolu. GENIS 1.154 · DAR 1.204.
                Karar degismedi, sayilar buyudu: iki an da yazili ki
                yorumu okuyan bugunku sayiyi eskisiyle karistirmasin (§5.8.1).

                ALAN LISTESI BURADA YOK: kural sunucuda ve orada da elle
                yazilmamis, mdb-birlestirme.UCRET_ALANLARI'ndan turetiliyor.
                Panel yalnizca bayragi gonderiyor. */}
            {section(
              <>
                {/* Baslik YOK [Y18d]: kutunun kendi etiketi ayni metni yaziyor. */}
                {checkbox(
                  filters.ucretYok,
                  (v) => patchFilters({ ucretYok: v }),
                  <span className="text-[12px] text-[#6D6960]">{t.noRateLabel}</span>,
                  'master-db-no-rate'
                )}
              </>,
              'ucret-yok'
            )}

            {/* SON BOLUM — Diger filtreler akordiyonu [Y18d: en alta indi, icerik ayni]. */}
            {section(
              <>
                <button
                  type="button"
                  onClick={() => setOtherFiltersOpen((o) => !o)}
                  className="w-full flex items-center justify-between text-[12px] text-[#6D6960] hover:text-[#8A6A28] transition"
                  data-testid="master-db-other-filters-toggle"
                >
                  <span>{t.otherFilters}</span>
                  <span className="text-[11px] text-[#9B978E]">{otherFiltersOpen ? '▴' : '▾'}</span>
                </button>
                {otherFiltersOpen && (
                  <div className="mt-2.5">
                    {sectionTitle(t.cityLabel)}
                    {/* 58 farkli deger — rozet yerine select. Tam eslesme gerektigi icin
                        serbest metin yerine kontrollu liste kullanildi. */}
                    {citiesError ? (
                      <div
                        className="w-full text-[12px] px-[7px] py-[6px] mb-3 rounded-[6px] border-[0.5px] border-[#A34940]/40 bg-[#F9E5E2] text-[#A34940]"
                        data-testid="master-db-cities-error"
                      >
                        {t.citiesError}
                      </div>
                    ) : (
                      <select
                        value={filters.city}
                        onChange={(e) => patchFilters({ city: e.target.value })}
                        className="w-full text-[12px] h-[29px] px-[5px] mb-3 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                        data-testid="master-db-city"
                      >
                        <option value="">{t.allCities}</option>
                        {cities.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                    )}

                    {/* Cocuk SAYISI min-maks. Onceden tek yonlu bir kaydiriciydi
                        ("en az N"); "tam 2 cocuklu" ya da "1-3 arasi" denemiyordu.
                        Bebek ve cocuk YASI zaten min-maks — ayni desen. */}
                    <div className="text-[12px] text-[#6D6960] mb-1">{t.childrenCount}</div>
                    <div className="flex flex-col gap-y-[5px] mb-3">
                      {numberInput(filters.childrenMin, (v) => patchFilters({ childrenMin: v }), t.min, 'master-db-children-min')}
                      {numberInput(filters.childrenMax, (v) => patchFilters({ childrenMax: v }), t.max, 'master-db-children-max')}
                    </div>

                    <div className="space-y-[7px]">
                      {checkbox(
                        filters.whatsapp,
                        (v) => patchFilters({ whatsapp: v }),
                        <span className="text-[12px] text-[#6D6960]">{t.whatsappLabel}</span>,
                        'master-db-whatsapp'
                      )}
                      {checkbox(
                        filters.barter,
                        (v) => patchFilters({ barter: v }),
                        <span className="text-[12px] text-[#6D6960]">{t.barterLabel}</span>,
                        'master-db-barter'
                      )}
                    </div>
                  </div>
                )}
              </>,
              'other-filters'
            )}
          </aside>

          {/* === SAG: ozet + tablo === */}
          <div>
            <div className="text-[13px] text-[#6D6960] mb-2" data-testid="master-db-summary">
              <span className="text-[#232019] font-medium">
                {fmtSayi(data.total)} {t.matches}
              </span>
              {/* Yas filtresi aktifken: sonuclarin kacinda yasin olcum tarihi bilinmiyor.
                  Filtre davranisi degismedi, sadece guvenilirlik belirtiliyor. */}
              {data.age_undated > 0 && (
                <span className="text-[#8A6A20]" data-testid="master-db-undated-note">
                  {' ('}
                  {t.undatedNote.replace('{n}', fmtSayi(data.age_undated))}
                  {')'}
                </span>
              )}
              {/* Kaydetme sonrasi gecici basari mesaji (~2.6 sn) */}
              {toast && (
                <span className="text-[#3D7A52] ml-1.5" data-testid="master-db-toast">
                  · {toast}
                </span>
              )}
            </div>

            {topluYetki && secili.size > 0 && (
              <div className="flex items-center gap-2 mb-2 px-3 py-1.5 rounded-[6px] bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] text-[12px] text-[#232019]"
                data-testid="master-db-bulk-bar">
                <span className="font-medium" data-testid="master-db-bulk-count">
                  {t.bulkSelected.replace('{n}', fmtSayi(secili.size))}
                </span>
                <span className="text-[#9B978E]">·</span>
                <button
                  type="button"
                  onClick={topluSilAc}
                  className="text-[12px] px-[9px] py-[3px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition"
                  data-testid="master-db-bulk-delete"
                >
                  {t.bulkDeleteSelected}
                </button>
                <span className="text-[#9B978E]">·</span>
                <button
                  type="button"
                  onClick={() => setSecili(new Set())}
                  className="text-[12px] text-[#6D6960] underline hover:text-[#232019]"
                  data-testid="master-db-bulk-clear"
                >
                  {t.bulkClearSelection}
                </button>
              </div>
            )}

            <div className="border-[0.5px] border-[#E4E1DC] rounded-xl overflow-hidden bg-white">
              {tableStatus === 'loading' ? (
                <div className="py-16 text-center text-[#6D6960] flex items-center justify-center gap-2 text-[13px]">
                  <Loader2 className="animate-spin" size={16} />
                  {t.tableLoading}
                </div>
              ) : tableStatus === 'error' ? (
                <div className="py-16 text-center">
                  <p className="text-[#A34940] mb-4 text-[13px]">{t.tableError}</p>
                  {tableErrorDetay && (
                    <p className="text-[#A34940] -mt-2 mb-4 text-[12px]" data-testid="master-db-table-error-detail">
                      {tableErrorDetay}
                    </p>
                  )}
                  <button
                    type="button"
                    onClick={() => fetchTable()}
                    className="text-[12px] px-[13px] py-[5px] rounded-[6px] bg-[#E8C35C] text-[#2A2317] font-medium hover:brightness-95 transition"
                    data-testid="master-db-table-retry"
                  >
                    {t.retry}
                  </button>
                </div>
              ) : sekmeSecilmedi ? (
                <div className="py-16 text-center text-[#9B978E] text-[13px]" data-testid="master-db-no-tab">
                  {t.noTabSelected}
                </div>
              ) : data.items.length === 0 ? (
                <div className="py-16 text-center text-[#9B978E] text-[13px]" data-testid="master-db-empty">
                  {searchQuery ? t.noSearchMatch.replace('{q}', searchQuery) : t.empty}
                </div>
              ) : (
                /* Tablo kutusu HEM yatay HEM dikey kaydirilabilir ve yuksekligi
                    gorunur alanla sinirli. Bu sart:
                    'overflow-x: auto' CSS'te overflow-y'yi de 'auto' yapar, yani bu kutu
                    zaten bir kaydirma baglami olur. Yukseklik sinirlanmazsa kutu icinde
                    dikey kaydirma OLMAZ ve sticky baslik sayfa kaydirilirken YAPISMAZ —
                    gercek Chrome'da olculdu: 900px genislikte yatay kaydirma calisiyor
                    ama baslik top=-326'ya kayip gozden kayboluyordu.
                    Yuksekligi sinirlayinca dikey kaydirma kutunun icine gecer ve baslik
                    kutunun ustune yapisir (olculen deger: top=59, yatay kaydirma 250px). */
                <div className="overflow-auto max-h-[calc(100vh-14rem)]">
                  <div className="min-w-[860px]">
                    {/* Baslik satiri sabit. bg-[#F3F1EE] SART: seffaf olsaydi altindan
                        gecen satirlar basligin icinden gorunurdu. */}
                    <div className={`${GRID} bg-[#F3F1EE] text-[12px] text-[#6D6960] sticky top-0 z-10`}>
                      <span>
                        {topluYetki && (
                          <input
                            type="checkbox"
                            checked={sayfaTumuSecili}
                            ref={(el) => { if (el) el.indeterminate = !sayfaTumuSecili && sayfaKismenSecili; }}
                            onChange={() => sayfaSec(gorunenKayitlar, !sayfaTumuSecili)}
                            aria-label={t.bulkSelectPage}
                            className="mr-1.5 align-middle cursor-pointer accent-[#A34940]"
                            data-testid="master-db-select-page"
                          />
                        )}
                        {t.colInfluencer}
                      </span>
                      {renderSortHeader('followers', t.colFollowers)}
                      {renderSortHeader('segment', t.colSegment)}
                      {renderSortHeader('ig_story', t.colStory)}
                      {renderSortHeader('ig_reel', t.colReel)}
                      {renderSortHeader('quoted_at', t.colQuotedAt)}
                      {renderSortHeader('tazelik', t.colFreshness)}
                    </div>

                    {/* ESLESTIRME MODU: tablo eslesen kayitlari gosterir. Sunucudan
                        tam belgeler geldigi icin yeniden sorgu atilmiyor; sayfalama da
                        bu modda anlamsiz, o yuzden gizli. */}
                    {/* Sayfanin tamami secili ve filtrede daha fazlasi var: filtrenin
                        tamamini secme (en fazla 200) ya da daraltma uyarisi. */}
                    {topluYetki && !listMatch && sayfaTumuSecili && data.total > gorunenKayitlar.length
                      && secili.size < data.total && (
                      <div className="px-3 py-1.5 text-[12px] bg-[#FAEFD5]/60 border-t-[0.5px] border-[#E4E1DC] text-[#8A6A20]"
                        data-testid="master-db-select-filter-row">
                        {data.total > 200 ? (
                          <span data-testid="master-db-select-too-many">{t.bulkSelectTooMany}</span>
                        ) : (
                          <button
                            type="button"
                            onClick={filtreTumunuSec}
                            disabled={filtreSecimi === 'busy'}
                            className="underline hover:text-[#6B521A] disabled:opacity-50"
                            data-testid="master-db-select-filter"
                          >
                            {filtreSecimi === 'busy'
                              ? t.bulkSelectFilterBusy
                              : t.bulkSelectFilter.replace('{n}', fmtSayi(data.total))}
                          </button>
                        )}
                        {filtreSecimi === 'error' && (
                          <span className="ml-2 text-[#A34940]">{t.bulkSelectFilterError}</span>
                        )}
                      </div>
                    )}
                    {gorunenKayitlar.map((doc) => renderRow(doc))}
                  </div>
                </div>
              )}
            </div>

            {/* Eslestirme modunda sayfalama YOK: sonuc kumesi zaten tam ve tek sayfa. */}
            {tableStatus === 'ok' && !listMatch && totalPages > 1 && (
              <div className="flex items-center justify-center gap-3 mt-4" data-testid="master-db-pagination">
                <button
                  type="button"
                  onClick={() => updateView({ page: Math.max(1, page - 1) })}
                  disabled={page <= 1}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE] transition disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1"
                  data-testid="master-db-prev"
                >
                  <ChevronLeft size={14} />
                  {t.prev}
                </button>
                <span className="text-[12px] text-[#6D6960]">
                  {t.pageOf.replace('{p}', page).replace('{n}', totalPages)}
                </span>
                <button
                  type="button"
                  onClick={() => updateView({ page: Math.min(totalPages, page + 1) })}
                  disabled={page >= totalPages}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE] transition disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1"
                  data-testid="master-db-next"
                >
                  {t.next}
                  <ChevronRight size={14} />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* === SIFRE DEGISTIRME PENCERESI ===
          Gorsel dil sayfanin kendi dili: beyaz kart, #E4E1DC kenar, #E8C35C dugme.
          Goz ikonu deseni giris ekranlarindakiyle AYNI (relative + absolute sag dugme). */}
      {/* YENI KAYIT — tek zorunlu alan handle. Gerisi sonradan kayit
          kartindan duzenlenir; modal bilerek kisa tutuldu. */}
      {/* === YENI KAYIT — AYRI FORM YOK, KARTIN KENDISI ===
          [KARAR, Bora 13 Eyl] Ekrana duzenleme modundaki influencer kartinin
          AYNISI geliyor, alanlari bos. Ayri bir yeni-kayit formu SILINDI: ayni
          veriye iki arayuzle yazmak bu turda uc kez ayri is acilmasina yol acti
          (Diger mecra, cocuk bilgisi, mukerrer mesaji).
          BOS BELGE {} YETERLI — olculdu: startEdit({}) 31 anahtarli tam taslak
          uretiyor, renderDetail'in turetilmis okumalari ({children:[], rates:{},
          notes:[]}) patlamiyor.
          Genislik max-w-[860px]: kart iki kolonlu (sm:grid-cols-2) ve 460px'lik
          eski pencerede kolonlar sikisiyordu. */}
      {yeniKayitAcik && editing && draft && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-start justify-center p-4 overflow-y-auto"
          data-testid="master-db-new-influencer-modal"
          // ARKA PLANA TIKLAMA KAPATIR — ama yalnizca arka plana: hedef bu katman
          // degilse (karta tiklanmissa) dokunulmaz.
          onMouseDown={(e) => { if (e.target === e.currentTarget) kapatmaIstegi(true); }}
        >
          <div className="bg-white rounded-xl w-full max-w-[860px] border-[0.5px] border-[#E4E1DC] max-h-[90vh] overflow-y-auto">
            {/* Baslik kartin kendi dolgusuyla HIZALI (px-[14px]); kart kok
                elemani border-t tasidigi icin ayirici cizgi zaten orada. */}
            <div className="text-[13px] font-medium text-[#232019] px-[14px] pt-3 pb-2.5">
              {t.newRecordTitle}
            </div>
            {renderDetail({}, { yeniMi: true })}
          </div>
        </div>
      )}

      {/* GERI GONDER — sebep ZORUNLU. Sunucu da bos sebebi 400 ile reddediyor;
          burasi kullaniciyi bos gondermeye hic birakmiyor. */}
      {reddetHedef && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-reject-modal"
        >
          <form
            onSubmit={(e) => { e.preventDefault(); geriGonder(); }}
            className="bg-white rounded-xl p-[17px] w-full max-w-[420px] border-[0.5px] border-[#E4E1DC]"
          >
            <div className="text-[13px] font-medium text-[#232019] mb-1">{t.rejectTitle}</div>
            <div className="text-[12px] text-[#6D6960] mb-2">{reddetHedef.file_name}</div>
            <div className="text-[11px] text-[#9B978E] mb-2 leading-snug">{t.rejectHint}</div>
            <textarea
              rows="4"
              value={reddetSebep}
              onChange={(e) => setReddetSebep(e.target.value.slice(0, 1000))}
              placeholder={t.rejectPlaceholder}
              className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
              data-testid="master-db-reject-reason"
            />
            <div className="text-[11px] text-[#9B978E] mt-1">{reddetSebep.length}/1000</div>
            <div className="flex items-center gap-2 mt-2.5 justify-end">
              <button
                type="button"
                onClick={() => { setReddetHedef(null); setReddetSebep(''); }}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition"
                data-testid="master-db-reject-cancel"
              >
                {t.rejectCancel}
              </button>
              <button
                type="submit"
                disabled={!reddetSebep.trim() || onayBusy === reddetHedef.id}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#232019] text-white hover:bg-[#3A352C] transition disabled:opacity-40"
                data-testid="master-db-reject-submit"
              >
                {t.rejectSubmit}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ONAY BEKLEYENLER PANELI — sayfanin mevcut pencere deseni
          (fixed inset-0 / bg-black/30); yeni modal bileseni yazilmadi.
          Bolum basliklari SUNUCUDAN gelen anahtarla t. sozlugunden okunuyor:
          sunucu metin gondermiyor, anahtar gonderiyor — dil degisimi panelde
          kaliyor ve sunucu ceviri tasimiyor. */}
      {kuyrukOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-queue-panel"
        >
          <div className="bg-white rounded-xl p-[17px] w-full max-w-[560px] max-h-[80vh] overflow-y-auto border-[0.5px] border-[#E4E1DC]">
            <div className="flex items-center justify-between mb-2.5">
              <div className="text-[13px] font-medium text-[#232019]">{t.queueTitle}</div>
              <button
                type="button"
                onClick={() => setKuyrukOpen(false)}
                className="text-[#9B978E] hover:text-[#232019] transition"
                data-testid="master-db-queue-close"
              >
                <X size={16} />
              </button>
            </div>

            {kuyruk.durum === 'loading' && kuyruk.bolumler.length === 0 ? (
              <div className="text-[12px] text-[#9B978E] flex items-center gap-1.5">
                <Loader2 className="animate-spin" size={13} />
                {t.loading}
              </div>
            ) : kuyruk.durum === 'error' ? (
              /* Ayri anahtar: kuyruk yarin silme ve arsiv taleplerini de
                 tasiyacak. "Yukleme listesi getirilemedi" mesaji o gun bir
                 arsiv talebi hatasinda gorunur ve yanlis yeri isaret ederdi. */
              <div className="text-[12px] text-[#A34940]">{t.queueError}</div>
            ) : kuyruk.bolumler.length === 0 ? (
              /* BOS DURUM: tek satir, sade. Sahte baslik cizilmiyor. */
              <div className="text-[12px] text-[#9B978E]" data-testid="master-db-queue-empty">
                {t.queueEmpty}
              </div>
            ) : (
              kuyruk.bolumler.map((bolum) => (bolum.tip === 'birlestirme' ? (
                /* [Y29] BIRLESTIRME TALEPLERI — "Onizle ve birlestir" ayni pencereyi
                   talebin kalan / giden / secimleriyle acar; Reddet mevcut desen. */
                <div key={bolum.tip} className="mb-3 last:mb-0" data-testid="master-db-queue-merge-requests">
                  <div className="text-[12px] text-[#6D6960] mb-1.5">
                    {t[bolum.baslik_anahtari] || bolum.tip} ({(bolum.kalemler || []).length})
                  </div>
                  {(bolum.kalemler || []).map((kalem) => {
                    const g = kalem.kayit_ozeti || kalem.kayit || {};
                    const k = kalem.kalan_ozeti || kalem.kalan_kayit || {};
                    return (
                      <div
                        key={kalem._id}
                        className="py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0"
                        data-testid="master-db-queue-merge-request"
                      >
                        <div className="flex items-center gap-2">
                          <div className="flex-1 min-w-0">
                            <div className="text-[12px] font-medium text-[#232019] truncate">
                              {`@${g.instagram_handle || '—'} → @${k.instagram_handle || '—'}`}
                            </div>
                            <div className="text-[11px] text-[#9B978E]">
                              {[
                                kalem.talep_eden,
                                kalem.talep_tarihi ? new Date(kalem.talep_tarihi).toLocaleString(locale) : null,
                                kalem.sebep,
                              ].filter(Boolean).join(' · ')}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => talepRetAc(kalem)}
                            className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition shrink-0"
                            data-testid="master-db-queue-merge-request-reject"
                          >
                            {t.queueReject}
                          </button>
                          <button
                            type="button"
                            onClick={() => talepBirlestirmeAc(kalem)}
                            disabled={g.var === false || k.var === false}
                            className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E8C35C] text-[#8A6A20] hover:bg-[#FAEFD5] transition shrink-0 disabled:opacity-40"
                            data-testid="master-db-queue-merge-request-open"
                          >
                            {t.queueMergeOpen}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : bolum.tip === 'silme' ? (
                /* SILME TALEPLERI — en eski once (sunucu siralar). Onayla, kayit
                   detayindaki [Sil] ile AYNI pencereyi acar (silme-onizleme dahil). */
                <div key={bolum.tip} className="mb-3 last:mb-0" data-testid="master-db-queue-delete-requests">
                  <div className="text-[12px] text-[#6D6960] mb-1.5">
                    {t[bolum.baslik_anahtari] || bolum.tip} ({(bolum.kalemler || []).length})
                  </div>
                  {(bolum.kalemler || []).map((kalem) => {
                    const oz = kalem.kayit_ozeti || kalem.kayit || {};
                    const kalemSayisi = kalem.campaign_items_sayisi || 0;
                    return (
                      <div
                        key={kalem._id}
                        className="py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0"
                        data-testid="master-db-queue-delete-request"
                      >
                        <div className="flex items-center gap-2">
                          <div className="flex-1 min-w-0">
                            <button
                              type="button"
                              onClick={() => talepKaydinaGit(kalem)}
                              disabled={!oz.instagram_handle || kalem.kayit_ozeti?.var === false}
                              className="text-[12px] font-medium text-[#232019] truncate hover:underline disabled:no-underline text-left max-w-full"
                              data-testid="master-db-queue-delete-request-open"
                            >
                              {safeText(oz.full_name) || t.deleteRecordNoName}
                              {oz.instagram_handle ? ` · @${oz.instagram_handle}` : ''}
                              {kalem.kayit_ozeti?.var === false ? ` (${t.queueRecordGone})` : ''}
                            </button>
                            <div className="text-[11px] text-[#9B978E]">
                              {[
                                kalem.talep_eden,
                                kalem.talep_tarihi ? new Date(kalem.talep_tarihi).toLocaleString(locale) : null,
                              ].filter(Boolean).join(' · ')}
                              {' · '}
                              <span
                                className={kalemSayisi > 0 ? 'text-[#8A6A20] font-medium' : ''}
                                data-testid="master-db-queue-delete-request-items"
                              >
                                {t.queueItemsCount.replace('{n}', kalemSayisi)}
                              </span>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => talepRetAc(kalem)}
                            className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition shrink-0"
                            data-testid="master-db-queue-delete-request-reject"
                          >
                            {t.queueReject}
                          </button>
                          <button
                            type="button"
                            onClick={() => talepOnayAc(kalem)}
                            className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4B8B2] text-[#A34940] hover:bg-[#FBEFED] transition shrink-0"
                            data-testid="master-db-queue-delete-request-approve"
                          >
                            {t.queueApprove}
                          </button>
                        </div>
                        <div className="text-[12px] text-[#232019] mt-1 whitespace-pre-wrap break-words">
                          {kalem.sebep}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div key={bolum.tip} className="mb-3 last:mb-0">
                  <div className="text-[12px] text-[#6D6960] mb-1.5">
                    {t[bolum.baslik_anahtari] || bolum.tip}
                  </div>
                  {(bolum.kalemler || []).map((kalem) => (
                    <div
                      key={kalem._id}
                      className="flex items-center gap-2 py-1.5 border-t-[0.5px] border-[#E4E1DC] first:border-t-0"
                      data-testid="master-db-queue-item"
                    >
                      <div className="flex-1 min-w-0">
                        <div className="text-[12px] font-medium text-[#232019] truncate">
                          {kalem.dosya_adi || '—'}
                        </div>
                        <div className="text-[11px] text-[#9B978E]">
                          {[
                            kalem.yukleyen,
                            kalem.yuklenme ? new Date(kalem.yuklenme).toLocaleString(locale) : null,
                            /* satir_sayisi null olabilir (plan uretilmeden yazilmiyor);
                               o zaman satir hic basilmaz, "0 satir" YAZILMAZ. */
                            typeof kalem.satir_sayisi === 'number' ? `${kalem.satir_sayisi} ${t.queueRows}` : null,
                          ].filter(Boolean).join(' · ')}
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => kuyruktanAc(kalem)}
                        className="text-[11px] px-[9px] py-[4px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition shrink-0"
                        data-testid="master-db-queue-open"
                      >
                        {t.queueOpen}
                      </button>
                    </div>
                  ))}
                </div>
              )))
            )}
          </div>
        </div>
      )}

      {/* [Y29] KART BIRLESTIRME PENCERESI — genis. Kural sunucuda (modul);
          pencere yalniz onizlemeyi gosterir, secimleri toplar ve gonderir. */}
      {birlestir && (() => {
        const o = birlestir.onizleme && birlestir.onizleme !== 'hata' ? birlestir.onizleme : null;
        const adminMi = user?.role === 'admin';
        const j = (v) => JSON.stringify(v === undefined ? null : v);
        const catisma = new Map((o?.catismalar || []).map((c) => [c.alan, c]));
        const gerekli = new Set(o?.secimGerekli || []);
        const alanlar = o ? [...new Set([...Object.keys(o.kalan), ...Object.keys(o.giden), ...Object.keys(o.sonuc)])]
          .filter((a) => !['_id', 'updated_at', 'raw', 'search_text'].includes(a)) : [];
        // [Y29b] Ust: her zaman gorunenler (ayni olsalar bile) · sonra farkli olanlar ·
        // katlanir: teknik alanlar ve "Ayni olan N alan" (her zaman gorunenler sayilmaz).
        const profilSatiri = (a) => a === 'anne_mi' || a === 'evli_mi';
        const hep = BIRLESTIR_HEP.filter((a) => profilSatiri(a) || alanlar.includes(a));
        const teknik = alanlar.filter((a) => BIRLESTIR_TEKNIK.includes(a) && !BIRLESTIR_HEP.includes(a));
        const kalanAlanlar = alanlar.filter((a) => !BIRLESTIR_HEP.includes(a) && !BIRLESTIR_TEKNIK.includes(a));
        const farkli = kalanAlanlar.filter((a) => catisma.has(a) || j(o.kalan[a]) !== j(o.giden[a]) || j(o.sonuc[a]) !== j(o.kalan[a]));
        const ayni = kalanAlanlar.filter((a) => !farkli.includes(a));
        const ku = o?.kalmayan_ucretler || null;
        const secimEksik = [...gerekli].some((a) => !(birlestir.secimler || {})[a]);
        const engelli = !o || birlestir.busy || secimEksik || Boolean(o.ucuncu_kayit) || (o.gecersizSecim || []).length > 0;
        const kimlikler = (d) => KIMLIK_SIRASI.filter((a) => d[a]).map((a) => kimlikEtiketi({ alan: a, deger: d[a] })).join(' · ') || '—';
        const kartBasi = (baslik, d, renk) => (
          <div className="min-w-0 flex-1 p-[9px] rounded-[6px] border-[0.5px] border-[#E4E1DC]">
            <div className={`text-[11px] ${renk}`}>{baslik}</div>
            <div className="text-[14px] font-medium text-[#232019] truncate">{safeText(d.full_name) || '—'}</div>
            <div className="text-[12px] text-[#6D6960] truncate">{kimlikler(d)}</div>
          </div>
        );
        const satir = (alan, sinif = '') => {
          if (profilSatiri(alan)) {
            const pz = o.profil_ozeti || {};
            const deger = (taraf, d) => birlestirProfilDegeri(alan, pz[taraf], d);
            const degisti = deger('sonuc', o.sonuc) !== deger('kalan', o.kalan);
            return (
              <div key={alan}
                className={`grid grid-cols-[140px_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] gap-2 py-1 text-[12px] border-t-[0.5px] border-[#E4E1DC] ${sinif}`}
                data-testid={`master-db-merge-row-${alan}`}>
                <div className="text-[#6D6960] min-w-0 break-words">{birlestirEtiketi(alan)}</div>
                <div className="min-w-0 break-words">{deger('kalan', o.kalan)}</div>
                <div className="min-w-0 break-words">{deger('giden', o.giden)}</div>
                <div className={`min-w-0 break-words px-1.5 -mx-1.5 rounded-[4px] bg-[#FAEFD5]/60 text-[#232019] ${degisti ? 'font-semibold' : ''}`}
                  data-testid={`master-db-merge-result-${alan}`}>{deger('sonuc', o.sonuc)}</div>
              </div>
            );
          }
          const c = catisma.get(alan);
          const secilen = c ? ((birlestir.secimler || {})[alan] || c.secilen) : null;
          const hucre = (taraf, d) => (
            <div className="min-w-0 break-words">
              <span>{birlestirDegeri(alan, d[alan])}</span>
              {c && (
                <button
                  type="button"
                  onClick={() => birlestirSec(alan, taraf)}
                  disabled={birlestir.busy}
                  className={`ml-1.5 text-[11px] px-[7px] py-px rounded-[6px] border-[0.5px] transition ${
                    secilen === taraf && (!gerekli.has(alan) || (birlestir.secimler || {})[alan])
                      ? 'bg-[#F6EBD3] border-[#E8C35C] text-[#8A6A20]' : 'bg-white border-[#E4E1DC] text-[#6D6960] hover:bg-[#F3F1EE]'}`}
                  data-testid={`master-db-merge-pick-${alan}-${taraf}`}
                >
                  {t.mergePick}
                </button>
              )}
            </div>
          );
          return (
            <div
              key={alan}
              className={`grid grid-cols-[140px_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] gap-2 py-1 text-[12px] border-t-[0.5px] border-[#E4E1DC] ${
                gerekli.has(alan) && !(birlestir.secimler || {})[alan] ? 'bg-[#FAEFD5]' : ''} ${sinif}`}
              data-testid={`master-db-merge-row-${alan}`}
            >
              <div className="text-[#6D6960] min-w-0 break-words">
                {birlestirEtiketi(alan)}
                {gerekli.has(alan) && !(birlestir.secimler || {})[alan] && (
                  <div className="text-[11px] text-[#8A6A20]">{t.mergePickNeeded}</div>
                )}
              </div>
              {hucre('kalan', o.kalan)}
              {hucre('giden', o.giden)}
              <div
                className={`min-w-0 break-words px-1.5 -mx-1.5 rounded-[4px] bg-[#FAEFD5]/60 text-[#232019] ${j(o.sonuc[alan]) !== j(o.kalan[alan]) ? 'font-semibold' : ''}`}
                data-testid={`master-db-merge-result-${alan}`}
              >
                {birlestirDegeri(alan, o.sonuc[alan], alan === 'notes' ? (o.kalan.notes || []) : undefined)}
              </div>
              {alan === 'rates' && ku && (
                <div className="col-span-4 text-[12px] text-[#8A6A20]" data-testid="master-db-merge-leftover-rates">
                  {t.mergeLeftoverRates
                    .replace('{liste}', ku.alanlar.map((x) => `${x.etiket} ${typeof x.deger === 'number' ? fmtMoney(x.deger, o.sonuc.rates?.currency) : safeText(x.deger)}`).join(' · '))
                    .replace('{handle}', ku.handle || '—')
                    .replace('{tarih}', ku.fiyat_tarihi || t.mergeNoDate)}
                </div>
              )}
            </div>
          );
        };
        return (
          <div
            className="fixed inset-0 z-50 bg-black/30 flex items-start justify-center p-4 overflow-y-auto"
            data-testid="master-db-merge-dialog"
          >
            <div className="bg-white rounded-xl p-[17px] w-full max-w-[960px] border-[0.5px] border-[#E4E1DC]">
              <div className="flex items-center justify-between mb-2.5">
                <div className="text-[13px] font-medium text-[#232019]">{t.mergeTitle}</div>
                <button type="button" onClick={birlestirKapat} disabled={birlestir.busy}
                  className="text-[#9B978E] hover:text-[#232019] transition" data-testid="master-db-merge-close">
                  <X size={16} />
                </button>
              </div>
              {!o ? (
                <div className={`text-[12px] ${birlestir.onizleme === 'hata' ? 'text-[#A34940]' : 'text-[#9B978E]'}`}
                  data-testid="master-db-merge-status">
                  {birlestir.onizleme === 'hata' ? (birlestir.hata || t.mergePreviewError) : t.mergeLoading}
                </div>
              ) : (
                <>
                  <div className="flex items-stretch gap-2 mb-2.5">
                    {kartBasi(t.mergeKeep, o.kalan, 'text-[#3D7A52]')}
                    <button
                      type="button"
                      onClick={birlestirYerDegistir}
                      disabled={birlestir.busy}
                      className="self-center text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40 shrink-0"
                      data-testid="master-db-merge-swap"
                    >
                      ⇄ {t.mergeSwap}
                    </button>
                    {kartBasi(t.mergeDrop, o.giden, 'text-[#A34940]')}
                  </div>
                  <div className="grid grid-cols-[140px_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] gap-2 pb-1 text-[11px] text-[#9B978E]">
                    <div>{t.mergeColField}</div><div>{t.mergeKeep}</div><div>{t.mergeDrop}</div>
                    <div className="px-1.5 -mx-1.5 rounded-[4px] bg-[#FAEFD5]/60 text-[#232019] font-medium" data-testid="master-db-merge-result-head">
                      {t.mergeColResult}
                    </div>
                  </div>
                  {hep.map((a) => satir(a))}
                  {farkli.map((a) => satir(a))}
                  {teknik.length > 0 && (
                    <details className="border-t-[0.5px] border-[#E4E1DC] py-1" data-testid="master-db-merge-technical">
                      <summary className="text-[12px] text-[#6D6960] cursor-pointer">{t.mergeTechnical.replace('{n}', teknik.length)}</summary>
                      {teknik.map((a) => satir(a, 'opacity-80'))}
                    </details>
                  )}
                  {ayni.length > 0 && (
                    <details className="border-t-[0.5px] border-[#E4E1DC] py-1" data-testid="master-db-merge-same">
                      <summary className="text-[12px] text-[#6D6960] cursor-pointer">{t.mergeSame.replace('{n}', ayni.length)}</summary>
                      {ayni.map((a) => satir(a, 'opacity-80'))}
                    </details>
                  )}
                  <div className="mt-2.5 flex flex-col gap-1 text-[12px]">
                    {o.kampanya.eskiHandlelar.length > 0 && (
                      <div className="text-[#232019]" data-testid="master-db-merge-campaign">
                        {t.mergeCampaign.replace('{n}', o.kampanya.kalem_sayisi)
                          .replace('{eski}', o.kampanya.eskiHandlelar.map((h) => `@${h}`).join(', '))
                          .replace('{yeni}', `@${o.kampanya.yeniHandle}`)}
                      </div>
                    )}
                    {(o.profil_duzeltmeleri || []).map((d) => (
                      <div key={d.alan} className="text-[#6A5A8C]" data-testid="master-db-merge-profile-fix">
                        {t.mergeProfileFix}: {birlestirEtiketi(d.alan)} {birlestirDegeri(d.alan, d.eski)} → {birlestirDegeri(d.alan, d.yeni)} ({d.sebep})
                      </div>
                    ))}
                    {o.ucuncu_kayit && (
                      <div className="text-[#A34940] font-medium" data-testid="master-db-merge-third">
                        {t.mergeThirdRecord.replace('{name}', o.ucuncu_kayit.full_name || '—')
                          .replace('{handle}', `@${o.ucuncu_kayit[o.ucuncu_kayit.alan] || o.ucuncu_kayit.instagram_handle || '—'}`)
                          .replace('{id}', o.ucuncu_kayit._id)}
                      </div>
                    )}
                    <div className="text-[#6D6960]">{t.mergeBackupNote}</div>
                  </div>
                </>
              )}
              {birlestir.hata && o && (
                <div className="text-[12px] text-[#A34940] mt-2" data-testid="master-db-merge-error">{birlestir.hata}</div>
              )}
              {o && !adminMi && (
                <div className="mt-2.5">
                  <div className="text-[12px] text-[#6D6960] mb-1">{t.mergeReason}</div>
                  <textarea
                    rows="2"
                    value={birlestir.sebep || ''}
                    onChange={(e) => { const v = e.target.value.slice(0, 1000); setBirlestir((b) => ({ ...b, sebep: v })); }}
                    className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                    data-testid="master-db-merge-reason"
                  />
                </div>
              )}
              <div className="flex items-center gap-2 mt-2.5 justify-end flex-wrap">
                {adminMi && birlestir.onay && (
                  <span className="text-[12px] text-[#A34940] mr-auto">{t.mergeConfirmAsk}</span>
                )}
                <button
                  type="button"
                  autoFocus
                  onClick={birlestirKapat}
                  disabled={birlestir.busy}
                  className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                  data-testid="master-db-merge-cancel"
                >
                  {t.cancel}
                </button>
                {adminMi ? (
                  <button
                    type="button"
                    onClick={birlestirGonder}
                    disabled={engelli}
                    className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition disabled:opacity-40"
                    data-testid="master-db-merge-confirm"
                  >
                    {birlestir.busy ? t.mergeBusy : birlestir.onay ? t.mergeConfirmYes : t.mergeConfirm}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={birlestirGonder}
                    disabled={engelli || String(birlestir.sebep || '').trim().length < 5}
                    className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#E8C35C] text-[#2A2317] font-medium hover:brightness-95 transition disabled:opacity-40"
                    data-testid="master-db-merge-request"
                  >
                    {birlestir.busy ? t.deleteRequestSending : t.mergeRequest}
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {/* KAYIT SILME ONAYI — detay panelindeki [Kaydi sil] acar.
          Pencere ACILANA KADAR hicbir sey silinmez; acildiktan sonra da
          yalnizca [Onayla] siler. Sayfadaki diger onay pencereleriyle ayni
          desen (fixed inset-0 / bg-black/30), yeni bir modal bileseni
          yazilmadi. */}
      {silmeHedef && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-delete-dialog"
        >
          <form
            onSubmit={(e) => { e.preventDefault(); kayitSil(); }}
            className="bg-white rounded-xl p-[17px] w-full max-w-[460px] border-[0.5px] border-[#E4E1DC]"
          >
            <div className="text-[13px] font-medium text-[#A34940] mb-2">{t.deleteRecordTitle}</div>

            {/* 1) KIM siliniyor — okunakli ve buyukce. */}
            <div className="text-[15px] font-medium text-[#232019] leading-snug">
              {safeText(silmeHedef.doc.full_name) || t.deleteRecordNoName}
            </div>
            <div className="text-[13px] text-[#6D6960] mb-2.5">
              {silmeHedef.doc.instagram_handle ? `@${silmeHedef.doc.instagram_handle}` : '—'}
            </div>

            {/* 2) Kampanya kalemi UYARISI — yalnizca kalem VARSA. Sayi 0 ise
                   kutu hic cizilmez; olmayan bir riski hatirlatmak uyariyi
                   degersizlestirir. */}
            {silmeOnizleme === 'hata' && (
              <div className="text-[12px] text-[#A34940] mb-2.5">{t.deleteRecordPreviewError}</div>
            )}
            {silmeOnizleme && silmeOnizleme !== 'hata' && silmeOnizleme.campaign_items_sayisi > 0 && (
              <div className="text-[12px] text-[#8A6A20] leading-snug mb-2.5 p-[9px] rounded-[6px] bg-[#FAEFD5]/60 border-[0.5px] border-[#E8C35C]">
                {t.deleteRecordItems
                  .replace('{n}', silmeOnizleme.campaign_items_sayisi)
                  .replace('{m}', silmeOnizleme.icerik_baglantili_sayisi)}
              </div>
            )}

            {/* 3) Sebep — ZORUNLU. Bos ya da yalniz bosluk iken Onayla pasif. */}
            {silmeOnizleme === null && (
              <div className="text-[12px] text-[#9B978E] mb-1.5" data-testid="master-db-delete-preview-loading">
                {t.deleteRecordPreviewLoading}
              </div>
            )}
            {silmeHedef.talep ? (
              /* TALEP ONAYI: sebep talepten gelir; silme sebebini sunucu kurar
                 ("talep: ... · talep eden ... · onaylayan ..."). */
              <div data-testid="master-db-delete-request-reason">
                <div className="text-[12px] text-[#6D6960] mb-1">
                  {t.deleteRequestReasonLabel} · {t.deleteRequestBy}: {silmeHedef.talep.talep_eden || '—'}
                </div>
                <div className="text-[12px] text-[#232019] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] whitespace-pre-wrap break-words">
                  {silmeHedef.talep.sebep}
                </div>
              </div>
            ) : (
              <>
                <div className="text-[12px] text-[#6D6960] mb-1">{t.deleteRecordReason}</div>
                <textarea
                  rows="3"
                  value={silmeSebep}
                  onChange={(e) => setSilmeSebep(e.target.value.slice(0, 1000))}
                  placeholder={t.deleteRecordReasonPlaceholder}
                  className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-delete-reason"
                />
                <div className="text-[11px] text-[#9B978E] mt-1">{silmeSebep.length}/1000</div>
              </>
            )}

            {/* 4) Son soru. */}
            <div className="text-[12px] text-[#232019] mt-2.5">{t.deleteRecordAsk}</div>

            {silmeHata && (
              <div className="text-[12px] text-[#A34940] mt-2" data-testid="master-db-delete-error">
                {silmeHata}
              </div>
            )}

            <div className="flex items-center gap-2 mt-2.5 justify-end">
              {/* Vazgec VARSAYILAN ODAKTA: pencere acilir acilmaz Enter'a basmak
                  silmeye degil vazgecmeye gitsin. */}
              <button
                type="button"
                autoFocus
                onClick={silmeKapat}
                disabled={silmeBusy}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                data-testid="master-db-delete-dialog-cancel"
              >
                {t.deleteRecordCancel}
              </button>
              {/* Onizleme GELMEDEN silinemez. Kampanya kalemi uyarisi bu ekranin
                  tek korumasi; gorulmediginde silme yapilmamali. 0 kalemde kutu
                  cizilmedigi icin "uyari yok" ile "uyari gelmedi" gozle ayirt
                  edilemiyor — ayrimi dugme yapiyor. */}
              <button
                type="submit"
                disabled={silmeBusy || !silmeOnizlemeHazir}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition disabled:opacity-40"
                data-testid="master-db-delete-confirm"
              >
                {silmeBusy ? t.deleteRecordBusy : t.deleteRecordConfirm}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* TOPLU SILME PENCERESI — yalniz admin. Onizleme (kalem uyarisi) gelmeden
          Onayla pasif; sonucta hatali / bulunamayan varsa adlariyla kalir. */}
      {topluPencere && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-bulk-dialog"
        >
          <form
            onSubmit={(e) => { e.preventDefault(); topluSil(); }}
            className="bg-white rounded-xl p-[17px] w-full max-w-[460px] max-h-[90vh] overflow-y-auto border-[0.5px] border-[#E4E1DC]"
          >
            {(() => {
              const o = topluPencere.onizleme && topluPencere.onizleme !== 'hata' ? topluPencere.onizleme : null;
              const sonuc = topluPencere.sonuc;
              if (sonuc) {
                return (
                  <div data-testid="master-db-bulk-result">
                    <div className="text-[13px] font-medium text-[#232019] mb-2">
                      {t.bulkDeleteResult.replace('{n}', fmtSayi(sonuc.silinen.length))}
                    </div>
                    {sonuc.hatali.length > 0 && (
                      <div className="text-[12px] text-[#A34940] mb-2" data-testid="master-db-bulk-failed">
                        <div className="font-medium">{t.bulkDeleteFailed.replace('{n}', sonuc.hatali.length)}</div>
                        {sonuc.hatali.map((h) => (
                          <div key={h._id}>{topluAdById(h._id)} · {h.hata}</div>
                        ))}
                      </div>
                    )}
                    {sonuc.bulunamayan.length > 0 && (
                      <div className="text-[12px] text-[#8A6A20] mb-2" data-testid="master-db-bulk-notfound">
                        <div className="font-medium">{t.bulkDeleteNotFound.replace('{n}', sonuc.bulunamayan.length)}</div>
                        {sonuc.bulunamayan.map((id) => <div key={id}>{topluAdById(id)}</div>)}
                      </div>
                    )}
                    <div className="flex justify-end mt-2.5">
                      <button
                        type="button"
                        autoFocus
                        onClick={topluKapat}
                        className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition"
                        data-testid="master-db-bulk-close"
                      >
                        {t.bulkDeleteClose}
                      </button>
                    </div>
                  </div>
                );
              }
              const adlar = o ? (o.kayitlar || []) : [];
              return (
                <>
                  <div className="text-[13px] font-medium text-[#A34940] mb-2" data-testid="master-db-bulk-title">
                    {t.bulkDeleteTitle.replace('{n}', fmtSayi(o ? o.kayit_sayisi : secili.size))}
                  </div>
                  {topluPencere.onizleme === null && (
                    <div className="text-[12px] text-[#9B978E] mb-1.5">{t.deleteRecordPreviewLoading}</div>
                  )}
                  {topluPencere.onizleme === 'hata' && (
                    <div className="text-[12px] text-[#A34940] mb-2.5">
                      {t.bulkDeletePreviewError}{topluHata ? ` (${topluHata})` : ''}
                    </div>
                  )}
                  {o && (
                    <div className="text-[12px] text-[#232019] mb-2.5" data-testid="master-db-bulk-names">
                      {adlar.slice(0, 10).map((k) => <div key={k._id}>{topluAd(k)}</div>)}
                      {adlar.length > 10 && (
                        <div className="text-[#6D6960]">{t.bulkDeleteMore.replace('{m}', fmtSayi(adlar.length - 10))}</div>
                      )}
                    </div>
                  )}
                  {o && o.bulunamayan.length > 0 && (
                    <div className="text-[12px] text-[#8A6A20] mb-2.5">
                      {t.bulkDeleteMissing.replace('{n}', o.bulunamayan.length)}
                    </div>
                  )}
                  {o && o.kalemli.length > 0 && (
                    <div className="text-[12px] text-[#8A6A20] leading-snug mb-2.5 p-[9px] rounded-[6px] bg-[#FAEFD5]/60 border-[0.5px] border-[#E8C35C]"
                      data-testid="master-db-bulk-items">
                      <div>
                        {t.bulkDeleteItems
                          .replace('{k}', o.kalemli.length)
                          .replace('{n}', fmtSayi(o.toplam_kalem))}
                      </div>
                      {o.kalemli.map((k) => (
                        <div key={k._id}>
                          {t.bulkDeleteItemsRow
                            .replace('{ad}', topluAd(k))
                            .replace('{n}', k.campaign_items_sayisi)
                            .replace('{m}', k.icerik_baglantili_sayisi)}
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="text-[12px] text-[#6D6960] mb-1">{t.deleteRecordReason}</div>
                  <textarea
                    rows="3"
                    value={topluSebep}
                    onChange={(e) => setTopluSebep(e.target.value.slice(0, 1000))}
                    placeholder={t.deleteRecordReasonPlaceholder}
                    className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                    data-testid="master-db-bulk-reason"
                  />
                  <div className="text-[11px] text-[#9B978E] mt-1">{topluSebep.length}/1000</div>
                  <div className="text-[12px] text-[#232019] mt-2.5">{t.bulkDeleteAsk}</div>
                  {topluHata && topluPencere.onizleme !== 'hata' && (
                    <div className="text-[12px] text-[#A34940] mt-2" data-testid="master-db-bulk-error">{topluHata}</div>
                  )}
                  <div className="flex items-center gap-2 mt-2.5 justify-end">
                    {/* Vazgec VARSAYILAN ODAKTA — tekli silme penceresiyle ayni. */}
                    <button
                      type="button"
                      autoFocus
                      onClick={topluKapat}
                      disabled={topluBusy}
                      className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                      data-testid="master-db-bulk-cancel"
                    >
                      {t.deleteRecordCancel}
                    </button>
                    <button
                      type="submit"
                      disabled={topluBusy || !topluOnizlemeHazir}
                      className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition disabled:opacity-40"
                      data-testid="master-db-bulk-confirm"
                    >
                      {topluBusy ? t.deleteRecordBusy : t.deleteRecordConfirm}
                    </button>
                  </div>
                </>
              );
            })()}
          </form>
        </div>
      )}

      {/* SILME TALEBI PENCERESI — ekip uyesi, kayit detayindaki [Silme talebi
          gonder] acar. Sebep ZORUNLU (sunucu en az 5 karakter ister). Hicbir
          sey silinmez; talep admin onayina gider. */}
      {talepHedef && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-delete-request-dialog"
        >
          <form
            onSubmit={(e) => { e.preventDefault(); talepGonder(); }}
            className="bg-white rounded-xl p-[17px] w-full max-w-[460px] border-[0.5px] border-[#E4E1DC]"
          >
            <div className="text-[13px] font-medium text-[#A34940] mb-2">{t.deleteRequestTitle}</div>
            <div className="text-[15px] font-medium text-[#232019] leading-snug">
              {safeText(talepHedef.doc.full_name) || t.deleteRecordNoName}
            </div>
            <div className="text-[13px] text-[#6D6960] mb-2.5">
              {talepHedef.doc.instagram_handle ? `@${talepHedef.doc.instagram_handle}` : '—'}
            </div>
            <div className="text-[12px] text-[#6D6960] leading-snug mb-2.5">{t.deleteRequestInfo}</div>
            <div className="text-[12px] text-[#6D6960] mb-1">{t.deleteRequestReason}</div>
            <textarea
              rows="3"
              value={talepSebep}
              onChange={(e) => setTalepSebep(e.target.value.slice(0, 1000))}
              placeholder={t.deleteRequestReasonPlaceholder}
              className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
              data-testid="master-db-delete-request-reason-input"
            />
            <div className="text-[11px] text-[#9B978E] mt-1">{talepSebep.length}/1000</div>
            {talepHata && (
              <div className="text-[12px] text-[#A34940] mt-2" data-testid="master-db-delete-request-error">
                {talepHata}
              </div>
            )}
            <div className="flex items-center gap-2 mt-2.5 justify-end">
              <button
                type="button"
                autoFocus
                onClick={talepKapat}
                disabled={talepBusy}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                data-testid="master-db-delete-request-cancel"
              >
                {t.deleteRequestCancel}
              </button>
              <button
                type="submit"
                disabled={talepBusy || !talepSebep.trim()}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition disabled:opacity-40"
                data-testid="master-db-delete-request-submit"
              >
                {talepBusy ? t.deleteRequestSending : t.deleteRequestSend}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* SILME TALEBI RET PENCERESI — admin, Onay Bekleyenler'den. Not istege bagli. */}
      {talepRetHedef && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-reject-request-dialog"
        >
          <form
            onSubmit={(e) => { e.preventDefault(); talepReddet(); }}
            className="bg-white rounded-xl p-[17px] w-full max-w-[460px] border-[0.5px] border-[#E4E1DC]"
          >
            <div className="text-[13px] font-medium text-[#232019] mb-2">
              {talepRetHedef.tur === 'birlestir' ? t.rejectMergeTitle : t.rejectRequestTitle}
            </div>
            <div className="text-[13px] text-[#232019] mb-1">
              {safeText((talepRetHedef.kayit_ozeti || talepRetHedef.kayit || {}).full_name) || t.deleteRecordNoName}
              {(talepRetHedef.kayit_ozeti || talepRetHedef.kayit || {}).instagram_handle
                ? ` · @${(talepRetHedef.kayit_ozeti || talepRetHedef.kayit).instagram_handle}` : ''}
            </div>
            <div className="text-[12px] text-[#6D6960] mb-2.5 whitespace-pre-wrap break-words">
              {t.deleteRequestReasonLabel}: {talepRetHedef.sebep}
            </div>
            <div className="text-[12px] text-[#6D6960] mb-1">{t.rejectRequestNote}</div>
            <textarea
              rows="2"
              value={talepRetNot}
              onChange={(e) => setTalepRetNot(e.target.value.slice(0, 1000))}
              placeholder={t.rejectRequestNotePlaceholder}
              className="w-full text-[12px] p-2 bg-[#F3F1EE] border-[0.5px] border-[#E4E1DC] rounded-[6px] text-[#232019] outline-none focus:border-[#CAC6BF]"
              data-testid="master-db-reject-request-note"
            />
            {talepRetHata && (
              <div className="text-[12px] text-[#A34940] mt-2" data-testid="master-db-reject-request-error">
                {talepRetHata}
              </div>
            )}
            <div className="flex items-center gap-2 mt-2.5 justify-end">
              <button
                type="button"
                autoFocus
                onClick={talepRetKapat}
                disabled={talepRetBusy}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition disabled:opacity-40"
                data-testid="master-db-reject-request-cancel"
              >
                {t.deleteRequestCancel}
              </button>
              <button
                type="submit"
                disabled={talepRetBusy}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#232019] text-white hover:brightness-110 transition disabled:opacity-40"
                data-testid="master-db-reject-request-submit"
              >
                {talepRetBusy ? t.rejectRequestBusy : t.rejectRequestConfirm}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* SILME ONAYI — iz kaybini ACIKCA soyluyor. Artimli yukleme audit_log'a
          alan bazinda yazmiyor; uploads kaydi o Taslak'in ne degistirdiginin
          TEK izi. Silme islemi kayda geciyor ama silinen plan geri gelmiyor. */}
      {silHedef && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-delete-modal"
        >
          <div className="bg-white rounded-xl p-[17px] w-full max-w-[460px] border-[0.5px] border-[#E4E1DC]">
            <div className="text-[13px] font-medium text-[#A34940] mb-1">{t.deleteTitle}</div>
            <div className="text-[12px] text-[#232019] mb-2">{silHedef.file_name}</div>
            <div className="text-[12px] text-[#6D6960] leading-snug mb-3" data-testid="master-db-delete-warning">
              {t.deleteWarning}
            </div>
            <div className="flex items-center gap-2 justify-end">
              <button
                type="button"
                onClick={() => setSilHedef(null)}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] hover:bg-[#F3F1EE] transition"
                data-testid="master-db-delete-cancel"
              >
                {t.deleteCancel}
              </button>
              <button
                type="button"
                onClick={yuklemeSil}
                disabled={onayBusy === silHedef.id}
                className="text-[12px] px-[11px] py-[5px] rounded-[6px] bg-[#A34940] text-white hover:bg-[#8E3F37] transition disabled:opacity-40"
                data-testid="master-db-delete-submit"
              >
                {t.deleteSubmit}
              </button>
            </div>
          </div>
        </div>
      )}

      {sifreModal && (
        <div
          className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center p-4"
          data-testid="master-db-password-modal"
        >
          <form
            onSubmit={sifreDegistirOturum}
            className="w-full max-w-sm bg-white border-[0.5px] border-[#E4E1DC] rounded-2xl p-6 shadow-lg"
            data-testid="master-db-password-form"
          >
            <div className="flex items-start justify-between mb-4">
              <h2 className="text-[15px] font-semibold text-[#232019]">{t.cpTitle}</h2>
              <button
                type="button"
                onClick={sifreModalKapat}
                className="text-[#9B978E] hover:text-[#232019] transition"
                aria-label={t.cpCancel}
                data-testid="master-db-password-close"
              >
                <X size={16} />
              </button>
            </div>

            {sdHata && (
              <div
                className="mb-4 px-3 py-2.5 text-[12px] bg-[#FAEFD5] border-[0.5px] border-[#E8C35C] text-[#8A6A20] rounded-[8px]"
                data-testid="master-db-password-error"
              >
                {sdHata}
              </div>
            )}

            <div className="mb-3">
              <label className="block text-[12px] text-[#6D6960] mb-1.5">{t.cpCurrent}</label>
              <div className="relative">
                <input
                  type={sdMevcutGoster ? 'text' : 'password'}
                  required
                  autoComplete="current-password"
                  value={sdMevcut}
                  onChange={(e) => setSdMevcut(e.target.value)}
                  className="w-full px-3 py-2.5 pr-10 text-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[8px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-current-password"
                />
                <button
                  type="button"
                  onClick={() => setSdMevcutGoster(!sdMevcutGoster)}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9B978E] hover:text-[#232019] transition"
                  aria-label={sdMevcutGoster ? t.pwHide : t.pwShow}
                  data-testid="master-db-current-password-toggle"
                >
                  {sdMevcutGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="block text-[12px] text-[#6D6960] mb-1.5">{t.pwNew}</label>
              <div className="relative">
                <input
                  type={sdYeniGoster ? 'text' : 'password'}
                  required
                  minLength={12}
                  autoComplete="new-password"
                  value={sdYeni}
                  onChange={(e) => setSdYeni(e.target.value)}
                  className="w-full px-3 py-2.5 pr-10 text-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[8px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-new-password"
                />
                <button
                  type="button"
                  onClick={() => setSdYeniGoster(!sdYeniGoster)}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9B978E] hover:text-[#232019] transition"
                  aria-label={sdYeniGoster ? t.pwHide : t.pwShow}
                  data-testid="master-db-new-password-toggle"
                >
                  {sdYeniGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <div className="mb-2">
              <label className="block text-[12px] text-[#6D6960] mb-1.5">{t.pwRepeat}</label>
              <div className="relative">
                <input
                  type={sdTekrarGoster ? 'text' : 'password'}
                  required
                  minLength={12}
                  autoComplete="new-password"
                  value={sdTekrar}
                  onChange={(e) => setSdTekrar(e.target.value)}
                  className="w-full px-3 py-2.5 pr-10 text-[13px] bg-white border-[0.5px] border-[#E4E1DC] rounded-[8px] text-[#232019] outline-none focus:border-[#CAC6BF]"
                  data-testid="master-db-repeat-password"
                />
                <button
                  type="button"
                  onClick={() => setSdTekrarGoster(!sdTekrarGoster)}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9B978E] hover:text-[#232019] transition"
                  aria-label={sdTekrarGoster ? t.pwHide : t.pwShow}
                  data-testid="master-db-repeat-password-toggle"
                >
                  {sdTekrarGoster ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            {/* Kural metni sifre belirleme ekranindakiyle AYNI dizge (t.pwRules) —
                iki yerde farkli yazilirsa biri gunceldigi zaman digeri yalan soyler. */}
            <p className="text-[11px] text-[#9B978E] mb-5 leading-snug" data-testid="master-db-password-rules">
              {t.pwRules}
            </p>

            <div className="flex gap-2">
              <button
                type="button"
                onClick={sifreModalKapat}
                className="flex-1 py-2.5 text-[13px] bg-white border-[0.5px] border-[#E4E1DC] text-[#232019] rounded-[8px] hover:bg-[#F3F1EE] transition"
                data-testid="master-db-password-cancel"
              >
                {t.cpCancel}
              </button>
              <button
                type="submit"
                disabled={sdMesgul}
                className="flex-1 py-2.5 text-[13px] bg-[#E8C35C] text-[#2A2317] font-semibold rounded-[8px] hover:brightness-95 transition disabled:opacity-40"
                data-testid="master-db-password-submit"
              >
                {sdMesgul ? <Loader2 className="mx-auto animate-spin" size={16} /> : t.cpSave}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default MasterDatabasePage;
